
      var $parcel$global = globalThis;
    
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("dUYS2", function(module, exports) {

parcelRequire("ihxXg");




// Need to disable this because this affects how files are bundled together
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $fd10e50337bcb934$var$lazyImports = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("2I68T"));
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("7lk3V"));
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    (parcelRequire("lDIQ7"));
};
// We set this global variable to ensure it is available to all environments
// and then overwrite its value to TRUE in the JiraSPA entries: SSR and non-SSR
$parcel$global.__SPA__ = false;

});
parcelRegister("ihxXg", function(module, exports) {

var $4FGdU = parcelRequire("4FGdU");

var $d2S0J = parcelRequire("d2S0J");

var $hGtke = parcelRequire("hGtke");

var $7oY9g = parcelRequire("7oY9g");

var $cWTNU = parcelRequire("cWTNU");
if (!(0, $7oY9g.default)('fe_platform_error_tracking_enabled_sentry')) (0, $4FGdU.installGlobalHandler)();
(0, $hGtke.installErrorHandler)((0, $cWTNU.platformErrorHandler));
(0, $d2S0J.default)();

});
parcelRegister("4FGdU", function(module, exports) {
$parcel$export(module.exports, "installGlobalHandler", () => $cf687519d44893cf$export$7da675e3dd1bd6b5);

var $9BykO = parcelRequire("9BykO");
const $cf687519d44893cf$export$7da675e3dd1bd6b5 = ()=>false ? undefined : (0, $9BykO.installGlobalHandler)();

});
parcelRegister("9BykO", function(module, exports) {
$parcel$export(module.exports, "installGlobalHandler", () => $280de4be0bf09be6$export$7da675e3dd1bd6b5);

var $kINbm = parcelRequire("kINbm");
var $38t4T = parcelRequire("38t4T");
var $kvkQX = parcelRequire("kvkQX");

var $5fWuD = parcelRequire("5fWuD");
var $gwUes = parcelRequire("gwUes");
var $gOI8F = parcelRequire("gOI8F");
var $jPpPM = parcelRequire("jPpPM");

var $lopBx = parcelRequire("lopBx");

var $aYncF = parcelRequire("aYncF");

var $4cTDP = parcelRequire("4cTDP");

var $hWeHP = parcelRequire("hWeHP");

var $hwYGJ = parcelRequire("hwYGJ");

var $fJfOq = parcelRequire("fJfOq");

var $avUww = parcelRequire("avUww");
const $280de4be0bf09be6$var$SENTRY_URL = 'https://12742a0abbd1484686195dca8ba74be6@o55978.ingest.sentry.io/5988809';
const $280de4be0bf09be6$var$FRONTEND_RESOURCES = [
    // Our DEV and PROD environments in Micros Static
    /https:\/\/jira-frontend.*\..*\.atl-paas\.net\//,
    // For devs using `yarn start`
    /atlastunnel/,
    /localhost/,
    // Old S3 DEV environment
    /https:\/\/d398cwy4pffc4s\.cloudfront\.net\//,
    // Monolith staging|hello|ap|us environment
    /https:\/\/(d25s903c0x7s6j|dgjotco7y2aa|d9x1z07c483jl|d1vkjhvgh6tvn1).cloudfront.net\//,
    // Old S3 PROD environment
    /https:\/\/d2oj435jmh0qvz\.cloudfront\.net\//,
    // Automation S3 dev|staging|prod environment
    /https:\/\/(d3r49bgl1frqoy|d2v2wiwzx86dg|d283vu6e5qi87p).cloudfront.net\//
];
// https://docs.sentry.io/platforms/javascript/#removing-an-integration
// Remove Breadcrumbs integration from the Sentry default integrations
// we will re-add it manually with custom options
const $280de4be0bf09be6$var$getFilteredIntegrations = (integrations)=>integrations.filter(({ name: name })=>name !== 'Breadcrumbs');
// This is used to mark which frames of the stacktrace are part of our app. They will be
// displayed in a different UI in Sentry.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $280de4be0bf09be6$var$rewriteFramesIteratee = (frame)=>{
    const curFrame = frame;
    if (curFrame.filename) curFrame.in_app = $280de4be0bf09be6$var$FRONTEND_RESOURCES.some((resource)=>resource.test(frame.filename));
    return curFrame;
};
const $280de4be0bf09be6$var$getSentryEnvironment = ()=>{
    if ((0, $4cTDP.fg)('jira-bypass-sentry-environment-filter')) return 'dev';
    return (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)().environment ?? 'no-environment';
};
/**
 * Initializes Sentry for error logging with configurations tailored to the application's environment. It ensures error
 * reports are not duplicated if Sentry is already active, and sets up custom handling for errors and breadcrumbs,
 * enhancing error reporting with specific application context like bundler version, build variant, and user information.
 *
 * We import this code early in SSR static fallback (in entry-fs/), to catch errors in that code. However, it is
 * compiled in a different Parcel build, so typical bundler deduplication doesn't work and this script is run twice
 * (from different script tags), so we prevent double-init here using a global (only read+written here).
 *
 * IMPORTANT: fg calls in the modern SSR static fallback will always serve the default value, because we need to init
 * Sentry and other error tracking before bootstrap code that loads feature gate values. In code below here, please
 * clean up fg's quickly to avoid fallback values being served for an extended time.
 */ const $280de4be0bf09be6$export$7da675e3dd1bd6b5 = ()=>{
    // @ts-expect-error global to communicate between multiple copies of this file. Should not be accessed elsewhere.
    if (globalThis.__JIRA_SENTRY_INSTALLED) return;
    // @ts-expect-error global to communicate between multiple copies of this file. Should not be accessed elsewhere.
    globalThis.__JIRA_SENTRY_INSTALLED = true;
    // Check for sentry already enabled to be defensive in case two fragments are loaded in the same page, we
    // don't want duplicated error reports
    const sentryClient = (0, $kINbm.getCurrentHub)().getClient();
    if (sentryClient && sentryClient.getOptions().enabled) return;
    let environment = $280de4be0bf09be6$var$getSentryEnvironment();
    if (environment === 'prod') environment = 'production';
    const tags = {
        region: (0, $hWeHP.default)('ajs-region') || 'unknown'
    };
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.BUNDLER_VERSION) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const bundlerVersionTag = window.BUNDLER_VERSION.includes('@') ? window.BUNDLER_VERSION : `webpack@${window.BUNDLER_VERSION}`;
        tags.bundler = bundlerVersionTag;
    }
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.BUILD_VARIANT) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    tags.variant = window.BUILD_VARIANT;
    const config = {
        // This is evaluated against the *first* frame of the stack trace.
        // If it doesn't match, the error is not sent.
        allowUrls: $280de4be0bf09be6$var$FRONTEND_RESOURCES,
        beforeSend: (0, $fJfOq.normaliseSentryEvent),
        // Sentry dom adds more attrs (like title, alt...) to breadcrumbs
        // but they might contain UGC/PII so we need to force strip them
        beforeBreadcrumb: (0, $hwYGJ.normaliseSentryBreadcrumbs),
        dsn: (0, $lopBx.isFedRamp)() ? undefined : $280de4be0bf09be6$var$SENTRY_URL,
        environment: environment,
        initialScope: {
            tags: tags,
            user: {
                id: (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)().atlassianAccountId ?? undefined
            }
        },
        integrations: (integrations)=>[
                ...$280de4be0bf09be6$var$getFilteredIntegrations(integrations),
                new (0, $kvkQX.Integrations).Breadcrumbs({
                    // only enable breadcrumbs for dom (UI clicks and inputs)
                    // include 'data-test-id', 'data-testid' in the breadcrumbs if they are found
                    dom: {
                        serializeAttribute: (0, $hwYGJ.SERIALIZABLE_ATTRIBUTES),
                        maxStringLength: 300
                    },
                    fetch: false,
                    xhr: false,
                    console: false,
                    history: false,
                    sentry: false
                }),
                new (0, $gwUes.Dedupe)(),
                new (0, $gOI8F.ExtraErrorData)(),
                new (0, $jPpPM.RewriteFrames)({
                    iteratee: $280de4be0bf09be6$var$rewriteFramesIteratee
                }),
                ...(0, $4cTDP.fg)('jira-capture-console-errors-in-sentry') ? [
                    new (0, $5fWuD.CaptureConsole)({
                        levels: [
                            'error'
                        ]
                    })
                ] : []
            ],
        maxBreadcrumbs: 15,
        release: globalThis.BUILD_KEY,
        dist: globalThis.BUILD_VARIANT || 'default'
    };
    (0, $38t4T.init)(config);
    // Once Sentry is initialized, start reporting Atlaspack errors
    (0, $avUww.handleAtlaspackErrors)();
    // Returning this value to prevent tree shaking in SSR
    return 'sentry-init';
};

});
parcelRegister("38t4T", function(module, exports) {
$parcel$export(module.exports, "defaultIntegrations", () => $2488acb788027f49$export$5ef831fccfce35e5);
$parcel$export(module.exports, "init", () => $2488acb788027f49$export$2cd8252107eb640b);

var $3vr70 = parcelRequire("3vr70");
var $3idHc = parcelRequire("3idHc");
var $kINbm = parcelRequire("kINbm");
var $8WCUT = parcelRequire("8WCUT");
var $71uQM = parcelRequire("71uQM");
var $hTs4r = parcelRequire("hTs4r");
var $bQI3R = parcelRequire("bQI3R");

var $6g60L = parcelRequire("6g60L");
var $6lJZW = parcelRequire("6lJZW");
var $amn5g = parcelRequire("amn5g");
var $fsPAv = parcelRequire("fsPAv");

var $lt7A0 = parcelRequire("lt7A0");

var $bl0Xy = parcelRequire("bl0Xy");

var $3FkMI = parcelRequire("3FkMI");

var $fK4F3 = parcelRequire("fK4F3");

var $lo7wK = parcelRequire("lo7wK");

var $jFqF2 = parcelRequire("jFqF2");

var $11Thk = parcelRequire("11Thk");

var $fTNUR = parcelRequire("fTNUR");

var $jWbWT = parcelRequire("jWbWT");

var $7JgVP = parcelRequire("7JgVP");

var $3SNJd = parcelRequire("3SNJd");

var $1FjJN = parcelRequire("1FjJN");
/** @deprecated Use `getDefaultIntegrations(options)` instead. */ const $2488acb788027f49$export$5ef831fccfce35e5 = [
    (0, $hTs4r.inboundFiltersIntegration)(),
    (0, $3idHc.functionToStringIntegration)(),
    (0, $jWbWT.browserApiErrorsIntegration)(),
    (0, $fK4F3.breadcrumbsIntegration)(),
    (0, $jFqF2.globalHandlersIntegration)(),
    (0, $fTNUR.linkedErrorsIntegration)(),
    (0, $lo7wK.dedupeIntegration)(),
    (0, $11Thk.httpContextIntegration)()
];
/** Get the default integrations for the browser SDK. */ function $2488acb788027f49$export$5783b2920b1d62b9(_options) {
    // We return a copy of the defaultIntegrations here to avoid mutating this
    return [
        // eslint-disable-next-line deprecation/deprecation
        ...$2488acb788027f49$export$5ef831fccfce35e5
    ];
}
/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */ function $2488acb788027f49$export$2cd8252107eb640b(options = {}) {
    if (options.defaultIntegrations === undefined) options.defaultIntegrations = $2488acb788027f49$export$5783b2920b1d62b9();
    if (options.release === undefined) {
        // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
        if (typeof __SENTRY_RELEASE__ === 'string') options.release = __SENTRY_RELEASE__;
        // This supports the variable that sentry-webpack-plugin injects
        if ((0, $3FkMI.WINDOW).SENTRY_RELEASE && (0, $3FkMI.WINDOW).SENTRY_RELEASE.id) options.release = (0, $3FkMI.WINDOW).SENTRY_RELEASE.id;
    }
    if (options.autoSessionTracking === undefined) options.autoSessionTracking = true;
    if (options.sendClientReports === undefined) options.sendClientReports = true;
    const clientOptions = {
        ...options,
        stackParser: (0, $amn5g.stackParserFromStackParserOptions)(options.stackParser || (0, $7JgVP.defaultStackParser)),
        integrations: (0, $8WCUT.getIntegrationsToSetup)(options),
        transport: options.transport || ((0, $fsPAv.supportsFetch)() ? (0, $3SNJd.makeFetchTransport) : (0, $1FjJN.makeXHRTransport))
    };
    (0, $bQI3R.initAndBind)((0, $lt7A0.BrowserClient), clientOptions);
    if (options.autoSessionTracking) $2488acb788027f49$var$startSessionTracking();
}
const $2488acb788027f49$export$3a8fd680da42627b = (// eslint-disable-next-line deprecation/deprecation
options = {}, // eslint-disable-next-line deprecation/deprecation
hub = (0, $kINbm.getCurrentHub)())=>{
    // doesn't work without a document (React Native)
    if (!(0, $3FkMI.WINDOW).document) {
        (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).error('Global document not defined in showReportDialog call');
        return;
    }
    // eslint-disable-next-line deprecation/deprecation
    const { client: client, scope: scope } = hub.getStackTop();
    const dsn = options.dsn || client && client.getDsn();
    if (!dsn) {
        (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).error('DSN not configured for showReportDialog call');
        return;
    }
    if (scope) options.user = {
        ...scope.getUser(),
        ...options.user
    };
    if (!options.eventId) // eslint-disable-next-line deprecation/deprecation
    options.eventId = hub.lastEventId();
    const script = (0, $3FkMI.WINDOW).document.createElement('script');
    script.async = true;
    script.crossOrigin = 'anonymous';
    script.src = (0, $71uQM.getReportDialogEndpoint)(dsn, options);
    if (options.onLoad) script.onload = options.onLoad;
    const { onClose: onClose } = options;
    if (onClose) {
        const reportDialogClosedMessageHandler = (event)=>{
            if (event.data === '__sentry_reportdialog_closed__') try {
                onClose();
            } finally{
                (0, $3FkMI.WINDOW).removeEventListener('message', reportDialogClosedMessageHandler);
            }
        };
        (0, $3FkMI.WINDOW).addEventListener('message', reportDialogClosedMessageHandler);
    }
    const injectionPoint = (0, $3FkMI.WINDOW).document.head || (0, $3FkMI.WINDOW).document.body;
    if (injectionPoint) injectionPoint.appendChild(script);
    else (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).error('Not injecting report dialog. No injection point found in HTML');
};
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $2488acb788027f49$export$a3f323d81eede727() {
// Noop
}
/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */ function $2488acb788027f49$export$4e4d8b287d028b6b(callback) {
    callback();
}
/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @deprecated This function will be removed in v8.
 * It is not part of Sentry's official API and it's easily replaceable by using a try/catch block
 * and calling Sentry.captureException.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */ // TODO(v8): Remove this function
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $2488acb788027f49$export$4997ffc0176396a6(fn) {
    return (0, $3FkMI.wrap)(fn)();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */ function $2488acb788027f49$var$startSessionTracking() {
    if (typeof (0, $3FkMI.WINDOW).document === 'undefined') {
        (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    (0, $3vr70.startSession)({
        ignoreDuration: true
    });
    (0, $3vr70.captureSession)();
    // We want to create a session for every navigation as well
    (0, $6g60L.addHistoryInstrumentationHandler)(({ from: from, to: to })=>{
        // Don't create an additional session for the initial route or if the location did not change
        if (from !== undefined && from !== to) {
            (0, $3vr70.startSession)({
                ignoreDuration: true
            });
            (0, $3vr70.captureSession)();
        }
    });
}
/**
 * Captures user feedback and sends it to Sentry.
 */ function $2488acb788027f49$export$88cefaf72d1e58a3(feedback) {
    const client = (0, $3vr70.getClient)();
    if (client) client.captureUserFeedback(feedback);
}

});
parcelRegister("3idHc", function(module, exports) {
$parcel$export(module.exports, "functionToStringIntegration", () => $265dad34a5fd4856$export$7918117e9202e4fb);
$parcel$export(module.exports, "FunctionToString", () => $265dad34a5fd4856$export$da4704525c20ae79);

var $3dFJR = parcelRequire("3dFJR");

var $3vr70 = parcelRequire("3vr70");

var $8WCUT = parcelRequire("8WCUT");
let $265dad34a5fd4856$var$originalFunctionToString;
const $265dad34a5fd4856$var$INTEGRATION_NAME = 'FunctionToString';
const $265dad34a5fd4856$var$SETUP_CLIENTS = new WeakMap();
const $265dad34a5fd4856$var$_functionToStringIntegration = ()=>{
    return {
        name: $265dad34a5fd4856$var$INTEGRATION_NAME,
        setupOnce () {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            $265dad34a5fd4856$var$originalFunctionToString = Function.prototype.toString;
            // intrinsics (like Function.prototype) might be immutable in some environments
            // e.g. Node with --frozen-intrinsics, XS (an embedded JavaScript engine) or SES (a JavaScript proposal)
            try {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                Function.prototype.toString = function(...args) {
                    const originalFunction = (0, $3dFJR.getOriginalFunction)(this);
                    const context = $265dad34a5fd4856$var$SETUP_CLIENTS.has((0, $3vr70.getClient)()) && originalFunction !== undefined ? originalFunction : this;
                    return $265dad34a5fd4856$var$originalFunctionToString.apply(context, args);
                };
            } catch (e) {
            // ignore errors here, just don't patch this
            }
        },
        setup (client) {
            $265dad34a5fd4856$var$SETUP_CLIENTS.set(client, true);
        }
    };
};
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * ```js
 * Sentry.init({
 *   integrations: [
 *     functionToStringIntegration(),
 *   ],
 * });
 * ```
 */ const $265dad34a5fd4856$export$7918117e9202e4fb = (0, $8WCUT.defineIntegration)($265dad34a5fd4856$var$_functionToStringIntegration);
/**
 * Patch toString calls to return proper name for wrapped functions.
 *
 * @deprecated Use `functionToStringIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $265dad34a5fd4856$export$da4704525c20ae79 = (0, $8WCUT.convertIntegrationFnToClass)($265dad34a5fd4856$var$INTEGRATION_NAME, $265dad34a5fd4856$export$7918117e9202e4fb);

});
parcelRegister("8WCUT", function(module, exports) {
$parcel$export(module.exports, "getIntegrationsToSetup", () => $6831ed87625f4209$export$68bc4c01ab8ae766);
$parcel$export(module.exports, "setupIntegrations", () => $6831ed87625f4209$export$51abed9797baa598);
$parcel$export(module.exports, "setupIntegration", () => $6831ed87625f4209$export$e7390a03b70a6f2f);
$parcel$export(module.exports, "afterSetupIntegrations", () => $6831ed87625f4209$export$35abcfd71227c6ca);
$parcel$export(module.exports, "convertIntegrationFnToClass", () => $6831ed87625f4209$export$afa219bf23651160);
$parcel$export(module.exports, "defineIntegration", () => $6831ed87625f4209$export$2323046b9414659f);

var $kgI9H = parcelRequire("kgI9H");
var $6lJZW = parcelRequire("6lJZW");

var $fZ2r3 = parcelRequire("fZ2r3");

var $1feQE = parcelRequire("1feQE");

var $3vr70 = parcelRequire("3vr70");

var $kINbm = parcelRequire("kINbm");
const $6831ed87625f4209$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $6831ed87625f4209$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $6831ed87625f4209$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') integrations = (0, $kgI9H.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $6831ed87625f4209$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $6831ed87625f4209$var$findIndex(finalIntegrations, (integration)=>integration.name === 'Debug');
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $6831ed87625f4209$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $6831ed87625f4209$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $6831ed87625f4209$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $6831ed87625f4209$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($6831ed87625f4209$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $1feQE.addGlobalEventProcessor), (0, $kINbm.getCurrentHub));
        $6831ed87625f4209$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $6831ed87625f4209$export$2d8f5188773bcddd(integration) {
    const client = (0, $3vr70.getClient)();
    if (!client || !client.addIntegration) {
        (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $6831ed87625f4209$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $6831ed87625f4209$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $6831ed87625f4209$export$2323046b9414659f(fn) {
    return fn;
}

});


parcelRegister("71uQM", function(module, exports) {
$parcel$export(module.exports, "getEnvelopeEndpointWithUrlEncodedAuth", () => $51d08ea3e3dabc25$export$9964600bfe84e6a3);
$parcel$export(module.exports, "getReportDialogEndpoint", () => $51d08ea3e3dabc25$export$671c7ed8e40a7a57);

var $cLBIh = parcelRequire("cLBIh");
var $3dFJR = parcelRequire("3dFJR");
const $51d08ea3e3dabc25$var$SENTRY_API_VERSION = '7';
/** Returns the prefix to construct Sentry ingestion API endpoints. */ function $51d08ea3e3dabc25$var$getBaseApiEndpoint(dsn) {
    const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
    const port = dsn.port ? `:${dsn.port}` : '';
    return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}
/** Returns the ingest API endpoint for target. */ function $51d08ea3e3dabc25$var$_getIngestEndpoint(dsn) {
    return `${$51d08ea3e3dabc25$var$getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}
/** Returns a URL-encoded string with auth config suitable for a query string. */ function $51d08ea3e3dabc25$var$_encodedAuth(dsn, sdkInfo) {
    return (0, $3dFJR.urlEncode)({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: $51d08ea3e3dabc25$var$SENTRY_API_VERSION,
        ...sdkInfo && {
            sentry_client: `${sdkInfo.name}/${sdkInfo.version}`
        }
    });
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */ function $51d08ea3e3dabc25$export$9964600bfe84e6a3(dsn, // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
// options: ClientOptions = {} as ClientOptions,
tunnelOrOptions = {}) {
    // TODO (v8): Use this code instead
    // const { tunnel, _metadata = {} } = options;
    // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;
    const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
    const sdkInfo = typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;
    return tunnel ? tunnel : `${$51d08ea3e3dabc25$var$_getIngestEndpoint(dsn)}?${$51d08ea3e3dabc25$var$_encodedAuth(dsn, sdkInfo)}`;
}
/** Returns the url to the report dialog endpoint. */ function $51d08ea3e3dabc25$export$671c7ed8e40a7a57(dsnLike, dialogOptions) {
    const dsn = (0, $cLBIh.makeDsn)(dsnLike);
    if (!dsn) return '';
    const endpoint = `${$51d08ea3e3dabc25$var$getBaseApiEndpoint(dsn)}embed/error-page/`;
    let encodedOptions = `dsn=${(0, $cLBIh.dsnToString)(dsn)}`;
    for(const key in dialogOptions){
        if (key === 'dsn') continue;
        if (key === 'onClose') continue;
        if (key === 'user') {
            const user = dialogOptions.user;
            if (!user) continue;
            if (user.name) encodedOptions += `&name=${encodeURIComponent(user.name)}`;
            if (user.email) encodedOptions += `&email=${encodeURIComponent(user.email)}`;
        } else encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key])}`;
    }
    return `${endpoint}?${encodedOptions}`;
}

});
parcelRegister("cLBIh", function(module, exports) {
$parcel$export(module.exports, "dsnToString", () => $94b720db496a5659$export$44d472fbb931a776);
$parcel$export(module.exports, "makeDsn", () => $94b720db496a5659$export$128827c3562ec0cb);

var $fUFQt = parcelRequire("fUFQt");

var $6lJZW = parcelRequire("6lJZW");
/** Regular expression used to parse a Dsn. */ const $94b720db496a5659$var$DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function $94b720db496a5659$var$isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */ function $94b720db496a5659$export$44d472fbb931a776(dsn, withPassword = false) {
    const { host: host, path: path, pass: pass, port: port, projectId: projectId, protocol: protocol, publicKey: publicKey } = dsn;
    return `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` + `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`;
}
/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents or undefined if @param str is not a valid DSN string
 */ function $94b720db496a5659$export$b892860177f70a30(str) {
    const match = $94b720db496a5659$var$DSN_REGEX.exec(str);
    if (!match) {
        // This should be logged to the console
        (0, $6lJZW.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.error(`Invalid Sentry Dsn: ${str}`);
        });
        return undefined;
    }
    const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
    let path = '';
    let projectId = lastPath;
    const split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        const projectMatch = projectId.match(/^\d+/);
        if (projectMatch) projectId = projectMatch[0];
    }
    return $94b720db496a5659$var$dsnFromComponents({
        host: host,
        pass: pass,
        path: path,
        projectId: projectId,
        port: port,
        protocol: protocol,
        publicKey: publicKey
    });
}
function $94b720db496a5659$var$dsnFromComponents(components) {
    return {
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId
    };
}
function $94b720db496a5659$var$validateDsn(dsn) {
    if (!(0, $fUFQt.DEBUG_BUILD)) return true;
    const { port: port, projectId: projectId, protocol: protocol } = dsn;
    const requiredComponents = [
        'protocol',
        'publicKey',
        'host',
        'projectId'
    ];
    const hasMissingRequiredComponent = requiredComponents.find((component)=>{
        if (!dsn[component]) {
            (0, $6lJZW.logger).error(`Invalid Sentry Dsn: ${component} missing`);
            return true;
        }
        return false;
    });
    if (hasMissingRequiredComponent) return false;
    if (!projectId.match(/^\d+$/)) {
        (0, $6lJZW.logger).error(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
        return false;
    }
    if (!$94b720db496a5659$var$isValidProtocol(protocol)) {
        (0, $6lJZW.logger).error(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
        return false;
    }
    if (port && isNaN(parseInt(port, 10))) {
        (0, $6lJZW.logger).error(`Invalid Sentry Dsn: Invalid port ${port}`);
        return false;
    }
    return true;
}
/**
 * Creates a valid Sentry Dsn object, identifying a Sentry instance and project.
 * @returns a valid DsnComponents object or `undefined` if @param from is an invalid DSN source
 */ function $94b720db496a5659$export$128827c3562ec0cb(from) {
    const components = typeof from === 'string' ? $94b720db496a5659$export$b892860177f70a30(from) : $94b720db496a5659$var$dsnFromComponents(from);
    if (!components || !$94b720db496a5659$var$validateDsn(components)) return undefined;
    return components;
}

});


parcelRegister("hTs4r", function(module, exports) {
$parcel$export(module.exports, "inboundFiltersIntegration", () => $d06d58f921047467$export$cb3c5c2ceb9818ba);
$parcel$export(module.exports, "InboundFilters", () => $d06d58f921047467$export$2ffbb5359dcc6be4);

var $kgI9H = parcelRequire("kgI9H");
var $6lJZW = parcelRequire("6lJZW");
var $4RzNY = parcelRequire("4RzNY");

var $fZ2r3 = parcelRequire("fZ2r3");

var $8WCUT = parcelRequire("8WCUT");
// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const $d06d58f921047467$var$DEFAULT_IGNORE_ERRORS = [
    /^Script error\.?$/,
    /^Javascript error: Script error\.? on line 0$/,
    /^ResizeObserver loop completed with undelivered notifications.$/,
    /^Cannot redefine property: googletag$/
];
const $d06d58f921047467$var$DEFAULT_IGNORE_TRANSACTIONS = [
    /^.*\/healthcheck$/,
    /^.*\/healthy$/,
    /^.*\/live$/,
    /^.*\/ready$/,
    /^.*\/heartbeat$/,
    /^.*\/health$/,
    /^.*\/healthz$/
];
/** Options for the InboundFilters integration */ const $d06d58f921047467$var$INTEGRATION_NAME = 'InboundFilters';
const $d06d58f921047467$var$_inboundFiltersIntegration = (options = {})=>{
    return {
        name: $d06d58f921047467$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, _hint, client) {
            const clientOptions = client.getOptions();
            const mergedOptions = $d06d58f921047467$var$_mergeOptions(options, clientOptions);
            return $d06d58f921047467$var$_shouldDropEvent(event, mergedOptions) ? null : event;
        }
    };
};
const $d06d58f921047467$export$cb3c5c2ceb9818ba = (0, $8WCUT.defineIntegration)($d06d58f921047467$var$_inboundFiltersIntegration);
/**
 * Inbound filters configurable by the user.
 * @deprecated Use `inboundFiltersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $d06d58f921047467$export$2ffbb5359dcc6be4 = (0, $8WCUT.convertIntegrationFnToClass)($d06d58f921047467$var$INTEGRATION_NAME, $d06d58f921047467$export$cb3c5c2ceb9818ba);
function $d06d58f921047467$var$_mergeOptions(internalOptions = {}, clientOptions = {}) {
    return {
        allowUrls: [
            ...internalOptions.allowUrls || [],
            ...clientOptions.allowUrls || []
        ],
        denyUrls: [
            ...internalOptions.denyUrls || [],
            ...clientOptions.denyUrls || []
        ],
        ignoreErrors: [
            ...internalOptions.ignoreErrors || [],
            ...clientOptions.ignoreErrors || [],
            ...internalOptions.disableErrorDefaults ? [] : $d06d58f921047467$var$DEFAULT_IGNORE_ERRORS
        ],
        ignoreTransactions: [
            ...internalOptions.ignoreTransactions || [],
            ...clientOptions.ignoreTransactions || [],
            ...internalOptions.disableTransactionDefaults ? [] : $d06d58f921047467$var$DEFAULT_IGNORE_TRANSACTIONS
        ],
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true
    };
}
function $d06d58f921047467$var$_shouldDropEvent(event, options) {
    if (options.ignoreInternal && $d06d58f921047467$var$_isSentryError(event)) {
        (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0, $kgI9H.getEventDescription)(event)}`);
        return true;
    }
    if ($d06d58f921047467$var$_isIgnoredError(event, options.ignoreErrors)) {
        (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn(`Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0, $kgI9H.getEventDescription)(event)}`);
        return true;
    }
    if ($d06d58f921047467$var$_isIgnoredTransaction(event, options.ignoreTransactions)) {
        (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn(`Event dropped due to being matched by \`ignoreTransactions\` option.\nEvent: ${(0, $kgI9H.getEventDescription)(event)}`);
        return true;
    }
    if ($d06d58f921047467$var$_isDeniedUrl(event, options.denyUrls)) {
        (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn(`Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0, $kgI9H.getEventDescription)(event)}.\nUrl: ${$d06d58f921047467$var$_getEventFilterUrl(event)}`);
        return true;
    }
    if (!$d06d58f921047467$var$_isAllowedUrl(event, options.allowUrls)) {
        (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn(`Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0, $kgI9H.getEventDescription)(event)}.\nUrl: ${$d06d58f921047467$var$_getEventFilterUrl(event)}`);
        return true;
    }
    return false;
}
function $d06d58f921047467$var$_isIgnoredError(event, ignoreErrors) {
    // If event.type, this is not an error
    if (event.type || !ignoreErrors || !ignoreErrors.length) return false;
    return $d06d58f921047467$var$_getPossibleEventMessages(event).some((message)=>(0, $4RzNY.stringMatchesSomePattern)(message, ignoreErrors));
}
function $d06d58f921047467$var$_isIgnoredTransaction(event, ignoreTransactions) {
    if (event.type !== 'transaction' || !ignoreTransactions || !ignoreTransactions.length) return false;
    const name = event.transaction;
    return name ? (0, $4RzNY.stringMatchesSomePattern)(name, ignoreTransactions) : false;
}
function $d06d58f921047467$var$_isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) return false;
    const url = $d06d58f921047467$var$_getEventFilterUrl(event);
    return !url ? false : (0, $4RzNY.stringMatchesSomePattern)(url, denyUrls);
}
function $d06d58f921047467$var$_isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) return true;
    const url = $d06d58f921047467$var$_getEventFilterUrl(event);
    return !url ? true : (0, $4RzNY.stringMatchesSomePattern)(url, allowUrls);
}
function $d06d58f921047467$var$_getPossibleEventMessages(event) {
    const possibleMessages = [];
    if (event.message) possibleMessages.push(event.message);
    let lastException;
    try {
        // @ts-expect-error Try catching to save bundle size
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        lastException = event.exception.values[event.exception.values.length - 1];
    } catch (e) {
    // try catching to save bundle size checking existence of variables
    }
    if (lastException) {
        if (lastException.value) {
            possibleMessages.push(lastException.value);
            if (lastException.type) possibleMessages.push(`${lastException.type}: ${lastException.value}`);
        }
    }
    if ((0, $fZ2r3.DEBUG_BUILD) && possibleMessages.length === 0) (0, $6lJZW.logger).error(`Could not extract message for event ${(0, $kgI9H.getEventDescription)(event)}`);
    return possibleMessages;
}
function $d06d58f921047467$var$_isSentryError(event) {
    try {
        // @ts-expect-error can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    } catch (e) {
    // ignore
    }
    return false;
}
function $d06d58f921047467$var$_getLastValidUrl(frames = []) {
    for(let i = frames.length - 1; i >= 0; i--){
        const frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') return frame.filename || null;
    }
    return null;
}
function $d06d58f921047467$var$_getEventFilterUrl(event) {
    try {
        let frames;
        try {
            // @ts-expect-error we only care about frames if the whole thing here is defined
            frames = event.exception.values[0].stacktrace.frames;
        } catch (e) {
        // ignore
        }
        return frames ? $d06d58f921047467$var$_getLastValidUrl(frames) : null;
    } catch (oO) {
        (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).error(`Cannot extract url for event ${(0, $kgI9H.getEventDescription)(event)}`);
        return null;
    }
}

});

parcelRegister("bQI3R", function(module, exports) {
$parcel$export(module.exports, "initAndBind", () => $8a06baaaa3ce2e6f$export$5333c3f1c58d9bc1);

var $6lJZW = parcelRequire("6lJZW");

var $fZ2r3 = parcelRequire("fZ2r3");

var $3vr70 = parcelRequire("3vr70");

var $kINbm = parcelRequire("kINbm");
/** A class object that can instantiate Client objects. */ /**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */ function $8a06baaaa3ce2e6f$export$5333c3f1c58d9bc1(clientClass, options) {
    if (options.debug === true) {
        if (0, $fZ2r3.DEBUG_BUILD) (0, $6lJZW.logger).enable();
        else // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
        (0, $6lJZW.consoleSandbox)(()=>{
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        });
    }
    const scope = (0, $3vr70.getCurrentScope)();
    scope.update(options.initialScope);
    const client = new clientClass(options);
    $8a06baaaa3ce2e6f$export$ecb76f41d43c0e43(client);
    $8a06baaaa3ce2e6f$var$initializeClient(client);
}
/**
 * Make the given client the current client.
 */ function $8a06baaaa3ce2e6f$export$ecb76f41d43c0e43(client) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $kINbm.getCurrentHub)();
    // eslint-disable-next-line deprecation/deprecation
    const top = hub.getStackTop();
    top.client = client;
    top.scope.setClient(client);
}
/**
 * Initialize the client for the current scope.
 * Make sure to call this after `setCurrentClient()`.
 */ function $8a06baaaa3ce2e6f$var$initializeClient(client) {
    if (client.init) client.init();
    else if (client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
    client.setupIntegrations();
}

});

parcelRegister("6g60L", function(module, exports) {
$parcel$export(module.exports, "addHistoryInstrumentationHandler", () => $48e8e66873fd2079$export$3f18c56c58114e75);

var $3dFJR = parcelRequire("3dFJR");



var $aFn2S = parcelRequire("aFn2S");

var $fwWJJ = parcelRequire("fwWJJ");

var $6i9I9 = parcelRequire("6i9I9");
const $48e8e66873fd2079$var$WINDOW = (0, $aFn2S.GLOBAL_OBJ);
let $48e8e66873fd2079$var$lastHref;
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $48e8e66873fd2079$export$3f18c56c58114e75(handler) {
    const type = 'history';
    (0, $6i9I9.addHandler)(type, handler);
    (0, $6i9I9.maybeInstrument)(type, $48e8e66873fd2079$var$instrumentHistory);
}
function $48e8e66873fd2079$var$instrumentHistory() {
    if (!(0, $fwWJJ.supportsHistory)()) return;
    const oldOnPopState = $48e8e66873fd2079$var$WINDOW.onpopstate;
    $48e8e66873fd2079$var$WINDOW.onpopstate = function(...args) {
        const to = $48e8e66873fd2079$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $48e8e66873fd2079$var$lastHref;
        $48e8e66873fd2079$var$lastHref = to;
        const handlerData = {
            from: from,
            to: to
        };
        (0, $6i9I9.triggerHandlers)('history', handlerData);
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $48e8e66873fd2079$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $48e8e66873fd2079$var$lastHref = to;
                const handlerData = {
                    from: from,
                    to: to
                };
                (0, $6i9I9.triggerHandlers)('history', handlerData);
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $3dFJR.fill)($48e8e66873fd2079$var$WINDOW.history, 'pushState', historyReplacementFunction);
    (0, $3dFJR.fill)($48e8e66873fd2079$var$WINDOW.history, 'replaceState', historyReplacementFunction);
}

});
parcelRegister("fwWJJ", function(module, exports) {
$parcel$export(module.exports, "supportsHistory", () => $b4e7680ed5576b3d$export$67fc34576016d6ec);

var $aFn2S = parcelRequire("aFn2S");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $b4e7680ed5576b3d$var$WINDOW = (0, $aFn2S.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $b4e7680ed5576b3d$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chromeVar = $b4e7680ed5576b3d$var$WINDOW.chrome;
    const isChromePackagedApp = chromeVar && chromeVar.app && chromeVar.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = 'history' in $b4e7680ed5576b3d$var$WINDOW && !!$b4e7680ed5576b3d$var$WINDOW.history.pushState && !!$b4e7680ed5576b3d$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});

parcelRegister("6i9I9", function(module, exports) {
$parcel$export(module.exports, "addHandler", () => $494bf4f3e7409cef$export$a4e09611e30da72e);
$parcel$export(module.exports, "maybeInstrument", () => $494bf4f3e7409cef$export$e18d6c5462c01368);
$parcel$export(module.exports, "triggerHandlers", () => $494bf4f3e7409cef$export$b18c893e424d3127);

var $fUFQt = parcelRequire("fUFQt");

var $6lJZW = parcelRequire("6lJZW");

var $amn5g = parcelRequire("amn5g");
// We keep the handlers globally
const $494bf4f3e7409cef$var$handlers = {};
const $494bf4f3e7409cef$var$instrumented = {};
/** Add a handler function. */ function $494bf4f3e7409cef$export$a4e09611e30da72e(type, handler) {
    $494bf4f3e7409cef$var$handlers[type] = $494bf4f3e7409cef$var$handlers[type] || [];
    $494bf4f3e7409cef$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $494bf4f3e7409cef$export$b17eab759a1cb5fe() {
    Object.keys($494bf4f3e7409cef$var$handlers).forEach((key)=>{
        $494bf4f3e7409cef$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $494bf4f3e7409cef$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$494bf4f3e7409cef$var$instrumented[type]) {
        instrumentFn();
        $494bf4f3e7409cef$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $494bf4f3e7409cef$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $494bf4f3e7409cef$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $fUFQt.DEBUG_BUILD) && (0, $6lJZW.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $amn5g.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("fsPAv", function(module, exports) {
$parcel$export(module.exports, "supportsFetch", () => $b4217ccfa1db06c9$export$edf3cb81fd7d2a3e);
$parcel$export(module.exports, "isNativeFetch", () => $b4217ccfa1db06c9$export$18cf36ed71d733e7);
$parcel$export(module.exports, "supportsNativeFetch", () => $b4217ccfa1db06c9$export$c82d238e23c40b21);

var $fUFQt = parcelRequire("fUFQt");

var $6lJZW = parcelRequire("6lJZW");

var $aFn2S = parcelRequire("aFn2S");
// eslint-disable-next-line deprecation/deprecation
const $b4217ccfa1db06c9$var$WINDOW = (0, $aFn2S.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $b4217ccfa1db06c9$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $b4217ccfa1db06c9$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-expect-error It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $b4217ccfa1db06c9$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $b4217ccfa1db06c9$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $b4217ccfa1db06c9$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $b4217ccfa1db06c9$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $b4217ccfa1db06c9$export$c82d238e23c40b21() {
    if (typeof EdgeRuntime === 'string') return true;
    if (!$b4217ccfa1db06c9$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($b4217ccfa1db06c9$export$18cf36ed71d733e7($b4217ccfa1db06c9$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $b4217ccfa1db06c9$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $b4217ccfa1db06c9$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (0, $fUFQt.DEBUG_BUILD) && (0, $6lJZW.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $b4217ccfa1db06c9$export$531055a6c684a70a() {
    return 'ReportingObserver' in $b4217ccfa1db06c9$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $b4217ccfa1db06c9$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$b4217ccfa1db06c9$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("lt7A0", function(module, exports) {
$parcel$export(module.exports, "BrowserClient", () => $fa122f98ec465c81$export$1df9218a526d318d);

var $2XwhW = parcelRequire("2XwhW");
var $1NMDh = parcelRequire("1NMDh");

var $fF6rH = parcelRequire("fF6rH");
var $cLBIh = parcelRequire("cLBIh");
var $bUvh9 = parcelRequire("bUvh9");
var $6lJZW = parcelRequire("6lJZW");

var $bl0Xy = parcelRequire("bl0Xy");

var $iRG6Q = parcelRequire("iRG6Q");

var $3FkMI = parcelRequire("3FkMI");

var $6377k = parcelRequire("6377k");
/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */ /**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */ class $fa122f98ec465c81$export$1df9218a526d318d extends (0, $1NMDh.BaseClient) {
    /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */ constructor(options){
        const sdkSource = (0, $3FkMI.WINDOW).SENTRY_SDK_SOURCE || (0, $bUvh9.getSDKSource)();
        (0, $2XwhW.applySdkMetadata)(options, 'browser', [
            'browser'
        ], sdkSource);
        super(options);
        if (options.sendClientReports && (0, $3FkMI.WINDOW).document) (0, $3FkMI.WINDOW).document.addEventListener('visibilitychange', ()=>{
            if ((0, $3FkMI.WINDOW).document.visibilityState === 'hidden') this._flushOutcomes();
        });
    }
    /**
   * @inheritDoc
   */ eventFromException(exception, hint) {
        return (0, $iRG6Q.eventFromException)(this._options.stackParser, exception, hint, this._options.attachStacktrace);
    }
    /**
   * @inheritDoc
   */ eventFromMessage(message, // eslint-disable-next-line deprecation/deprecation
    level = 'info', hint) {
        return (0, $iRG6Q.eventFromMessage)(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
    }
    /**
   * Sends user feedback to Sentry.
   */ captureUserFeedback(feedback) {
        if (!this._isEnabled()) {
            (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).warn('SDK not enabled, will not capture user feedback.');
            return;
        }
        const envelope = (0, $6377k.createUserFeedbackEnvelope)(feedback, {
            metadata: this.getSdkMetadata(),
            dsn: this.getDsn(),
            tunnel: this.getOptions().tunnel
        });
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
    /**
   * @inheritDoc
   */ _prepareEvent(event, hint, scope) {
        event.platform = event.platform || 'javascript';
        return super._prepareEvent(event, hint, scope);
    }
    /**
   * Sends client reports as an envelope.
   */ _flushOutcomes() {
        const outcomes = this._clearOutcomes();
        if (outcomes.length === 0) {
            (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).log('No outcomes to send');
            return;
        }
        // This is really the only place where we want to check for a DSN and only send outcomes then
        if (!this._dsn) {
            (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).log('No dsn provided, will not send outcomes');
            return;
        }
        (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).log('Sending outcomes:', outcomes);
        const envelope = (0, $fF6rH.createClientReportEnvelope)(outcomes, this._options.tunnel && (0, $cLBIh.dsnToString)(this._dsn));
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(envelope);
    }
}

});
parcelRegister("2XwhW", function(module, exports) {
$parcel$export(module.exports, "applySdkMetadata", () => $227a233ba412a14a$export$b9f95b027256052c);

var $7IBdF = parcelRequire("7IBdF");
/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 *
 * Note: This function is identical to `buildMetadata` in Remix and NextJS and SvelteKit.
 * We don't extract it for bundle size reasons.
 * @see https://github.com/getsentry/sentry-javascript/pull/7404
 * @see https://github.com/getsentry/sentry-javascript/pull/4196
 *
 * If you make changes to this function consider updating the others as well.
 *
 * @param options SDK options object that gets mutated
 * @param names list of package names
 */ function $227a233ba412a14a$export$b9f95b027256052c(options, name, names = [
    name
], source = 'npm') {
    const metadata = options._metadata || {};
    if (!metadata.sdk) metadata.sdk = {
        name: `sentry.javascript.${name}`,
        packages: names.map((name)=>({
                name: `${source}:@sentry/${name}`,
                version: (0, $7IBdF.SDK_VERSION)
            })),
        version: (0, $7IBdF.SDK_VERSION)
    };
    options._metadata = metadata;
}

});

parcelRegister("1NMDh", function(module, exports) {
$parcel$export(module.exports, "BaseClient", () => $15001778090acaba$export$4f22f74eddb7716a);

var $9CzI9 = parcelRequire("9CzI9");
var $kgI9H = parcelRequire("kgI9H");
var $2Jaqc = parcelRequire("2Jaqc");
var $6lJZW = parcelRequire("6lJZW");
var $cLBIh = parcelRequire("cLBIh");
var $dtmqq = parcelRequire("dtmqq");
var $lxc2k = parcelRequire("lxc2k");

var $71uQM = parcelRequire("71uQM");

var $fZ2r3 = parcelRequire("fZ2r3");

var $i0zSS = parcelRequire("i0zSS");

var $3vr70 = parcelRequire("3vr70");

var $kINbm = parcelRequire("kINbm");

var $8WCUT = parcelRequire("8WCUT");

var $9Ji56 = parcelRequire("9Ji56");

var $bHHGA = parcelRequire("bHHGA");

var $13IdK = parcelRequire("13IdK");

var $2biSp = parcelRequire("2biSp");
const $15001778090acaba$var$ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */ class $15001778090acaba$export$4f22f74eddb7716a {
    /**
   * A reference to a metrics aggregator
   *
   * @experimental Note this is alpha API. It may experience breaking changes in the future.
   */ /** Options passed to the SDK. */ /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */ /** Array of set up integrations. */ /** Indicates whether this client's integrations have been set up. */ /** Number of calls being processed */ /** Holds flushable  */ // eslint-disable-next-line @typescript-eslint/ban-types
    /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */ constructor(options){
        this._options = options;
        this._integrations = {};
        this._integrationsInitialized = false;
        this._numProcessing = 0;
        this._outcomes = {};
        this._hooks = {};
        this._eventProcessors = [];
        if (options.dsn) this._dsn = (0, $cLBIh.makeDsn)(options.dsn);
        else (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn('No DSN provided, client will not send events.');
        if (this._dsn) {
            const url = (0, $71uQM.getEnvelopeEndpointWithUrlEncodedAuth)(this._dsn, options);
            this._transport = options.transport({
                tunnel: this._options.tunnel,
                recordDroppedEvent: this.recordDroppedEvent.bind(this),
                ...options.transportOptions,
                url: url
            });
        }
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    captureException(exception, hint, scope) {
        // ensure we haven't captured this very object before
        if ((0, $kgI9H.checkOrSetAlreadyCaught)(exception)) {
            (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).log($15001778090acaba$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        this._process(this.eventFromException(exception, hint).then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint, scope) {
        let eventId = hint && hint.event_id;
        const eventMessage = (0, $2Jaqc.isParameterizedString)(message) ? message : String(message);
        const promisedEvent = (0, $2Jaqc.isPrimitive)(message) ? this.eventFromMessage(eventMessage, level, hint) : this.eventFromException(message, hint);
        this._process(promisedEvent.then((event)=>this._captureEvent(event, hint, scope)).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && (0, $kgI9H.checkOrSetAlreadyCaught)(hint.originalException)) {
            (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).log($15001778090acaba$var$ALREADY_SEEN_ERROR);
            return;
        }
        let eventId = hint && hint.event_id;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanScope = sdkProcessingMetadata.capturedSpanScope;
        this._process(this._captureEvent(event, hint, capturedSpanScope || scope).then((result)=>{
            eventId = result;
        }));
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureSession(session) {
        if (!(typeof session.release === 'string')) (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn('Discarded session because of missing or non-string release');
        else {
            this.sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            (0, $bHHGA.updateSession)(session, {
                init: false
            });
        }
    }
    /**
   * @inheritDoc
   */ getDsn() {
        return this._dsn;
    }
    /**
   * @inheritDoc
   */ getOptions() {
        return this._options;
    }
    /**
   * @see SdkMetadata in @sentry/types
   *
   * @return The metadata of the SDK
   */ getSdkMetadata() {
        return this._options._metadata;
    }
    /**
   * @inheritDoc
   */ getTransport() {
        return this._transport;
    }
    /**
   * @inheritDoc
   */ flush(timeout) {
        const transport = this._transport;
        if (transport) {
            if (this.metricsAggregator) this.metricsAggregator.flush();
            return this._isClientDoneProcessing(timeout).then((clientFinished)=>{
                return transport.flush(timeout).then((transportFlushed)=>clientFinished && transportFlushed);
            });
        } else return (0, $dtmqq.resolvedSyncPromise)(true);
    }
    /**
   * @inheritDoc
   */ close(timeout) {
        return this.flush(timeout).then((result)=>{
            this.getOptions().enabled = false;
            if (this.metricsAggregator) this.metricsAggregator.close();
            return result;
        });
    }
    /** Get all installed event processors. */ getEventProcessors() {
        return this._eventProcessors;
    }
    /** @inheritDoc */ addEventProcessor(eventProcessor) {
        this._eventProcessors.push(eventProcessor);
    }
    /**
   * This is an internal function to setup all integrations that should run on the client.
   * @deprecated Use `client.init()` instead.
   */ setupIntegrations(forceInitialize) {
        if (forceInitialize && !this._integrationsInitialized || this._isEnabled() && !this._integrationsInitialized) this._setupIntegrations();
    }
    /** @inheritdoc */ init() {
        if (this._isEnabled()) this._setupIntegrations();
    }
    /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegrationById(integrationId) {
        return this.getIntegrationByName(integrationId);
    }
    /**
   * Gets an installed integration by its name.
   *
   * @returns The installed integration or `undefined` if no integration with that `name` was installed.
   */ getIntegrationByName(integrationName) {
        return this._integrations[integrationName];
    }
    /**
   * Returns the client's instance of the given integration class, it any.
   * @deprecated Use `getIntegrationByName()` instead.
   */ getIntegration(integration) {
        try {
            return this._integrations[integration.id] || null;
        } catch (_oO) {
            (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn(`Cannot retrieve integration ${integration.id} from the current Client`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ addIntegration(integration) {
        const isAlreadyInstalled = this._integrations[integration.name];
        // This hook takes care of only installing if not already installed
        (0, $8WCUT.setupIntegration)(this, integration, this._integrations);
        // Here we need to check manually to make sure to not run this multiple times
        if (!isAlreadyInstalled) (0, $8WCUT.afterSetupIntegrations)(this, [
            integration
        ]);
    }
    /**
   * @inheritDoc
   */ sendEvent(event, hint = {}) {
        this.emit('beforeSendEvent', event, hint);
        let env = (0, $i0zSS.createEventEnvelope)(event, this._dsn, this._options._metadata, this._options.tunnel);
        for (const attachment of hint.attachments || [])env = (0, $9CzI9.addItemToEnvelope)(env, (0, $9CzI9.createAttachmentEnvelopeItem)(attachment, this._options.transportOptions && this._options.transportOptions.textEncoder));
        const promise = this._sendEnvelope(env);
        if (promise) promise.then((sendResponse)=>this.emit('afterSendEvent', event, sendResponse), null);
    }
    /**
   * @inheritDoc
   */ sendSession(session) {
        const env = (0, $i0zSS.createSessionEnvelope)(session, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(env);
    }
    /**
   * @inheritDoc
   */ recordDroppedEvent(reason, category, eventOrCount) {
        if (this._options.sendClientReports) {
            // TODO v9: We do not need the `event` passed as third argument anymore, and can possibly remove this overload
            // If event is passed as third argument, we assume this is a count of 1
            const count = typeof eventOrCount === 'number' ? eventOrCount : 1;
            // We want to track each category (error, transaction, session, replay_event) separately
            // but still keep the distinction between different type of outcomes.
            // We could use nested maps, but it's much easier to read and type this way.
            // A correct type for map-based implementation if we want to go that route
            // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
            // With typescript 4.1 we could even use template literal types
            const key = `${reason}:${category}`;
            (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).log(`Recording outcome: "${key}"${count > 1 ? ` (${count} times)` : ''}`);
            this._outcomes[key] = (this._outcomes[key] || 0) + count;
        }
    }
    /**
   * @inheritDoc
   */ captureAggregateMetrics(metricBucketItems) {
        (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).log(`Flushing aggregated metrics, number of metrics: ${metricBucketItems.length}`);
        const metricsEnvelope = (0, $9Ji56.createMetricEnvelope)(metricBucketItems, this._dsn, this._options._metadata, this._options.tunnel);
        // _sendEnvelope should not throw
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        this._sendEnvelope(metricsEnvelope);
    }
    // Keep on() & emit() signatures in sync with types' client.ts interface
    /* eslint-disable @typescript-eslint/unified-signatures */ /** @inheritdoc */ /** @inheritdoc */ on(hook, callback) {
        if (!this._hooks[hook]) this._hooks[hook] = [];
        // @ts-expect-error We assue the types are correct
        this._hooks[hook].push(callback);
    }
    /** @inheritdoc */ /** @inheritdoc */ emit(hook, ...rest) {
        if (this._hooks[hook]) this._hooks[hook].forEach((callback)=>callback(...rest));
    }
    /* eslint-enable @typescript-eslint/unified-signatures */ /** Setup integrations for this client. */ _setupIntegrations() {
        const { integrations: integrations } = this._options;
        this._integrations = (0, $8WCUT.setupIntegrations)(this, integrations);
        (0, $8WCUT.afterSetupIntegrations)(this, integrations);
        // TODO v8: We don't need this flag anymore
        this._integrationsInitialized = true;
    }
    /** Updates existing session based on the provided event */ _updateSessionFromEvent(session, event) {
        let crashed = false;
        let errored = false;
        const exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            for (const ex of exceptions){
                const mechanism = ex.mechanism;
                if (mechanism && mechanism.handled === false) {
                    crashed = true;
                    break;
                }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        const sessionNonTerminal = session.status === 'ok';
        const shouldUpdateAndSend = sessionNonTerminal && session.errors === 0 || sessionNonTerminal && crashed;
        if (shouldUpdateAndSend) {
            (0, $bHHGA.updateSession)(session, {
                ...crashed && {
                    status: 'crashed'
                },
                errors: session.errors || Number(errored || crashed)
            });
            this.captureSession(session);
        }
    }
    /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */ _isClientDoneProcessing(timeout) {
        return new (0, $dtmqq.SyncPromise)((resolve)=>{
            let ticked = 0;
            const tick = 1;
            const interval = setInterval(()=>{
                if (this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                } else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    }
    /** Determines whether this SDK is enabled and a transport is present. */ _isEnabled() {
        return this.getOptions().enabled !== false && this._transport !== undefined;
    }
    /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */ _prepareEvent(event, hint, scope, isolationScope = (0, $kINbm.getIsolationScope)()) {
        const options = this.getOptions();
        const integrations = Object.keys(this._integrations);
        if (!hint.integrations && integrations.length > 0) hint.integrations = integrations;
        this.emit('preprocessEvent', event, hint);
        return (0, $2biSp.prepareEvent)(options, event, hint, scope, this, isolationScope).then((evt)=>{
            if (evt === null) return evt;
            const propagationContext = {
                ...isolationScope.getPropagationContext(),
                ...scope ? scope.getPropagationContext() : undefined
            };
            const trace = evt.contexts && evt.contexts.trace;
            if (!trace && propagationContext) {
                const { traceId: trace_id, spanId: spanId, parentSpanId: parentSpanId, dsc: dsc } = propagationContext;
                evt.contexts = {
                    trace: {
                        trace_id: trace_id,
                        span_id: spanId,
                        parent_span_id: parentSpanId
                    },
                    ...evt.contexts
                };
                const dynamicSamplingContext = dsc ? dsc : (0, $13IdK.getDynamicSamplingContextFromClient)(trace_id, this, scope);
                evt.sdkProcessingMetadata = {
                    dynamicSamplingContext: dynamicSamplingContext,
                    ...evt.sdkProcessingMetadata
                };
            }
            return evt;
        });
    }
    /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */ _captureEvent(event, hint = {}, scope) {
        return this._processEvent(event, hint, scope).then((finalEvent)=>{
            return finalEvent.event_id;
        }, (reason)=>{
            if (0, $fZ2r3.DEBUG_BUILD) {
                // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
                // control flow, log just the message (no stack) as a log-level log.
                const sentryError = reason;
                if (sentryError.logLevel === 'log') (0, $6lJZW.logger).log(sentryError.message);
                else (0, $6lJZW.logger).warn(sentryError);
            }
            return undefined;
        });
    }
    /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */ _processEvent(event, hint, scope) {
        const options = this.getOptions();
        const { sampleRate: sampleRate } = options;
        const isTransaction = $15001778090acaba$var$isTransactionEvent(event);
        const isError = $15001778090acaba$var$isErrorEvent(event);
        const eventType = event.type || 'error';
        const beforeSendLabel = `before send for type \`${eventType}\``;
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            this.recordDroppedEvent('sample_rate', 'error', event);
            return (0, $dtmqq.rejectedSyncPromise)(new (0, $lxc2k.SentryError)(`Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`, 'log'));
        }
        const dataCategory = eventType === 'replay_event' ? 'replay' : eventType;
        const sdkProcessingMetadata = event.sdkProcessingMetadata || {};
        const capturedSpanIsolationScope = sdkProcessingMetadata.capturedSpanIsolationScope;
        return this._prepareEvent(event, hint, scope, capturedSpanIsolationScope).then((prepared)=>{
            if (prepared === null) {
                this.recordDroppedEvent('event_processor', dataCategory, event);
                throw new (0, $lxc2k.SentryError)('An event processor returned `null`, will not send event.', 'log');
            }
            const isInternalException = hint.data && hint.data.__sentry__ === true;
            if (isInternalException) return prepared;
            const result = $15001778090acaba$var$processBeforeSend(options, prepared, hint);
            return $15001778090acaba$var$_validateBeforeSendResult(result, beforeSendLabel);
        }).then((processedEvent)=>{
            if (processedEvent === null) {
                this.recordDroppedEvent('before_send', dataCategory, event);
                if (isTransaction) {
                    const spans = event.spans || [];
                    // the transaction itself counts as one span, plus all the child spans that are added
                    const spanCount = 1 + spans.length;
                    this.recordDroppedEvent('before_send', 'span', spanCount);
                }
                throw new (0, $lxc2k.SentryError)(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
            }
            const session = scope && scope.getSession();
            if (!isTransaction && session) this._updateSessionFromEvent(session, processedEvent);
            if (isTransaction) {
                const spanCountBefore = processedEvent.sdkProcessingMetadata && processedEvent.sdkProcessingMetadata.spanCountBeforeProcessing || 0;
                const spanCountAfter = processedEvent.spans ? processedEvent.spans.length : 0;
                const droppedSpanCount = spanCountBefore - spanCountAfter;
                if (droppedSpanCount > 0) this.recordDroppedEvent('before_send', 'span', droppedSpanCount);
            }
            // None of the Sentry built event processor will update transaction name,
            // so if the transaction name has been changed by an event processor, we know
            // it has to come from custom event processor added by a user
            const transactionInfo = processedEvent.transaction_info;
            if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
                const source = 'custom';
                processedEvent.transaction_info = {
                    ...transactionInfo,
                    source: source
                };
            }
            this.sendEvent(processedEvent, hint);
            return processedEvent;
        }).then(null, (reason)=>{
            if (reason instanceof (0, $lxc2k.SentryError)) throw reason;
            this.captureException(reason, {
                data: {
                    __sentry__: true
                },
                originalException: reason
            });
            throw new (0, $lxc2k.SentryError)(`Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`);
        });
    }
    /**
   * Occupies the client with processing and event
   */ _process(promise) {
        this._numProcessing++;
        promise.then((value)=>{
            this._numProcessing--;
            return value;
        }, (reason)=>{
            this._numProcessing--;
            return reason;
        });
    }
    /**
   * @inheritdoc
   */ _sendEnvelope(envelope) {
        this.emit('beforeEnvelope', envelope);
        if (this._isEnabled() && this._transport) return this._transport.send(envelope).then(null, (reason)=>{
            (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).error('Error while sending event:', reason);
        });
        else (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).error('Transport disabled');
    }
    /**
   * Clears outcomes on this client and returns them.
   */ _clearOutcomes() {
        const outcomes = this._outcomes;
        this._outcomes = {};
        return Object.keys(outcomes).map((key)=>{
            const [reason, category] = key.split(':');
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key]
            };
        });
    }
}
/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */ function $15001778090acaba$var$_validateBeforeSendResult(beforeSendResult, beforeSendLabel) {
    const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
    if ((0, $2Jaqc.isThenable)(beforeSendResult)) return beforeSendResult.then((event)=>{
        if (!(0, $2Jaqc.isPlainObject)(event) && event !== null) throw new (0, $lxc2k.SentryError)(invalidValueError);
        return event;
    }, (e)=>{
        throw new (0, $lxc2k.SentryError)(`${beforeSendLabel} rejected with ${e}`);
    });
    else if (!(0, $2Jaqc.isPlainObject)(beforeSendResult) && beforeSendResult !== null) throw new (0, $lxc2k.SentryError)(invalidValueError);
    return beforeSendResult;
}
/**
 * Process the matching `beforeSendXXX` callback.
 */ function $15001778090acaba$var$processBeforeSend(options, event, hint) {
    const { beforeSend: beforeSend, beforeSendTransaction: beforeSendTransaction } = options;
    if ($15001778090acaba$var$isErrorEvent(event) && beforeSend) return beforeSend(event, hint);
    if ($15001778090acaba$var$isTransactionEvent(event) && beforeSendTransaction) {
        if (event.spans) {
            // We store the # of spans before processing in SDK metadata,
            // so we can compare it afterwards to determine how many spans were dropped
            const spanCountBefore = event.spans.length;
            event.sdkProcessingMetadata = {
                ...event.sdkProcessingMetadata,
                spanCountBeforeProcessing: spanCountBefore
            };
        }
        return beforeSendTransaction(event, hint);
    }
    return event;
}
function $15001778090acaba$var$isErrorEvent(event) {
    return event.type === undefined;
}
function $15001778090acaba$var$isTransactionEvent(event) {
    return event.type === 'transaction';
}
/**
 * Add an event processor to the current client.
 * This event processor will run for all events processed by this client.
 */ function $15001778090acaba$export$9aac0b9f77928fbf(callback) {
    const client = (0, $3vr70.getClient)();
    if (!client || !client.addEventProcessor) return;
    client.addEventProcessor(callback);
}

});
parcelRegister("9CzI9", function(module, exports) {
$parcel$export(module.exports, "createEnvelope", () => $70135d2a181505db$export$f93f7f385160c44e);
$parcel$export(module.exports, "addItemToEnvelope", () => $70135d2a181505db$export$d650323442802f6f);
$parcel$export(module.exports, "forEachEnvelopeItem", () => $70135d2a181505db$export$c56c55acf0136fd3);
$parcel$export(module.exports, "serializeEnvelope", () => $70135d2a181505db$export$32f9b428425aac85);
$parcel$export(module.exports, "createAttachmentEnvelopeItem", () => $70135d2a181505db$export$d8fc80952cc31fa4);
$parcel$export(module.exports, "envelopeItemTypeToDataCategory", () => $70135d2a181505db$export$b11169581eeaf237);
$parcel$export(module.exports, "getSdkMetadataForEnvelopeHeader", () => $70135d2a181505db$export$d369f3b2758f6743);
$parcel$export(module.exports, "createEventEnvelopeHeaders", () => $70135d2a181505db$export$92b6093782fe661b);

var $cLBIh = parcelRequire("cLBIh");

var $9ZmTE = parcelRequire("9ZmTE");

var $3dFJR = parcelRequire("3dFJR");
/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $70135d2a181505db$export$f93f7f385160c44e(headers, items = []) {
    return [
        headers,
        items
    ];
}
/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */ function $70135d2a181505db$export$d650323442802f6f(envelope, newItem) {
    const [headers, items] = envelope;
    return [
        headers,
        [
            ...items,
            newItem
        ]
    ];
}
/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 *
 * If the callback returns true, the rest of the items will be skipped.
 */ function $70135d2a181505db$export$c56c55acf0136fd3(envelope, callback) {
    const envelopeItems = envelope[1];
    for (const envelopeItem of envelopeItems){
        const envelopeItemType = envelopeItem[0].type;
        const result = callback(envelopeItem, envelopeItemType);
        if (result) return true;
    }
    return false;
}
/**
 * Returns true if the envelope contains any of the given envelope item types
 */ function $70135d2a181505db$export$604a45d95a155e2b(envelope, types) {
    return $70135d2a181505db$export$c56c55acf0136fd3(envelope, (_, type)=>types.includes(type));
}
/**
 * Encode a string to UTF8.
 */ function $70135d2a181505db$var$encodeUTF8(input, textEncoder) {
    const utf8 = textEncoder || new TextEncoder();
    return utf8.encode(input);
}
/**
 * Serializes an envelope.
 */ function $70135d2a181505db$export$32f9b428425aac85(envelope, textEncoder) {
    const [envHeaders, items] = envelope;
    // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
    let parts = JSON.stringify(envHeaders);
    function append(next) {
        if (typeof parts === 'string') parts = typeof next === 'string' ? parts + next : [
            $70135d2a181505db$var$encodeUTF8(parts, textEncoder),
            next
        ];
        else parts.push(typeof next === 'string' ? $70135d2a181505db$var$encodeUTF8(next, textEncoder) : next);
    }
    for (const item of items){
        const [itemHeaders, payload] = item;
        append(`\n${JSON.stringify(itemHeaders)}\n`);
        if (typeof payload === 'string' || payload instanceof Uint8Array) append(payload);
        else {
            let stringifiedPayload;
            try {
                stringifiedPayload = JSON.stringify(payload);
            } catch (e) {
                // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
                // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
                // performance impact but in this case a performance hit is better than throwing.
                stringifiedPayload = JSON.stringify((0, $9ZmTE.normalize)(payload));
            }
            append(stringifiedPayload);
        }
    }
    return typeof parts === 'string' ? parts : $70135d2a181505db$var$concatBuffers(parts);
}
function $70135d2a181505db$var$concatBuffers(buffers) {
    const totalLength = buffers.reduce((acc, buf)=>acc + buf.length, 0);
    const merged = new Uint8Array(totalLength);
    let offset = 0;
    for (const buffer of buffers){
        merged.set(buffer, offset);
        offset += buffer.length;
    }
    return merged;
}
/**
 * Parses an envelope
 */ function $70135d2a181505db$export$3338d0c7b6e17a2b(env, textEncoder, textDecoder) {
    let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;
    function readBinary(length) {
        const bin = buffer.subarray(0, length);
        // Replace the buffer with the remaining data excluding trailing newline
        buffer = buffer.subarray(length + 1);
        return bin;
    }
    function readJson() {
        let i = buffer.indexOf(0xa);
        // If we couldn't find a newline, we must have found the end of the buffer
        if (i < 0) i = buffer.length;
        return JSON.parse(textDecoder.decode(readBinary(i)));
    }
    const envelopeHeader = readJson();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const items = [];
    while(buffer.length){
        const itemHeader = readJson();
        const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;
        items.push([
            itemHeader,
            binaryLength ? readBinary(binaryLength) : readJson()
        ]);
    }
    return [
        envelopeHeader,
        items
    ];
}
/**
 * Creates attachment envelope items
 */ function $70135d2a181505db$export$d8fc80952cc31fa4(attachment, textEncoder) {
    const buffer = typeof attachment.data === 'string' ? $70135d2a181505db$var$encodeUTF8(attachment.data, textEncoder) : attachment.data;
    return [
        (0, $3dFJR.dropUndefinedKeys)({
            type: 'attachment',
            length: buffer.length,
            filename: attachment.filename,
            content_type: attachment.contentType,
            attachment_type: attachment.attachmentType
        }),
        buffer
    ];
}
const $70135d2a181505db$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
    session: 'session',
    sessions: 'session',
    attachment: 'attachment',
    transaction: 'transaction',
    event: 'error',
    client_report: 'internal',
    user_report: 'default',
    profile: 'profile',
    replay_event: 'replay',
    replay_recording: 'replay',
    check_in: 'monitor',
    feedback: 'feedback',
    span: 'span',
    statsd: 'metric_bucket'
};
/**
 * Maps the type of an envelope item to a data category.
 */ function $70135d2a181505db$export$b11169581eeaf237(type) {
    return $70135d2a181505db$var$ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}
/** Extracts the minimal SDK info from the metadata or an events */ function $70135d2a181505db$export$d369f3b2758f6743(metadataOrEvent) {
    if (!metadataOrEvent || !metadataOrEvent.sdk) return;
    const { name: name, version: version } = metadataOrEvent.sdk;
    return {
        name: name,
        version: version
    };
}
/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */ function $70135d2a181505db$export$92b6093782fe661b(event, sdkInfo, tunnel, dsn) {
    const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;
    return {
        event_id: event.event_id,
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $cLBIh.dsnToString)(dsn)
        },
        ...dynamicSamplingContext && {
            trace: (0, $3dFJR.dropUndefinedKeys)({
                ...dynamicSamplingContext
            })
        }
    };
}

});

parcelRegister("lxc2k", function(module, exports) {
$parcel$export(module.exports, "SentryError", () => $fad604414083c48c$export$5949942ba2a7c0e2);
/** An error emitted by Sentry SDKs and related utilities. */ class $fad604414083c48c$export$5949942ba2a7c0e2 extends Error {
    /** Display name of this error instance. */ constructor(message, logLevel = 'warn'){
        super(message);
        this.message = message;
        this.name = new.target.prototype.constructor.name;
        // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
        // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
        // instances of `SentryError` fail `obj instanceof SentryError` checks.
        Object.setPrototypeOf(this, new.target.prototype);
        this.logLevel = logLevel;
    }
}

});

parcelRegister("i0zSS", function(module, exports) {
$parcel$export(module.exports, "createSessionEnvelope", () => $d1c40fee9e218d65$export$124b03c077baa2f3);
$parcel$export(module.exports, "createEventEnvelope", () => $d1c40fee9e218d65$export$c31057337a18010f);

var $9CzI9 = parcelRequire("9CzI9");
var $cLBIh = parcelRequire("cLBIh");
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/ function $d1c40fee9e218d65$var$enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) return event;
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = [
        ...event.sdk.integrations || [],
        ...sdkInfo.integrations || []
    ];
    event.sdk.packages = [
        ...event.sdk.packages || [],
        ...sdkInfo.packages || []
    ];
    return event;
}
/** Creates an envelope from a Session */ function $d1c40fee9e218d65$export$124b03c077baa2f3(session, dsn, metadata, tunnel) {
    const sdkInfo = (0, $9CzI9.getSdkMetadataForEnvelopeHeader)(metadata);
    const envelopeHeaders = {
        sent_at: new Date().toISOString(),
        ...sdkInfo && {
            sdk: sdkInfo
        },
        ...!!tunnel && dsn && {
            dsn: (0, $cLBIh.dsnToString)(dsn)
        }
    };
    const envelopeItem = 'aggregates' in session ? [
        {
            type: 'sessions'
        },
        session
    ] : [
        {
            type: 'session'
        },
        session.toJSON()
    ];
    return (0, $9CzI9.createEnvelope)(envelopeHeaders, [
        envelopeItem
    ]);
}
/**
 * Create an Envelope from an event.
 */ function $d1c40fee9e218d65$export$c31057337a18010f(event, dsn, metadata, tunnel) {
    const sdkInfo = (0, $9CzI9.getSdkMetadataForEnvelopeHeader)(metadata);
    /*
    Note: Due to TS, event.type may be `replay_event`, theoretically.
    In practice, we never call `createEventEnvelope` with `replay_event` type,
    and we'd have to adjut a looot of types to make this work properly.
    We want to avoid casting this around, as that could lead to bugs (e.g. when we add another type)
    So the safe choice is to really guard against the replay_event type here.
  */ const eventType = event.type && event.type !== 'replay_event' ? event.type : 'event';
    $d1c40fee9e218d65$var$enhanceEventWithSdkInfo(event, metadata && metadata.sdk);
    const envelopeHeaders = (0, $9CzI9.createEventEnvelopeHeaders)(event, sdkInfo, tunnel, dsn);
    // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
    // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
    // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
    // of this `delete`, lest we miss putting it back in the next time the property is in use.)
    delete event.sdkProcessingMetadata;
    const eventItem = [
        {
            type: eventType
        },
        event
    ];
    return (0, $9CzI9.createEnvelope)(envelopeHeaders, [
        eventItem
    ]);
}

});

parcelRegister("9Ji56", function(module, exports) {
$parcel$export(module.exports, "createMetricEnvelope", () => $71565792f3185651$export$f23eb96e33154901);

var $9CzI9 = parcelRequire("9CzI9");
var $cLBIh = parcelRequire("cLBIh");

var $8bqGQ = parcelRequire("8bqGQ");
/**
 * Create envelope from a metric aggregate.
 */ function $71565792f3185651$export$f23eb96e33154901(metricBucketItems, dsn, metadata, tunnel) {
    const headers = {
        sent_at: new Date().toISOString()
    };
    if (metadata && metadata.sdk) headers.sdk = {
        name: metadata.sdk.name,
        version: metadata.sdk.version
    };
    if (!!tunnel && dsn) headers.dsn = (0, $cLBIh.dsnToString)(dsn);
    const item = $71565792f3185651$var$createMetricEnvelopeItem(metricBucketItems);
    return (0, $9CzI9.createEnvelope)(headers, [
        item
    ]);
}
function $71565792f3185651$var$createMetricEnvelopeItem(metricBucketItems) {
    const payload = (0, $8bqGQ.serializeMetricBuckets)(metricBucketItems);
    const metricHeaders = {
        type: 'statsd',
        length: payload.length
    };
    return [
        metricHeaders,
        payload
    ];
}

});
parcelRegister("8bqGQ", function(module, exports) {
$parcel$export(module.exports, "serializeMetricBuckets", () => $5f540de4b57d4567$export$66decd709db01dc8);

var $3dFJR = parcelRequire("3dFJR");
/**
 * Generate bucket key from metric properties.
 */ function $5f540de4b57d4567$export$b8bd8c4dffa5aa2d(metricType, name, unit, tags) {
    const stringifiedTags = Object.entries((0, $3dFJR.dropUndefinedKeys)(tags)).sort((a, b)=>a[0].localeCompare(b[0]));
    return `${metricType}${name}${unit}${stringifiedTags}`;
}
/* eslint-disable no-bitwise */ /**
 * Simple hash function for strings.
 */ function $5f540de4b57d4567$export$b211ce59c0ea1cfb(s) {
    let rv = 0;
    for(let i = 0; i < s.length; i++){
        const c = s.charCodeAt(i);
        rv = (rv << 5) - rv + c;
        rv &= rv;
    }
    return rv >>> 0;
}
/* eslint-enable no-bitwise */ /**
 * Serialize metrics buckets into a string based on statsd format.
 *
 * Example of format:
 * metric.name@second:1:1.2|d|#a:value,b:anothervalue|T12345677
 * Segments:
 * name: metric.name
 * unit: second
 * value: [1, 1.2]
 * type of metric: d (distribution)
 * tags: { a: value, b: anothervalue }
 * timestamp: 12345677
 */ function $5f540de4b57d4567$export$66decd709db01dc8(metricBucketItems) {
    let out = '';
    for (const item of metricBucketItems){
        const tagEntries = Object.entries(item.tags);
        const maybeTags = tagEntries.length > 0 ? `|#${tagEntries.map(([key, value])=>`${key}:${value}`).join(',')}` : '';
        out += `${item.name}@${item.unit}:${item.metric}|${item.metricType}${maybeTags}|T${item.timestamp}\n`;
    }
    return out;
}
/** Sanitizes units */ function $5f540de4b57d4567$export$2d8c9911396bbf5f(unit) {
    return unit.replace(/[^\w]+/gi, '_');
}
/** Sanitizes metric keys */ function $5f540de4b57d4567$export$d3b3167f2ebbcecc(key) {
    return key.replace(/[^\w\-.]+/gi, '_');
}
function $5f540de4b57d4567$var$sanitizeTagKey(key) {
    return key.replace(/[^\w\-./]+/gi, '');
}
const $5f540de4b57d4567$var$tagValueReplacements = [
    [
        '\n',
        '\\n'
    ],
    [
        '\r',
        '\\r'
    ],
    [
        '\t',
        '\\t'
    ],
    [
        '\\',
        '\\\\'
    ],
    [
        '|',
        '\\u{7c}'
    ],
    [
        ',',
        '\\u{2c}'
    ]
];
function $5f540de4b57d4567$var$getCharOrReplacement(input) {
    for (const [search, replacement] of $5f540de4b57d4567$var$tagValueReplacements){
        if (input === search) return replacement;
    }
    return input;
}
function $5f540de4b57d4567$var$sanitizeTagValue(value) {
    return [
        ...value
    ].reduce((acc, char)=>acc + $5f540de4b57d4567$var$getCharOrReplacement(char), '');
}
/**
 * Sanitizes tags.
 */ function $5f540de4b57d4567$export$ae49af12dbdf2477(unsanitizedTags) {
    const tags = {};
    for(const key in unsanitizedTags)if (Object.prototype.hasOwnProperty.call(unsanitizedTags, key)) {
        const sanitizedKey = $5f540de4b57d4567$var$sanitizeTagKey(key);
        tags[sanitizedKey] = $5f540de4b57d4567$var$sanitizeTagValue(String(unsanitizedTags[key]));
    }
    return tags;
}

});



parcelRegister("fF6rH", function(module, exports) {
$parcel$export(module.exports, "createClientReportEnvelope", () => $b66faf559e07f01b$export$f3b9ed77c03eeb00);

var $9CzI9 = parcelRequire("9CzI9");

var $gv1sw = parcelRequire("gv1sw");
/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */ function $b66faf559e07f01b$export$f3b9ed77c03eeb00(discarded_events, dsn, timestamp) {
    const clientReportItem = [
        {
            type: 'client_report'
        },
        {
            timestamp: timestamp || (0, $gv1sw.dateTimestampInSeconds)(),
            discarded_events: discarded_events
        }
    ];
    return (0, $9CzI9.createEnvelope)(dsn ? {
        dsn: dsn
    } : {}, [
        clientReportItem
    ]);
}

});

parcelRegister("bUvh9", function(module, exports) {
$parcel$export(module.exports, "getSDKSource", () => $8abd2f5c9e8bf9fd$export$8ad33f488b1ab046);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $8abd2f5c9e8bf9fd$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $8abd2f5c9e8bf9fd$export$8ad33f488b1ab046() {
    // @ts-expect-error "npm" is injected by rollup during build process
    return "npm";
}

});

parcelRegister("bl0Xy", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $0221543b93b3d1f1$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $0221543b93b3d1f1$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("iRG6Q", function(module, exports) {
$parcel$export(module.exports, "exceptionFromError", () => $dbbdd74e32b77fa2$export$a6c2d27607295951);
$parcel$export(module.exports, "eventFromException", () => $dbbdd74e32b77fa2$export$ea3ec7e569b823fc);
$parcel$export(module.exports, "eventFromUnknownInput", () => $dbbdd74e32b77fa2$export$9dd56ed1ef0c3420);
$parcel$export(module.exports, "eventFromMessage", () => $dbbdd74e32b77fa2$export$5425b53185d13d6c);

var $3vr70 = parcelRequire("3vr70");

var $kgI9H = parcelRequire("kgI9H");
var $3dFJR = parcelRequire("3dFJR");
var $2Jaqc = parcelRequire("2Jaqc");
var $9ZmTE = parcelRequire("9ZmTE");
var $dtmqq = parcelRequire("dtmqq");
/**
 * This function creates an exception from a JavaScript Error
 */ function $dbbdd74e32b77fa2$export$a6c2d27607295951(stackParser, ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    const frames = $dbbdd74e32b77fa2$export$d478b2c12fbcfdda(stackParser, ex);
    const exception = {
        type: ex && ex.name,
        value: $dbbdd74e32b77fa2$var$extractMessage(ex)
    };
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    if (exception.type === undefined && exception.value === '') exception.value = 'Unrecoverable error caught';
    return exception;
}
/**
 * @hidden
 */ function $dbbdd74e32b77fa2$export$a6a5dd73e489caf(stackParser, exception, syntheticException, isUnhandledRejection) {
    const client = (0, $3vr70.getClient)();
    const normalizeDepth = client && client.getOptions().normalizeDepth;
    const event = {
        exception: {
            values: [
                {
                    type: (0, $2Jaqc.isEvent)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: $dbbdd74e32b77fa2$var$getNonErrorObjectExceptionValue(exception, {
                        isUnhandledRejection: isUnhandledRejection
                    })
                }
            ]
        },
        extra: {
            __serialized__: (0, $9ZmTE.normalizeToSize)(exception, normalizeDepth)
        }
    };
    if (syntheticException) {
        const frames = $dbbdd74e32b77fa2$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) // event.exception.values[0] has been set above
        event.exception.values[0].stacktrace = {
            frames: frames
        };
    }
    return event;
}
/**
 * @hidden
 */ function $dbbdd74e32b77fa2$export$73fbea5a0a5234af(stackParser, ex) {
    return {
        exception: {
            values: [
                $dbbdd74e32b77fa2$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
}
/** Parses stack frames from an error */ function $dbbdd74e32b77fa2$export$d478b2c12fbcfdda(stackParser, ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    const stacktrace = ex.stacktrace || ex.stack || '';
    const popSize = $dbbdd74e32b77fa2$var$getPopSize(ex);
    try {
        return stackParser(stacktrace, popSize);
    } catch (e) {
    // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const $dbbdd74e32b77fa2$var$reactMinifiedRegexp = /Minified React error #\d+;/i;
function $dbbdd74e32b77fa2$var$getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') return ex.framesToPop;
        if ($dbbdd74e32b77fa2$var$reactMinifiedRegexp.test(ex.message)) return 1;
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */ function $dbbdd74e32b77fa2$var$extractMessage(ex) {
    const message = ex && ex.message;
    if (!message) return 'No error message';
    if (message.error && typeof message.error.message === 'string') return message.error.message;
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */ function $dbbdd74e32b77fa2$export$ea3ec7e569b823fc(stackParser, exception, hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $dbbdd74e32b77fa2$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace);
    (0, $kgI9H.addExceptionMechanism)(event); // defaults to { type: 'generic', handled: true }
    event.level = 'error';
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $dtmqq.resolvedSyncPromise)(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $dbbdd74e32b77fa2$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const syntheticException = hint && hint.syntheticException || undefined;
    const event = $dbbdd74e32b77fa2$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) event.event_id = hint.event_id;
    return (0, $dtmqq.resolvedSyncPromise)(event);
}
/**
 * @hidden
 */ function $dbbdd74e32b77fa2$export$9dd56ed1ef0c3420(stackParser, exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    let event;
    if ((0, $2Jaqc.isErrorEvent)(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        const errorEvent = exception;
        return $dbbdd74e32b77fa2$export$73fbea5a0a5234af(stackParser, errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if ((0, $2Jaqc.isDOMError)(exception) || (0, $2Jaqc.isDOMException)(exception)) {
        const domException = exception;
        if ('stack' in exception) event = $dbbdd74e32b77fa2$export$73fbea5a0a5234af(stackParser, exception);
        else {
            const name = domException.name || ((0, $2Jaqc.isDOMError)(domException) ? 'DOMError' : 'DOMException');
            const message = domException.message ? `${name}: ${domException.message}` : name;
            event = $dbbdd74e32b77fa2$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace);
            (0, $kgI9H.addExceptionTypeValue)(event, message);
        }
        if ('code' in domException) // eslint-disable-next-line deprecation/deprecation
        event.tags = {
            ...event.tags,
            'DOMException.code': `${domException.code}`
        };
        return event;
    }
    if ((0, $2Jaqc.isError)(exception)) // we have a real Error object, do nothing
    return $dbbdd74e32b77fa2$export$73fbea5a0a5234af(stackParser, exception);
    if ((0, $2Jaqc.isPlainObject)(exception) || (0, $2Jaqc.isEvent)(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        const objectException = exception;
        event = $dbbdd74e32b77fa2$export$a6a5dd73e489caf(stackParser, objectException, syntheticException, isUnhandledRejection);
        (0, $kgI9H.addExceptionMechanism)(event, {
            synthetic: true
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = $dbbdd74e32b77fa2$export$47d86ae4b3c9994(stackParser, exception, syntheticException, attachStacktrace);
    (0, $kgI9H.addExceptionTypeValue)(event, `${exception}`, undefined);
    (0, $kgI9H.addExceptionMechanism)(event, {
        synthetic: true
    });
    return event;
}
/**
 * @hidden
 */ function $dbbdd74e32b77fa2$export$47d86ae4b3c9994(stackParser, message, syntheticException, attachStacktrace) {
    const event = {};
    if (attachStacktrace && syntheticException) {
        const frames = $dbbdd74e32b77fa2$export$d478b2c12fbcfdda(stackParser, syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $2Jaqc.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}
function $dbbdd74e32b77fa2$var$getNonErrorObjectExceptionValue(exception, { isUnhandledRejection: isUnhandledRejection }) {
    const keys = (0, $3dFJR.extractExceptionKeysForMessage)(exception);
    const captureType = isUnhandledRejection ? 'promise rejection' : 'exception';
    // Some ErrorEvent instances do not have an `error` property, which is why they are not handled before
    // We still want to try to get a decent message for these cases
    if ((0, $2Jaqc.isErrorEvent)(exception)) return `Event \`ErrorEvent\` captured as ${captureType} with message \`${exception.message}\``;
    if ((0, $2Jaqc.isEvent)(exception)) {
        const className = $dbbdd74e32b77fa2$var$getObjectClassName(exception);
        return `Event \`${className}\` (type=${exception.type}) captured as ${captureType}`;
    }
    return `Object captured as ${captureType} with keys: ${keys}`;
}
function $dbbdd74e32b77fa2$var$getObjectClassName(obj) {
    try {
        const prototype = Object.getPrototypeOf(obj);
        return prototype ? prototype.constructor.name : undefined;
    } catch (e) {
    // ignore errors here
    }
}

});

parcelRegister("3FkMI", function(module, exports) {
$parcel$export(module.exports, "WINDOW", () => $2ab552d7bbe7b9d8$export$56d8a8a25bd48b81);
$parcel$export(module.exports, "shouldIgnoreOnError", () => $2ab552d7bbe7b9d8$export$b79738ab10c590b2);
$parcel$export(module.exports, "wrap", () => $2ab552d7bbe7b9d8$export$4997ffc0176396a6);


var $3vr70 = parcelRequire("3vr70");

var $kgI9H = parcelRequire("kgI9H");
var $3dFJR = parcelRequire("3dFJR");
var $aFn2S = parcelRequire("aFn2S");
const $2ab552d7bbe7b9d8$export$56d8a8a25bd48b81 = (0, $aFn2S.GLOBAL_OBJ);
let $2ab552d7bbe7b9d8$var$ignoreOnError = 0;
/**
 * @hidden
 */ function $2ab552d7bbe7b9d8$export$b79738ab10c590b2() {
    return $2ab552d7bbe7b9d8$var$ignoreOnError > 0;
}
/**
 * @hidden
 */ function $2ab552d7bbe7b9d8$export$1265a142ff5ba165() {
    // onerror should trigger before setTimeout
    $2ab552d7bbe7b9d8$var$ignoreOnError++;
    setTimeout(()=>{
        $2ab552d7bbe7b9d8$var$ignoreOnError--;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */ function $2ab552d7bbe7b9d8$export$4997ffc0176396a6(fn, options = {}, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (typeof fn !== 'function') return fn;
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        const wrapper = fn.__sentry_wrapped__;
        if (wrapper) return wrapper;
        // We don't wanna wrap it twice
        if ((0, $3dFJR.getOriginalFunction)(fn)) return fn;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */ // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
    const sentryWrapped = function() {
        const args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') before.apply(this, arguments);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            const wrappedArguments = args.map((arg)=>$2ab552d7bbe7b9d8$export$4997ffc0176396a6(arg, options));
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        } catch (ex) {
            $2ab552d7bbe7b9d8$export$1265a142ff5ba165();
            (0, $3vr70.withScope)((scope)=>{
                scope.addEventProcessor((event)=>{
                    if (options.mechanism) {
                        (0, $kgI9H.addExceptionTypeValue)(event, undefined, undefined);
                        (0, $kgI9H.addExceptionMechanism)(event, options.mechanism);
                    }
                    event.extra = {
                        ...event.extra,
                        arguments: args
                    };
                    return event;
                });
                (0, $3vr70.captureException)(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */ // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for(const property in fn)if (Object.prototype.hasOwnProperty.call(fn, property)) sentryWrapped[property] = fn[property];
    } catch (_oO) {} // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    (0, $3dFJR.markFunctionWrapped)(sentryWrapped, fn);
    (0, $3dFJR.addNonEnumerableProperty)(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) Object.defineProperty(sentryWrapped, 'name', {
            get () {
                return fn.name;
            }
        });
    // eslint-disable-next-line no-empty
    } catch (_oO) {}
    return sentryWrapped;
}

});

parcelRegister("6377k", function(module, exports) {
$parcel$export(module.exports, "createUserFeedbackEnvelope", () => $46788b35bdcb3014$export$24a4dfcb686ee5bf);

var $9CzI9 = parcelRequire("9CzI9");
var $cLBIh = parcelRequire("cLBIh");
/**
 * Creates an envelope from a user feedback.
 */ function $46788b35bdcb3014$export$24a4dfcb686ee5bf(feedback, { metadata: metadata, tunnel: tunnel, dsn: dsn }) {
    const headers = {
        event_id: feedback.event_id,
        sent_at: new Date().toISOString(),
        ...metadata && metadata.sdk && {
            sdk: {
                name: metadata.sdk.name,
                version: metadata.sdk.version
            }
        },
        ...!!tunnel && !!dsn && {
            dsn: (0, $cLBIh.dsnToString)(dsn)
        }
    };
    const item = $46788b35bdcb3014$var$createUserFeedbackEnvelopeItem(feedback);
    return (0, $9CzI9.createEnvelope)(headers, [
        item
    ]);
}
function $46788b35bdcb3014$var$createUserFeedbackEnvelopeItem(feedback) {
    const feedbackHeaders = {
        type: 'user_report'
    };
    return [
        feedbackHeaders,
        feedback
    ];
}

});


parcelRegister("fK4F3", function(module, exports) {
$parcel$export(module.exports, "breadcrumbsIntegration", () => $b75ec480d5b3e975$export$c079d904b326663a);
$parcel$export(module.exports, "Breadcrumbs", () => $b75ec480d5b3e975$export$2dc68d50d56fbbd);

var $3vr70 = parcelRequire("3vr70");
var $8WCUT = parcelRequire("8WCUT");

var $aNrXU = parcelRequire("aNrXU");
var $7pl6s = parcelRequire("7pl6s");
var $hpPel = parcelRequire("hpPel");
var $6g60L = parcelRequire("6g60L");
var $1eUoF = parcelRequire("1eUoF");
var $1Pi8W = parcelRequire("1Pi8W");
var $kgI9H = parcelRequire("kgI9H");
var $6lJZW = parcelRequire("6lJZW");
var $29V09 = parcelRequire("29V09");
var $4RzNY = parcelRequire("4RzNY");
var $7VcJa = parcelRequire("7VcJa");

var $bl0Xy = parcelRequire("bl0Xy");

var $3FkMI = parcelRequire("3FkMI");
/* eslint-disable max-lines */ /** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */ const $b75ec480d5b3e975$var$MAX_ALLOWED_STRING_LENGTH = 1024;
const $b75ec480d5b3e975$var$INTEGRATION_NAME = 'Breadcrumbs';
const $b75ec480d5b3e975$var$_breadcrumbsIntegration = (options = {})=>{
    const _options = {
        console: true,
        dom: true,
        fetch: true,
        history: true,
        sentry: true,
        xhr: true,
        ...options
    };
    return {
        name: $b75ec480d5b3e975$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (_options.console) (0, $7pl6s.addConsoleInstrumentationHandler)($b75ec480d5b3e975$var$_getConsoleBreadcrumbHandler(client));
            if (_options.dom) (0, $aNrXU.addClickKeypressInstrumentationHandler)($b75ec480d5b3e975$var$_getDomBreadcrumbHandler(client, _options.dom));
            if (_options.xhr) (0, $1eUoF.addXhrInstrumentationHandler)($b75ec480d5b3e975$var$_getXhrBreadcrumbHandler(client));
            if (_options.fetch) (0, $hpPel.addFetchInstrumentationHandler)($b75ec480d5b3e975$var$_getFetchBreadcrumbHandler(client));
            if (_options.history) (0, $6g60L.addHistoryInstrumentationHandler)($b75ec480d5b3e975$var$_getHistoryBreadcrumbHandler(client));
            if (_options.sentry && client.on) client.on('beforeSendEvent', $b75ec480d5b3e975$var$_getSentryBreadcrumbHandler(client));
        }
    };
};
const $b75ec480d5b3e975$export$c079d904b326663a = (0, $8WCUT.defineIntegration)($b75ec480d5b3e975$var$_breadcrumbsIntegration);
/**
 * Default Breadcrumbs instrumentations
 *
 * @deprecated Use `breadcrumbsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $b75ec480d5b3e975$export$2dc68d50d56fbbd = (0, $8WCUT.convertIntegrationFnToClass)($b75ec480d5b3e975$var$INTEGRATION_NAME, $b75ec480d5b3e975$export$c079d904b326663a);
/**
 * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
 */ function $b75ec480d5b3e975$var$_getSentryBreadcrumbHandler(client) {
    return function addSentryBreadcrumb(event) {
        if ((0, $3vr70.getClient)() !== client) return;
        (0, $3vr70.addBreadcrumb)({
            category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
            event_id: event.event_id,
            level: event.level,
            message: (0, $kgI9H.getEventDescription)(event)
        }, {
            event: event
        });
    };
}
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */ function $b75ec480d5b3e975$var$_getDomBreadcrumbHandler(client, dom) {
    return function _innerDomBreadcrumb(handlerData) {
        if ((0, $3vr70.getClient)() !== client) return;
        let target;
        let componentName;
        let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        let maxStringLength = typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
        if (maxStringLength && maxStringLength > $b75ec480d5b3e975$var$MAX_ALLOWED_STRING_LENGTH) {
            (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).warn(`\`dom.maxStringLength\` cannot exceed ${$b75ec480d5b3e975$var$MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${$b75ec480d5b3e975$var$MAX_ALLOWED_STRING_LENGTH} instead.`);
            maxStringLength = $b75ec480d5b3e975$var$MAX_ALLOWED_STRING_LENGTH;
        }
        if (typeof keyAttrs === 'string') keyAttrs = [
            keyAttrs
        ];
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            const event = handlerData.event;
            const element = $b75ec480d5b3e975$var$_isEvent(event) ? event.target : event;
            target = (0, $1Pi8W.htmlTreeAsString)(element, {
                keyAttrs: keyAttrs,
                maxStringLength: maxStringLength
            });
            componentName = (0, $1Pi8W.getComponentName)(element);
        } catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) return;
        const breadcrumb = {
            category: `ui.${handlerData.name}`,
            message: target
        };
        if (componentName) breadcrumb.data = {
            'ui.component_name': componentName
        };
        (0, $3vr70.addBreadcrumb)(breadcrumb, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global
        });
    };
}
/**
 * Creates breadcrumbs from console API calls
 */ function $b75ec480d5b3e975$var$_getConsoleBreadcrumbHandler(client) {
    return function _consoleBreadcrumb(handlerData) {
        if ((0, $3vr70.getClient)() !== client) return;
        const breadcrumb = {
            category: 'console',
            data: {
                arguments: handlerData.args,
                logger: 'console'
            },
            level: (0, $7VcJa.severityLevelFromString)(handlerData.level),
            message: (0, $4RzNY.safeJoin)(handlerData.args, ' ')
        };
        if (handlerData.level === 'assert') {
            if (handlerData.args[0] === false) {
                breadcrumb.message = `Assertion failed: ${(0, $4RzNY.safeJoin)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
                breadcrumb.data.arguments = handlerData.args.slice(1);
            } else // Don't capture a breadcrumb for passed assertions
            return;
        }
        (0, $3vr70.addBreadcrumb)(breadcrumb, {
            input: handlerData.args,
            level: handlerData.level
        });
    };
}
/**
 * Creates breadcrumbs from XHR API calls
 */ function $b75ec480d5b3e975$var$_getXhrBreadcrumbHandler(client) {
    return function _xhrBreadcrumb(handlerData) {
        if ((0, $3vr70.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        const sentryXhrData = handlerData.xhr[0, $1eUoF.SENTRY_XHR_DATA_KEY];
        // We only capture complete, non-sentry requests
        if (!startTimestamp || !endTimestamp || !sentryXhrData) return;
        const { method: method, url: url, status_code: status_code, body: body } = sentryXhrData;
        const data = {
            method: method,
            url: url,
            status_code: status_code
        };
        const hint = {
            xhr: handlerData.xhr,
            input: body,
            startTimestamp: startTimestamp,
            endTimestamp: endTimestamp
        };
        (0, $3vr70.addBreadcrumb)({
            category: 'xhr',
            data: data,
            type: 'http'
        }, hint);
    };
}
/**
 * Creates breadcrumbs from fetch API calls
 */ function $b75ec480d5b3e975$var$_getFetchBreadcrumbHandler(client) {
    return function _fetchBreadcrumb(handlerData) {
        if ((0, $3vr70.getClient)() !== client) return;
        const { startTimestamp: startTimestamp, endTimestamp: endTimestamp } = handlerData;
        // We only capture complete fetch requests
        if (!endTimestamp) return;
        if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
        if (handlerData.error) {
            const data = handlerData.fetchData;
            const hint = {
                data: handlerData.error,
                input: handlerData.args,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $3vr70.addBreadcrumb)({
                category: 'fetch',
                data: data,
                level: 'error',
                type: 'http'
            }, hint);
        } else {
            const response = handlerData.response;
            const data = {
                ...handlerData.fetchData,
                status_code: response && response.status
            };
            const hint = {
                input: handlerData.args,
                response: response,
                startTimestamp: startTimestamp,
                endTimestamp: endTimestamp
            };
            (0, $3vr70.addBreadcrumb)({
                category: 'fetch',
                data: data,
                type: 'http'
            }, hint);
        }
    };
}
/**
 * Creates breadcrumbs from history API calls
 */ function $b75ec480d5b3e975$var$_getHistoryBreadcrumbHandler(client) {
    return function _historyBreadcrumb(handlerData) {
        if ((0, $3vr70.getClient)() !== client) return;
        let from = handlerData.from;
        let to = handlerData.to;
        const parsedLoc = (0, $29V09.parseUrl)((0, $3FkMI.WINDOW).location.href);
        let parsedFrom = from ? (0, $29V09.parseUrl)(from) : undefined;
        const parsedTo = (0, $29V09.parseUrl)(to);
        // Initial pushState doesn't provide `from` information
        if (!parsedFrom || !parsedFrom.path) parsedFrom = parsedLoc;
        // Use only the path component of the URL if the URL matches the current
        // document (almost all the time when using pushState)
        if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) to = parsedTo.relative;
        if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) from = parsedFrom.relative;
        (0, $3vr70.addBreadcrumb)({
            category: 'navigation',
            data: {
                from: from,
                to: to
            }
        });
    };
}
function $b75ec480d5b3e975$var$_isEvent(event) {
    return !!event && !!event.target;
}

});
parcelRegister("aNrXU", function(module, exports) {
$parcel$export(module.exports, "addClickKeypressInstrumentationHandler", () => $7dc42c5339563501$export$5aeffd3db2cf9df7);

var $kgI9H = parcelRequire("kgI9H");

var $3dFJR = parcelRequire("3dFJR");

var $aFn2S = parcelRequire("aFn2S");

var $6i9I9 = parcelRequire("6i9I9");
const $7dc42c5339563501$var$WINDOW = (0, $aFn2S.GLOBAL_OBJ);
const $7dc42c5339563501$var$DEBOUNCE_DURATION = 1000;
let $7dc42c5339563501$var$debounceTimerID;
let $7dc42c5339563501$var$lastCapturedEventType;
let $7dc42c5339563501$var$lastCapturedEventTargetId;
/**
 * Add an instrumentation handler for when a click or a keypress happens.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $7dc42c5339563501$export$5aeffd3db2cf9df7(handler) {
    const type = 'dom';
    (0, $6i9I9.addHandler)(type, handler);
    (0, $6i9I9.maybeInstrument)(type, $7dc42c5339563501$export$3014bbf0af0e1d4a);
}
/** Exported for tests only. */ function $7dc42c5339563501$export$3014bbf0af0e1d4a() {
    if (!$7dc42c5339563501$var$WINDOW.document) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = (0, $6i9I9.triggerHandlers).bind(null, 'dom');
    const globalDOMEventHandler = $7dc42c5339563501$var$makeDOMEventHandler(triggerDOMHandler, true);
    $7dc42c5339563501$var$WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
    $7dc42c5339563501$var$WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $7dc42c5339563501$var$WINDOW[target] && $7dc42c5339563501$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $3dFJR.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $7dc42c5339563501$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $3dFJR.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
/**
 * Check whether the event is similar to the last captured one. For example, two click events on the same button.
 */ function $7dc42c5339563501$var$isSimilarToLastCapturedEvent(event) {
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (event.type !== $7dc42c5339563501$var$lastCapturedEventType) return false;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (!event.target || event.target._sentryId !== $7dc42c5339563501$var$lastCapturedEventTargetId) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return true;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $7dc42c5339563501$var$shouldSkipDOMEvent(eventType, target) {
    // We are only interested in filtering `keypress` events for now.
    if (eventType !== 'keypress') return false;
    if (!target || !target.tagName) return true;
    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 */ function $7dc42c5339563501$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || event['_sentryCaptured']) return;
        const target = $7dc42c5339563501$var$getEventTarget(event);
        // We always want to skip _some_ events.
        if ($7dc42c5339563501$var$shouldSkipDOMEvent(event.type, target)) return;
        // Mark event as "seen"
        (0, $3dFJR.addNonEnumerableProperty)(event, '_sentryCaptured', true);
        if (target && !target._sentryId) // Add UUID to event target so we can identify if
        (0, $3dFJR.addNonEnumerableProperty)(target, '_sentryId', (0, $kgI9H.uuid4)());
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no last captured event, it means that we can safely capture the new event and store it for future comparisons.
        // If there is a last captured event, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        if (!$7dc42c5339563501$var$isSimilarToLastCapturedEvent(event)) {
            const handlerData = {
                event: event,
                name: name,
                global: globalListener
            };
            handler(handlerData);
            $7dc42c5339563501$var$lastCapturedEventType = event.type;
            $7dc42c5339563501$var$lastCapturedEventTargetId = target ? target._sentryId : undefined;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($7dc42c5339563501$var$debounceTimerID);
        $7dc42c5339563501$var$debounceTimerID = $7dc42c5339563501$var$WINDOW.setTimeout(()=>{
            $7dc42c5339563501$var$lastCapturedEventTargetId = undefined;
            $7dc42c5339563501$var$lastCapturedEventType = undefined;
        }, $7dc42c5339563501$var$DEBOUNCE_DURATION);
    };
}
function $7dc42c5339563501$var$getEventTarget(event) {
    try {
        return event.target;
    } catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
        return null;
    }
}

});

parcelRegister("7pl6s", function(module, exports) {
$parcel$export(module.exports, "addConsoleInstrumentationHandler", () => $564b3cd814cf7a5a$export$1d6e0d073f9e6723);

var $6lJZW = parcelRequire("6lJZW");

var $3dFJR = parcelRequire("3dFJR");

var $aFn2S = parcelRequire("aFn2S");

var $6i9I9 = parcelRequire("6i9I9");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $564b3cd814cf7a5a$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $6i9I9.addHandler)(type, handler);
    (0, $6i9I9.maybeInstrument)(type, $564b3cd814cf7a5a$var$instrumentConsole);
}
function $564b3cd814cf7a5a$var$instrumentConsole() {
    if (!('console' in (0, $aFn2S.GLOBAL_OBJ))) return;
    (0, $6lJZW.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $aFn2S.GLOBAL_OBJ).console)) return;
        (0, $3dFJR.fill)((0, $aFn2S.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $6lJZW.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $6i9I9.triggerHandlers)('console', handlerData);
                const log = (0, $6lJZW.originalConsoleMethods)[level];
                log && log.apply((0, $aFn2S.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});

parcelRegister("hpPel", function(module, exports) {
$parcel$export(module.exports, "addFetchInstrumentationHandler", () => $cadc82c56874dc17$export$f75d3c772c923df0);

var $3dFJR = parcelRequire("3dFJR");

var $fsPAv = parcelRequire("fsPAv");

var $aFn2S = parcelRequire("aFn2S");

var $6i9I9 = parcelRequire("6i9I9");
/**
 * Add an instrumentation handler for when a fetch request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $cadc82c56874dc17$export$f75d3c772c923df0(handler) {
    const type = 'fetch';
    (0, $6i9I9.addHandler)(type, handler);
    (0, $6i9I9.maybeInstrument)(type, $cadc82c56874dc17$var$instrumentFetch);
}
function $cadc82c56874dc17$var$instrumentFetch() {
    if (!(0, $fsPAv.supportsNativeFetch)()) return;
    (0, $3dFJR.fill)((0, $aFn2S.GLOBAL_OBJ), 'fetch', function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $cadc82c56874dc17$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            (0, $6i9I9.triggerHandlers)('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply((0, $aFn2S.GLOBAL_OBJ), args).then((response)=>{
                const finishedHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                };
                (0, $6i9I9.triggerHandlers)('fetch', finishedHandlerData);
                return response;
            }, (error)=>{
                const erroredHandlerData = {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                };
                (0, $6i9I9.triggerHandlers)('fetch', erroredHandlerData);
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $cadc82c56874dc17$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $cadc82c56874dc17$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($cadc82c56874dc17$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request.
 * Exported for tests only.
 */ function $cadc82c56874dc17$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $cadc82c56874dc17$var$getUrlFromResource(url),
            method: $cadc82c56874dc17$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $cadc82c56874dc17$var$getUrlFromResource(arg),
        method: $cadc82c56874dc17$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}

});

parcelRegister("1eUoF", function(module, exports) {
$parcel$export(module.exports, "SENTRY_XHR_DATA_KEY", () => $0e72d880fb6ffb53$export$55b6bb1e45c6cf59);
$parcel$export(module.exports, "addXhrInstrumentationHandler", () => $0e72d880fb6ffb53$export$26ace48dd54c9aea);

var $2Jaqc = parcelRequire("2Jaqc");

var $3dFJR = parcelRequire("3dFJR");

var $aFn2S = parcelRequire("aFn2S");

var $6i9I9 = parcelRequire("6i9I9");
const $0e72d880fb6ffb53$var$WINDOW = (0, $aFn2S.GLOBAL_OBJ);
const $0e72d880fb6ffb53$export$55b6bb1e45c6cf59 = '__sentry_xhr_v3__';
/**
 * Add an instrumentation handler for when an XHR request happens.
 * The handler function is called once when the request starts and once when it ends,
 * which can be identified by checking if it has an `endTimestamp`.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $0e72d880fb6ffb53$export$26ace48dd54c9aea(handler) {
    const type = 'xhr';
    (0, $6i9I9.addHandler)(type, handler);
    (0, $6i9I9.maybeInstrument)(type, $0e72d880fb6ffb53$export$c67d533bf77cbf54);
}
/** Exported only for tests. */ function $0e72d880fb6ffb53$export$c67d533bf77cbf54() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (!$0e72d880fb6ffb53$var$WINDOW.XMLHttpRequest) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $3dFJR.fill)(xhrproto, 'open', function(originalOpen) {
        return function(...args) {
            const startTimestamp = Date.now();
            // open() should always be called with two or more arguments
            // But to be on the safe side, we actually validate this and bail out if we don't have a method & url
            const method = (0, $2Jaqc.isString)(args[0]) ? args[0].toUpperCase() : undefined;
            const url = $0e72d880fb6ffb53$var$parseUrl(args[1]);
            if (!method || !url) return originalOpen.apply(this, args);
            this[$0e72d880fb6ffb53$export$55b6bb1e45c6cf59] = {
                method: method,
                url: url,
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            if (method === 'POST' && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this[$0e72d880fb6ffb53$export$55b6bb1e45c6cf59];
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    const handlerData = {
                        args: [
                            method,
                            url
                        ],
                        endTimestamp: Date.now(),
                        startTimestamp: startTimestamp,
                        xhr: this
                    };
                    (0, $6i9I9.triggerHandlers)('xhr', handlerData);
                }
            };
            if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') (0, $3dFJR.fill)(this, 'onreadystatechange', function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $3dFJR.fill)(this, 'setRequestHeader', function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this[$0e72d880fb6ffb53$export$55b6bb1e45c6cf59];
                    if (xhrInfo && (0, $2Jaqc.isString)(header) && (0, $2Jaqc.isString)(value)) xhrInfo.request_headers[header.toLowerCase()] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $3dFJR.fill)(xhrproto, 'send', function(originalSend) {
        return function(...args) {
            const sentryXhrData = this[$0e72d880fb6ffb53$export$55b6bb1e45c6cf59];
            if (!sentryXhrData) return originalSend.apply(this, args);
            if (args[0] !== undefined) sentryXhrData.body = args[0];
            const handlerData = {
                args: [
                    sentryXhrData.method,
                    sentryXhrData.url
                ],
                startTimestamp: Date.now(),
                xhr: this
            };
            (0, $6i9I9.triggerHandlers)('xhr', handlerData);
            return originalSend.apply(this, args);
        };
    });
}
function $0e72d880fb6ffb53$var$parseUrl(url) {
    if ((0, $2Jaqc.isString)(url)) return url;
    try {
        // url can be a string or URL
        // but since URL is not available in IE11, we do not check for it,
        // but simply assume it is an URL and return `toString()` from it (which returns the full URL)
        // If that fails, we just return undefined
        return url.toString();
    } catch (e2) {} // eslint-disable-line no-empty
    return undefined;
}

});

parcelRegister("29V09", function(module, exports) {
$parcel$export(module.exports, "parseUrl", () => $1928a35931a4ddde$export$7a5253c0f62e0150);
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $1928a35931a4ddde$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $1928a35931a4ddde$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $1928a35931a4ddde$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $1928a35931a4ddde$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    // TODO: Use new URL global if it exists
    .replace(/(:80)$/, '').replace(/(:443)$/, '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

});

parcelRegister("7VcJa", function(module, exports) {
$parcel$export(module.exports, "severityLevelFromString", () => $5c47bab40404e116$export$d771ef054122c30a);
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $5c47bab40404e116$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $5c47bab40404e116$export$e01cef29b4327697(level) {
    return $5c47bab40404e116$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $5c47bab40404e116$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $5c47bab40404e116$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}

});


parcelRegister("lo7wK", function(module, exports) {
$parcel$export(module.exports, "dedupeIntegration", () => $f921ad9e3802490f$export$6d39aa44cd0c7567);
$parcel$export(module.exports, "Dedupe", () => $f921ad9e3802490f$export$688d98c249d31ad3);

var $8WCUT = parcelRequire("8WCUT");

var $6lJZW = parcelRequire("6lJZW");

var $bl0Xy = parcelRequire("bl0Xy");
const $f921ad9e3802490f$var$INTEGRATION_NAME = 'Dedupe';
const $f921ad9e3802490f$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $f921ad9e3802490f$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($f921ad9e3802490f$var$_shouldDropEvent(currentEvent, previousEvent)) {
                    (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $f921ad9e3802490f$export$6d39aa44cd0c7567 = (0, $8WCUT.defineIntegration)($f921ad9e3802490f$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $f921ad9e3802490f$export$688d98c249d31ad3 = (0, $8WCUT.convertIntegrationFnToClass)($f921ad9e3802490f$var$INTEGRATION_NAME, $f921ad9e3802490f$export$6d39aa44cd0c7567);
function $f921ad9e3802490f$var$_shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($f921ad9e3802490f$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($f921ad9e3802490f$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $f921ad9e3802490f$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$f921ad9e3802490f$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$f921ad9e3802490f$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $f921ad9e3802490f$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $f921ad9e3802490f$var$_getExceptionFromEvent(previousEvent);
    const currentException = $f921ad9e3802490f$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$f921ad9e3802490f$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$f921ad9e3802490f$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $f921ad9e3802490f$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $f921ad9e3802490f$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $f921ad9e3802490f$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $f921ad9e3802490f$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $f921ad9e3802490f$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $f921ad9e3802490f$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

});

parcelRegister("jFqF2", function(module, exports) {
$parcel$export(module.exports, "globalHandlersIntegration", () => $e51686f51cf86652$export$66acc70e8cf2b71a);
$parcel$export(module.exports, "GlobalHandlers", () => $e51686f51cf86652$export$204155decbc90e5a);

var $3vr70 = parcelRequire("3vr70");
var $8WCUT = parcelRequire("8WCUT");

var $1QDmA = parcelRequire("1QDmA");
var $kS6cd = parcelRequire("kS6cd");
var $1Pi8W = parcelRequire("1Pi8W");
var $2Jaqc = parcelRequire("2Jaqc");
var $6lJZW = parcelRequire("6lJZW");

var $bl0Xy = parcelRequire("bl0Xy");

var $iRG6Q = parcelRequire("iRG6Q");

var $3FkMI = parcelRequire("3FkMI");
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ const $e51686f51cf86652$var$INTEGRATION_NAME = 'GlobalHandlers';
const $e51686f51cf86652$var$_globalHandlersIntegration = (options = {})=>{
    const _options = {
        onerror: true,
        onunhandledrejection: true,
        ...options
    };
    return {
        name: $e51686f51cf86652$var$INTEGRATION_NAME,
        setupOnce () {
            Error.stackTraceLimit = 50;
        },
        setup (client) {
            if (_options.onerror) {
                $e51686f51cf86652$var$_installGlobalOnErrorHandler(client);
                $e51686f51cf86652$var$globalHandlerLog('onerror');
            }
            if (_options.onunhandledrejection) {
                $e51686f51cf86652$var$_installGlobalOnUnhandledRejectionHandler(client);
                $e51686f51cf86652$var$globalHandlerLog('onunhandledrejection');
            }
        }
    };
};
const $e51686f51cf86652$export$66acc70e8cf2b71a = (0, $8WCUT.defineIntegration)($e51686f51cf86652$var$_globalHandlersIntegration);
/**
 * Global handlers.
 * @deprecated Use `globalHandlersIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $e51686f51cf86652$export$204155decbc90e5a = (0, $8WCUT.convertIntegrationFnToClass)($e51686f51cf86652$var$INTEGRATION_NAME, $e51686f51cf86652$export$66acc70e8cf2b71a);
function $e51686f51cf86652$var$_installGlobalOnErrorHandler(client) {
    (0, $1QDmA.addGlobalErrorInstrumentationHandler)((data)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $e51686f51cf86652$var$getOptions();
        if ((0, $3vr70.getClient)() !== client || (0, $3FkMI.shouldIgnoreOnError)()) return;
        const { msg: msg, url: url, line: line, column: column, error: error } = data;
        const event = error === undefined && (0, $2Jaqc.isString)(msg) ? $e51686f51cf86652$var$_eventFromIncompleteOnError(msg, url, line, column) : $e51686f51cf86652$var$_enhanceEventWithInitialFrame((0, $iRG6Q.eventFromUnknownInput)(stackParser, error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = 'error';
        (0, $3vr70.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onerror'
            }
        });
    });
}
function $e51686f51cf86652$var$_installGlobalOnUnhandledRejectionHandler(client) {
    (0, $kS6cd.addGlobalUnhandledRejectionInstrumentationHandler)((e)=>{
        const { stackParser: stackParser, attachStacktrace: attachStacktrace } = $e51686f51cf86652$var$getOptions();
        if ((0, $3vr70.getClient)() !== client || (0, $3FkMI.shouldIgnoreOnError)()) return;
        const error = $e51686f51cf86652$var$_getUnhandledRejectionError(e);
        const event = (0, $2Jaqc.isPrimitive)(error) ? $e51686f51cf86652$var$_eventFromRejectionWithPrimitive(error) : (0, $iRG6Q.eventFromUnknownInput)(stackParser, error, undefined, attachStacktrace, true);
        event.level = 'error';
        (0, $3vr70.captureEvent)(event, {
            originalException: error,
            mechanism: {
                handled: false,
                type: 'onunhandledrejection'
            }
        });
    });
}
function $e51686f51cf86652$var$_getUnhandledRejectionError(error) {
    if ((0, $2Jaqc.isPrimitive)(error)) return error;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const e = error;
    // dig the object of the rejection out of known event types
    try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) return e.reason;
        else if ('detail' in e && 'reason' in e.detail) return e.detail.reason;
    } catch (e2) {} // eslint-disable-line no-empty
    return error;
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */ function $e51686f51cf86652$var$_eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: `Non-Error promise rejection captured with value: ${String(reason)}`
                }
            ]
        }
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e51686f51cf86652$var$_eventFromIncompleteOnError(msg, url, line, column) {
    const ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    let message = (0, $2Jaqc.isErrorEvent)(msg) ? msg.message : msg;
    let name = 'Error';
    const groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    const event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message
                }
            ]
        }
    };
    return $e51686f51cf86652$var$_enhanceEventWithInitialFrame(event, url, line, column);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e51686f51cf86652$var$_enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    const e = event.exception = event.exception || {};
    // event.exception.values
    const ev = e.values = e.values || [];
    // event.exception.values[0]
    const ev0 = ev[0] = ev[0] || {};
    // event.exception.values[0].stacktrace
    const ev0s = ev0.stacktrace = ev0.stacktrace || {};
    // event.exception.values[0].stacktrace.frames
    const ev0sf = ev0s.frames = ev0s.frames || [];
    const colno = isNaN(parseInt(column, 10)) ? undefined : column;
    const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    const filename = (0, $2Jaqc.isString)(url) && url.length > 0 ? url : (0, $1Pi8W.getLocationHref)();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) ev0sf.push({
        colno: colno,
        filename: filename,
        function: '?',
        in_app: true,
        lineno: lineno
    });
    return event;
}
function $e51686f51cf86652$var$globalHandlerLog(type) {
    (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).log(`Global Handler attached: ${type}`);
}
function $e51686f51cf86652$var$getOptions() {
    const client = (0, $3vr70.getClient)();
    const options = client && client.getOptions() || {
        stackParser: ()=>[],
        attachStacktrace: false
    };
    return options;
}

});
parcelRegister("1QDmA", function(module, exports) {
$parcel$export(module.exports, "addGlobalErrorInstrumentationHandler", () => $15892e7c224b8e3a$export$55b5c3ba2194f0c6);

var $aFn2S = parcelRequire("aFn2S");

var $6i9I9 = parcelRequire("6i9I9");
let $15892e7c224b8e3a$var$_oldOnErrorHandler = null;
/**
 * Add an instrumentation handler for when an error is captured by the global error handler.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $15892e7c224b8e3a$export$55b5c3ba2194f0c6(handler) {
    const type = 'error';
    (0, $6i9I9.addHandler)(type, handler);
    (0, $6i9I9.maybeInstrument)(type, $15892e7c224b8e3a$var$instrumentError);
}
function $15892e7c224b8e3a$var$instrumentError() {
    $15892e7c224b8e3a$var$_oldOnErrorHandler = (0, $aFn2S.GLOBAL_OBJ).onerror;
    (0, $aFn2S.GLOBAL_OBJ).onerror = function(msg, url, line, column, error) {
        const handlerData = {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        };
        (0, $6i9I9.triggerHandlers)('error', handlerData);
        if ($15892e7c224b8e3a$var$_oldOnErrorHandler && !$15892e7c224b8e3a$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $15892e7c224b8e3a$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    (0, $aFn2S.GLOBAL_OBJ).onerror.__SENTRY_INSTRUMENTED__ = true;
}

});

parcelRegister("kS6cd", function(module, exports) {
$parcel$export(module.exports, "addGlobalUnhandledRejectionInstrumentationHandler", () => $f31da83365f8d695$export$8bf4fc6858821a4e);

var $aFn2S = parcelRequire("aFn2S");

var $6i9I9 = parcelRequire("6i9I9");
let $f31da83365f8d695$var$_oldOnUnhandledRejectionHandler = null;
/**
 * Add an instrumentation handler for when an unhandled promise rejection is captured.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $f31da83365f8d695$export$8bf4fc6858821a4e(handler) {
    const type = 'unhandledrejection';
    (0, $6i9I9.addHandler)(type, handler);
    (0, $6i9I9.maybeInstrument)(type, $f31da83365f8d695$var$instrumentUnhandledRejection);
}
function $f31da83365f8d695$var$instrumentUnhandledRejection() {
    $f31da83365f8d695$var$_oldOnUnhandledRejectionHandler = (0, $aFn2S.GLOBAL_OBJ).onunhandledrejection;
    (0, $aFn2S.GLOBAL_OBJ).onunhandledrejection = function(e) {
        const handlerData = e;
        (0, $6i9I9.triggerHandlers)('unhandledrejection', handlerData);
        if ($f31da83365f8d695$var$_oldOnUnhandledRejectionHandler && !$f31da83365f8d695$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $f31da83365f8d695$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    (0, $aFn2S.GLOBAL_OBJ).onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});


parcelRegister("11Thk", function(module, exports) {
$parcel$export(module.exports, "httpContextIntegration", () => $0c00c3958b78b76f$export$1378794447170364);
$parcel$export(module.exports, "HttpContext", () => $0c00c3958b78b76f$export$5d2ee9a544b09a94);

var $8WCUT = parcelRequire("8WCUT");

var $3FkMI = parcelRequire("3FkMI");
const $0c00c3958b78b76f$var$INTEGRATION_NAME = 'HttpContext';
const $0c00c3958b78b76f$var$_httpContextIntegration = ()=>{
    return {
        name: $0c00c3958b78b76f$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event) {
            // if none of the information we want exists, don't bother
            if (!(0, $3FkMI.WINDOW).navigator && !(0, $3FkMI.WINDOW).location && !(0, $3FkMI.WINDOW).document) return;
            // grab as much info as exists and add it to the event
            const url = event.request && event.request.url || (0, $3FkMI.WINDOW).location && (0, $3FkMI.WINDOW).location.href;
            const { referrer: referrer } = (0, $3FkMI.WINDOW).document || {};
            const { userAgent: userAgent } = (0, $3FkMI.WINDOW).navigator || {};
            const headers = {
                ...event.request && event.request.headers,
                ...referrer && {
                    Referer: referrer
                },
                ...userAgent && {
                    'User-Agent': userAgent
                }
            };
            const request = {
                ...event.request,
                ...url && {
                    url: url
                },
                headers: headers
            };
            event.request = request;
        }
    };
};
const $0c00c3958b78b76f$export$1378794447170364 = (0, $8WCUT.defineIntegration)($0c00c3958b78b76f$var$_httpContextIntegration);
/**
 * HttpContext integration collects information about HTTP request headers.
 * @deprecated Use `httpContextIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $0c00c3958b78b76f$export$5d2ee9a544b09a94 = (0, $8WCUT.convertIntegrationFnToClass)($0c00c3958b78b76f$var$INTEGRATION_NAME, $0c00c3958b78b76f$export$1378794447170364);

});

parcelRegister("fTNUR", function(module, exports) {
$parcel$export(module.exports, "linkedErrorsIntegration", () => $b932b65e88c59ae2$export$ebabb00eb7f3a395);
$parcel$export(module.exports, "LinkedErrors", () => $b932b65e88c59ae2$export$8d1e60aaf616fb4f);

var $8WCUT = parcelRequire("8WCUT");

var $1EqWC = parcelRequire("1EqWC");

var $iRG6Q = parcelRequire("iRG6Q");
const $b932b65e88c59ae2$var$DEFAULT_KEY = 'cause';
const $b932b65e88c59ae2$var$DEFAULT_LIMIT = 5;
const $b932b65e88c59ae2$var$INTEGRATION_NAME = 'LinkedErrors';
const $b932b65e88c59ae2$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $b932b65e88c59ae2$var$DEFAULT_LIMIT;
    const key = options.key || $b932b65e88c59ae2$var$DEFAULT_KEY;
    return {
        name: $b932b65e88c59ae2$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $1EqWC.applyAggregateErrorsToEvent)(// This differs from the LinkedErrors integration in core by using a different exceptionFromError function
            (0, $iRG6Q.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $b932b65e88c59ae2$export$ebabb00eb7f3a395 = (0, $8WCUT.defineIntegration)($b932b65e88c59ae2$var$_linkedErrorsIntegration);
/**
 * Aggregrate linked errors in an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $b932b65e88c59ae2$export$8d1e60aaf616fb4f = (0, $8WCUT.convertIntegrationFnToClass)($b932b65e88c59ae2$var$INTEGRATION_NAME, $b932b65e88c59ae2$export$ebabb00eb7f3a395);

});
parcelRegister("1EqWC", function(module, exports) {
$parcel$export(module.exports, "applyAggregateErrorsToEvent", () => $133e6d7ac7a2df5c$export$b91c38ed7d8ae9b2);

var $2Jaqc = parcelRequire("2Jaqc");

var $4RzNY = parcelRequire("4RzNY");
/**
 * Creates exceptions inside `event.exception.values` for errors that are nested on properties based on the `key` parameter.
 */ function $133e6d7ac7a2df5c$export$b91c38ed7d8ae9b2(exceptionFromErrorImplementation, parser, maxValueLimit = 250, key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !(0, $2Jaqc.isInstanceOf)(hint.originalException, Error)) return;
    // Generally speaking the last item in `event.exception.values` is the exception originating from the original Error
    const originalException = event.exception.values.length > 0 ? event.exception.values[event.exception.values.length - 1] : undefined;
    // We only create exception grouping if there is an exception in the event.
    if (originalException) event.exception.values = $133e6d7ac7a2df5c$var$truncateAggregateExceptions($133e6d7ac7a2df5c$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, hint.originalException, key, event.exception.values, originalException, 0), maxValueLimit);
}
function $133e6d7ac7a2df5c$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error, key, prevExceptions, exception, exceptionId) {
    if (prevExceptions.length >= limit + 1) return prevExceptions;
    let newExceptions = [
        ...prevExceptions
    ];
    // Recursively call this function in order to walk down a chain of errors
    if ((0, $2Jaqc.isInstanceOf)(error[key], Error)) {
        $133e6d7ac7a2df5c$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
        const newException = exceptionFromErrorImplementation(parser, error[key]);
        const newExceptionId = newExceptions.length;
        $133e6d7ac7a2df5c$var$applyExceptionGroupFieldsForChildException(newException, key, newExceptionId, exceptionId);
        newExceptions = $133e6d7ac7a2df5c$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, error[key], key, [
            newException,
            ...newExceptions
        ], newException, newExceptionId);
    }
    // This will create exception grouping for AggregateErrors
    // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/AggregateError
    if (Array.isArray(error.errors)) error.errors.forEach((childError, i)=>{
        if ((0, $2Jaqc.isInstanceOf)(childError, Error)) {
            $133e6d7ac7a2df5c$var$applyExceptionGroupFieldsForParentException(exception, exceptionId);
            const newException = exceptionFromErrorImplementation(parser, childError);
            const newExceptionId = newExceptions.length;
            $133e6d7ac7a2df5c$var$applyExceptionGroupFieldsForChildException(newException, `errors[${i}]`, newExceptionId, exceptionId);
            newExceptions = $133e6d7ac7a2df5c$var$aggregateExceptionsFromError(exceptionFromErrorImplementation, parser, limit, childError, key, [
                newException,
                ...newExceptions
            ], newException, newExceptionId);
        }
    });
    return newExceptions;
}
function $133e6d7ac7a2df5c$var$applyExceptionGroupFieldsForParentException(exception, exceptionId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        ...exception.type === 'AggregateError' && {
            is_exception_group: true
        },
        exception_id: exceptionId
    };
}
function $133e6d7ac7a2df5c$var$applyExceptionGroupFieldsForChildException(exception, source, exceptionId, parentId) {
    // Don't know if this default makes sense. The protocol requires us to set these values so we pick *some* default.
    exception.mechanism = exception.mechanism || {
        type: 'generic',
        handled: true
    };
    exception.mechanism = {
        ...exception.mechanism,
        type: 'chained',
        source: source,
        exception_id: exceptionId,
        parent_id: parentId
    };
}
/**
 * Truncate the message (exception.value) of all exceptions in the event.
 * Because this event processor is ran after `applyClientOptions`,
 * we need to truncate the message of the added exceptions here.
 */ function $133e6d7ac7a2df5c$var$truncateAggregateExceptions(exceptions, maxValueLength) {
    return exceptions.map((exception)=>{
        if (exception.value) exception.value = (0, $4RzNY.truncate)(exception.value, maxValueLength);
        return exception;
    });
}

});


parcelRegister("jWbWT", function(module, exports) {
$parcel$export(module.exports, "browserApiErrorsIntegration", () => $e83cb3e6cc54780e$export$59bfe9f1c76150e);
$parcel$export(module.exports, "TryCatch", () => $e83cb3e6cc54780e$export$f1a018517668e6d3);

var $8WCUT = parcelRequire("8WCUT");

var $3dFJR = parcelRequire("3dFJR");
var $amn5g = parcelRequire("amn5g");

var $3FkMI = parcelRequire("3FkMI");
const $e83cb3e6cc54780e$var$DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'BroadcastChannel',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'SharedWorker',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload'
];
const $e83cb3e6cc54780e$var$INTEGRATION_NAME = 'TryCatch';
const $e83cb3e6cc54780e$var$_browserApiErrorsIntegration = (options = {})=>{
    const _options = {
        XMLHttpRequest: true,
        eventTarget: true,
        requestAnimationFrame: true,
        setInterval: true,
        setTimeout: true,
        ...options
    };
    return {
        name: $e83cb3e6cc54780e$var$INTEGRATION_NAME,
        // TODO: This currently only works for the first client this is setup
        // We may want to adjust this to check for client etc.
        setupOnce () {
            if (_options.setTimeout) (0, $3dFJR.fill)((0, $3FkMI.WINDOW), 'setTimeout', $e83cb3e6cc54780e$var$_wrapTimeFunction);
            if (_options.setInterval) (0, $3dFJR.fill)((0, $3FkMI.WINDOW), 'setInterval', $e83cb3e6cc54780e$var$_wrapTimeFunction);
            if (_options.requestAnimationFrame) (0, $3dFJR.fill)((0, $3FkMI.WINDOW), 'requestAnimationFrame', $e83cb3e6cc54780e$var$_wrapRAF);
            if (_options.XMLHttpRequest && 'XMLHttpRequest' in (0, $3FkMI.WINDOW)) (0, $3dFJR.fill)(XMLHttpRequest.prototype, 'send', $e83cb3e6cc54780e$var$_wrapXHR);
            const eventTargetOption = _options.eventTarget;
            if (eventTargetOption) {
                const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : $e83cb3e6cc54780e$var$DEFAULT_EVENT_TARGET;
                eventTarget.forEach($e83cb3e6cc54780e$var$_wrapEventTarget);
            }
        }
    };
};
const $e83cb3e6cc54780e$export$59bfe9f1c76150e = (0, $8WCUT.defineIntegration)($e83cb3e6cc54780e$var$_browserApiErrorsIntegration);
/**
 * Wrap timer functions and event targets to catch errors and provide better meta data.
 * @deprecated Use `browserApiErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $e83cb3e6cc54780e$export$f1a018517668e6d3 = (0, $8WCUT.convertIntegrationFnToClass)($e83cb3e6cc54780e$var$INTEGRATION_NAME, $e83cb3e6cc54780e$export$59bfe9f1c76150e);
function $e83cb3e6cc54780e$var$_wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        const originalCallback = args[0];
        args[0] = (0, $3FkMI.wrap)(originalCallback, {
            mechanism: {
                data: {
                    function: (0, $amn5g.getFunctionName)(original)
                },
                handled: false,
                type: 'instrument'
            }
        });
        return original.apply(this, args);
    };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $e83cb3e6cc54780e$var$_wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            (0, $3FkMI.wrap)(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: (0, $amn5g.getFunctionName)(original)
                    },
                    handled: false,
                    type: 'instrument'
                }
            })
        ]);
    };
}
function $e83cb3e6cc54780e$var$_wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(...args) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const xhr = this;
        const xmlHttpRequestProps = [
            'onload',
            'onerror',
            'onprogress',
            'onreadystatechange'
        ];
        xmlHttpRequestProps.forEach((prop)=>{
            if (prop in xhr && typeof xhr[prop] === 'function') // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (0, $3dFJR.fill)(xhr, prop, function(original) {
                const wrapOptions = {
                    mechanism: {
                        data: {
                            function: prop,
                            handler: (0, $amn5g.getFunctionName)(original)
                        },
                        handled: false,
                        type: 'instrument'
                    }
                };
                // If Instrument integration has been called before TryCatch, get the name of original function
                const originalFunction = (0, $3dFJR.getOriginalFunction)(original);
                if (originalFunction) wrapOptions.mechanism.data.handler = (0, $amn5g.getFunctionName)(originalFunction);
                // Otherwise wrap directly
                return (0, $3FkMI.wrap)(original, wrapOptions);
            });
        });
        return originalSend.apply(this, args);
    };
}
function $e83cb3e6cc54780e$var$_wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const globalObject = (0, $3FkMI.WINDOW);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = globalObject[target] && globalObject[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
    (0, $3dFJR.fill)(proto, 'addEventListener', function(original) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') // ESlint disable explanation:
                //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
                //  introduce a bug here, because bind returns a new function that doesn't have our
                //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
                //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
                // eslint-disable-next-line @typescript-eslint/unbound-method
                fn.handleEvent = (0, $3FkMI.wrap)(fn.handleEvent, {
                    mechanism: {
                        data: {
                            function: 'handleEvent',
                            handler: (0, $amn5g.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                });
            } catch (err) {
            // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                (0, $3FkMI.wrap)(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: (0, $amn5g.getFunctionName)(fn),
                            target: target
                        },
                        handled: false,
                        type: 'instrument'
                    }
                }),
                options
            ]);
        };
    });
    (0, $3dFJR.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
        return function(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        eventName, fn, options) {
            /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */ const wrappedEventHandler = fn;
            try {
                const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
            } catch (e) {
            // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

});

parcelRegister("7JgVP", function(module, exports) {
$parcel$export(module.exports, "defaultStackParser", () => $5a09dea27edb4e14$export$2b2b997d81bf3907);

var $amn5g = parcelRequire("amn5g");
// global reference to slice
const $5a09dea27edb4e14$var$UNKNOWN_FUNCTION = '?';
const $5a09dea27edb4e14$var$OPERA10_PRIORITY = 10;
const $5a09dea27edb4e14$var$OPERA11_PRIORITY = 20;
const $5a09dea27edb4e14$var$CHROME_PRIORITY = 30;
const $5a09dea27edb4e14$var$WINJS_PRIORITY = 40;
const $5a09dea27edb4e14$var$GECKO_PRIORITY = 50;
function $5a09dea27edb4e14$var$createFrame(filename, func, lineno, colno) {
    const frame = {
        filename: filename,
        function: func,
        in_app: true
    };
    if (lineno !== undefined) frame.lineno = lineno;
    if (colno !== undefined) frame.colno = colno;
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const $5a09dea27edb4e14$var$chromeRegex = /^\s*at (?:(.+?\)(?: \[.+\])?|.*?) ?\((?:address at )?)?(?:async )?((?:<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const $5a09dea27edb4e14$var$chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
// We cannot call this variable `chrome` because it can conflict with global `chrome` variable in certain environments
// See: https://github.com/getsentry/sentry-javascript/issues/6880
const $5a09dea27edb4e14$var$chromeStackParserFn = (line)=>{
    const parts = $5a09dea27edb4e14$var$chromeRegex.exec(line);
    if (parts) {
        const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            const subMatch = $5a09dea27edb4e14$var$chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        const [func, filename] = $5a09dea27edb4e14$var$extractSafariExtensionDetails(parts[1] || $5a09dea27edb4e14$var$UNKNOWN_FUNCTION, parts[2]);
        return $5a09dea27edb4e14$var$createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
const $5a09dea27edb4e14$export$263a749fff749872 = [
    $5a09dea27edb4e14$var$CHROME_PRIORITY,
    $5a09dea27edb4e14$var$chromeStackParserFn
];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const $5a09dea27edb4e14$var$geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:[-a-z]+)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const $5a09dea27edb4e14$var$geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
const $5a09dea27edb4e14$var$gecko = (line)=>{
    const parts = $5a09dea27edb4e14$var$geckoREgex.exec(line);
    if (parts) {
        const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            const subMatch = $5a09dea27edb4e14$var$geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        let filename = parts[3];
        let func = parts[1] || $5a09dea27edb4e14$var$UNKNOWN_FUNCTION;
        [func, filename] = $5a09dea27edb4e14$var$extractSafariExtensionDetails(func, filename);
        return $5a09dea27edb4e14$var$createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
const $5a09dea27edb4e14$export$cdba47a5dd2804d = [
    $5a09dea27edb4e14$var$GECKO_PRIORITY,
    $5a09dea27edb4e14$var$gecko
];
const $5a09dea27edb4e14$var$winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:[-a-z]+):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
const $5a09dea27edb4e14$var$winjs = (line)=>{
    const parts = $5a09dea27edb4e14$var$winjsRegex.exec(line);
    return parts ? $5a09dea27edb4e14$var$createFrame(parts[2], parts[1] || $5a09dea27edb4e14$var$UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined) : undefined;
};
const $5a09dea27edb4e14$export$179460296da408e8 = [
    $5a09dea27edb4e14$var$WINJS_PRIORITY,
    $5a09dea27edb4e14$var$winjs
];
const $5a09dea27edb4e14$var$opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
const $5a09dea27edb4e14$var$opera10 = (line)=>{
    const parts = $5a09dea27edb4e14$var$opera10Regex.exec(line);
    return parts ? $5a09dea27edb4e14$var$createFrame(parts[2], parts[3] || $5a09dea27edb4e14$var$UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
const $5a09dea27edb4e14$export$f892b52c880ffc7a = [
    $5a09dea27edb4e14$var$OPERA10_PRIORITY,
    $5a09dea27edb4e14$var$opera10
];
const $5a09dea27edb4e14$var$opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
const $5a09dea27edb4e14$var$opera11 = (line)=>{
    const parts = $5a09dea27edb4e14$var$opera11Regex.exec(line);
    return parts ? $5a09dea27edb4e14$var$createFrame(parts[5], parts[3] || parts[4] || $5a09dea27edb4e14$var$UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
const $5a09dea27edb4e14$export$af11af13f09fb0dc = [
    $5a09dea27edb4e14$var$OPERA11_PRIORITY,
    $5a09dea27edb4e14$var$opera11
];
const $5a09dea27edb4e14$export$7197c0fe6554c079 = [
    $5a09dea27edb4e14$export$263a749fff749872,
    $5a09dea27edb4e14$export$cdba47a5dd2804d,
    $5a09dea27edb4e14$export$179460296da408e8
];
const $5a09dea27edb4e14$export$2b2b997d81bf3907 = (0, $amn5g.createStackParser)(...$5a09dea27edb4e14$export$7197c0fe6554c079);
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */ const $5a09dea27edb4e14$var$extractSafariExtensionDetails = (func, filename)=>{
    const isSafariExtension = func.indexOf('safari-extension') !== -1;
    const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : $5a09dea27edb4e14$var$UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`
    ] : [
        func,
        filename
    ];
};

});

parcelRegister("3SNJd", function(module, exports) {
$parcel$export(module.exports, "makeFetchTransport", () => $2d3cfd3debb30c89$export$b2311068c46d7cc8);

var $5ks7K = parcelRequire("5ks7K");

var $dtmqq = parcelRequire("dtmqq");

var $9eUfH = parcelRequire("9eUfH");
/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */ function $2d3cfd3debb30c89$export$b2311068c46d7cc8(options, nativeFetch = (0, $9eUfH.getNativeFetchImplementation)()) {
    let pendingBodySize = 0;
    let pendingCount = 0;
    function makeRequest(request) {
        const requestSize = request.body.length;
        pendingBodySize += requestSize;
        pendingCount++;
        const requestOptions = {
            body: request.body,
            method: 'POST',
            referrerPolicy: 'origin',
            headers: options.headers,
            // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
            // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
            // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
            // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
            // Gotchas:
            // - `keepalive` isn't supported by Firefox
            // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch):
            //   If the sum of contentLength and inflightKeepaliveBytes is greater than 64 kibibytes, then return a network error.
            //   We will therefore only activate the flag when we're below that limit.
            // There is also a limit of requests that can be open at the same time, so we also limit this to 15
            // See https://github.com/getsentry/sentry-javascript/pull/7553 for details
            keepalive: pendingBodySize <= 60000 && pendingCount < 15,
            ...options.fetchOptions
        };
        try {
            return nativeFetch(options.url, requestOptions).then((response)=>{
                pendingBodySize -= requestSize;
                pendingCount--;
                return {
                    statusCode: response.status,
                    headers: {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After')
                    }
                };
            });
        } catch (e) {
            (0, $9eUfH.clearCachedFetchImplementation)();
            pendingBodySize -= requestSize;
            pendingCount--;
            return (0, $dtmqq.rejectedSyncPromise)(e);
        }
    }
    return (0, $5ks7K.createTransport)(options, makeRequest);
}

});
parcelRegister("5ks7K", function(module, exports) {
$parcel$export(module.exports, "createTransport", () => $3e14a2d32e466f22$export$d09f50d9ab7f7b69);

var $9CzI9 = parcelRequire("9CzI9");
var $egZpt = parcelRequire("egZpt");
var $6lJZW = parcelRequire("6lJZW");
var $bONan = parcelRequire("bONan");
var $dtmqq = parcelRequire("dtmqq");
var $lxc2k = parcelRequire("lxc2k");

var $fZ2r3 = parcelRequire("fZ2r3");
const $3e14a2d32e466f22$export$e515cf6dfd2f98b8 = 30;
/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */ function $3e14a2d32e466f22$export$d09f50d9ab7f7b69(options, makeRequest, buffer = (0, $bONan.makePromiseBuffer)(options.bufferSize || $3e14a2d32e466f22$export$e515cf6dfd2f98b8)) {
    let rateLimits = {};
    const flush = (timeout)=>buffer.drain(timeout);
    function send(envelope) {
        const filteredEnvelopeItems = [];
        // Drop rate limited items from envelope
        (0, $9CzI9.forEachEnvelopeItem)(envelope, (item, type)=>{
            const dataCategory = (0, $9CzI9.envelopeItemTypeToDataCategory)(type);
            if ((0, $egZpt.isRateLimited)(rateLimits, dataCategory)) {
                const event = $3e14a2d32e466f22$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent('ratelimit_backoff', dataCategory, event);
            } else filteredEnvelopeItems.push(item);
        });
        // Skip sending if envelope is empty after filtering out rate limited events
        if (filteredEnvelopeItems.length === 0) return (0, $dtmqq.resolvedSyncPromise)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const filteredEnvelope = (0, $9CzI9.createEnvelope)(envelope[0], filteredEnvelopeItems);
        // Creates client report for each item in an envelope
        const recordEnvelopeLoss = (reason)=>{
            (0, $9CzI9.forEachEnvelopeItem)(filteredEnvelope, (item, type)=>{
                const event = $3e14a2d32e466f22$var$getEventForEnvelopeItem(item, type);
                options.recordDroppedEvent(reason, (0, $9CzI9.envelopeItemTypeToDataCategory)(type), event);
            });
        };
        const requestTask = ()=>makeRequest({
                body: (0, $9CzI9.serializeEnvelope)(filteredEnvelope, options.textEncoder)
            }).then((response)=>{
                // We don't want to throw on NOK responses, but we want to at least log them
                if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
                rateLimits = (0, $egZpt.updateRateLimits)(rateLimits, response);
                return response;
            }, (error)=>{
                recordEnvelopeLoss('network_error');
                throw error;
            });
        return buffer.add(requestTask).then((result)=>result, (error)=>{
            if (error instanceof (0, $lxc2k.SentryError)) {
                (0, $fZ2r3.DEBUG_BUILD) && (0, $6lJZW.logger).error('Skipped sending event because buffer is full.');
                recordEnvelopeLoss('queue_overflow');
                return (0, $dtmqq.resolvedSyncPromise)();
            } else throw error;
        });
    }
    // We use this to identifify if the transport is the base transport
    // TODO (v8): Remove this again as we'll no longer need it
    send.__sentry__baseTransport__ = true;
    return {
        send: send,
        flush: flush
    };
}
function $3e14a2d32e466f22$var$getEventForEnvelopeItem(item, type) {
    if (type !== 'event' && type !== 'transaction') return undefined;
    return Array.isArray(item) ? item[1] : undefined;
}

});
parcelRegister("egZpt", function(module, exports) {
$parcel$export(module.exports, "isRateLimited", () => $a642320356270be7$export$6c91fec22056810a);
$parcel$export(module.exports, "updateRateLimits", () => $a642320356270be7$export$699aff705e0d49d4);
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend
const $a642320356270be7$export$b09ce39faaeb1e7c = 60000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */ function $a642320356270be7$export$615352e17ed7741(header, now = Date.now()) {
    const headerDelay = parseInt(`${header}`, 10);
    if (!isNaN(headerDelay)) return headerDelay * 1000;
    const headerDate = Date.parse(`${header}`);
    if (!isNaN(headerDate)) return headerDate - now;
    return $a642320356270be7$export$b09ce39faaeb1e7c;
}
/**
 * Gets the time that the given category is disabled until for rate limiting.
 * In case no category-specific limit is set but a general rate limit across all categories is active,
 * that time is returned.
 *
 * @return the time in ms that the category is disabled until or 0 if there's no active rate limit.
 */ function $a642320356270be7$export$b89fc7b2e4c799e7(limits, dataCategory) {
    return limits[dataCategory] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */ function $a642320356270be7$export$6c91fec22056810a(limits, dataCategory, now = Date.now()) {
    return $a642320356270be7$export$b89fc7b2e4c799e7(limits, dataCategory) > now;
}
/**
 * Update ratelimits from incoming headers.
 *
 * @return the updated RateLimits object.
 */ function $a642320356270be7$export$699aff705e0d49d4(limits, { statusCode: statusCode, headers: headers }, now = Date.now()) {
    const updatedRateLimits = {
        ...limits
    };
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
    const retryAfterHeader = headers && headers['retry-after'];
    if (rateLimitHeader) /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>: <namespaces>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     *     <namespaces> Semicolon-separated list of metric namespace identifiers. Defines which namespace(s) will be affected.
     *         Only present if rate limit applies to the metric_bucket data category.
     */ for (const limit of rateLimitHeader.trim().split(',')){
        const [retryAfter, categories, , , namespaces] = limit.split(':', 5);
        const headerDelay = parseInt(retryAfter, 10);
        const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
        if (!categories) updatedRateLimits.all = now + delay;
        else for (const category of categories.split(';')){
            if (category === 'metric_bucket') // namespaces will be present when category === 'metric_bucket'
            {
                if (!namespaces || namespaces.split(';').includes('custom')) updatedRateLimits[category] = now + delay;
            } else updatedRateLimits[category] = now + delay;
        }
    }
    else if (retryAfterHeader) updatedRateLimits.all = now + $a642320356270be7$export$615352e17ed7741(retryAfterHeader, now);
    else if (statusCode === 429) updatedRateLimits.all = now + 60000;
    return updatedRateLimits;
}

});

parcelRegister("bONan", function(module, exports) {
$parcel$export(module.exports, "makePromiseBuffer", () => $89aa80a6d2bece5d$export$85a4f67f852183e6);

var $lxc2k = parcelRequire("lxc2k");

var $dtmqq = parcelRequire("dtmqq");
/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */ function $89aa80a6d2bece5d$export$85a4f67f852183e6(limit) {
    const buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */ function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */ function add(taskProducer) {
        if (!isReady()) return (0, $dtmqq.rejectedSyncPromise)(new (0, $lxc2k.SentryError)('Not adding Promise because buffer limit was reached.'));
        // start the task and add its promise to the queue
        const task = taskProducer();
        if (buffer.indexOf(task) === -1) buffer.push(task);
        task.then(()=>remove(task))// Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
        // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
        // have promises, so TS has to polyfill when down-compiling.)
        .then(null, ()=>remove(task).then(null, ()=>{
            // We have to add another catch here because `remove()` starts a new promise chain.
            }));
        return task;
    }
    /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */ function drain(timeout) {
        return new (0, $dtmqq.SyncPromise)((resolve, reject)=>{
            let counter = buffer.length;
            if (!counter) return resolve(true);
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            const capturedSetTimeout = setTimeout(()=>{
                if (timeout && timeout > 0) resolve(false);
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach((item)=>{
                (0, $dtmqq.resolvedSyncPromise)(item).then(()=>{
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain
    };
}

});


parcelRegister("9eUfH", function(module, exports) {
$parcel$export(module.exports, "getNativeFetchImplementation", () => $6ba10e5e88e965b4$export$8be2119ce08e3379);
$parcel$export(module.exports, "clearCachedFetchImplementation", () => $6ba10e5e88e965b4$export$d499686d2dd738c6);

var $fsPAv = parcelRequire("fsPAv");
var $6lJZW = parcelRequire("6lJZW");

var $bl0Xy = parcelRequire("bl0Xy");

var $3FkMI = parcelRequire("3FkMI");
let $6ba10e5e88e965b4$var$cachedFetchImpl = undefined;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */ function $6ba10e5e88e965b4$export$8be2119ce08e3379() {
    if ($6ba10e5e88e965b4$var$cachedFetchImpl) return $6ba10e5e88e965b4$var$cachedFetchImpl;
    /* eslint-disable @typescript-eslint/unbound-method */ // Fast path to avoid DOM I/O
    if ((0, $fsPAv.isNativeFetch)((0, $3FkMI.WINDOW).fetch)) return $6ba10e5e88e965b4$var$cachedFetchImpl = (0, $3FkMI.WINDOW).fetch.bind((0, $3FkMI.WINDOW));
    const document = (0, $3FkMI.WINDOW).document;
    let fetchImpl = (0, $3FkMI.WINDOW).fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') try {
        const sandbox = document.createElement('iframe');
        sandbox.hidden = true;
        document.head.appendChild(sandbox);
        const contentWindow = sandbox.contentWindow;
        if (contentWindow && contentWindow.fetch) fetchImpl = contentWindow.fetch;
        document.head.removeChild(sandbox);
    } catch (e) {
        (0, $bl0Xy.DEBUG_BUILD) && (0, $6lJZW.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
    return $6ba10e5e88e965b4$var$cachedFetchImpl = fetchImpl.bind((0, $3FkMI.WINDOW));
/* eslint-enable @typescript-eslint/unbound-method */ }
/** Clears cached fetch impl */ function $6ba10e5e88e965b4$export$d499686d2dd738c6() {
    $6ba10e5e88e965b4$var$cachedFetchImpl = undefined;
}

});


parcelRegister("1FjJN", function(module, exports) {
$parcel$export(module.exports, "makeXHRTransport", () => $1368ee45dd559bc3$export$5e1441cee30d5a39);

var $5ks7K = parcelRequire("5ks7K");

var $dtmqq = parcelRequire("dtmqq");
/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */ const $1368ee45dd559bc3$var$XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */ function $1368ee45dd559bc3$export$5e1441cee30d5a39(options) {
    function makeRequest(request) {
        return new (0, $dtmqq.SyncPromise)((resolve, reject)=>{
            const xhr = new XMLHttpRequest();
            xhr.onerror = reject;
            xhr.onreadystatechange = ()=>{
                if (xhr.readyState === $1368ee45dd559bc3$var$XHR_READYSTATE_DONE) resolve({
                    statusCode: xhr.status,
                    headers: {
                        'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                        'retry-after': xhr.getResponseHeader('Retry-After')
                    }
                });
            };
            xhr.open('POST', options.url);
            for(const header in options.headers)if (Object.prototype.hasOwnProperty.call(options.headers, header)) xhr.setRequestHeader(header, options.headers[header]);
            xhr.send(request.body);
        });
    }
    return (0, $5ks7K.createTransport)(options, makeRequest);
}

});


parcelRegister("kvkQX", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $eed6e0e057d8942d$export$99d02219d259eb94);

var $3vr70 = parcelRequire("3vr70");
var $1feQE = parcelRequire("1feQE");
var $kINbm = parcelRequire("kINbm");
var $gIi6D = parcelRequire("gIi6D");


var $lt7A0 = parcelRequire("lt7A0");

var $3SNJd = parcelRequire("3SNJd");


var $7JgVP = parcelRequire("7JgVP");



var $38t4T = parcelRequire("38t4T");







var $ezgAK = parcelRequire("ezgAK");

var $lOA8N = parcelRequire("lOA8N");


var $lOA8N = parcelRequire("lOA8N");





let $eed6e0e057d8942d$var$windowIntegrations = {};
/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $eed6e0e057d8942d$export$99d02219d259eb94 = {
    ...$eed6e0e057d8942d$var$windowIntegrations,
    // eslint-disable-next-line deprecation/deprecation
    ...(0, $gIi6D.Integrations),
    ...$ezgAK
};

});
parcelRegister("gIi6D", function(module, exports) {
$parcel$export(module.exports, "Integrations", () => $c2aecce334b74f3f$export$99d02219d259eb94);













var $3vr70 = parcelRequire("3vr70");

var $kINbm = parcelRequire("kINbm");




var $1feQE = parcelRequire("1feQE");

var $71uQM = parcelRequire("71uQM");

var $1NMDh = parcelRequire("1NMDh");


var $bQI3R = parcelRequire("bQI3R");

var $5ks7K = parcelRequire("5ks7K");




var $8WCUT = parcelRequire("8WCUT");











var $2XwhW = parcelRequire("2XwhW");




var $hTs4r = parcelRequire("hTs4r");

var $3idHc = parcelRequire("3idHc");


var $6Uzyg = parcelRequire("6Uzyg");

/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ const $c2aecce334b74f3f$export$99d02219d259eb94 = $6Uzyg;

});
parcelRegister("6Uzyg", function(module, exports) {
$parcel$export(module.exports, "FunctionToString", () => (parcelRequire("3idHc")).FunctionToString);
$parcel$export(module.exports, "InboundFilters", () => (parcelRequire("hTs4r")).InboundFilters);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("3kUOV")).LinkedErrors);

var $3idHc = parcelRequire("3idHc");

var $hTs4r = parcelRequire("hTs4r");

var $3kUOV = parcelRequire("3kUOV");
 /* eslint-disable deprecation/deprecation */ 
});
parcelRegister("3kUOV", function(module, exports) {
$parcel$export(module.exports, "LinkedErrors", () => $26df50b0a5bc8189$export$8d1e60aaf616fb4f);

var $1EqWC = parcelRequire("1EqWC");
var $dFeC8 = parcelRequire("dFeC8");

var $8WCUT = parcelRequire("8WCUT");
const $26df50b0a5bc8189$var$DEFAULT_KEY = 'cause';
const $26df50b0a5bc8189$var$DEFAULT_LIMIT = 5;
const $26df50b0a5bc8189$var$INTEGRATION_NAME = 'LinkedErrors';
const $26df50b0a5bc8189$var$_linkedErrorsIntegration = (options = {})=>{
    const limit = options.limit || $26df50b0a5bc8189$var$DEFAULT_LIMIT;
    const key = options.key || $26df50b0a5bc8189$var$DEFAULT_KEY;
    return {
        name: $26df50b0a5bc8189$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        preprocessEvent (event, hint, client) {
            const options = client.getOptions();
            (0, $1EqWC.applyAggregateErrorsToEvent)((0, $dFeC8.exceptionFromError), options.stackParser, options.maxValueLength, key, limit, event, hint);
        }
    };
};
const $26df50b0a5bc8189$export$ebabb00eb7f3a395 = (0, $8WCUT.defineIntegration)($26df50b0a5bc8189$var$_linkedErrorsIntegration);
/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $26df50b0a5bc8189$export$8d1e60aaf616fb4f = (0, $8WCUT.convertIntegrationFnToClass)($26df50b0a5bc8189$var$INTEGRATION_NAME, $26df50b0a5bc8189$export$ebabb00eb7f3a395);

});
parcelRegister("dFeC8", function(module, exports) {
$parcel$export(module.exports, "exceptionFromError", () => $9f2a70bcca4952d7$export$a6c2d27607295951);

var $2Jaqc = parcelRequire("2Jaqc");

var $kgI9H = parcelRequire("kgI9H");

var $9ZmTE = parcelRequire("9ZmTE");

var $3dFJR = parcelRequire("3dFJR");
/**
 * Extracts stack frames from the error.stack string
 */ function $9f2a70bcca4952d7$export$d478b2c12fbcfdda(stackParser, error) {
    return stackParser(error.stack || '', 1);
}
/**
 * Extracts stack frames from the error and builds a Sentry Exception
 */ function $9f2a70bcca4952d7$export$a6c2d27607295951(stackParser, error) {
    const exception = {
        type: error.name || error.constructor.name,
        value: error.message
    };
    const frames = $9f2a70bcca4952d7$export$d478b2c12fbcfdda(stackParser, error);
    if (frames.length) exception.stacktrace = {
        frames: frames
    };
    return exception;
}
function $9f2a70bcca4952d7$var$getMessageForObject(exception) {
    if ('name' in exception && typeof exception.name === 'string') {
        let message = `'${exception.name}' captured as exception`;
        if ('message' in exception && typeof exception.message === 'string') message += ` with message '${exception.message}'`;
        return message;
    } else if ('message' in exception && typeof exception.message === 'string') return exception.message;
    else // This will allow us to group events based on top-level keys
    // which is much better than creating new group when any key/value change
    return `Object captured as exception with keys: ${(0, $3dFJR.extractExceptionKeysForMessage)(exception)}`;
}
/**
 * Builds and Event from a Exception
 *
 * TODO(v8): Remove getHub fallback
 * @hidden
 */ function $9f2a70bcca4952d7$export$9dd56ed1ef0c3420(// eslint-disable-next-line deprecation/deprecation
getHubOrClient, stackParser, exception, hint) {
    const client = typeof getHubOrClient === 'function' ? getHubOrClient().getClient() : getHubOrClient;
    let ex = exception;
    const providedMechanism = hint && hint.data && hint.data.mechanism;
    const mechanism = providedMechanism || {
        handled: true,
        type: 'generic'
    };
    let extras;
    if (!(0, $2Jaqc.isError)(exception)) {
        if ((0, $2Jaqc.isPlainObject)(exception)) {
            const normalizeDepth = client && client.getOptions().normalizeDepth;
            extras = {
                ['__serialized__']: (0, $9ZmTE.normalizeToSize)(exception, normalizeDepth)
            };
            const message = $9f2a70bcca4952d7$var$getMessageForObject(exception);
            ex = hint && hint.syntheticException || new Error(message);
            ex.message = message;
        } else {
            // This handles when someone does: `throw "something awesome";`
            // We use synthesized Error here so we can extract a (rough) stack trace.
            ex = hint && hint.syntheticException || new Error(exception);
            ex.message = exception;
        }
        mechanism.synthetic = true;
    }
    const event = {
        exception: {
            values: [
                $9f2a70bcca4952d7$export$a6c2d27607295951(stackParser, ex)
            ]
        }
    };
    if (extras) event.extra = extras;
    (0, $kgI9H.addExceptionTypeValue)(event, undefined, undefined);
    (0, $kgI9H.addExceptionMechanism)(event, mechanism);
    return {
        ...event,
        event_id: hint && hint.event_id
    };
}
/**
 * Builds and Event from a Message
 * @hidden
 */ function $9f2a70bcca4952d7$export$5425b53185d13d6c(stackParser, message, // eslint-disable-next-line deprecation/deprecation
level = 'info', hint, attachStacktrace) {
    const event = {
        event_id: hint && hint.event_id,
        level: level
    };
    if (attachStacktrace && hint && hint.syntheticException) {
        const frames = $9f2a70bcca4952d7$export$d478b2c12fbcfdda(stackParser, hint.syntheticException);
        if (frames.length) event.exception = {
            values: [
                {
                    value: message,
                    stacktrace: {
                        frames: frames
                    }
                }
            ]
        };
    }
    if ((0, $2Jaqc.isParameterizedString)(message)) {
        const { __sentry_template_string__: __sentry_template_string__, __sentry_template_values__: __sentry_template_values__ } = message;
        event.logentry = {
            message: __sentry_template_string__,
            params: __sentry_template_values__
        };
        return event;
    }
    event.message = message;
    return event;
}

});




parcelRegister("ezgAK", function(module, exports) {
$parcel$export(module.exports, "GlobalHandlers", () => (parcelRequire("jFqF2")).GlobalHandlers);
$parcel$export(module.exports, "TryCatch", () => (parcelRequire("jWbWT")).TryCatch);
$parcel$export(module.exports, "Breadcrumbs", () => (parcelRequire("fK4F3")).Breadcrumbs);
$parcel$export(module.exports, "LinkedErrors", () => (parcelRequire("fTNUR")).LinkedErrors);
$parcel$export(module.exports, "HttpContext", () => (parcelRequire("11Thk")).HttpContext);
$parcel$export(module.exports, "Dedupe", () => (parcelRequire("lo7wK")).Dedupe);

var $jFqF2 = parcelRequire("jFqF2");

var $jWbWT = parcelRequire("jWbWT");

var $fK4F3 = parcelRequire("fK4F3");

var $fTNUR = parcelRequire("fTNUR");

var $11Thk = parcelRequire("11Thk");

var $lo7wK = parcelRequire("lo7wK");
 /* eslint-disable deprecation/deprecation */ 
});


parcelRegister("5fWuD", function(module, exports) {
$parcel$export(module.exports, "captureConsoleIntegration", () => $3d3bb9f8cd87f17d$export$caa9b6c4a4144db4);
$parcel$export(module.exports, "CaptureConsole", () => $3d3bb9f8cd87f17d$export$25a43cb5b5c58c08);

var $511RT = parcelRequire("511RT");
var $fAZCe = parcelRequire("fAZCe");

var $5GIDi = parcelRequire("5GIDi");
var $frGXd = parcelRequire("frGXd");
var $ihOje = parcelRequire("ihOje");
var $euqZU = parcelRequire("euqZU");
var $4q36w = parcelRequire("4q36w");
var $fmRSM = parcelRequire("fmRSM");
const $3d3bb9f8cd87f17d$var$INTEGRATION_NAME = 'CaptureConsole';
const $3d3bb9f8cd87f17d$var$_captureConsoleIntegration = (options = {})=>{
    const levels = options.levels || (0, $ihOje.CONSOLE_LEVELS);
    return {
        name: $3d3bb9f8cd87f17d$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        setup (client) {
            if (!('console' in (0, $euqZU.GLOBAL_OBJ))) return;
            (0, $5GIDi.addConsoleInstrumentationHandler)(({ args: args, level: level })=>{
                if ((0, $511RT.getClient)() !== client || !levels.includes(level)) return;
                $3d3bb9f8cd87f17d$var$consoleHandler(args, level);
            });
        }
    };
};
const $3d3bb9f8cd87f17d$export$caa9b6c4a4144db4 = (0, $fAZCe.defineIntegration)($3d3bb9f8cd87f17d$var$_captureConsoleIntegration);
/**
 * Send Console API calls as Sentry Events.
 * @deprecated Use `captureConsoleIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $3d3bb9f8cd87f17d$export$25a43cb5b5c58c08 = (0, $fAZCe.convertIntegrationFnToClass)($3d3bb9f8cd87f17d$var$INTEGRATION_NAME, $3d3bb9f8cd87f17d$export$caa9b6c4a4144db4);
function $3d3bb9f8cd87f17d$var$consoleHandler(args, level) {
    const captureContext = {
        level: (0, $fmRSM.severityLevelFromString)(level),
        extra: {
            arguments: args
        }
    };
    (0, $511RT.withScope)((scope)=>{
        scope.addEventProcessor((event)=>{
            event.logger = 'console';
            (0, $frGXd.addExceptionMechanism)(event, {
                handled: false,
                type: 'console'
            });
            return event;
        });
        if (level === 'assert' && args[0] === false) {
            const message = `Assertion failed: ${(0, $4q36w.safeJoin)(args.slice(1), ' ') || 'console.assert'}`;
            scope.setExtra('arguments', args.slice(1));
            (0, $511RT.captureMessage)(message, captureContext);
            return;
        }
        const error = args.find((arg)=>arg instanceof Error);
        if (level === 'error' && error) {
            (0, $511RT.captureException)(error, captureContext);
            return;
        }
        const message = (0, $4q36w.safeJoin)(args, ' ');
        (0, $511RT.captureMessage)(message, captureContext);
    });
}

});
parcelRegister("511RT", function(module, exports) {
$parcel$export(module.exports, "captureException", () => $3a6e7eb8f319d6cb$export$f5282963edea4a68);
$parcel$export(module.exports, "captureMessage", () => $3a6e7eb8f319d6cb$export$45654777c133ae80);
$parcel$export(module.exports, "captureEvent", () => $3a6e7eb8f319d6cb$export$1462b974fdcf6ba2);
$parcel$export(module.exports, "withScope", () => $3a6e7eb8f319d6cb$export$ec58d9285c204497);
$parcel$export(module.exports, "getCurrentScope", () => $3a6e7eb8f319d6cb$export$c7be4b0125a10cba);
$parcel$export(module.exports, "getClient", () => $3a6e7eb8f319d6cb$export$6bb76d6eba7e258c);

var $euqZU = parcelRequire("euqZU");
var $ja8Ap = parcelRequire("ja8Ap");
var $ihOje = parcelRequire("ihOje");
var $bjakf = parcelRequire("bjakf");
var $frGXd = parcelRequire("frGXd");

var $4jwTD = parcelRequire("4jwTD");

var $1pxS3 = parcelRequire("1pxS3");

var $e8ylv = parcelRequire("e8ylv");

var $4bksy = parcelRequire("4bksy");

var $3fbVq = parcelRequire("3fbVq");
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured Sentry event.
 */ function $3a6e7eb8f319d6cb$export$f5282963edea4a68(// eslint-disable-next-line @typescript-eslint/no-explicit-any
exception, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $e8ylv.getCurrentHub)().captureException(exception, (0, $3fbVq.parseEventHintOrCaptureContext)(hint));
}
/**
 * Captures a message event and sends it to Sentry.
 *
 * @param exception The exception to capture.
 * @param captureContext Define the level of the message or pass in additional data to attach to the message.
 * @returns the id of the captured message.
 */ function $3a6e7eb8f319d6cb$export$45654777c133ae80(message, // eslint-disable-next-line deprecation/deprecation
captureContext) {
    // This is necessary to provide explicit scopes upgrade, without changing the original
    // arity of the `captureMessage(message, level)` method.
    const level = typeof captureContext === 'string' ? captureContext : undefined;
    const context = typeof captureContext !== 'string' ? {
        captureContext: captureContext
    } : undefined;
    // eslint-disable-next-line deprecation/deprecation
    return (0, $e8ylv.getCurrentHub)().captureMessage(message, level, context);
}
/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param exception The event to send to Sentry.
 * @param hint Optional additional data to attach to the Sentry event.
 * @returns the id of the captured event.
 */ function $3a6e7eb8f319d6cb$export$1462b974fdcf6ba2(event, hint) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $e8ylv.getCurrentHub)().captureEvent(event, hint);
}
/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 *
 * @deprecated Use getCurrentScope() directly.
 */ // eslint-disable-next-line deprecation/deprecation
function $3a6e7eb8f319d6cb$export$99d44f04437e9cb8(callback) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $e8ylv.getCurrentHub)().configureScope(callback);
}
/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */ // eslint-disable-next-line deprecation/deprecation
function $3a6e7eb8f319d6cb$export$efda9a273d7a036d(breadcrumb, hint) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $e8ylv.getCurrentHub)().addBreadcrumb(breadcrumb, hint);
}
/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, deprecation/deprecation
function $3a6e7eb8f319d6cb$export$2f04de43fe27971a(name, context) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $e8ylv.getCurrentHub)().setContext(name, context);
}
/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $3a6e7eb8f319d6cb$export$bb4922da0dd51b92(extras) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $e8ylv.getCurrentHub)().setExtras(extras);
}
/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */ // eslint-disable-next-line deprecation/deprecation
function $3a6e7eb8f319d6cb$export$8e8e7789d42ed61d(key, extra) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $e8ylv.getCurrentHub)().setExtra(key, extra);
}
/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */ // eslint-disable-next-line deprecation/deprecation
function $3a6e7eb8f319d6cb$export$74a8fb34822092e6(tags) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $e8ylv.getCurrentHub)().setTags(tags);
}
/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */ // eslint-disable-next-line deprecation/deprecation
function $3a6e7eb8f319d6cb$export$a37d07ee78eb4569(key, value) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $e8ylv.getCurrentHub)().setTag(key, value);
}
/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */ // eslint-disable-next-line deprecation/deprecation
function $3a6e7eb8f319d6cb$export$8b6bb3dd62a01be2(user) {
    // eslint-disable-next-line deprecation/deprecation
    (0, $e8ylv.getCurrentHub)().setUser(user);
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 */ /**
 * Either creates a new active scope, or sets the given scope as active scope in the given callback.
 */ function $3a6e7eb8f319d6cb$export$ec58d9285c204497(...rest) {
    // eslint-disable-next-line deprecation/deprecation
    const hub = (0, $e8ylv.getCurrentHub)();
    // If a scope is defined, we want to make this the active scope instead of the default one
    if (rest.length === 2) {
        const [scope, callback] = rest;
        if (!scope) // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(callback);
        // eslint-disable-next-line deprecation/deprecation
        return hub.withScope(()=>{
            // eslint-disable-next-line deprecation/deprecation
            hub.getStackTop().scope = scope;
            return callback(scope);
        });
    }
    // eslint-disable-next-line deprecation/deprecation
    return hub.withScope(rest[0]);
}
/**
 * Attempts to fork the current isolation scope and the current scope based on the current async context strategy. If no
 * async context strategy is set, the isolation scope and the current scope will not be forked (this is currently the
 * case, for example, in the browser).
 *
 * Usage of this function in environments without async context strategy is discouraged and may lead to unexpected behaviour.
 *
 * This function is intended for Sentry SDK and SDK integration development. It is not recommended to be used in "normal"
 * applications directly because it comes with pitfalls. Use at your own risk!
 *
 * @param callback The callback in which the passed isolation scope is active. (Note: In environments without async
 * context strategy, the currently active isolation scope may change within execution of the callback.)
 * @returns The same value that `callback` returns.
 */ function $3a6e7eb8f319d6cb$export$9a4fed82c350c2bd(callback) {
    return (0, $e8ylv.runWithAsyncContext)(()=>{
        return callback((0, $e8ylv.getIsolationScope)());
    });
}
/**
 * Forks the current scope and sets the provided span as active span in the context of the provided callback.
 *
 * @param span Spans started in the context of the provided callback will be children of this span.
 * @param callback Execution context in which the provided span will be active. Is passed the newly forked scope.
 * @returns the value returned from the provided callback function.
 */ function $3a6e7eb8f319d6cb$export$e57ac09b143d92a2(span, callback) {
    return $3a6e7eb8f319d6cb$export$ec58d9285c204497((scope)=>{
        // eslint-disable-next-line deprecation/deprecation
        scope.setSpan(span);
        return callback(scope);
    });
}
/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 *
 * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
 */ function $3a6e7eb8f319d6cb$export$e262da7ae6480481(context, customSamplingContext) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $e8ylv.getCurrentHub)().startTransaction({
        ...context
    }, customSamplingContext);
}
/**
 * Create a cron monitor check in and send it to Sentry.
 *
 * @param checkIn An object that describes a check in.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $3a6e7eb8f319d6cb$export$413528111fbc67c(checkIn, upsertMonitorConfig) {
    const scope = $3a6e7eb8f319d6cb$export$c7be4b0125a10cba();
    const client = $3a6e7eb8f319d6cb$export$6bb76d6eba7e258c();
    if (!client) (0, $1pxS3.DEBUG_BUILD) && (0, $ihOje.logger).warn('Cannot capture check-in. No client defined.');
    else if (!client.captureCheckIn) (0, $1pxS3.DEBUG_BUILD) && (0, $ihOje.logger).warn('Cannot capture check-in. Client does not support sending check-ins.');
    else return client.captureCheckIn(checkIn, upsertMonitorConfig, scope);
    return (0, $frGXd.uuid4)();
}
/**
 * Wraps a callback with a cron monitor check in. The check in will be sent to Sentry when the callback finishes.
 *
 * @param monitorSlug The distinct slug of the monitor.
 * @param upsertMonitorConfig An optional object that describes a monitor config. Use this if you want
 * to create a monitor automatically when sending a check in.
 */ function $3a6e7eb8f319d6cb$export$553526fc5f03c0b1(monitorSlug, callback, upsertMonitorConfig) {
    const checkInId = $3a6e7eb8f319d6cb$export$413528111fbc67c({
        monitorSlug: monitorSlug,
        status: 'in_progress'
    }, upsertMonitorConfig);
    const now = (0, $bjakf.timestampInSeconds)();
    function finishCheckIn(status) {
        $3a6e7eb8f319d6cb$export$413528111fbc67c({
            monitorSlug: monitorSlug,
            status: status,
            checkInId: checkInId,
            duration: (0, $bjakf.timestampInSeconds)() - now
        });
    }
    let maybePromiseResult;
    try {
        maybePromiseResult = callback();
    } catch (e) {
        finishCheckIn('error');
        throw e;
    }
    if ((0, $ja8Ap.isThenable)(maybePromiseResult)) Promise.resolve(maybePromiseResult).then(()=>{
        finishCheckIn('ok');
    }, ()=>{
        finishCheckIn('error');
    });
    else finishCheckIn('ok');
    return maybePromiseResult;
}
/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $3a6e7eb8f319d6cb$export$4909b86c8034bf73(timeout) {
    const client = $3a6e7eb8f319d6cb$export$6bb76d6eba7e258c();
    if (client) return client.flush(timeout);
    (0, $1pxS3.DEBUG_BUILD) && (0, $ihOje.logger).warn('Cannot flush events. No client defined.');
    return Promise.resolve(false);
}
/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */ async function $3a6e7eb8f319d6cb$export$8360e631d277ea4d(timeout) {
    const client = $3a6e7eb8f319d6cb$export$6bb76d6eba7e258c();
    if (client) return client.close(timeout);
    (0, $1pxS3.DEBUG_BUILD) && (0, $ihOje.logger).warn('Cannot flush events and disable SDK. No client defined.');
    return Promise.resolve(false);
}
/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */ function $3a6e7eb8f319d6cb$export$5d4e9fd7fac8e617() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $e8ylv.getCurrentHub)().lastEventId();
}
/**
 * Get the currently active client.
 */ function $3a6e7eb8f319d6cb$export$6bb76d6eba7e258c() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $e8ylv.getCurrentHub)().getClient();
}
/**
 * Returns true if Sentry has been properly initialized.
 */ function $3a6e7eb8f319d6cb$export$3f95c6f800b78024() {
    return !!$3a6e7eb8f319d6cb$export$6bb76d6eba7e258c();
}
/**
 * Get the currently active scope.
 */ function $3a6e7eb8f319d6cb$export$c7be4b0125a10cba() {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $e8ylv.getCurrentHub)().getScope();
}
/**
 * Start a session on the current isolation scope.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns the new active session
 */ function $3a6e7eb8f319d6cb$export$c0d84948cecf78d8(context) {
    const client = $3a6e7eb8f319d6cb$export$6bb76d6eba7e258c();
    const isolationScope = (0, $e8ylv.getIsolationScope)();
    const currentScope = $3a6e7eb8f319d6cb$export$c7be4b0125a10cba();
    const { release: release, environment: environment = (0, $4jwTD.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
    // Will fetch userAgent if called from browser sdk
    const { userAgent: userAgent } = (0, $euqZU.GLOBAL_OBJ).navigator || {};
    const session = (0, $4bksy.makeSession)({
        release: release,
        environment: environment,
        user: currentScope.getUser() || isolationScope.getUser(),
        ...userAgent && {
            userAgent: userAgent
        },
        ...context
    });
    // End existing session if there's one
    const currentSession = isolationScope.getSession();
    if (currentSession && currentSession.status === 'ok') (0, $4bksy.updateSession)(currentSession, {
        status: 'exited'
    });
    $3a6e7eb8f319d6cb$export$17a5be43989a0bc1();
    // Afterwards we set the new session on the scope
    isolationScope.setSession(session);
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession(session);
    return session;
}
/**
 * End the session on the current isolation scope.
 */ function $3a6e7eb8f319d6cb$export$17a5be43989a0bc1() {
    const isolationScope = (0, $e8ylv.getIsolationScope)();
    const currentScope = $3a6e7eb8f319d6cb$export$c7be4b0125a10cba();
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session) (0, $4bksy.closeSession)(session);
    $3a6e7eb8f319d6cb$var$_sendSessionUpdate();
    // the session is over; take it off of the scope
    isolationScope.setSession();
    // TODO (v8): Remove this and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    currentScope.setSession();
}
/**
 * Sends the current Session on the scope
 */ function $3a6e7eb8f319d6cb$var$_sendSessionUpdate() {
    const isolationScope = (0, $e8ylv.getIsolationScope)();
    const currentScope = $3a6e7eb8f319d6cb$export$c7be4b0125a10cba();
    const client = $3a6e7eb8f319d6cb$export$6bb76d6eba7e258c();
    // TODO (v8): Remove currentScope and only use the isolation scope(?).
    // For v7 though, we can't "soft-break" people using getCurrentHub().getScope().setSession()
    const session = currentScope.getSession() || isolationScope.getSession();
    if (session && client && client.captureSession) client.captureSession(session);
}
/**
 * Sends the current session on the scope to Sentry
 *
 * @param end If set the session will be marked as exited and removed from the scope.
 *            Defaults to `false`.
 */ function $3a6e7eb8f319d6cb$export$667e7b4d445d566b(end = false) {
    // both send the update and pull the session from the scope
    if (end) {
        $3a6e7eb8f319d6cb$export$17a5be43989a0bc1();
        return;
    }
    // only send the update
    $3a6e7eb8f319d6cb$var$_sendSessionUpdate();
}

});
parcelRegister("euqZU", function(module, exports) {
$parcel$export(module.exports, "GLOBAL_OBJ", () => $a8c8cf309392cfa0$export$f1a6cdb1459e81d1);
$parcel$export(module.exports, "getGlobalObject", () => $a8c8cf309392cfa0$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $a8c8cf309392cfa0$export$7e223ec222791509);
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $a8c8cf309392cfa0$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $a8c8cf309392cfa0$export$f1a6cdb1459e81d1 = typeof globalThis == 'object' && $a8c8cf309392cfa0$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && $a8c8cf309392cfa0$var$isGlobalObj(window) || typeof self == 'object' && $a8c8cf309392cfa0$var$isGlobalObj(self) || typeof $parcel$global == 'object' && $a8c8cf309392cfa0$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $a8c8cf309392cfa0$export$256479dc0cea61c4() {
    return $a8c8cf309392cfa0$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $a8c8cf309392cfa0$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $a8c8cf309392cfa0$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});

parcelRegister("ja8Ap", function(module, exports) {
$parcel$export(module.exports, "isError", () => $df359c8fa31f0a87$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $df359c8fa31f0a87$export$49034edbe6b62415);
$parcel$export(module.exports, "isString", () => $df359c8fa31f0a87$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $df359c8fa31f0a87$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $df359c8fa31f0a87$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $df359c8fa31f0a87$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $df359c8fa31f0a87$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $df359c8fa31f0a87$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $df359c8fa31f0a87$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $df359c8fa31f0a87$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $df359c8fa31f0a87$export$c9f5652083b8129d);
$parcel$export(module.exports, "isVueViewModel", () => $df359c8fa31f0a87$export$7916fad0ebc23f48);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $df359c8fa31f0a87$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $df359c8fa31f0a87$export$e6127cc7fe7395c3(wat) {
    switch($df359c8fa31f0a87$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $df359c8fa31f0a87$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $df359c8fa31f0a87$var$isBuiltin(wat, className) {
    return $df359c8fa31f0a87$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $df359c8fa31f0a87$export$9f9636d330b71954(wat) {
    return $df359c8fa31f0a87$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $df359c8fa31f0a87$export$ef9e2056653f0c8e(wat) {
    return $df359c8fa31f0a87$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $df359c8fa31f0a87$export$12e869b2a583f783(wat) {
    return $df359c8fa31f0a87$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $df359c8fa31f0a87$export$844ec244b1367d54(wat) {
    return $df359c8fa31f0a87$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given string is parameterized
 * {@link isParameterizedString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $df359c8fa31f0a87$export$dbcbffa59149b824(wat) {
    return typeof wat === 'object' && wat !== null && '__sentry_template_string__' in wat && '__sentry_template_values__' in wat;
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $df359c8fa31f0a87$export$c3825b437cbdea5c(wat) {
    return wat === null || $df359c8fa31f0a87$export$dbcbffa59149b824(wat) || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal, or a class instance.
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $df359c8fa31f0a87$export$53b83ca8eaab0383(wat) {
    return $df359c8fa31f0a87$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $df359c8fa31f0a87$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $df359c8fa31f0a87$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $df359c8fa31f0a87$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $df359c8fa31f0a87$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $df359c8fa31f0a87$export$49841c62b9eff15(wat) {
    return $df359c8fa31f0a87$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $df359c8fa31f0a87$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $df359c8fa31f0a87$export$bc2894c7158efbac(wat) {
    return $df359c8fa31f0a87$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $df359c8fa31f0a87$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $df359c8fa31f0a87$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}
/**
 * Checks whether given value's type is a Vue ViewModel.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $df359c8fa31f0a87$export$7916fad0ebc23f48(wat) {
    // Not using Object.prototype.toString because in Vue 3 it would read the instance's Symbol(Symbol.toStringTag) property.
    return !!(typeof wat === 'object' && wat !== null && (wat.__isVue || wat._isVue));
}

});

parcelRegister("ihOje", function(module, exports) {
$parcel$export(module.exports, "CONSOLE_LEVELS", () => $d500d6e6a4d2a0ee$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "originalConsoleMethods", () => $d500d6e6a4d2a0ee$export$77c4ce905194557b);
$parcel$export(module.exports, "consoleSandbox", () => $d500d6e6a4d2a0ee$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $d500d6e6a4d2a0ee$export$af88d00dbe7f521);

var $3CaV7 = parcelRequire("3CaV7");

var $euqZU = parcelRequire("euqZU");
/** Prefix for logging strings */ const $d500d6e6a4d2a0ee$var$PREFIX = 'Sentry Logger ';
const $d500d6e6a4d2a0ee$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/** This may be mutated by the console instrumentation. */ const $d500d6e6a4d2a0ee$export$77c4ce905194557b = {};
/** JSDoc */ /**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $d500d6e6a4d2a0ee$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $euqZU.GLOBAL_OBJ))) return callback();
    const console = (0, $euqZU.GLOBAL_OBJ).console;
    const wrappedFuncs = {};
    const wrappedLevels = Object.keys($d500d6e6a4d2a0ee$export$77c4ce905194557b);
    // Restore all wrapped console methods
    wrappedLevels.forEach((level)=>{
        const originalConsoleMethod = $d500d6e6a4d2a0ee$export$77c4ce905194557b[level];
        wrappedFuncs[level] = console[level];
        console[level] = originalConsoleMethod;
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        wrappedLevels.forEach((level)=>{
            console[level] = wrappedFuncs[level];
        });
    }
}
function $d500d6e6a4d2a0ee$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        },
        isEnabled: ()=>enabled
    };
    if (0, $3CaV7.DEBUG_BUILD) $d500d6e6a4d2a0ee$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $d500d6e6a4d2a0ee$export$cda52e2a8927a2ca(()=>{
                (0, $euqZU.GLOBAL_OBJ).console[name](`${$d500d6e6a4d2a0ee$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $d500d6e6a4d2a0ee$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
const $d500d6e6a4d2a0ee$export$af88d00dbe7f521 = $d500d6e6a4d2a0ee$var$makeLogger();

});
parcelRegister("3CaV7", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $2a1d64439d5e0a1b$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $2a1d64439d5e0a1b$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});


parcelRegister("bjakf", function(module, exports) {
$parcel$export(module.exports, "dateTimestampInSeconds", () => $83b97a856eb05217$export$7740643b9eeaf0c4);
$parcel$export(module.exports, "timestampInSeconds", () => $83b97a856eb05217$export$ee52dced521e3e18);

var $euqZU = parcelRequire("euqZU");
const $83b97a856eb05217$var$ONE_SECOND_IN_MS = 1000;
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 *
 * TODO(v8): Return type should be rounded.
 */ function $83b97a856eb05217$export$7740643b9eeaf0c4() {
    return Date.now() / $83b97a856eb05217$var$ONE_SECOND_IN_MS;
}
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function $83b97a856eb05217$var$createUnixTimestampInSecondsFunc() {
    const { performance: performance } = (0, $euqZU.GLOBAL_OBJ);
    if (!performance || !performance.now) return $83b97a856eb05217$export$7740643b9eeaf0c4;
    // Some browser and environments don't have a timeOrigin, so we fallback to
    // using Date.now() to compute the starting time.
    const approxStartingTimeOrigin = Date.now() - performance.now();
    const timeOrigin = performance.timeOrigin == undefined ? approxStartingTimeOrigin : performance.timeOrigin;
    // performance.now() is a monotonic clock, which means it starts at 0 when the process begins. To get the current
    // wall clock time (actual UNIX timestamp), we need to add the starting time origin and the current time elapsed.
    //
    // TODO: This does not account for the case where the monotonic clock that powers performance.now() drifts from the
    // wall clock time, which causes the returned timestamp to be inaccurate. We should investigate how to detect and
    // correct for this.
    // See: https://github.com/getsentry/sentry-javascript/issues/2590
    // See: https://github.com/mdn/content/issues/4713
    // See: https://dev.to/noamr/when-a-millisecond-is-not-a-millisecond-3h6
    return ()=>{
        return (timeOrigin + performance.now()) / $83b97a856eb05217$var$ONE_SECOND_IN_MS;
    };
}
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const $83b97a856eb05217$export$ee52dced521e3e18 = $83b97a856eb05217$var$createUnixTimestampInSecondsFunc();
/**
 * Re-exported with an old name for backwards-compatibility.
 * TODO (v8): Remove this
 *
 * @deprecated Use `timestampInSeconds` instead.
 */ const $83b97a856eb05217$export$c5907b5a8838db13 = $83b97a856eb05217$export$ee52dced521e3e18;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let $83b97a856eb05217$export$f9f8cce55af5194c;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const $83b97a856eb05217$export$baf075a948ffc0bf = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance: performance } = (0, $euqZU.GLOBAL_OBJ);
    if (!performance || !performance.now) {
        $83b97a856eb05217$export$f9f8cce55af5194c = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            $83b97a856eb05217$export$f9f8cce55af5194c = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            $83b97a856eb05217$export$f9f8cce55af5194c = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    $83b97a856eb05217$export$f9f8cce55af5194c = 'dateNow';
    return dateNow;
})();

});

parcelRegister("frGXd", function(module, exports) {
$parcel$export(module.exports, "uuid4", () => $b3eab26f7a86dc33$export$19f53698e68b2496);
$parcel$export(module.exports, "addExceptionMechanism", () => $b3eab26f7a86dc33$export$c69a9a0313b03bb1);
$parcel$export(module.exports, "addContextToFrame", () => $b3eab26f7a86dc33$export$ec2291bfc64632f0);
$parcel$export(module.exports, "arrayify", () => $b3eab26f7a86dc33$export$3131421a7d01b4fb);

var $1dhjw = parcelRequire("1dhjw");

var $4q36w = parcelRequire("4q36w");

var $euqZU = parcelRequire("euqZU");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $b3eab26f7a86dc33$export$19f53698e68b2496() {
    const gbl = (0, $euqZU.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    let getRandomByte = ()=>Math.random() * 16;
    try {
        if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
        if (crypto && crypto.getRandomValues) getRandomByte = ()=>{
            // crypto.getRandomValues might return undefined instead of the typed array
            // in old Chromium versions (e.g. 23.0.1235.0 (151422))
            // However, `typedArray` is still filled in-place.
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues#typedarray
            const typedArray = new Uint8Array(1);
            crypto.getRandomValues(typedArray);
            return typedArray[0];
        };
    } catch (_) {
    // some runtimes can crash invoking crypto
    // https://github.com/getsentry/sentry-javascript/issues/8935
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $b3eab26f7a86dc33$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $b3eab26f7a86dc33$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $b3eab26f7a86dc33$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $b3eab26f7a86dc33$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $b3eab26f7a86dc33$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $b3eab26f7a86dc33$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $b3eab26f7a86dc33$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $b3eab26f7a86dc33$export$d364f2020ab30578(input) {
    const match = input.match($b3eab26f7a86dc33$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $b3eab26f7a86dc33$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines - 1, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $4q36w.snipLine)(line, 0));
    frame.context_line = (0, $4q36w.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $4q36w.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $b3eab26f7a86dc33$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $1dhjw.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $b3eab26f7a86dc33$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("1dhjw", function(module, exports) {
$parcel$export(module.exports, "fill", () => $0e246f890349caa9$export$9563e054e6f787fb);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $0e246f890349caa9$export$e73679ffaf56810e);
$parcel$export(module.exports, "convertToPlainObject", () => $0e246f890349caa9$export$62ff257738bf57f5);
$parcel$export(module.exports, "dropUndefinedKeys", () => $0e246f890349caa9$export$d25f2688db1bb433);

var $ewVos = parcelRequire("ewVos");

var $3CaV7 = parcelRequire("3CaV7");

var $ja8Ap = parcelRequire("ja8Ap");

var $ihOje = parcelRequire("ihOje");

var $4q36w = parcelRequire("4q36w");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $0e246f890349caa9$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') $0e246f890349caa9$export$5c1499e2e5d010ae(wrapped, original);
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $0e246f890349caa9$export$e73679ffaf56810e(obj, name, value) {
    try {
        Object.defineProperty(obj, name, {
            // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
            value: value,
            writable: true,
            configurable: true
        });
    } catch (o_O) {
        (0, $3CaV7.DEBUG_BUILD) && (0, $ihOje.logger).log(`Failed to add non-enumerable property "${name}" to object`, obj);
    }
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $0e246f890349caa9$export$5c1499e2e5d010ae(wrapped, original) {
    try {
        const proto = original.prototype || {};
        wrapped.prototype = original.prototype = proto;
        $0e246f890349caa9$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
    } catch (o_O) {} // eslint-disable-line no-empty
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $0e246f890349caa9$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $0e246f890349caa9$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $0e246f890349caa9$export$62ff257738bf57f5(value) {
    if ((0, $ja8Ap.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$0e246f890349caa9$var$getOwnProperties(value)
    };
    else if ((0, $ja8Ap.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $0e246f890349caa9$var$serializeEventTarget(value.target),
            currentTarget: $0e246f890349caa9$var$serializeEventTarget(value.currentTarget),
            ...$0e246f890349caa9$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $ja8Ap.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $0e246f890349caa9$var$serializeEventTarget(target) {
    try {
        return (0, $ja8Ap.isElement)(target) ? (0, $ewVos.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $0e246f890349caa9$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $0e246f890349caa9$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($0e246f890349caa9$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $4q36w.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $4q36w.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $0e246f890349caa9$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $0e246f890349caa9$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $0e246f890349caa9$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ($0e246f890349caa9$var$isPojo(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $0e246f890349caa9$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($0e246f890349caa9$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
function $0e246f890349caa9$var$isPojo(input) {
    if (!(0, $ja8Ap.isPlainObject)(input)) return false;
    try {
        const name = Object.getPrototypeOf(input).constructor.name;
        return !name || name === 'Object';
    } catch (e) {
        return true;
    }
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $0e246f890349caa9$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $ja8Ap.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("ewVos", function(module, exports) {
$parcel$export(module.exports, "htmlTreeAsString", () => $a94092fa99d1a6dc$export$5647df6b7814ac86);

var $ja8Ap = parcelRequire("ja8Ap");

var $euqZU = parcelRequire("euqZU");
// eslint-disable-next-line deprecation/deprecation
const $a94092fa99d1a6dc$var$WINDOW = (0, $euqZU.getGlobalObject)();
const $a94092fa99d1a6dc$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $a94092fa99d1a6dc$export$5647df6b7814ac86(elem, options = {}) {
    if (!elem) return '<unknown>';
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $a94092fa99d1a6dc$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $a94092fa99d1a6dc$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $a94092fa99d1a6dc$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    // @ts-expect-error WINDOW has HTMLElement
    if ($a94092fa99d1a6dc$var$WINDOW.HTMLElement) {
        // If using the component name annotation plugin, this value may be available on the DOM node
        if (elem instanceof HTMLElement && elem.dataset && elem.dataset['sentryComponent']) return elem.dataset['sentryComponent'];
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $ja8Ap.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $a94092fa99d1a6dc$export$1cfafeee2987818b() {
    try {
        return $a94092fa99d1a6dc$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $a94092fa99d1a6dc$export$c660c1f3ab49225c(selector) {
    if ($a94092fa99d1a6dc$var$WINDOW.document && $a94092fa99d1a6dc$var$WINDOW.document.querySelector) return $a94092fa99d1a6dc$var$WINDOW.document.querySelector(selector);
    return null;
}
/**
 * Given a DOM element, traverses up the tree until it finds the first ancestor node
 * that has the `data-sentry-component` attribute. This attribute is added at build-time
 * by projects that have the component name annotation plugin installed.
 *
 * @returns a string representation of the component for the provided DOM element, or `null` if not found
 */ function $a94092fa99d1a6dc$export$26727cfcc4d7e0fc(elem) {
    // @ts-expect-error WINDOW has HTMLElement
    if (!$a94092fa99d1a6dc$var$WINDOW.HTMLElement) return null;
    let currentElem = elem;
    const MAX_TRAVERSE_HEIGHT = 5;
    for(let i = 0; i < MAX_TRAVERSE_HEIGHT; i++){
        if (!currentElem) return null;
        if (currentElem instanceof HTMLElement && currentElem.dataset['sentryComponent']) return currentElem.dataset['sentryComponent'];
        currentElem = currentElem.parentNode;
    }
    return null;
}

});

parcelRegister("4q36w", function(module, exports) {
$parcel$export(module.exports, "truncate", () => $337bff8cfad2a78f$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $337bff8cfad2a78f$export$4215662d762d6f9d);
$parcel$export(module.exports, "safeJoin", () => $337bff8cfad2a78f$export$465e9d514283d4fd);

var $ja8Ap = parcelRequire("ja8Ap");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $337bff8cfad2a78f$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $337bff8cfad2a78f$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $337bff8cfad2a78f$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
            // console warnings. This happens when a Vue template is rendered with
            // an undeclared variable, which we try to stringify, ultimately causing
            // Vue to issue another warning which repeats indefinitely.
            // see: https://github.com/getsentry/sentry-javascript/pull/8981
            if ((0, $ja8Ap.isVueViewModel)(value)) output.push('[VueViewModel]');
            else output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $337bff8cfad2a78f$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $ja8Ap.isString)(value)) return false;
    if ((0, $ja8Ap.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $ja8Ap.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $337bff8cfad2a78f$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$337bff8cfad2a78f$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("4jwTD", function(module, exports) {
$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", () => $32427446d8a1a9bb$export$849dbeeeda01ae98);
const $32427446d8a1a9bb$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("1pxS3", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $1072664f65f184b7$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $1072664f65f184b7$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});

parcelRegister("e8ylv", function(module, exports) {
$parcel$export(module.exports, "getCurrentHub", () => $a4ac746fcfa9bc22$export$a07cdf6544bbd7c);
$parcel$export(module.exports, "getIsolationScope", () => $a4ac746fcfa9bc22$export$68f3af03034c9e90);
$parcel$export(module.exports, "runWithAsyncContext", () => $a4ac746fcfa9bc22$export$70d775fb1f267027);

var $ihOje = parcelRequire("ihOje");
var $bjakf = parcelRequire("bjakf");
var $euqZU = parcelRequire("euqZU");
var $ja8Ap = parcelRequire("ja8Ap");
var $frGXd = parcelRequire("frGXd");

var $4jwTD = parcelRequire("4jwTD");

var $1pxS3 = parcelRequire("1pxS3");

var $b6Cmo = parcelRequire("b6Cmo");

var $4bksy = parcelRequire("4bksy");

var $lBThz = parcelRequire("lBThz");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $a4ac746fcfa9bc22$export$24a86ef7798177e4 = parseFloat((0, $lBThz.SDK_VERSION));
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $a4ac746fcfa9bc22$var$DEFAULT_BREADCRUMBS = 100;
/**
 * @deprecated The `Hub` class will be removed in version 8 of the SDK in favour of `Scope` and `Client` objects.
 *
 * If you previously used the `Hub` class directly, replace it with `Scope` and `Client` objects. More information:
 * - [Multiple Sentry Instances](https://docs.sentry.io/platforms/javascript/best-practices/multiple-sentry-instances/)
 * - [Browser Extensions](https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/)
 *
 * Some of our APIs are typed with the Hub class instead of the interface (e.g. `getCurrentHub`). Most of them are deprecated
 * themselves and will also be removed in version 8. More information:
 * - [Migration Guide](https://github.com/getsentry/sentry-javascript/blob/develop/MIGRATION.md#deprecate-hub)
 */ // eslint-disable-next-line deprecation/deprecation
class $a4ac746fcfa9bc22$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   *
   * @deprecated Instantiation of Hub objects is deprecated and the constructor will be removed in version 8 of the SDK.
   *
   * If you are currently using the Hub for multi-client use like so:
   *
   * ```
   * // OLD
   * const hub = new Hub();
   * hub.bindClient(client);
   * makeMain(hub)
   * ```
   *
   * instead initialize the client as follows:
   *
   * ```
   * // NEW
   * Sentry.withIsolationScope(() => {
   *    Sentry.setCurrentClient(client);
   *    client.init();
   * });
   * ```
   *
   * If you are using the Hub to capture events like so:
   *
   * ```
   * // OLD
   * const client = new Client();
   * const hub = new Hub(client);
   * hub.captureException()
   * ```
   *
   * instead capture isolated events as follows:
   *
   * ```
   * // NEW
   * const client = new Client();
   * const scope = new Scope();
   * scope.setClient(client);
   * scope.captureException();
   * ```
   */ constructor(client, scope, isolationScope, _version = $a4ac746fcfa9bc22$export$24a86ef7798177e4){
        this._version = _version;
        let assignedScope;
        if (!scope) {
            assignedScope = new (0, $b6Cmo.Scope)();
            assignedScope.setClient(client);
        } else assignedScope = scope;
        let assignedIsolationScope;
        if (!isolationScope) {
            assignedIsolationScope = new (0, $b6Cmo.Scope)();
            assignedIsolationScope.setClient(client);
        } else assignedIsolationScope = isolationScope;
        this._stack = [
            {
                scope: assignedScope
            }
        ];
        if (client) // eslint-disable-next-line deprecation/deprecation
        this.bindClient(client);
        this._isolationScope = assignedIsolationScope;
    }
    /**
   * Checks if this hub's version is older than the given version.
   *
   * @param version A version number to compare to.
   * @return True if the given version is newer; otherwise false.
   *
   * @deprecated This will be removed in v8.
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * This binds the given client to the current scope.
   * @param client An SDK client (client) instance.
   *
   * @deprecated Use `initAndBind()` directly, or `setCurrentClient()` and/or `client.init()` instead.
   */ bindClient(client) {
        // eslint-disable-next-line deprecation/deprecation
        const top = this.getStackTop();
        top.client = client;
        top.scope.setClient(client);
        // eslint-disable-next-line deprecation/deprecation
        if (client && client.setupIntegrations) // eslint-disable-next-line deprecation/deprecation
        client.setupIntegrations();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ pushScope() {
        // We want to clone the content of prev scope
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.getScope().clone();
        // eslint-disable-next-line deprecation/deprecation
        this.getStack().push({
            // eslint-disable-next-line deprecation/deprecation
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `withScope` instead.
   */ popScope() {
        // eslint-disable-next-line deprecation/deprecation
        if (this.getStack().length <= 1) return false;
        // eslint-disable-next-line deprecation/deprecation
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.withScope()` instead.
   */ withScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const scope = this.pushScope();
        let maybePromiseResult;
        try {
            maybePromiseResult = callback(scope);
        } catch (e) {
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        }
        if ((0, $ja8Ap.isThenable)(maybePromiseResult)) // @ts-expect-error - isThenable returns the wrong type
        return maybePromiseResult.then((res)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            return res;
        }, (e)=>{
            // eslint-disable-next-line deprecation/deprecation
            this.popScope();
            throw e;
        });
        // eslint-disable-next-line deprecation/deprecation
        this.popScope();
        return maybePromiseResult;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.getClient()` instead.
   */ getClient() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().client;
    }
    /**
   * Returns the scope of the top stack.
   *
   * @deprecated Use `Sentry.getCurrentScope()` instead.
   */ getScope() {
        // eslint-disable-next-line deprecation/deprecation
        return this.getStackTop().scope;
    }
    /**
   * @deprecated Use `Sentry.getIsolationScope()` instead.
   */ getIsolationScope() {
        return this._isolationScope;
    }
    /**
   * Returns the scope stack for domains or the process.
   * @deprecated This will be removed in v8.
   */ getStack() {
        return this._stack;
    }
    /**
   * Returns the topmost scope layer in the order domain > local > process.
   * @deprecated This will be removed in v8.
   */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureException()` instead.
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $frGXd.uuid4)();
        const syntheticException = new Error('Sentry syntheticException');
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use  `Sentry.captureMessage()` instead.
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $frGXd.uuid4)();
        const syntheticException = new Error(message);
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.captureEvent()` instead.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $frGXd.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().captureEvent(event, {
            ...hint,
            event_id: eventId
        });
        return eventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated This will be removed in v8.
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `Sentry.addBreadcrumb()` instead.
   */ addBreadcrumb(breadcrumb, hint) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $a4ac746fcfa9bc22$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $bjakf.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $ihOje.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
        // TODO(v8): I know this comment doesn't make much sense because the hub will be deprecated but I still wanted to
        // write it down. In theory, we would have to add the breadcrumbs to the isolation scope here, however, that would
        // duplicate all of the breadcrumbs. There was the possibility of adding breadcrumbs to both, the isolation scope
        // and the normal scope, and deduplicating it down the line in the event processing pipeline. However, that would
        // have been very fragile, because the breadcrumb objects would have needed to keep their identity all throughout
        // the event processing pipeline.
        // In the new implementation, the top level `Sentry.addBreadcrumb()` should ONLY write to the isolation scope.
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setUser()` instead.
   */ setUser(user) {
        // TODO(v8): The top level `Sentry.setUser()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setUser(user);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setUser(user);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTags()` instead.
   */ setTags(tags) {
        // TODO(v8): The top level `Sentry.setTags()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTags(tags);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTags(tags);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtras()` instead.
   */ setExtras(extras) {
        // TODO(v8): The top level `Sentry.setExtras()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtras(extras);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setTag()` instead.
   */ setTag(key, value) {
        // TODO(v8): The top level `Sentry.setTag()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setTag(key, value);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setExtra()` instead.
   */ setExtra(key, extra) {
        // TODO(v8): The top level `Sentry.setExtra()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setExtra(key, extra);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.setContext()` instead.
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        // TODO(v8): The top level `Sentry.setContext()` function should write ONLY to the isolation scope.
        // eslint-disable-next-line deprecation/deprecation
        this.getScope().setContext(name, context);
        // eslint-disable-next-line deprecation/deprecation
        this.getIsolationScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use `getScope()` directly.
   */ configureScope(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line deprecation/deprecation
    run(callback) {
        // eslint-disable-next-line deprecation/deprecation
        const oldHub = $a4ac746fcfa9bc22$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            // eslint-disable-next-line deprecation/deprecation
            $a4ac746fcfa9bc22$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   * @deprecated Use `Sentry.getClient().getIntegrationByName()` instead.
   */ getIntegration(integration) {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        if (!client) return null;
        try {
            // eslint-disable-next-line deprecation/deprecation
            return client.getIntegration(integration);
        } catch (_oO) {
            (0, $1pxS3.DEBUG_BUILD) && (0, $ihOje.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
   *
   * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
   * new child span within the transaction or any span, call the respective `.startChild()` method.
   *
   * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
   *
   * The transaction must be finished with a call to its `.end()` method, at which point the transaction with all its
   * finished child spans will be sent to Sentry.
   *
   * @param context Properties of the new `Transaction`.
   * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
   * default values). See {@link Options.tracesSampler}.
   *
   * @returns The transaction which was just started
   *
   * @deprecated Use `startSpan()`, `startSpanManual()` or `startInactiveSpan()` instead.
   */ startTransaction(context, customSamplingContext) {
        const result = this._callExtensionMethod('startTransaction', context, customSamplingContext);
        if ((0, $1pxS3.DEBUG_BUILD) && !result) {
            // eslint-disable-next-line deprecation/deprecation
            const client = this.getClient();
            if (!client) (0, $ihOje.logger).warn("Tracing extension 'startTransaction' is missing. You should 'init' the SDK before calling 'startTransaction'");
            else (0, $ihOje.logger).warn(`Tracing extension 'startTransaction' has not been added. Call 'addTracingExtensions' before calling 'init':
Sentry.addTracingExtensions();
Sentry.init({...});
`);
        }
        return result;
    }
    /**
   * @inheritDoc
   * @deprecated Use `spanToTraceHeader()` instead.
   */ traceHeaders() {
        return this._callExtensionMethod('traceHeaders');
    }
    /**
   * @inheritDoc
   *
   * @deprecated Use top level `captureSession` instead.
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) // eslint-disable-next-line deprecation/deprecation
        return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `endSession` instead.
   */ endSession() {
        // eslint-disable-next-line deprecation/deprecation
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $4bksy.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   * @deprecated Use top level `startSession` instead.
   */ startSession(context) {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $4jwTD.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $euqZU.GLOBAL_OBJ).navigator || {};
        const session = (0, $4bksy.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === 'ok') (0, $4bksy.updateSession)(currentSession, {
            status: 'exited'
        });
        // eslint-disable-next-line deprecation/deprecation
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   *
   * @deprecated Use top-level `getClient().getOptions().sendDefaultPii` instead. This function
   * only unnecessarily increased API surface but only wrapped accessing the option.
   */ shouldSendDefaultPii() {
        // eslint-disable-next-line deprecation/deprecation
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        // eslint-disable-next-line deprecation/deprecation
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-expect-error Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $a4ac746fcfa9bc22$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (0, $1pxS3.DEBUG_BUILD) && (0, $ihOje.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $a4ac746fcfa9bc22$export$19eade501500c6c1() {
    (0, $euqZU.GLOBAL_OBJ).__SENTRY__ = (0, $euqZU.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $euqZU.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 *
 * @deprecated Use `setCurrentClient()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $a4ac746fcfa9bc22$export$4188a14ad302d1bc(hub) {
    const registry = $a4ac746fcfa9bc22$export$19eade501500c6c1();
    const oldHub = $a4ac746fcfa9bc22$export$bfa8a924a84a76b7(registry);
    $a4ac746fcfa9bc22$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 *
 * @deprecated Use the respective replacement method directly instead.
 */ // eslint-disable-next-line deprecation/deprecation
function $a4ac746fcfa9bc22$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $a4ac746fcfa9bc22$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) {
        const hub = registry.__SENTRY__.acs.getCurrentHub();
        if (hub) return hub;
    }
    // Return hub that lives on a global object
    return $a4ac746fcfa9bc22$var$getGlobalHub(registry);
}
/**
 * Get the currently active isolation scope.
 * The isolation scope is active for the current exection context,
 * meaning that it will remain stable for the same Hub.
 */ function $a4ac746fcfa9bc22$export$68f3af03034c9e90() {
    // eslint-disable-next-line deprecation/deprecation
    return $a4ac746fcfa9bc22$export$a07cdf6544bbd7c().getIsolationScope();
}
// eslint-disable-next-line deprecation/deprecation
function $a4ac746fcfa9bc22$var$getGlobalHub(registry = $a4ac746fcfa9bc22$export$19eade501500c6c1()) {
    // If there's no hub, or its an old API, assign a new one
    if (!$a4ac746fcfa9bc22$var$hasHubOnCarrier(registry) || // eslint-disable-next-line deprecation/deprecation
    $a4ac746fcfa9bc22$export$bfa8a924a84a76b7(registry).isOlderThan($a4ac746fcfa9bc22$export$24a86ef7798177e4)) // eslint-disable-next-line deprecation/deprecation
    $a4ac746fcfa9bc22$export$849f05434e95d2f2(registry, new $a4ac746fcfa9bc22$export$8c41bb232f1008b1());
    // Return hub that lives on a global object
    return $a4ac746fcfa9bc22$export$bfa8a924a84a76b7(registry);
}
/**
 * @private Private API with no semver guarantees!
 *
 * If the carrier does not contain a hub, a new hub is created with the global hub client and scope.
 */ // eslint-disable-next-line deprecation/deprecation
function $a4ac746fcfa9bc22$export$236689a79f5aa020(carrier, parent = $a4ac746fcfa9bc22$var$getGlobalHub()) {
    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!$a4ac746fcfa9bc22$var$hasHubOnCarrier(carrier) || // eslint-disable-next-line deprecation/deprecation
    $a4ac746fcfa9bc22$export$bfa8a924a84a76b7(carrier).isOlderThan($a4ac746fcfa9bc22$export$24a86ef7798177e4)) {
        // eslint-disable-next-line deprecation/deprecation
        const client = parent.getClient();
        // eslint-disable-next-line deprecation/deprecation
        const scope = parent.getScope();
        // eslint-disable-next-line deprecation/deprecation
        const isolationScope = parent.getIsolationScope();
        // eslint-disable-next-line deprecation/deprecation
        $a4ac746fcfa9bc22$export$849f05434e95d2f2(carrier, new $a4ac746fcfa9bc22$export$8c41bb232f1008b1(client, scope.clone(), isolationScope.clone()));
    }
}
/**
 * @private Private API with no semver guarantees!
 *
 * Sets the global async context strategy
 */ function $a4ac746fcfa9bc22$export$774ae0e6b6e444ca(strategy) {
    // Get main carrier (global for every environment)
    const registry = $a4ac746fcfa9bc22$export$19eade501500c6c1();
    registry.__SENTRY__ = registry.__SENTRY__ || {};
    registry.__SENTRY__.acs = strategy;
}
/**
 * Runs the supplied callback in its own async context. Async Context strategies are defined per SDK.
 *
 * @param callback The callback to run in its own async context
 * @param options Options to pass to the async context strategy
 * @returns The result of the callback
 */ function $a4ac746fcfa9bc22$export$70d775fb1f267027(callback, options = {}) {
    const registry = $a4ac746fcfa9bc22$export$19eade501500c6c1();
    if (registry.__SENTRY__ && registry.__SENTRY__.acs) return registry.__SENTRY__.acs.runWithAsyncContext(callback, options);
    // if there was no strategy, fallback to just calling the callback
    return callback();
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $a4ac746fcfa9bc22$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ // eslint-disable-next-line deprecation/deprecation
function $a4ac746fcfa9bc22$export$bfa8a924a84a76b7(carrier) {
    // eslint-disable-next-line deprecation/deprecation
    return (0, $euqZU.getGlobalSingleton)('hub', ()=>new $a4ac746fcfa9bc22$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ // eslint-disable-next-line deprecation/deprecation
function $a4ac746fcfa9bc22$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("b6Cmo", function(module, exports) {
$parcel$export(module.exports, "Scope", () => $815e02c755260849$export$775b6bb06e53a214);
$parcel$export(module.exports, "getGlobalScope", () => $815e02c755260849$export$aa55d5ab8e05984f);

var $bjakf = parcelRequire("bjakf");
var $ja8Ap = parcelRequire("ja8Ap");
var $ihOje = parcelRequire("ihOje");
var $frGXd = parcelRequire("frGXd");

var $30AuM = parcelRequire("30AuM");

var $4bksy = parcelRequire("4bksy");

var $ebsY6 = parcelRequire("ebsY6");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $815e02c755260849$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * The global scope is kept in this module.
 * When accessing this via `getGlobalScope()` we'll make sure to set one if none is currently present.
 */ let $815e02c755260849$var$globalScope;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $815e02c755260849$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /** Propagation Context for distributed tracing */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /**
   * Transaction Name
   */ /** Span */ /** Session */ /** Request Mode Session Status */ /** The client on this scope */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
        this._propagationContext = $815e02c755260849$var$generatePropagationContext();
    }
    /**
   * Inherit values from the parent scope.
   * @deprecated Use `scope.clone()` and `new Scope()` instead.
   */ static clone(scope) {
        return scope ? scope.clone() : new $815e02c755260849$export$775b6bb06e53a214();
    }
    /**
   * Clone this scope instance.
   */ clone() {
        const newScope = new $815e02c755260849$export$775b6bb06e53a214();
        newScope._breadcrumbs = [
            ...this._breadcrumbs
        ];
        newScope._tags = {
            ...this._tags
        };
        newScope._extra = {
            ...this._extra
        };
        newScope._contexts = {
            ...this._contexts
        };
        newScope._user = this._user;
        newScope._level = this._level;
        newScope._span = this._span;
        newScope._session = this._session;
        newScope._transactionName = this._transactionName;
        newScope._fingerprint = this._fingerprint;
        newScope._eventProcessors = [
            ...this._eventProcessors
        ];
        newScope._requestSession = this._requestSession;
        newScope._attachments = [
            ...this._attachments
        ];
        newScope._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata
        };
        newScope._propagationContext = {
            ...this._propagationContext
        };
        newScope._client = this._client;
        return newScope;
    }
    /** Update the client on the scope. */ setClient(client) {
        this._client = client;
    }
    /**
   * Get the client assigned to this scope.
   *
   * It is generally recommended to use the global function `Sentry.getClient()` instead, unless you know what you are doing.
   */ getClient() {
        return this._client;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        // If null is passed we want to unset everything, but still define keys,
        // so that later down in the pipeline any existing values are cleared.
        this._user = user || {
            email: undefined,
            id: undefined,
            ip_address: undefined,
            segment: undefined,
            username: undefined
        };
        if (this._session) (0, $4bksy.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the transaction name on the scope for future events.
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Sets the Span on the scope.
   * @param span Span
   * @deprecated Instead of setting a span on a scope, use `startSpan()`/`startSpanManual()` instead.
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * Returns the `Span` if there is one.
   * @deprecated Use `getActiveSpan()` instead.
   */ getSpan() {
        return this._span;
    }
    /**
   * Returns the `Transaction` attached to the scope (if there is one).
   * @deprecated You should not rely on the transaction, but just use `startSpan()` APIs instead.
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this._span;
        // Cannot replace with getRootSpan because getRootSpan returns a span, not a transaction
        // Also, this method will be removed anyway.
        // eslint-disable-next-line deprecation/deprecation
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        const scopeToMerge = typeof captureContext === 'function' ? captureContext(this) : captureContext;
        if (scopeToMerge instanceof $815e02c755260849$export$775b6bb06e53a214) {
            const scopeData = scopeToMerge.getScopeData();
            this._tags = {
                ...this._tags,
                ...scopeData.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeData.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeData.contexts
            };
            if (scopeData.user && Object.keys(scopeData.user).length) this._user = scopeData.user;
            if (scopeData.level) this._level = scopeData.level;
            if (scopeData.fingerprint.length) this._fingerprint = scopeData.fingerprint;
            if (scopeToMerge.getRequestSession()) this._requestSession = scopeToMerge.getRequestSession();
            if (scopeData.propagationContext) this._propagationContext = scopeData.propagationContext;
        } else if ((0, $ja8Ap.isPlainObject)(scopeToMerge)) {
            const scopeContext = captureContext;
            this._tags = {
                ...this._tags,
                ...scopeContext.tags
            };
            this._extra = {
                ...this._extra,
                ...scopeContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...scopeContext.contexts
            };
            if (scopeContext.user) this._user = scopeContext.user;
            if (scopeContext.level) this._level = scopeContext.level;
            if (scopeContext.fingerprint) this._fingerprint = scopeContext.fingerprint;
            if (scopeContext.requestSession) this._requestSession = scopeContext.requestSession;
            if (scopeContext.propagationContext) this._propagationContext = scopeContext.propagationContext;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        this._propagationContext = $815e02c755260849$var$generatePropagationContext();
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $815e02c755260849$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $bjakf.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        const breadcrumbs = this._breadcrumbs;
        breadcrumbs.push(mergedBreadcrumb);
        this._breadcrumbs = breadcrumbs.length > maxCrumbs ? breadcrumbs.slice(-maxCrumbs) : breadcrumbs;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   * @deprecated Use `getScopeData()` instead.
   */ getAttachments() {
        const data = this.getScopeData();
        return data.attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /** @inheritDoc */ getScopeData() {
        const { _breadcrumbs: _breadcrumbs, _attachments: _attachments, _contexts: _contexts, _tags: _tags, _extra: _extra, _user: _user, _level: _level, _fingerprint: _fingerprint, _eventProcessors: _eventProcessors, _propagationContext: _propagationContext, _sdkProcessingMetadata: _sdkProcessingMetadata, _transactionName: _transactionName, _span: _span } = this;
        return {
            breadcrumbs: _breadcrumbs,
            attachments: _attachments,
            contexts: _contexts,
            tags: _tags,
            extra: _extra,
            user: _user,
            level: _level,
            fingerprint: _fingerprint || [],
            eventProcessors: _eventProcessors,
            propagationContext: _propagationContext,
            sdkProcessingMetadata: _sdkProcessingMetadata,
            transactionName: _transactionName,
            span: _span
        };
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   * @deprecated Use `applyScopeDataToEvent()` directly
   */ applyToEvent(event, hint = {}, additionalEventProcessors = []) {
        (0, $ebsY6.applyScopeDataToEvent)(event, this.getScopeData());
        // TODO (v8): Update this order to be: Global > Client > Scope
        const eventProcessors = [
            ...additionalEventProcessors,
            // eslint-disable-next-line deprecation/deprecation
            ...(0, $30AuM.getGlobalEventProcessors)(),
            ...this._eventProcessors
        ];
        return (0, $30AuM.notifyEventProcessors)(eventProcessors, event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setPropagationContext(context) {
        this._propagationContext = context;
        return this;
    }
    /**
   * @inheritDoc
   */ getPropagationContext() {
        return this._propagationContext;
    }
    /**
   * Capture an exception for this scope.
   *
   * @param exception The exception to capture.
   * @param hint Optinal additional data to attach to the Sentry event.
   * @returns the id of the captured Sentry event.
   */ captureException(exception, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $frGXd.uuid4)();
        if (!this._client) {
            (0, $ihOje.logger).warn('No client configured on scope - will not capture exception!');
            return eventId;
        }
        const syntheticException = new Error('Sentry syntheticException');
        this._client.captureException(exception, {
            originalException: exception,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Capture a message for this scope.
   *
   * @param message The message to capture.
   * @param level An optional severity level to report the message with.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured message.
   */ captureMessage(message, level, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $frGXd.uuid4)();
        if (!this._client) {
            (0, $ihOje.logger).warn('No client configured on scope - will not capture message!');
            return eventId;
        }
        const syntheticException = new Error(message);
        this._client.captureMessage(message, level, {
            originalException: message,
            syntheticException: syntheticException,
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * Captures a manually created event for this scope and sends it to Sentry.
   *
   * @param exception The event to capture.
   * @param hint Optional additional data to attach to the Sentry event.
   * @returns the id of the captured event.
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $frGXd.uuid4)();
        if (!this._client) {
            (0, $ihOje.logger).warn('No client configured on scope - will not capture event!');
            return eventId;
        }
        this._client.captureEvent(event, {
            ...hint,
            event_id: eventId
        }, this);
        return eventId;
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
}
/**
 * Get the global scope.
 * This scope is applied to _all_ events.
 */ function $815e02c755260849$export$aa55d5ab8e05984f() {
    if (!$815e02c755260849$var$globalScope) $815e02c755260849$var$globalScope = new $815e02c755260849$export$775b6bb06e53a214();
    return $815e02c755260849$var$globalScope;
}
/**
 * This is mainly needed for tests.
 * DO NOT USE this, as this is an internal API and subject to change.
 * @hidden
 */ function $815e02c755260849$export$c83048efd17527d6(scope) {
    $815e02c755260849$var$globalScope = scope;
}
function $815e02c755260849$var$generatePropagationContext() {
    return {
        traceId: (0, $frGXd.uuid4)(),
        spanId: (0, $frGXd.uuid4)().substring(16)
    };
}

});
parcelRegister("30AuM", function(module, exports) {
$parcel$export(module.exports, "getGlobalEventProcessors", () => $230dae712745986b$export$3c4238858b85e8ac);
$parcel$export(module.exports, "addGlobalEventProcessor", () => $230dae712745986b$export$8e4e25f54d456511);
$parcel$export(module.exports, "notifyEventProcessors", () => $230dae712745986b$export$bf2a096c3e883e79);

var $euqZU = parcelRequire("euqZU");
var $ja8Ap = parcelRequire("ja8Ap");
var $ihOje = parcelRequire("ihOje");
var $iCSdt = parcelRequire("iCSdt");

var $1pxS3 = parcelRequire("1pxS3");
/**
 * Returns the global event processors.
 * @deprecated Global event processors will be removed in v8.
 */ function $230dae712745986b$export$3c4238858b85e8ac() {
    return (0, $euqZU.getGlobalSingleton)('globalEventProcessors', ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @deprecated Use `addEventProcessor` instead. Global event processors will be removed in v8.
 */ function $230dae712745986b$export$8e4e25f54d456511(callback) {
    // eslint-disable-next-line deprecation/deprecation
    $230dae712745986b$export$3c4238858b85e8ac().push(callback);
}
/**
 * Process an array of event processors, returning the processed event (or `null` if the event was dropped).
 */ function $230dae712745986b$export$bf2a096c3e883e79(processors, event, hint, index = 0) {
    return new (0, $iCSdt.SyncPromise)((resolve, reject)=>{
        const processor = processors[index];
        if (event === null || typeof processor !== 'function') resolve(event);
        else {
            const result = processor({
                ...event
            }, hint);
            (0, $1pxS3.DEBUG_BUILD) && processor.id && result === null && (0, $ihOje.logger).log(`Event processor "${processor.id}" dropped event`);
            if ((0, $ja8Ap.isThenable)(result)) result.then((final)=>$230dae712745986b$export$bf2a096c3e883e79(processors, final, hint, index + 1).then(resolve)).then(null, reject);
            else $230dae712745986b$export$bf2a096c3e883e79(processors, result, hint, index + 1).then(resolve).then(null, reject);
        }
    });
}

});
parcelRegister("iCSdt", function(module, exports) {
$parcel$export(module.exports, "SyncPromise", () => $d8f5d4da9d265e7e$export$6f292d4960313241);

var $ja8Ap = parcelRequire("ja8Ap");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $d8f5d4da9d265e7e$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($d8f5d4da9d265e7e$var$States || ($d8f5d4da9d265e7e$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $d8f5d4da9d265e7e$export$1fda8aa4d135f8aa(value) {
    return new $d8f5d4da9d265e7e$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $d8f5d4da9d265e7e$export$78e43115b553f358(reason) {
    return new $d8f5d4da9d265e7e$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $d8f5d4da9d265e7e$export$6f292d4960313241 {
    constructor(executor){
        $d8f5d4da9d265e7e$export$6f292d4960313241.prototype.__init.call(this);
        $d8f5d4da9d265e7e$export$6f292d4960313241.prototype.__init2.call(this);
        $d8f5d4da9d265e7e$export$6f292d4960313241.prototype.__init3.call(this);
        $d8f5d4da9d265e7e$export$6f292d4960313241.prototype.__init4.call(this);
        this._state = $d8f5d4da9d265e7e$var$States.PENDING;
        this._handlers = [];
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $d8f5d4da9d265e7e$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $d8f5d4da9d265e7e$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init() {
        this._resolve = (value)=>{
            this._setResult($d8f5d4da9d265e7e$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init2() {
        this._reject = (reason)=>{
            this._setResult($d8f5d4da9d265e7e$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init3() {
        this._setResult = (state, value)=>{
            if (this._state !== $d8f5d4da9d265e7e$var$States.PENDING) return;
            if ((0, $ja8Ap.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init4() {
        this._executeHandlers = ()=>{
            if (this._state === $d8f5d4da9d265e7e$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $d8f5d4da9d265e7e$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $d8f5d4da9d265e7e$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});


parcelRegister("4bksy", function(module, exports) {
$parcel$export(module.exports, "makeSession", () => $30b80f5dc1936a03$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $30b80f5dc1936a03$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $30b80f5dc1936a03$export$56521d9ba90f62ee);

var $1dhjw = parcelRequire("1dhjw");
var $bjakf = parcelRequire("bjakf");
var $frGXd = parcelRequire("frGXd");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $30b80f5dc1936a03$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $bjakf.timestampInSeconds)();
    const session = {
        sid: (0, $frGXd.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$30b80f5dc1936a03$var$sessionToJSON(session)
    };
    if (context) $30b80f5dc1936a03$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $30b80f5dc1936a03$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $bjakf.timestampInSeconds)();
    if (context.abnormal_mechanism) session.abnormal_mechanism = context.abnormal_mechanism;
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $frGXd.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $30b80f5dc1936a03$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $30b80f5dc1936a03$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $30b80f5dc1936a03$var$sessionToJSON(session) {
    return (0, $1dhjw.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        abnormal_mechanism: session.abnormal_mechanism,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});

parcelRegister("ebsY6", function(module, exports) {
$parcel$export(module.exports, "applyScopeDataToEvent", () => $a5389043ceee0397$export$43988bc651a80216);
$parcel$export(module.exports, "mergeScopeData", () => $a5389043ceee0397$export$25ac7e259a513db4);

var $frGXd = parcelRequire("frGXd");
var $1dhjw = parcelRequire("1dhjw");

var $7UuMD = parcelRequire("7UuMD");

var $9fbQy = parcelRequire("9fbQy");

var $8UfMF = parcelRequire("8UfMF");
/**
 * Applies data from the scope to the event and runs all event processors on it.
 */ function $a5389043ceee0397$export$43988bc651a80216(event, data) {
    const { fingerprint: fingerprint, span: span, breadcrumbs: breadcrumbs, sdkProcessingMetadata: sdkProcessingMetadata } = data;
    // Apply general data
    $a5389043ceee0397$var$applyDataToEvent(event, data);
    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (span) $a5389043ceee0397$var$applySpanToEvent(event, span);
    $a5389043ceee0397$var$applyFingerprintToEvent(event, fingerprint);
    $a5389043ceee0397$var$applyBreadcrumbsToEvent(event, breadcrumbs);
    $a5389043ceee0397$var$applySdkMetadataToEvent(event, sdkProcessingMetadata);
}
/** Merge data of two scopes together. */ function $a5389043ceee0397$export$25ac7e259a513db4(data, mergeData) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, sdkProcessingMetadata: sdkProcessingMetadata, breadcrumbs: breadcrumbs, fingerprint: fingerprint, eventProcessors: eventProcessors, attachments: attachments, propagationContext: propagationContext, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName, span: span } = mergeData;
    $a5389043ceee0397$export$b1a120a2871faa46(data, 'extra', extra);
    $a5389043ceee0397$export$b1a120a2871faa46(data, 'tags', tags);
    $a5389043ceee0397$export$b1a120a2871faa46(data, 'user', user);
    $a5389043ceee0397$export$b1a120a2871faa46(data, 'contexts', contexts);
    $a5389043ceee0397$export$b1a120a2871faa46(data, 'sdkProcessingMetadata', sdkProcessingMetadata);
    if (level) data.level = level;
    if (transactionName) // eslint-disable-next-line deprecation/deprecation
    data.transactionName = transactionName;
    if (span) data.span = span;
    if (breadcrumbs.length) data.breadcrumbs = [
        ...data.breadcrumbs,
        ...breadcrumbs
    ];
    if (fingerprint.length) data.fingerprint = [
        ...data.fingerprint,
        ...fingerprint
    ];
    if (eventProcessors.length) data.eventProcessors = [
        ...data.eventProcessors,
        ...eventProcessors
    ];
    if (attachments.length) data.attachments = [
        ...data.attachments,
        ...attachments
    ];
    data.propagationContext = {
        ...data.propagationContext,
        ...propagationContext
    };
}
/**
 * Merges certain scope data. Undefined values will overwrite any existing values.
 * Exported only for tests.
 */ function $a5389043ceee0397$export$b1a120a2871faa46(data, prop, mergeVal) {
    if (mergeVal && Object.keys(mergeVal).length) {
        // Clone object
        data[prop] = {
            ...data[prop]
        };
        for(const key in mergeVal)if (Object.prototype.hasOwnProperty.call(mergeVal, key)) data[prop][key] = mergeVal[key];
    }
}
function $a5389043ceee0397$var$applyDataToEvent(event, data) {
    const { extra: extra, tags: tags, user: user, contexts: contexts, level: level, transactionName: // eslint-disable-next-line deprecation/deprecation
    transactionName } = data;
    const cleanedExtra = (0, $1dhjw.dropUndefinedKeys)(extra);
    if (cleanedExtra && Object.keys(cleanedExtra).length) event.extra = {
        ...cleanedExtra,
        ...event.extra
    };
    const cleanedTags = (0, $1dhjw.dropUndefinedKeys)(tags);
    if (cleanedTags && Object.keys(cleanedTags).length) event.tags = {
        ...cleanedTags,
        ...event.tags
    };
    const cleanedUser = (0, $1dhjw.dropUndefinedKeys)(user);
    if (cleanedUser && Object.keys(cleanedUser).length) event.user = {
        ...cleanedUser,
        ...event.user
    };
    const cleanedContexts = (0, $1dhjw.dropUndefinedKeys)(contexts);
    if (cleanedContexts && Object.keys(cleanedContexts).length) event.contexts = {
        ...cleanedContexts,
        ...event.contexts
    };
    if (level) event.level = level;
    if (transactionName) event.transaction = transactionName;
}
function $a5389043ceee0397$var$applyBreadcrumbsToEvent(event, breadcrumbs) {
    const mergedBreadcrumbs = [
        ...event.breadcrumbs || [],
        ...breadcrumbs
    ];
    event.breadcrumbs = mergedBreadcrumbs.length ? mergedBreadcrumbs : undefined;
}
function $a5389043ceee0397$var$applySdkMetadataToEvent(event, sdkProcessingMetadata) {
    event.sdkProcessingMetadata = {
        ...event.sdkProcessingMetadata,
        ...sdkProcessingMetadata
    };
}
function $a5389043ceee0397$var$applySpanToEvent(event, span) {
    event.contexts = {
        trace: (0, $8UfMF.spanToTraceContext)(span),
        ...event.contexts
    };
    const rootSpan = (0, $9fbQy.getRootSpan)(span);
    if (rootSpan) {
        event.sdkProcessingMetadata = {
            dynamicSamplingContext: (0, $7UuMD.getDynamicSamplingContextFromSpan)(span),
            ...event.sdkProcessingMetadata
        };
        const transactionName = (0, $8UfMF.spanToJSON)(rootSpan).description;
        if (transactionName) event.tags = {
            transaction: transactionName,
            ...event.tags
        };
    }
}
/**
 * Applies fingerprint from the scope to the event if there's one,
 * uses message if there's one instead or get rid of empty fingerprint
 */ function $a5389043ceee0397$var$applyFingerprintToEvent(event, fingerprint) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0, $frGXd.arrayify)(event.fingerprint) : [];
    // If we have something on the scope, then merge it with event
    if (fingerprint) event.fingerprint = event.fingerprint.concat(fingerprint);
    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
}

});
parcelRegister("7UuMD", function(module, exports) {
$parcel$export(module.exports, "getDynamicSamplingContextFromSpan", () => $5c25a44f360e5046$export$a117f995597e25df);

var $1dhjw = parcelRequire("1dhjw");

var $4jwTD = parcelRequire("4jwTD");

var $511RT = parcelRequire("511RT");

var $9fbQy = parcelRequire("9fbQy");

var $8UfMF = parcelRequire("8UfMF");
/**
 * Creates a dynamic sampling context from a client.
 *
 * Dispatches the `createDsc` lifecycle hook as a side effect.
 */ function $5c25a44f360e5046$export$366bad00d6815eed(trace_id, client, scope) {
    const options = client.getOptions();
    const { publicKey: public_key } = client.getDsn() || {};
    // TODO(v8): Remove segment from User
    // eslint-disable-next-line deprecation/deprecation
    const { segment: user_segment } = scope && scope.getUser() || {};
    const dsc = (0, $1dhjw.dropUndefinedKeys)({
        environment: options.environment || (0, $4jwTD.DEFAULT_ENVIRONMENT),
        release: options.release,
        user_segment: user_segment,
        public_key: public_key,
        trace_id: trace_id
    });
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}
/**
 * A Span with a frozen dynamic sampling context.
 */ /**
 * Creates a dynamic sampling context from a span (and client and scope)
 *
 * @param span the span from which a few values like the root span name and sample rate are extracted.
 *
 * @returns a dynamic sampling context
 */ function $5c25a44f360e5046$export$a117f995597e25df(span) {
    const client = (0, $511RT.getClient)();
    if (!client) return {};
    // passing emit=false here to only emit later once the DSC is actually populated
    const dsc = $5c25a44f360e5046$export$366bad00d6815eed((0, $8UfMF.spanToJSON)(span).trace_id || '', client, (0, $511RT.getCurrentScope)());
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    const txn = (0, $9fbQy.getRootSpan)(span);
    if (!txn) return dsc;
    // TODO (v8): Remove v7FrozenDsc as a Transaction will no longer have _frozenDynamicSamplingContext
    // For now we need to avoid breaking users who directly created a txn with a DSC, where this field is still set.
    // @see Transaction class constructor
    const v7FrozenDsc = txn && txn._frozenDynamicSamplingContext;
    if (v7FrozenDsc) return v7FrozenDsc;
    // TODO (v8): Replace txn.metadata with txn.attributes[]
    // We can't do this yet because attributes aren't always set yet.
    // eslint-disable-next-line deprecation/deprecation
    const { sampleRate: maybeSampleRate, source: source } = txn.metadata;
    if (maybeSampleRate != null) dsc.sample_rate = `${maybeSampleRate}`;
    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const jsonSpan = (0, $8UfMF.spanToJSON)(txn);
    // after JSON conversion, txn.name becomes jsonSpan.description
    if (source && source !== 'url') dsc.transaction = jsonSpan.description;
    dsc.sampled = String((0, $8UfMF.spanIsSampled)(txn));
    client.emit && client.emit('createDsc', dsc);
    return dsc;
}

});
parcelRegister("9fbQy", function(module, exports) {
$parcel$export(module.exports, "getRootSpan", () => $01bc9fcf9e63c658$export$c4c6a79b1260ca1b);
/**
 * Returns the root span of a given span.
 *
 * As long as we use `Transaction`s internally, the returned root span
 * will be a `Transaction` but be aware that this might change in the future.
 *
 * If the given span has no root span or transaction, `undefined` is returned.
 */ function $01bc9fcf9e63c658$export$c4c6a79b1260ca1b(span) {
    // TODO (v8): Remove this check and just return span
    // eslint-disable-next-line deprecation/deprecation
    return span.transaction;
}

});

parcelRegister("8UfMF", function(module, exports) {
$parcel$export(module.exports, "spanToTraceContext", () => $67bfcc0e5b58d683$export$46c6fbd1d265ebf0);
$parcel$export(module.exports, "spanToJSON", () => $67bfcc0e5b58d683$export$92d8c23565496537);
$parcel$export(module.exports, "spanIsSampled", () => $67bfcc0e5b58d683$export$5caecac1caaf3a71);

var $1dhjw = parcelRequire("1dhjw");
var $iL1a7 = parcelRequire("iL1a7");
var $bjakf = parcelRequire("bjakf");
// These are aligned with OpenTelemetry trace flags
const $67bfcc0e5b58d683$export$208d5b368507fb8b = 0x0;
const $67bfcc0e5b58d683$export$eb571cd9b5d98de8 = 0x1;
/**
 * Convert a span to a trace context, which can be sent as the `trace` context in an event.
 */ function $67bfcc0e5b58d683$export$46c6fbd1d265ebf0(span) {
    const { spanId: span_id, traceId: trace_id } = span.spanContext();
    const { data: data, op: op, parent_span_id: parent_span_id, status: status, tags: tags, origin: origin } = $67bfcc0e5b58d683$export$92d8c23565496537(span);
    return (0, $1dhjw.dropUndefinedKeys)({
        data: data,
        op: op,
        parent_span_id: parent_span_id,
        span_id: span_id,
        status: status,
        tags: tags,
        trace_id: trace_id,
        origin: origin
    });
}
/**
 * Convert a Span to a Sentry trace header.
 */ function $67bfcc0e5b58d683$export$7e9f8ae9e4a328ab(span) {
    const { traceId: traceId, spanId: spanId } = span.spanContext();
    const sampled = $67bfcc0e5b58d683$export$5caecac1caaf3a71(span);
    return (0, $iL1a7.generateSentryTraceHeader)(traceId, spanId, sampled);
}
/**
 * Convert a span time input intp a timestamp in seconds.
 */ function $67bfcc0e5b58d683$export$3f7581298f56c6d7(input) {
    if (typeof input === 'number') return $67bfcc0e5b58d683$var$ensureTimestampInSeconds(input);
    if (Array.isArray(input)) // See {@link HrTime} for the array-based time format
    return input[0] + input[1] / 1e9;
    if (input instanceof Date) return $67bfcc0e5b58d683$var$ensureTimestampInSeconds(input.getTime());
    return (0, $bjakf.timestampInSeconds)();
}
/**
 * Converts a timestamp to second, if it was in milliseconds, or keeps it as second.
 */ function $67bfcc0e5b58d683$var$ensureTimestampInSeconds(timestamp) {
    const isMs = timestamp > 9999999999;
    return isMs ? timestamp / 1000 : timestamp;
}
/**
 * Convert a span to a JSON representation.
 * Note that all fields returned here are optional and need to be guarded against.
 *
 * Note: Because of this, we currently have a circular type dependency (which we opted out of in package.json).
 * This is not avoidable as we need `spanToJSON` in `spanUtils.ts`, which in turn is needed by `span.ts` for backwards compatibility.
 * And `spanToJSON` needs the Span class from `span.ts` to check here.
 * TODO v8: When we remove the deprecated stuff from `span.ts`, we can remove the circular dependency again.
 */ function $67bfcc0e5b58d683$export$92d8c23565496537(span) {
    if ($67bfcc0e5b58d683$var$spanIsSpanClass(span)) return span.getSpanJSON();
    // Fallback: We also check for `.toJSON()` here...
    // eslint-disable-next-line deprecation/deprecation
    if (typeof span.toJSON === 'function') // eslint-disable-next-line deprecation/deprecation
    return span.toJSON();
    return {};
}
/**
 * Sadly, due to circular dependency checks we cannot actually import the Span class here and check for instanceof.
 * :( So instead we approximate this by checking if it has the `getSpanJSON` method.
 */ function $67bfcc0e5b58d683$var$spanIsSpanClass(span) {
    return typeof span.getSpanJSON === 'function';
}
/**
 * Returns true if a span is sampled.
 * In most cases, you should just use `span.isRecording()` instead.
 * However, this has a slightly different semantic, as it also returns false if the span is finished.
 * So in the case where this distinction is important, use this method.
 */ function $67bfcc0e5b58d683$export$5caecac1caaf3a71(span) {
    // We align our trace flags with the ones OpenTelemetry use
    // So we also check for sampled the same way they do.
    const { traceFlags: traceFlags } = span.spanContext();
    // eslint-disable-next-line no-bitwise
    return Boolean(traceFlags & $67bfcc0e5b58d683$export$eb571cd9b5d98de8);
}

});
parcelRegister("iL1a7", function(module, exports) {
$parcel$export(module.exports, "generateSentryTraceHeader", () => $da7d84942d444432$export$f35d907436da45cf);

var $b8hkh = parcelRequire("b8hkh");

var $frGXd = parcelRequire("frGXd");
// eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- RegExp is used for readability here
const $da7d84942d444432$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $da7d84942d444432$export$8e9a29865c0a1226(traceparent) {
    if (!traceparent) return undefined;
    const matches = traceparent.match($da7d84942d444432$export$394a210812ba3012);
    if (!matches) return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}
/**
 * Create tracing context from incoming headers.
 *
 * @deprecated Use `propagationContextFromHeaders` instead.
 */ // TODO(v8): Remove this function
function $da7d84942d444432$export$ca5c066532785b6e(sentryTrace, baggage) {
    const traceparentData = $da7d84942d444432$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $b8hkh.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceparentData: traceparentData,
        dynamicSamplingContext: undefined,
        propagationContext: {
            traceId: traceId || (0, $frGXd.uuid4)(),
            spanId: (0, $frGXd.uuid4)().substring(16)
        }
    };
    else return {
        traceparentData: traceparentData,
        dynamicSamplingContext: dynamicSamplingContext || {},
        propagationContext: {
            traceId: traceId || (0, $frGXd.uuid4)(),
            parentSpanId: parentSpanId || (0, $frGXd.uuid4)().substring(16),
            spanId: (0, $frGXd.uuid4)().substring(16),
            sampled: parentSampled,
            dsc: dynamicSamplingContext || {}
        }
    };
}
/**
 * Create a propagation context from incoming headers.
 */ function $da7d84942d444432$export$261f383d16a93e39(sentryTrace, baggage) {
    const traceparentData = $da7d84942d444432$export$8e9a29865c0a1226(sentryTrace);
    const dynamicSamplingContext = (0, $b8hkh.baggageHeaderToDynamicSamplingContext)(baggage);
    const { traceId: traceId, parentSpanId: parentSpanId, parentSampled: parentSampled } = traceparentData || {};
    if (!traceparentData) return {
        traceId: traceId || (0, $frGXd.uuid4)(),
        spanId: (0, $frGXd.uuid4)().substring(16)
    };
    else return {
        traceId: traceId || (0, $frGXd.uuid4)(),
        parentSpanId: parentSpanId || (0, $frGXd.uuid4)().substring(16),
        spanId: (0, $frGXd.uuid4)().substring(16),
        sampled: parentSampled,
        dsc: dynamicSamplingContext || {}
    };
}
/**
 * Create sentry-trace header from span context values.
 */ function $da7d84942d444432$export$f35d907436da45cf(traceId = (0, $frGXd.uuid4)(), spanId = (0, $frGXd.uuid4)().substring(16), sampled) {
    let sampledString = '';
    if (sampled !== undefined) sampledString = sampled ? '-1' : '-0';
    return `${traceId}-${spanId}${sampledString}`;
}

});
parcelRegister("b8hkh", function(module, exports) {
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", () => $81ade1a9dee56fc3$export$5b96ee2c8421f107);

var $3CaV7 = parcelRequire("3CaV7");

var $ja8Ap = parcelRequire("ja8Ap");

var $ihOje = parcelRequire("ihOje");
const $81ade1a9dee56fc3$export$9ca9946bd449ac06 = 'baggage';
const $81ade1a9dee56fc3$export$6e69537d67fa20f = 'sentry-';
const $81ade1a9dee56fc3$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $81ade1a9dee56fc3$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $81ade1a9dee56fc3$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $ja8Ap.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $81ade1a9dee56fc3$var$baggageHeaderToObject(curr);
        for (const key of Object.keys(currBaggageObject))acc[key] = currBaggageObject[key];
        return acc;
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $81ade1a9dee56fc3$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($81ade1a9dee56fc3$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($81ade1a9dee56fc3$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $81ade1a9dee56fc3$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    if (!dynamicSamplingContext) return undefined;
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$81ade1a9dee56fc3$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $81ade1a9dee56fc3$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $81ade1a9dee56fc3$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $81ade1a9dee56fc3$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $81ade1a9dee56fc3$export$bdd844ddb2def819) {
            (0, $3CaV7.DEBUG_BUILD) && (0, $ihOje.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});






parcelRegister("lBThz", function(module, exports) {
$parcel$export(module.exports, "SDK_VERSION", () => $fbb7ef9792c08a33$export$31499a9cd224b78c);
const $fbb7ef9792c08a33$export$31499a9cd224b78c = '7.120.3';

});


parcelRegister("3fbVq", function(module, exports) {
$parcel$export(module.exports, "parseEventHintOrCaptureContext", () => $25cc05e96bfa521e$export$76b5f966996d1653);

var $frGXd = parcelRequire("frGXd");
var $bjakf = parcelRequire("bjakf");
var $euqZU = parcelRequire("euqZU");
var $bFtGG = parcelRequire("bFtGG");
var $4q36w = parcelRequire("4q36w");

var $4jwTD = parcelRequire("4jwTD");

var $30AuM = parcelRequire("30AuM");

var $b6Cmo = parcelRequire("b6Cmo");

var $ebsY6 = parcelRequire("ebsY6");

var $8UfMF = parcelRequire("8UfMF");
/**
 * This type makes sure that we get either a CaptureContext, OR an EventHint.
 * It does not allow mixing them, which could lead to unexpected outcomes, e.g. this is disallowed:
 * { user: { id: '123' }, mechanism: { handled: false } }
 */ /**
 * Adds common information to events.
 *
 * The information includes release and environment from `options`,
 * breadcrumbs and context (extra, tags and user) from the scope.
 *
 * Information that is already present in the event is never overwritten. For
 * nested objects, such as the context, keys are merged.
 *
 * Note: This also triggers callbacks for `addGlobalEventProcessor`, but not `beforeSend`.
 *
 * @param event The original event.
 * @param hint May contain additional information about the original exception.
 * @param scope A scope containing event metadata.
 * @returns A new event with more information.
 * @hidden
 */ function $25cc05e96bfa521e$export$2d67fb380bd11267(options, event, hint, scope, client, isolationScope) {
    const { normalizeDepth: normalizeDepth = 3, normalizeMaxBreadth: normalizeMaxBreadth = 1000 } = options;
    const prepared = {
        ...event,
        event_id: event.event_id || hint.event_id || (0, $frGXd.uuid4)(),
        timestamp: event.timestamp || (0, $bjakf.dateTimestampInSeconds)()
    };
    const integrations = hint.integrations || options.integrations.map((i)=>i.name);
    $25cc05e96bfa521e$var$applyClientOptions(prepared, options);
    $25cc05e96bfa521e$var$applyIntegrationsMetadata(prepared, integrations);
    // Only put debug IDs onto frames for error events.
    if (event.type === undefined) $25cc05e96bfa521e$export$63042efc86f043e7(prepared, options.stackParser);
    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    const finalScope = $25cc05e96bfa521e$var$getFinalScope(scope, hint.captureContext);
    if (hint.mechanism) (0, $frGXd.addExceptionMechanism)(prepared, hint.mechanism);
    const clientEventProcessors = client && client.getEventProcessors ? client.getEventProcessors() : [];
    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    // Merge scope data together
    const data = (0, $b6Cmo.getGlobalScope)().getScopeData();
    if (isolationScope) {
        const isolationData = isolationScope.getScopeData();
        (0, $ebsY6.mergeScopeData)(data, isolationData);
    }
    if (finalScope) {
        const finalScopeData = finalScope.getScopeData();
        (0, $ebsY6.mergeScopeData)(data, finalScopeData);
    }
    const attachments = [
        ...hint.attachments || [],
        ...data.attachments
    ];
    if (attachments.length) hint.attachments = attachments;
    (0, $ebsY6.applyScopeDataToEvent)(prepared, data);
    // TODO (v8): Update this order to be: Global > Client > Scope
    const eventProcessors = [
        ...clientEventProcessors,
        // eslint-disable-next-line deprecation/deprecation
        ...(0, $30AuM.getGlobalEventProcessors)(),
        // Run scope event processors _after_ all other processors
        ...data.eventProcessors
    ];
    const result = (0, $30AuM.notifyEventProcessors)(eventProcessors, prepared, hint);
    return result.then((evt)=>{
        if (evt) // We apply the debug_meta field only after all event processors have ran, so that if any event processors modified
        // file names (e.g.the RewriteFrames integration) the filename -> debug ID relationship isn't destroyed.
        // This should not cause any PII issues, since we're only moving data that is already on the event and not adding
        // any new data
        $25cc05e96bfa521e$export$1be657ba8ef44ff0(evt);
        if (typeof normalizeDepth === 'number' && normalizeDepth > 0) return $25cc05e96bfa521e$var$normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
        return evt;
    });
}
/**
 *  Enhances event using the client configuration.
 *  It takes care of all "static" values like environment, release and `dist`,
 *  as well as truncating overly long values.
 * @param event event instance to be enhanced
 */ function $25cc05e96bfa521e$var$applyClientOptions(event, options) {
    const { environment: environment, release: release, dist: dist, maxValueLength: maxValueLength = 250 } = options;
    if (!('environment' in event)) event.environment = 'environment' in options ? environment : (0, $4jwTD.DEFAULT_ENVIRONMENT);
    if (event.release === undefined && release !== undefined) event.release = release;
    if (event.dist === undefined && dist !== undefined) event.dist = dist;
    if (event.message) event.message = (0, $4q36w.truncate)(event.message, maxValueLength);
    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) exception.value = (0, $4q36w.truncate)(exception.value, maxValueLength);
    const request = event.request;
    if (request && request.url) request.url = (0, $4q36w.truncate)(request.url, maxValueLength);
}
const $25cc05e96bfa521e$var$debugIdStackParserCache = new WeakMap();
/**
 * Puts debug IDs into the stack frames of an error event.
 */ function $25cc05e96bfa521e$export$63042efc86f043e7(event, stackParser) {
    const debugIdMap = (0, $euqZU.GLOBAL_OBJ)._sentryDebugIds;
    if (!debugIdMap) return;
    let debugIdStackFramesCache;
    const cachedDebugIdStackFrameCache = $25cc05e96bfa521e$var$debugIdStackParserCache.get(stackParser);
    if (cachedDebugIdStackFrameCache) debugIdStackFramesCache = cachedDebugIdStackFrameCache;
    else {
        debugIdStackFramesCache = new Map();
        $25cc05e96bfa521e$var$debugIdStackParserCache.set(stackParser, debugIdStackFramesCache);
    }
    // Build a map of filename -> debug_id
    const filenameDebugIdMap = Object.keys(debugIdMap).reduce((acc, debugIdStackTrace)=>{
        let parsedStack;
        const cachedParsedStack = debugIdStackFramesCache.get(debugIdStackTrace);
        if (cachedParsedStack) parsedStack = cachedParsedStack;
        else {
            parsedStack = stackParser(debugIdStackTrace);
            debugIdStackFramesCache.set(debugIdStackTrace, parsedStack);
        }
        for(let i = parsedStack.length - 1; i >= 0; i--){
            const stackFrame = parsedStack[i];
            if (stackFrame.filename) {
                acc[stackFrame.filename] = debugIdMap[debugIdStackTrace];
                break;
            }
        }
        return acc;
    }, {});
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.filename) frame.debug_id = filenameDebugIdMap[frame.filename];
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
}
/**
 * Moves debug IDs from the stack frames of an error event into the debug_meta field.
 */ function $25cc05e96bfa521e$export$1be657ba8ef44ff0(event) {
    // Extract debug IDs and filenames from the stack frames on the event.
    const filenameDebugIdMap = {};
    try {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        event.exception.values.forEach((exception)=>{
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            exception.stacktrace.frames.forEach((frame)=>{
                if (frame.debug_id) {
                    if (frame.abs_path) filenameDebugIdMap[frame.abs_path] = frame.debug_id;
                    else if (frame.filename) filenameDebugIdMap[frame.filename] = frame.debug_id;
                    delete frame.debug_id;
                }
            });
        });
    } catch (e) {
    // To save bundle size we're just try catching here instead of checking for the existence of all the different objects.
    }
    if (Object.keys(filenameDebugIdMap).length === 0) return;
    // Fill debug_meta information
    event.debug_meta = event.debug_meta || {};
    event.debug_meta.images = event.debug_meta.images || [];
    const images = event.debug_meta.images;
    Object.keys(filenameDebugIdMap).forEach((filename)=>{
        images.push({
            type: 'sourcemap',
            code_file: filename,
            debug_id: filenameDebugIdMap[filename]
        });
    });
}
/**
 * This function adds all used integrations to the SDK info in the event.
 * @param event The event that will be filled with all integrations.
 */ function $25cc05e96bfa521e$var$applyIntegrationsMetadata(event, integrationNames) {
    if (integrationNames.length > 0) {
        event.sdk = event.sdk || {};
        event.sdk.integrations = [
            ...event.sdk.integrations || [],
            ...integrationNames
        ];
    }
}
/**
 * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
 * Normalized keys:
 * - `breadcrumbs.data`
 * - `user`
 * - `contexts`
 * - `extra`
 * @param event Event
 * @returns Normalized event
 */ function $25cc05e96bfa521e$var$normalizeEvent(event, depth, maxBreadth) {
    if (!event) return null;
    const normalized = {
        ...event,
        ...event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map((b)=>({
                    ...b,
                    ...b.data && {
                        data: (0, $bFtGG.normalize)(b.data, depth, maxBreadth)
                    }
                }))
        },
        ...event.user && {
            user: (0, $bFtGG.normalize)(event.user, depth, maxBreadth)
        },
        ...event.contexts && {
            contexts: (0, $bFtGG.normalize)(event.contexts, depth, maxBreadth)
        },
        ...event.extra && {
            extra: (0, $bFtGG.normalize)(event.extra, depth, maxBreadth)
        }
    };
    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
        normalized.contexts.trace = event.contexts.trace;
        // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
        if (event.contexts.trace.data) normalized.contexts.trace.data = (0, $bFtGG.normalize)(event.contexts.trace.data, depth, maxBreadth);
    }
    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) normalized.spans = event.spans.map((span)=>{
        const data = (0, $8UfMF.spanToJSON)(span).data;
        if (data) // This is a bit weird, as we generally have `Span` instances here, but to be safe we do not assume so
        // eslint-disable-next-line deprecation/deprecation
        span.data = (0, $bFtGG.normalize)(data, depth, maxBreadth);
        return span;
    });
    return normalized;
}
function $25cc05e96bfa521e$var$getFinalScope(scope, captureContext) {
    if (!captureContext) return scope;
    const finalScope = scope ? scope.clone() : new (0, $b6Cmo.Scope)();
    finalScope.update(captureContext);
    return finalScope;
}
/**
 * Parse either an `EventHint` directly, or convert a `CaptureContext` to an `EventHint`.
 * This is used to allow to update method signatures that used to accept a `CaptureContext` but should now accept an `EventHint`.
 */ function $25cc05e96bfa521e$export$76b5f966996d1653(hint) {
    if (!hint) return undefined;
    // If you pass a Scope or `() => Scope` as CaptureContext, we just return this as captureContext
    if ($25cc05e96bfa521e$var$hintIsScopeOrFunction(hint)) return {
        captureContext: hint
    };
    if ($25cc05e96bfa521e$var$hintIsScopeContext(hint)) return {
        captureContext: hint
    };
    return hint;
}
function $25cc05e96bfa521e$var$hintIsScopeOrFunction(hint) {
    return hint instanceof (0, $b6Cmo.Scope) || typeof hint === 'function';
}
const $25cc05e96bfa521e$var$captureContextKeys = [
    'user',
    'level',
    'extra',
    'contexts',
    'tags',
    'fingerprint',
    'requestSession',
    'propagationContext'
];
function $25cc05e96bfa521e$var$hintIsScopeContext(hint) {
    return Object.keys(hint).some((key)=>$25cc05e96bfa521e$var$captureContextKeys.includes(key));
}

});
parcelRegister("bFtGG", function(module, exports) {
$parcel$export(module.exports, "normalize", () => $87ea8d5806028e1a$export$a3295358bff77e);

var $ja8Ap = parcelRequire("ja8Ap");

var $8zO7Z = parcelRequire("8zO7Z");

var $1dhjw = parcelRequire("1dhjw");

var $btMed = parcelRequire("btMed");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $87ea8d5806028e1a$export$a3295358bff77e(input, depth = 100, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $87ea8d5806028e1a$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $87ea8d5806028e1a$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $87ea8d5806028e1a$export$a3295358bff77e(object, depth);
    if ($87ea8d5806028e1a$var$jsonSize(normalized) > maxSize) return $87ea8d5806028e1a$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $87ea8d5806028e1a$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $8zO7Z.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value == null || // this matches null and undefined -> eqeq not eqeqeq
    [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $ja8Ap.isNaN)(value)) return value;
    const stringified = $87ea8d5806028e1a$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // We can set `__sentry_override_normalization_depth__` on an object to ensure that from there
    // We keep a certain amount of depth.
    // This should be used sparingly, e.g. we use it for the redux integration to ensure we get a certain amount of state.
    const remainingDepth = typeof value['__sentry_override_normalization_depth__'] === 'number' ? value['__sentry_override_normalization_depth__'] : depth;
    // We're also done if we've reached the max depth
    if (remainingDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $87ea8d5806028e1a$export$588732934346abbf('', jsonValue, remainingDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $1dhjw.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $87ea8d5806028e1a$export$588732934346abbf(visitKey, visitValue, remainingDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/* eslint-disable complexity */ /**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $87ea8d5806028e1a$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        if ((0, $ja8Ap.isVueViewModel)(value)) return '[VueViewModel]';
        // React's SyntheticEvent thingy
        if ((0, $ja8Ap.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        if (typeof value === 'function') return `[Function: ${(0, $btMed.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        const objName = $87ea8d5806028e1a$var$getConstructorName(value);
        // Handle HTML Elements
        if (/^HTML(\w*)Element$/.test(objName)) return `[HTMLElement: ${objName}]`;
        return `[object ${objName}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
/* eslint-enable complexity */ function $87ea8d5806028e1a$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $87ea8d5806028e1a$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $87ea8d5806028e1a$var$jsonSize(value) {
    return $87ea8d5806028e1a$var$utf8Length(JSON.stringify(value));
}
/**
 * Normalizes URLs in exceptions and stacktraces to a base path so Sentry can fingerprint
 * across platforms and working directory.
 *
 * @param url The URL to be normalized.
 * @param basePath The application base path.
 * @returns The normalized URL.
 */ function $87ea8d5806028e1a$export$472b29734be05be3(url, basePath) {
    const escapedBase = basePath// Backslash to forward
    .replace(/\\/g, '/')// Escape RegExp special characters
    .replace(/[|\\{}()[\]^$+*?.]/g, '\\$&');
    let newUrl = url;
    try {
        newUrl = decodeURI(url);
    } catch (_Oo) {
    // Sometime this breaks
    }
    return newUrl.replace(/\\/g, '/').replace(/webpack:\/?/g, '') // Remove intermediate base path
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor
    .replace(new RegExp(`(file://)?/*${escapedBase}/*`, 'ig'), 'app:///');
}

});
parcelRegister("8zO7Z", function(module, exports) {
$parcel$export(module.exports, "memoBuilder", () => $63e879f462cedec9$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $63e879f462cedec9$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});

parcelRegister("btMed", function(module, exports) {
$parcel$export(module.exports, "getFunctionName", () => $85b7d0478502602b$export$aad197c7121a6651);

var $cyuQ5 = parcelRequire("cyuQ5");
const $85b7d0478502602b$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $85b7d0478502602b$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
const $85b7d0478502602b$var$STRIP_FRAME_REGEXP = /captureMessage|captureException/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $85b7d0478502602b$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $85b7d0478502602b$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($85b7d0478502602b$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            // https://github.com/getsentry/sentry-javascript/issues/7813
            // Skip Error: lines
            if (cleanedLine.match(/\S*Error: /)) continue;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $85b7d0478502602b$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $85b7d0478502602b$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $85b7d0478502602b$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $85b7d0478502602b$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $85b7d0478502602b$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = Array.from(stack);
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (/sentryWrapped/.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if ($85b7d0478502602b$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) {
        localStack.pop();
        // When using synthetic events, we will have a 2 levels deep stack, as `new Error('Sentry syntheticException')`
        // is produced within the hub itself, making it:
        //
        //   Sentry.captureException()
        //   getCurrentHub().captureException()
        //
        // instead of just the top `Sentry` call itself.
        // This forces us to possibly strip an additional frame in the exact same was as above.
        if ($85b7d0478502602b$var$STRIP_FRAME_REGEXP.test(localStack[localStack.length - 1].function || '')) localStack.pop();
    }
    return localStack.slice(0, $85b7d0478502602b$var$STACKTRACE_FRAME_LIMIT).map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || '?'
        }));
}
const $85b7d0478502602b$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $85b7d0478502602b$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $85b7d0478502602b$var$defaultFunctionName;
        return fn.name || $85b7d0478502602b$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $85b7d0478502602b$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $85b7d0478502602b$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $cyuQ5.node)(getModule)
    ];
}

});
parcelRegister("cyuQ5", function(module, exports) {
$parcel$export(module.exports, "node", () => $924094fd8fb70eff$export$35059013cd4a06db);
/**
 * Does this filename look like it's part of the app code?
 */ function $924094fd8fb70eff$export$1de92f38f4de99a8(filename, isNative = false) {
    const isInternal = isNative || filename && // It's not internal if it's an absolute linux path
    !filename.startsWith('/') && // It's not internal if it's an absolute windows path
    !filename.match(/^[A-Z]:/) && // It's not internal if the path is starting with a dot
    !filename.startsWith('.') && // It's not internal if the frame has a protocol. In node, this is usually the case if the file got pre-processed with a bundler like webpack
    !filename.match(/^[a-zA-Z]([a-zA-Z0-9.\-+])*:\/\//); // Schema from: https://stackoverflow.com/a/3641782
    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    return !isInternal && filename !== undefined && !filename.includes('node_modules/');
}
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $924094fd8fb70eff$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === 'native';
            // If it's a Windows path, trim the leading slash so that `/C:/foo` becomes `C:/foo`
            if (filename && filename.match(/\/[A-Z]:/)) filename = filename.slice(1);
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: $924094fd8fb70eff$export$1de92f38f4de99a8(filename, isNative)
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});





parcelRegister("fAZCe", function(module, exports) {
$parcel$export(module.exports, "convertIntegrationFnToClass", () => $b5aa0368cef83ead$export$afa219bf23651160);
$parcel$export(module.exports, "defineIntegration", () => $b5aa0368cef83ead$export$2323046b9414659f);

var $frGXd = parcelRequire("frGXd");
var $ihOje = parcelRequire("ihOje");

var $1pxS3 = parcelRequire("1pxS3");

var $30AuM = parcelRequire("30AuM");

var $511RT = parcelRequire("511RT");

var $e8ylv = parcelRequire("e8ylv");
const $b5aa0368cef83ead$export$b14a8888f80a0b3e = [];
/** Map of integrations assigned to a client */ /**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */ function $b5aa0368cef83ead$var$filterDuplicates(integrations) {
    const integrationsByName = {};
    integrations.forEach((currentInstance)=>{
        const { name: name } = currentInstance;
        const existingInstance = integrationsByName[name];
        // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
        // default instance to overwrite an existing user instance
        if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) return;
        integrationsByName[name] = currentInstance;
    });
    return Object.keys(integrationsByName).map((k)=>integrationsByName[k]);
}
/** Gets integrations to install */ function $b5aa0368cef83ead$export$68bc4c01ab8ae766(options) {
    const defaultIntegrations = options.defaultIntegrations || [];
    const userIntegrations = options.integrations;
    // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
    defaultIntegrations.forEach((integration)=>{
        integration.isDefaultInstance = true;
    });
    let integrations;
    if (Array.isArray(userIntegrations)) integrations = [
        ...defaultIntegrations,
        ...userIntegrations
    ];
    else if (typeof userIntegrations === 'function') integrations = (0, $frGXd.arrayify)(userIntegrations(defaultIntegrations));
    else integrations = defaultIntegrations;
    const finalIntegrations = $b5aa0368cef83ead$var$filterDuplicates(integrations);
    // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
    // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
    // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
    // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
    const debugIndex = $b5aa0368cef83ead$var$findIndex(finalIntegrations, (integration)=>integration.name === 'Debug');
    if (debugIndex !== -1) {
        const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
        finalIntegrations.push(debugInstance);
    }
    return finalIntegrations;
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */ function $b5aa0368cef83ead$export$51abed9797baa598(client, integrations) {
    const integrationIndex = {};
    integrations.forEach((integration)=>{
        // guard against empty provided integrations
        if (integration) $b5aa0368cef83ead$export$e7390a03b70a6f2f(client, integration, integrationIndex);
    });
    return integrationIndex;
}
/**
 * Execute the `afterAllSetup` hooks of the given integrations.
 */ function $b5aa0368cef83ead$export$35abcfd71227c6ca(client, integrations) {
    for (const integration of integrations)// guard against empty provided integrations
    if (integration && integration.afterAllSetup) integration.afterAllSetup(client);
}
/** Setup a single integration.  */ function $b5aa0368cef83ead$export$e7390a03b70a6f2f(client, integration, integrationIndex) {
    if (integrationIndex[integration.name]) {
        (0, $1pxS3.DEBUG_BUILD) && (0, $ihOje.logger).log(`Integration skipped because it was already installed: ${integration.name}`);
        return;
    }
    integrationIndex[integration.name] = integration;
    // `setupOnce` is only called the first time
    if ($b5aa0368cef83ead$export$b14a8888f80a0b3e.indexOf(integration.name) === -1) {
        // eslint-disable-next-line deprecation/deprecation
        integration.setupOnce((0, $30AuM.addGlobalEventProcessor), (0, $e8ylv.getCurrentHub));
        $b5aa0368cef83ead$export$b14a8888f80a0b3e.push(integration.name);
    }
    // `setup` is run for each client
    if (integration.setup && typeof integration.setup === 'function') integration.setup(client);
    if (client.on && typeof integration.preprocessEvent === 'function') {
        const callback = integration.preprocessEvent.bind(integration);
        client.on('preprocessEvent', (event, hint)=>callback(event, hint, client));
    }
    if (client.addEventProcessor && typeof integration.processEvent === 'function') {
        const callback = integration.processEvent.bind(integration);
        const processor = Object.assign((event, hint)=>callback(event, hint, client), {
            id: integration.name
        });
        client.addEventProcessor(processor);
    }
    (0, $1pxS3.DEBUG_BUILD) && (0, $ihOje.logger).log(`Integration installed: ${integration.name}`);
}
/** Add an integration to the current hub's client. */ function $b5aa0368cef83ead$export$2d8f5188773bcddd(integration) {
    const client = (0, $511RT.getClient)();
    if (!client || !client.addIntegration) {
        (0, $1pxS3.DEBUG_BUILD) && (0, $ihOje.logger).warn(`Cannot add integration "${integration.name}" because no SDK Client is available.`);
        return;
    }
    client.addIntegration(integration);
}
// Polyfill for Array.findIndex(), which is not supported in ES5
function $b5aa0368cef83ead$var$findIndex(arr, callback) {
    for(let i = 0; i < arr.length; i++){
        if (callback(arr[i]) === true) return i;
    }
    return -1;
}
/**
 * Convert a new integration function to the legacy class syntax.
 * In v8, we can remove this and instead export the integration functions directly.
 *
 * @deprecated This will be removed in v8!
 */ function $b5aa0368cef83ead$export$afa219bf23651160(name, fn) {
    return Object.assign(function ConvertedIntegration(...args) {
        return fn(...args);
    }, {
        id: name
    });
}
/**
 * Define an integration function that can be used to create an integration instance.
 * Note that this by design hides the implementation details of the integration, as they are considered internal.
 */ function $b5aa0368cef83ead$export$2323046b9414659f(fn) {
    return fn;
}

});

parcelRegister("5GIDi", function(module, exports) {
$parcel$export(module.exports, "addConsoleInstrumentationHandler", () => $42437f2706c89c2e$export$1d6e0d073f9e6723);

var $ihOje = parcelRequire("ihOje");

var $1dhjw = parcelRequire("1dhjw");

var $euqZU = parcelRequire("euqZU");

var $4UcS0 = parcelRequire("4UcS0");
/**
 * Add an instrumentation handler for when a console.xxx method is called.
 *
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $42437f2706c89c2e$export$1d6e0d073f9e6723(handler) {
    const type = 'console';
    (0, $4UcS0.addHandler)(type, handler);
    (0, $4UcS0.maybeInstrument)(type, $42437f2706c89c2e$var$instrumentConsole);
}
function $42437f2706c89c2e$var$instrumentConsole() {
    if (!('console' in (0, $euqZU.GLOBAL_OBJ))) return;
    (0, $ihOje.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in (0, $euqZU.GLOBAL_OBJ).console)) return;
        (0, $1dhjw.fill)((0, $euqZU.GLOBAL_OBJ).console, level, function(originalConsoleMethod) {
            (0, $ihOje.originalConsoleMethods)[level] = originalConsoleMethod;
            return function(...args) {
                const handlerData = {
                    args: args,
                    level: level
                };
                (0, $4UcS0.triggerHandlers)('console', handlerData);
                const log = (0, $ihOje.originalConsoleMethods)[level];
                log && log.apply((0, $euqZU.GLOBAL_OBJ).console, args);
            };
        });
    });
}

});
parcelRegister("4UcS0", function(module, exports) {
$parcel$export(module.exports, "addHandler", () => $392660194b090319$export$a4e09611e30da72e);
$parcel$export(module.exports, "maybeInstrument", () => $392660194b090319$export$e18d6c5462c01368);
$parcel$export(module.exports, "triggerHandlers", () => $392660194b090319$export$b18c893e424d3127);

var $3CaV7 = parcelRequire("3CaV7");

var $ihOje = parcelRequire("ihOje");

var $btMed = parcelRequire("btMed");
// We keep the handlers globally
const $392660194b090319$var$handlers = {};
const $392660194b090319$var$instrumented = {};
/** Add a handler function. */ function $392660194b090319$export$a4e09611e30da72e(type, handler) {
    $392660194b090319$var$handlers[type] = $392660194b090319$var$handlers[type] || [];
    $392660194b090319$var$handlers[type].push(handler);
}
/**
 * Reset all instrumentation handlers.
 * This can be used by tests to ensure we have a clean slate of instrumentation handlers.
 */ function $392660194b090319$export$b17eab759a1cb5fe() {
    Object.keys($392660194b090319$var$handlers).forEach((key)=>{
        $392660194b090319$var$handlers[key] = undefined;
    });
}
/** Maybe run an instrumentation function, unless it was already called. */ function $392660194b090319$export$e18d6c5462c01368(type, instrumentFn) {
    if (!$392660194b090319$var$instrumented[type]) {
        instrumentFn();
        $392660194b090319$var$instrumented[type] = true;
    }
}
/** Trigger handlers for a given instrumentation type. */ function $392660194b090319$export$b18c893e424d3127(type, data) {
    const typeHandlers = type && $392660194b090319$var$handlers[type];
    if (!typeHandlers) return;
    for (const handler of typeHandlers)try {
        handler(data);
    } catch (e) {
        (0, $3CaV7.DEBUG_BUILD) && (0, $ihOje.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $btMed.getFunctionName)(handler)}\nError:`, e);
    }
}

});


parcelRegister("fmRSM", function(module, exports) {
$parcel$export(module.exports, "severityLevelFromString", () => $b302b504c39f2fd3$export$d771ef054122c30a);
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.
const $b302b504c39f2fd3$export$411d0ffdba845b6c = [
    'fatal',
    'error',
    'warning',
    'log',
    'info',
    'debug'
];
/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */ function $b302b504c39f2fd3$export$e01cef29b4327697(level) {
    return $b302b504c39f2fd3$export$d771ef054122c30a(level);
}
/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */ function $b302b504c39f2fd3$export$d771ef054122c30a(level) {
    return level === 'warn' ? 'warning' : $b302b504c39f2fd3$export$411d0ffdba845b6c.includes(level) ? level : 'log';
}

});


parcelRegister("gwUes", function(module, exports) {
$parcel$export(module.exports, "dedupeIntegration", () => $c08b410787f030fd$export$6d39aa44cd0c7567);
$parcel$export(module.exports, "Dedupe", () => $c08b410787f030fd$export$688d98c249d31ad3);

var $fAZCe = parcelRequire("fAZCe");

var $ihOje = parcelRequire("ihOje");

var $2Vacp = parcelRequire("2Vacp");
const $c08b410787f030fd$var$INTEGRATION_NAME = 'Dedupe';
const $c08b410787f030fd$var$_dedupeIntegration = ()=>{
    let previousEvent;
    return {
        name: $c08b410787f030fd$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (currentEvent) {
            // We want to ignore any non-error type events, e.g. transactions or replays
            // These should never be deduped, and also not be compared against as _previousEvent.
            if (currentEvent.type) return currentEvent;
            // Juuust in case something goes wrong
            try {
                if ($c08b410787f030fd$export$3c6361fddf6cd929(currentEvent, previousEvent)) {
                    (0, $2Vacp.DEBUG_BUILD) && (0, $ihOje.logger).warn('Event dropped due to being a duplicate of previously captured event.');
                    return null;
                }
            } catch (_oO) {} // eslint-disable-line no-empty
            return previousEvent = currentEvent;
        }
    };
};
const $c08b410787f030fd$export$6d39aa44cd0c7567 = (0, $fAZCe.defineIntegration)($c08b410787f030fd$var$_dedupeIntegration);
/**
 * Deduplication filter.
 * @deprecated Use `dedupeIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $c08b410787f030fd$export$688d98c249d31ad3 = (0, $fAZCe.convertIntegrationFnToClass)($c08b410787f030fd$var$INTEGRATION_NAME, $c08b410787f030fd$export$6d39aa44cd0c7567);
/** only exported for tests. */ function $c08b410787f030fd$export$3c6361fddf6cd929(currentEvent, previousEvent) {
    if (!previousEvent) return false;
    if ($c08b410787f030fd$var$_isSameMessageEvent(currentEvent, previousEvent)) return true;
    if ($c08b410787f030fd$var$_isSameExceptionEvent(currentEvent, previousEvent)) return true;
    return false;
}
function $c08b410787f030fd$var$_isSameMessageEvent(currentEvent, previousEvent) {
    const currentMessage = currentEvent.message;
    const previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) return false;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentMessage && !previousMessage || !currentMessage && previousMessage) return false;
    if (currentMessage !== previousMessage) return false;
    if (!$c08b410787f030fd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$c08b410787f030fd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $c08b410787f030fd$var$_isSameExceptionEvent(currentEvent, previousEvent) {
    const previousException = $c08b410787f030fd$var$_getExceptionFromEvent(previousEvent);
    const currentException = $c08b410787f030fd$var$_getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) return false;
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) return false;
    if (!$c08b410787f030fd$var$_isSameFingerprint(currentEvent, previousEvent)) return false;
    if (!$c08b410787f030fd$var$_isSameStacktrace(currentEvent, previousEvent)) return false;
    return true;
}
function $c08b410787f030fd$var$_isSameStacktrace(currentEvent, previousEvent) {
    let currentFrames = $c08b410787f030fd$var$_getFramesFromEvent(currentEvent);
    let previousFrames = $c08b410787f030fd$var$_getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) return true;
    // If only one event has a stacktrace, but not the other one, they are not the same
    if (currentFrames && !previousFrames || !currentFrames && previousFrames) return false;
    currentFrames;
    previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) return false;
    // Otherwise, compare the two
    for(let i = 0; i < previousFrames.length; i++){
        const frameA = previousFrames[i];
        const frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename || frameA.lineno !== frameB.lineno || frameA.colno !== frameB.colno || frameA.function !== frameB.function) return false;
    }
    return true;
}
function $c08b410787f030fd$var$_isSameFingerprint(currentEvent, previousEvent) {
    let currentFingerprint = currentEvent.fingerprint;
    let previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) return true;
    // If only one event has a fingerprint, but not the other one, they are not the same
    if (currentFingerprint && !previousFingerprint || !currentFingerprint && previousFingerprint) return false;
    currentFingerprint;
    previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    } catch (_oO) {
        return false;
    }
}
function $c08b410787f030fd$var$_getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
function $c08b410787f030fd$var$_getFramesFromEvent(event) {
    const exception = event.exception;
    if (exception) try {
        // @ts-expect-error Object could be undefined
        return exception.values[0].stacktrace.frames;
    } catch (_oO) {
        return undefined;
    }
    return undefined;
}

});
parcelRegister("2Vacp", function(module, exports) {
$parcel$export(module.exports, "DEBUG_BUILD", () => $2208d0f5fc561583$export$16a28057038b10ef);
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ const $2208d0f5fc561583$export$16a28057038b10ef = typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__;

});


parcelRegister("gOI8F", function(module, exports) {
$parcel$export(module.exports, "extraErrorDataIntegration", () => $c3e38dec0f9d83f6$export$6e0872131894301d);
$parcel$export(module.exports, "ExtraErrorData", () => $c3e38dec0f9d83f6$export$56d961ef3a52a072);

var $fAZCe = parcelRequire("fAZCe");

var $1dhjw = parcelRequire("1dhjw");
var $ja8Ap = parcelRequire("ja8Ap");
var $ihOje = parcelRequire("ihOje");
var $bFtGG = parcelRequire("bFtGG");

var $2Vacp = parcelRequire("2Vacp");
const $c3e38dec0f9d83f6$var$INTEGRATION_NAME = 'ExtraErrorData';
const $c3e38dec0f9d83f6$var$_extraErrorDataIntegration = (options = {})=>{
    const depth = options.depth || 3;
    // TODO(v8): Flip the default for this option to true
    const captureErrorCause = options.captureErrorCause || false;
    return {
        name: $c3e38dec0f9d83f6$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (event, hint) {
            return $c3e38dec0f9d83f6$var$_enhanceEventWithErrorData(event, hint, depth, captureErrorCause);
        }
    };
};
const $c3e38dec0f9d83f6$export$6e0872131894301d = (0, $fAZCe.defineIntegration)($c3e38dec0f9d83f6$var$_extraErrorDataIntegration);
/**
 * Extract additional data for from original exceptions.
 * @deprecated Use `extraErrorDataIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $c3e38dec0f9d83f6$export$56d961ef3a52a072 = (0, $fAZCe.convertIntegrationFnToClass)($c3e38dec0f9d83f6$var$INTEGRATION_NAME, $c3e38dec0f9d83f6$export$6e0872131894301d);
function $c3e38dec0f9d83f6$var$_enhanceEventWithErrorData(event, hint = {}, depth, captureErrorCause) {
    if (!hint.originalException || !(0, $ja8Ap.isError)(hint.originalException)) return event;
    const exceptionName = hint.originalException.name || hint.originalException.constructor.name;
    const errorData = $c3e38dec0f9d83f6$var$_extractErrorData(hint.originalException, captureErrorCause);
    if (errorData) {
        const contexts = {
            ...event.contexts
        };
        const normalizedErrorData = (0, $bFtGG.normalize)(errorData, depth);
        if ((0, $ja8Ap.isPlainObject)(normalizedErrorData)) {
            // We mark the error data as "already normalized" here, because we don't want other normalization procedures to
            // potentially truncate the data we just already normalized, with a certain depth setting.
            (0, $1dhjw.addNonEnumerableProperty)(normalizedErrorData, '__sentry_skip_normalization__', true);
            contexts[exceptionName] = normalizedErrorData;
        }
        return {
            ...event,
            contexts: contexts
        };
    }
    return event;
}
/**
 * Extract extra information from the Error object
 */ function $c3e38dec0f9d83f6$var$_extractErrorData(error, captureErrorCause) {
    // We are trying to enhance already existing event, so no harm done if it won't succeed
    try {
        const nativeKeys = [
            'name',
            'message',
            'stack',
            'line',
            'column',
            'fileName',
            'lineNumber',
            'columnNumber',
            'toJSON'
        ];
        const extraErrorInfo = {};
        // We want only enumerable properties, thus `getOwnPropertyNames` is redundant here, as we filter keys anyway.
        for (const key of Object.keys(error)){
            if (nativeKeys.indexOf(key) !== -1) continue;
            const value = error[key];
            extraErrorInfo[key] = (0, $ja8Ap.isError)(value) ? value.toString() : value;
        }
        // Error.cause is a standard property that is non enumerable, we therefore need to access it separately.
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/cause
        if (captureErrorCause && error.cause !== undefined) extraErrorInfo.cause = (0, $ja8Ap.isError)(error.cause) ? error.cause.toString() : error.cause;
        // Check if someone attached `toJSON` method to grab even more properties (eg. axios is doing that)
        if (typeof error.toJSON === 'function') {
            const serializedError = error.toJSON();
            for (const key of Object.keys(serializedError)){
                const value = serializedError[key];
                extraErrorInfo[key] = (0, $ja8Ap.isError)(value) ? value.toString() : value;
            }
        }
        return extraErrorInfo;
    } catch (oO) {
        (0, $2Vacp.DEBUG_BUILD) && (0, $ihOje.logger).error('Unable to extract extra data from the Error object:', oO);
    }
    return null;
}

});

parcelRegister("jPpPM", function(module, exports) {
$parcel$export(module.exports, "rewriteFramesIntegration", () => $e6f6d1e21d14bbec$export$5ed0db6416cb6ea2);
$parcel$export(module.exports, "RewriteFrames", () => $e6f6d1e21d14bbec$export$af39fa91d1acf248);

var $fAZCe = parcelRequire("fAZCe");

var $kqd3M = parcelRequire("kqd3M");
const $e6f6d1e21d14bbec$var$INTEGRATION_NAME = 'RewriteFrames';
const $e6f6d1e21d14bbec$var$_rewriteFramesIntegration = (options = {})=>{
    const root = options.root;
    const prefix = options.prefix || 'app:///';
    const iteratee = options.iteratee || ((frame)=>{
        if (!frame.filename) return frame;
        // Determine if this is a Windows frame by checking for a Windows-style prefix such as `C:\`
        const isWindowsFrame = /^[a-zA-Z]:\\/.test(frame.filename) || // or the presence of a backslash without a forward slash (which are not allowed on Windows)
        frame.filename.includes('\\') && !frame.filename.includes('/');
        // Check if the frame filename begins with `/`
        const startsWithSlash = /^\//.test(frame.filename);
        if (isWindowsFrame || startsWithSlash) {
            const filename = isWindowsFrame ? frame.filename.replace(/^[a-zA-Z]:/, '') // remove Windows-style prefix
            .replace(/\\/g, '/') // replace all `\\` instances with `/`
             : frame.filename;
            const base = root ? (0, $kqd3M.relative)(root, filename) : (0, $kqd3M.basename)(filename);
            frame.filename = `${prefix}${base}`;
        }
        return frame;
    });
    /** Process an exception event. */ function _processExceptionsEvent(event) {
        try {
            return {
                ...event,
                exception: {
                    ...event.exception,
                    // The check for this is performed inside `process` call itself, safe to skip here
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    values: event.exception.values.map((value)=>({
                            ...value,
                            ...value.stacktrace && {
                                stacktrace: _processStacktrace(value.stacktrace)
                            }
                        }))
                }
            };
        } catch (_oO) {
            return event;
        }
    }
    /** Process a stack trace. */ function _processStacktrace(stacktrace) {
        return {
            ...stacktrace,
            frames: stacktrace && stacktrace.frames && stacktrace.frames.map((f)=>iteratee(f))
        };
    }
    return {
        name: $e6f6d1e21d14bbec$var$INTEGRATION_NAME,
        // TODO v8: Remove this
        setupOnce () {},
        processEvent (originalEvent) {
            let processedEvent = originalEvent;
            if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) processedEvent = _processExceptionsEvent(processedEvent);
            return processedEvent;
        }
    };
};
const $e6f6d1e21d14bbec$export$5ed0db6416cb6ea2 = (0, $fAZCe.defineIntegration)($e6f6d1e21d14bbec$var$_rewriteFramesIntegration);
/**
 * Rewrite event frames paths.
 * @deprecated Use `rewriteFramesIntegration()` instead.
 */ // eslint-disable-next-line deprecation/deprecation
const $e6f6d1e21d14bbec$export$af39fa91d1acf248 = (0, $fAZCe.convertIntegrationFnToClass)($e6f6d1e21d14bbec$var$INTEGRATION_NAME, $e6f6d1e21d14bbec$export$5ed0db6416cb6ea2);

});
parcelRegister("kqd3M", function(module, exports) {
$parcel$export(module.exports, "relative", () => $ede05dc681ffb095$export$f0e7d1106eeabbe6);
$parcel$export(module.exports, "basename", () => $ede05dc681ffb095$export$9bf319d8f74f51d1);
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://github.com/calvinmetcalf/rollup-plugin-node-builtins/blob/63ab8aacd013767445ca299e468d9a60a95328d7/src/es6/path.js
//
// Copyright Joyent, Inc.and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
/** JSDoc */ function $ede05dc681ffb095$var$normalizeArray(parts, allowAboveRoot) {
    // if the path tries to go above the root, `up` ends up > 0
    let up = 0;
    for(let i = parts.length - 1; i >= 0; i--){
        const last = parts[i];
        if (last === '.') parts.splice(i, 1);
        else if (last === '..') {
            parts.splice(i, 1);
            up++;
        } else if (up) {
            parts.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (allowAboveRoot) for(; up--; up)parts.unshift('..');
    return parts;
}
// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const $ede05dc681ffb095$var$splitPathRe = /^(\S+:\\|\/?)([\s\S]*?)((?:\.{1,2}|[^/\\]+?|)(\.[^./\\]*|))(?:[/\\]*)$/;
/** JSDoc */ function $ede05dc681ffb095$var$splitPath(filename) {
    // Truncate files names greater than 1024 characters to avoid regex dos
    // https://github.com/getsentry/sentry-javascript/pull/8737#discussion_r1285719172
    const truncated = filename.length > 1024 ? `<truncated>${filename.slice(-1024)}` : filename;
    const parts = $ede05dc681ffb095$var$splitPathRe.exec(truncated);
    return parts ? parts.slice(1) : [];
}
// path.resolve([from ...], to)
// posix version
/** JSDoc */ function $ede05dc681ffb095$export$f7ad0328861e2f03(...args) {
    let resolvedPath = '';
    let resolvedAbsolute = false;
    for(let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--){
        const path = i >= 0 ? args[i] : '/';
        // Skip empty entries
        if (!path) continue;
        resolvedPath = `${path}/${resolvedPath}`;
        resolvedAbsolute = path.charAt(0) === '/';
    }
    // At this point the path should be resolved to a full absolute path, but
    // handle relative paths to be safe (might happen when process.cwd() fails)
    // Normalize the path
    resolvedPath = $ede05dc681ffb095$var$normalizeArray(resolvedPath.split('/').filter((p)=>!!p), !resolvedAbsolute).join('/');
    return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}
/** JSDoc */ function $ede05dc681ffb095$var$trim(arr) {
    let start = 0;
    for(; start < arr.length; start++){
        if (arr[start] !== '') break;
    }
    let end = arr.length - 1;
    for(; end >= 0; end--){
        if (arr[end] !== '') break;
    }
    if (start > end) return [];
    return arr.slice(start, end - start + 1);
}
// path.relative(from, to)
// posix version
/** JSDoc */ function $ede05dc681ffb095$export$f0e7d1106eeabbe6(from, to) {
    /* eslint-disable no-param-reassign */ from = $ede05dc681ffb095$export$f7ad0328861e2f03(from).slice(1);
    to = $ede05dc681ffb095$export$f7ad0328861e2f03(to).slice(1);
    /* eslint-enable no-param-reassign */ const fromParts = $ede05dc681ffb095$var$trim(from.split('/'));
    const toParts = $ede05dc681ffb095$var$trim(to.split('/'));
    const length = Math.min(fromParts.length, toParts.length);
    let samePartsLength = length;
    for(let i = 0; i < length; i++)if (fromParts[i] !== toParts[i]) {
        samePartsLength = i;
        break;
    }
    let outputParts = [];
    for(let i = samePartsLength; i < fromParts.length; i++)outputParts.push('..');
    outputParts = outputParts.concat(toParts.slice(samePartsLength));
    return outputParts.join('/');
}
// path.normalize(path)
// posix version
/** JSDoc */ function $ede05dc681ffb095$export$6af368f973c74c5(path) {
    const isPathAbsolute = $ede05dc681ffb095$export$e434c7255acda994(path);
    const trailingSlash = path.slice(-1) === '/';
    // Normalize the path
    let normalizedPath = $ede05dc681ffb095$var$normalizeArray(path.split('/').filter((p)=>!!p), !isPathAbsolute).join('/');
    if (!normalizedPath && !isPathAbsolute) normalizedPath = '.';
    if (normalizedPath && trailingSlash) normalizedPath += '/';
    return (isPathAbsolute ? '/' : '') + normalizedPath;
}
// posix version
/** JSDoc */ function $ede05dc681ffb095$export$e434c7255acda994(path) {
    return path.charAt(0) === '/';
}
// posix version
/** JSDoc */ function $ede05dc681ffb095$export$f7e2c8231c57a8bd(...args) {
    return $ede05dc681ffb095$export$6af368f973c74c5(args.join('/'));
}
/** JSDoc */ function $ede05dc681ffb095$export$7f7b8152cc673abe(path) {
    const result = $ede05dc681ffb095$var$splitPath(path);
    const root = result[0];
    let dir = result[1];
    if (!root && !dir) // No dirname whatsoever
    return '.';
    if (dir) // It has a dirname, strip trailing slash
    dir = dir.slice(0, dir.length - 1);
    return root + dir;
}
/** JSDoc */ function $ede05dc681ffb095$export$9bf319d8f74f51d1(path, ext) {
    let f = $ede05dc681ffb095$var$splitPath(path)[2];
    if (ext && f.slice(ext.length * -1) === ext) f = f.slice(0, f.length - ext.length);
    return f;
}

});


parcelRegister("aYncF", function(module, exports) {
$parcel$export(module.exports, "LICENSED_PRODUCTS", () => $f94c92768d16d5bb$export$88049c64f9286584);
$parcel$export(module.exports, "getLicensedProducts", () => $f94c92768d16d5bb$export$8cc688f27940ac);
$parcel$export(module.exports, "getInitialProductList", () => $f94c92768d16d5bb$export$971bd624a4cf068e);
$parcel$export(module.exports, "getFirstActivationDate", () => $f94c92768d16d5bb$export$2fc3e4b3f0460c2f);
$parcel$export(module.exports, "determineProductCrossSellConfig", () => $f94c92768d16d5bb$export$2885d42113231825);
$parcel$export(module.exports, "getEnvironment", () => $f94c92768d16d5bb$export$57570b1603cf6adb);
$parcel$export(module.exports, "getAtlassianAccountId", () => $f94c92768d16d5bb$export$f5baf4f0aaa47428);
$parcel$export(module.exports, "getTenantContext_DEPRECATED_DO_NOT_USE", () => $f94c92768d16d5bb$export$374aeba69d52d74d);

var $LFmXM = parcelRequire("LFmXM");

var $jbr6p = parcelRequire("jbr6p");

var $5KtrL = parcelRequire("5KtrL");

var $dCptc = parcelRequire("dCptc");

var $hWeHP = parcelRequire("hWeHP");

var $kIz4h = parcelRequire("kIz4h");

var $es5G8 = parcelRequire("es5G8");

var $aFPNn = parcelRequire("aFPNn");

var $cDvK0 = parcelRequire("cDvK0");

var $8FAyk = parcelRequire("8FAyk");
const $f94c92768d16d5bb$export$88049c64f9286584 = {
    ATLASSIAN_ANALYTICS: 'atlassian-analytics-free',
    JIRA_SOFTWARE: 'jira-software',
    JIRA_SERVICEDESK: 'jira-servicedesk',
    JIRA_PORTFOLIO: 'com.radiantminds.roadmaps-jira',
    JIRA_CORE: 'jira-core',
    JIRA_PRODUCT_DISCOVERY: 'jira-product-discovery',
    CONFLUENCE: 'confluence',
    OPSGENIE: 'opsgenie',
    BITBUCKET: 'com.atlassian.bitbucket',
    STATUS_PAGE: 'statuspage',
    LOOM: 'loom',
    COMPASS: 'compass',
    TOWNSQUARE: 'townsquare',
    PROJECT: 'project',
    GOAL: 'goal'
};
const $f94c92768d16d5bb$export$b4187945225b3132 = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $hWeHP.default) : getMetaCustom;
    const metaValue = getMetaImpl('ajs-is-admin');
    if (metaValue === null) return 'unknown';
    return metaValue === 'true' ? 'admin' : 'non-admin';
};
const $f94c92768d16d5bb$export$8cc688f27940ac = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $hWeHP.default) : getMetaCustom;
    try {
        return JSON.parse(getMetaImpl('ajs-licensed-products') || '{}');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Invalid list of licensed products: ${error}`);
        return {};
    }
};
const $f94c92768d16d5bb$export$875713824cd90c85 = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $hWeHP.default) : getMetaCustom;
    try {
        return JSON.parse(getMetaImpl('ajs-product-entitlement-details') || '{}');
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        return {};
    }
};
const $f94c92768d16d5bb$export$971bd624a4cf068e = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $hWeHP.default) : getMetaCustom;
    const metaValue = getMetaImpl('ajs-initial-product-list');
    if (metaValue === null) return '';
    return metaValue;
};
const $f94c92768d16d5bb$export$2fc3e4b3f0460c2f = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $hWeHP.default) : getMetaCustom;
    const metaValue = getMetaImpl('ajs-first-activation-date');
    if (metaValue === null) return null;
    const timestamp = parseInt(metaValue, 10);
    if (Number.isNaN(timestamp)) return null;
    return timestamp;
};
const $f94c92768d16d5bb$export$c3fee804514cdf76 = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $hWeHP.default) : getMetaCustom;
    const metaValue = getMetaImpl('ajs-app-updates-available');
    if (metaValue === null) return null;
    const hasAppUpdates = parseInt(metaValue, 10);
    if (Number.isNaN(hasAppUpdates)) return null;
    return hasAppUpdates;
};
const $f94c92768d16d5bb$export$2885d42113231825 = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $hWeHP.default) : getMetaCustom;
    const metaValue = getMetaImpl('ajs-xflow-product-suggestions-enabled');
    if (metaValue === null) return 'unknown';
    return metaValue === 'true' ? 'enabled' : 'disabled';
};
const $f94c92768d16d5bb$export$57570b1603cf6adb = ()=>(0, $dCptc.toEnvironment)((0, $hWeHP.default)('ajs-environment'));
const $f94c92768d16d5bb$export$f5baf4f0aaa47428 = ()=>(0, $hWeHP.default)('ajs-atlassian-account-id');
const $f94c92768d16d5bb$export$8ece9c90e8293278 = ()=>{
    return(// Cloud ID is flushed early. Checking only this means critical values are available, but not "all of them".
    typeof (0, $hWeHP.default)('ajs-cloud-id') === 'string' && // Version number is retrieved via slow metadata provider call. its presence should indicate "the rest" are available, too.
    typeof (0, $hWeHP.default)('ajs-version-number') === 'string');
};
/**
 * Use hooks from @atlassian/jira-tenant-context-controller instead of this function. Because reading from 30 <meta> tags in DOM on each call slows page down considerably.
 * More info: https://hello.atlassian.net/wiki/spaces/MAGMA/blog/2022/01/12/1479453433/PSA+getTenantContext+is+now+deprecated
 */ const $f94c92768d16d5bb$var$getTenantContextFromMeta = (getMetaCustom)=>{
    const getMetaImpl = getMetaCustom === undefined ? (0, $hWeHP.default) : getMetaCustom;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const cloudId = getMetaImpl('ajs-cloud-id');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const activationId = getMetaImpl('ajs-activation-id');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const cloudName = getMetaImpl('ajs-cloud-name');
    const xsrfToken = getMetaImpl === (0, $hWeHP.default) ? (0, $kIz4h.default)() || null : getMetaImpl('atlassian-token');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const languageTag = getMetaImpl('ajs-fspage-locale');
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    const locale = getMetaImpl('ajs-user-locale');
    const userFullname = getMetaImpl('ajs-remote-user-fullname');
    const username = getMetaImpl('ajs-remote-user');
    const isAdmin = getMetaImpl('ajs-is-admin') === 'true';
    const isSiteAdmin = getMetaImpl('ajs-is-site-admin') === 'true';
    const fabricActivityUrl = '/gateway/api/activity';
    const fabricNotificationLogUrl = '/gateway/api/notification-log';
    const fabricPfDirUrl = getMetaImpl('ajs-fabric-pf-dir-url');
    const appPermissions = (0, $dCptc.populateApplicationPermissions)({
        hasSoftwareAccess: getMetaImpl('ajs-has-jira-software') === 'true',
        hasServiceDeskAccess: getMetaImpl('ajs-has-jira-service-desk') === 'true',
        hasCoreAccess: getMetaImpl('ajs-has-jira-core') === 'true',
        hasProductDiscoveryAccess: getMetaImpl('ajs-has-jira-product-discovery') === 'true',
        hasCustomerServiceAccess: getMetaImpl('ajs-has-jira-customer-service') === 'true'
    });
    const accountId = getMetaImpl('ajs-atlassian-account-id');
    const isAnonymous = accountId === '';
    const applicationKey = getMetaImpl('ajs-application-key');
    const environment = (0, $dCptc.toEnvironment)(getMetaImpl('ajs-environment'));
    const areProductSuggestionsEnabled = getMetaImpl('ajs-xflow-product-suggestions-enabled') === 'true';
    const licensedProducts = $f94c92768d16d5bb$export$8cc688f27940ac(getMetaImpl);
    const productEntitlementDetails = $f94c92768d16d5bb$export$875713824cd90c85(getMetaImpl);
    if (accountId === null || locale === null || cloudId === null) {
        (0, $es5G8.captureException)('getTenantContextFromMeta', new Error('Unable to find tenant context (detailed exception)'), {
            teamName: 'jfp-magma',
            isAnonymous: isAnonymous.toString(),
            isAccountIdNull: Boolean(accountId === null).toString(),
            isLocaleNull: Boolean(locale === null).toString(),
            isCloudIdNull: Boolean(cloudId === null).toString()
        });
        throw new Error('Unable to find tenant context');
    }
    if (!(0, $jbr6p.default).includes(locale)) // eslint-disable-next-line no-console
    console.warn(`Non supported locale in tenant context: ${locale}`);
    const siteAdminStatus = $f94c92768d16d5bb$export$b4187945225b3132(getMetaImpl);
    const productCrossSellConfig = $f94c92768d16d5bb$export$2885d42113231825(getMetaImpl);
    const appEditions = (0, $aFPNn.default)(getMetaImpl);
    const productPermissionGated = (0, $8FAyk.default)(getMetaImpl);
    let licenseStates;
    if (getMetaImpl('ajs-product-license-states') !== null) licenseStates = (0, $cDvK0.default)(getMetaImpl);
    else /**
		 * When feature flag is OFF, the value of licenseStates will just depend on ajs-has-* tags.
		 * At the moment, there's no other usages besides <LicenseStateCheck>, so this is safe
		 */ licenseStates = (0, $5KtrL.populateApplicationLicenseStates)({
        core: appPermissions.hasCoreAccess ? (0, $5KtrL.LICENSE_STATE_ACTIVE) : (0, $5KtrL.LICENSE_STATE_UNLICENSED),
        software: appPermissions.hasSoftwareAccess ? (0, $5KtrL.LICENSE_STATE_ACTIVE) : (0, $5KtrL.LICENSE_STATE_UNLICENSED),
        serviceDesk: appPermissions.hasServiceDeskAccess ? (0, $5KtrL.LICENSE_STATE_ACTIVE) : (0, $5KtrL.LICENSE_STATE_UNLICENSED),
        customerService: appPermissions.hasCustomerServiceAccess ? (0, $5KtrL.LICENSE_STATE_ACTIVE) : (0, $5KtrL.LICENSE_STATE_UNLICENSED),
        productDiscovery: appPermissions.hasProductDiscoveryAccess ? (0, $5KtrL.LICENSE_STATE_ACTIVE) : (0, $5KtrL.LICENSE_STATE_UNLICENSED)
    });
    const loggedInUser = username === '' ? null : username;
    const atlassianAccountId = accountId === '' ? null : accountId;
    const isDevMode = getMetaImpl('ajs-dev-mode') === 'true';
    const firstActivationDateMs = $f94c92768d16d5bb$export$2fc3e4b3f0460c2f(getMetaImpl);
    const isDevopsProjectCreationScenario = getMetaImpl('ajs-devops-project-creation-scenario') === 'true';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const devopsProjectSignupSource = getMetaImpl('ajs-devops-signup-source-scenario');
    const isMarketingOptOut = getMetaImpl('ajs-marketing-opt-out') === 'true';
    const hasDlpEnabled = getMetaImpl('ajs-has-dlp') === 'true';
    const appUpdatesAvailable = $f94c92768d16d5bb$export$c3fee804514cdf76(getMetaImpl);
    const avpWorkspaceId = getMetaImpl('ajs-avp-workspace-id');
    return {
        appEditions: appEditions,
        applicationKey: applicationKey,
        appPermissions: appPermissions,
        appUpdatesAvailable: appUpdatesAvailable,
        areProductSuggestionsEnabled: areProductSuggestionsEnabled,
        atlassianAccountId: atlassianAccountId,
        cloudId: cloudId,
        orgId: getMetaImpl('ajs-org-id') ?? undefined,
        activationId: activationId,
        cloudName: cloudName,
        devopsProjectSignupSource: devopsProjectSignupSource,
        environment: environment,
        fabricActivityUrl: fabricActivityUrl,
        fabricNotificationLogUrl: fabricNotificationLogUrl,
        fabricPfDirUrl: fabricPfDirUrl,
        firstActivationDateMs: firstActivationDateMs,
        isAdmin: isAdmin,
        isAnonymous: isAnonymous,
        isDevMode: isDevMode,
        isDevopsProjectCreationScenario: isDevopsProjectCreationScenario,
        isMarketingOptOut: isMarketingOptOut,
        isSiteAdmin: isSiteAdmin,
        languageTag: languageTag,
        licensedProducts: licensedProducts,
        licenseStates: licenseStates,
        locale: locale,
        loggedInUser: loggedInUser,
        productCrossSellConfig: productCrossSellConfig,
        productEntitlementDetails: productEntitlementDetails,
        productPermissionGated: productPermissionGated,
        siteAdminStatus: siteAdminStatus,
        userFullname: userFullname,
        xsrfToken: xsrfToken,
        hasDlpEnabled: hasDlpEnabled,
        avpWorkspaceId: avpWorkspaceId
    };
};
const $f94c92768d16d5bb$export$374aeba69d52d74d = (0, $LFmXM.default)($f94c92768d16d5bb$var$getTenantContextFromMeta);

});
parcelRegister("jbr6p", function(module, exports) {
$parcel$export(module.exports, "defaultLocale", () => $b5efbc768eb416ed$export$d7f512c98c859244);
$parcel$export(module.exports, "default", () => $b5efbc768eb416ed$export$2e2bcd8739ae039);
$parcel$export(module.exports, "standardizeLocale", () => $b5efbc768eb416ed$export$ca06804549ae25fb);

var $l9VJB = parcelRequire("l9VJB");
const $b5efbc768eb416ed$export$d7f512c98c859244 = 'en_US';
const $b5efbc768eb416ed$export$a95850d20423e414 = 'fr_FR';
const $b5efbc768eb416ed$var$locales = Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($l9VJB)))).map((locale)=>locale.replace('-', '_'));
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$b5efbc768eb416ed$export$2e2bcd8739ae039 = $b5efbc768eb416ed$var$locales;
const $b5efbc768eb416ed$export$ca06804549ae25fb = (locale)=>locale.replace('_', '-');

});
parcelRegister("l9VJB", function(module, exports) {
module.exports = JSON.parse("{\"cs-CZ\":{},\"da-DK\":{},\"de-DE\":{},\"en-GB\":{},\"en-UK\":{},\"en-US\":{},\"en-ZZ\":{},\"es-ES\":{},\"et-EE\":{},\"fi-FI\":{},\"fr-FR\":{},\"hu-HU\":{},\"is-IS\":{},\"it-IT\":{},\"ja-JP\":{},\"ko-KR\":{},\"nb-NO\":{},\"nl-NL\":{},\"pl-PL\":{},\"pt-BR\":{},\"pt-PT\":{},\"ro-RO\":{},\"ru-RU\":{},\"sk-SK\":{},\"sv-SE\":{},\"tr-TR\":{},\"zh-CN\":{},\"zh-TW\":{}}");

});


parcelRegister("5KtrL", function(module, exports) {
$parcel$export(module.exports, "LICENSE_STATE_ACTIVE", () => $8f57b5dc727d58b4$export$b1825e21241fc91);
$parcel$export(module.exports, "LICENSE_STATE_SUSPENDED", () => $8f57b5dc727d58b4$export$da47d37a794d21de);
$parcel$export(module.exports, "LICENSE_STATE_EXPIRED", () => $8f57b5dc727d58b4$export$7b174e57c0bd6a9c);
$parcel$export(module.exports, "LICENSE_STATE_UNLICENSED", () => $8f57b5dc727d58b4$export$2547e580661cf303);
$parcel$export(module.exports, "populateApplicationLicenseStates", () => $8f57b5dc727d58b4$export$d72e24da946cb239);
const $8f57b5dc727d58b4$export$b1825e21241fc91 = 'ACTIVE';
const $8f57b5dc727d58b4$export$da47d37a794d21de = 'SUSPENDED';
const $8f57b5dc727d58b4$export$7b174e57c0bd6a9c = 'EXPIRED';
const $8f57b5dc727d58b4$export$2547e580661cf303 = 'UNLICENSED';
const $8f57b5dc727d58b4$export$d72e24da946cb239 = (overrides = {}, defaultLicenseState = $8f57b5dc727d58b4$export$2547e580661cf303)=>({
        core: defaultLicenseState,
        software: defaultLicenseState,
        serviceDesk: defaultLicenseState,
        customerService: defaultLicenseState,
        productDiscovery: defaultLicenseState,
        ...overrides
    });

});

parcelRegister("dCptc", function(module, exports) {
$parcel$export(module.exports, "populateApplicationPermissions", () => $6387528062fc6074$export$4d9dffdb588381aa);
$parcel$export(module.exports, "toEnvironment", () => $6387528062fc6074$export$a69dcd7c1d779173);
const $6387528062fc6074$export$4d9dffdb588381aa = (overrides = {}, defaultPermission = false)=>({
        hasCoreAccess: defaultPermission,
        hasSoftwareAccess: defaultPermission,
        hasServiceDeskAccess: defaultPermission,
        hasCustomerServiceAccess: defaultPermission,
        hasProductDiscoveryAccess: defaultPermission,
        ...overrides
    });
const $6387528062fc6074$export$a69dcd7c1d779173 = (value)=>{
    switch(value){
        case 'dev':
            return 'dev';
        case 'staging':
            return 'staging';
        case 'prod':
            return 'prod';
        case 'local':
            return 'local';
        default:
            return null;
    }
};

});

parcelRegister("kIz4h", function(module, exports) {
$parcel$export(module.exports, "default", () => $1c418e7a8ed99ac0$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/cookie

var $5H4WP = parcelRequire("5H4WP");
/**
 * Returns 'atlassian-token' aka xsrf required to secure some operation.
 *
 *
 * Security note: it is important to read from cookies - the same source backend will use to validate the operation
 * The attempt to read it from meta-data ('atlassian-token') resulted in Sev2 HOT-108450
 *
 * The cookie is a part of XSRF technology itself and is exempt from "safe cookies"/FedRAMP requirements.
 * The technology is based on one's ability to read the cookie and this is one it shall be preserved.
 *
 * There is ongoing work to migrate from legacy experiences that rely on this sort of protection
 * Until the work is not done, it shall stay untouched
 * See:
 *  - https://jplat.jira.atlassian.cloud/browse/ISSUEHELP-1198
 */ const $1c418e7a8ed99ac0$var$getXSRFToken = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).get('atlassian.xsrf.token');
var $1c418e7a8ed99ac0$export$2e2bcd8739ae039 = $1c418e7a8ed99ac0$var$getXSRFToken;

});

parcelRegister("aFPNn", function(module, exports) {
$parcel$export(module.exports, "default", () => $6ec3e537150500ab$export$2e2bcd8739ae039);

var $cblKs = parcelRequire("cblKs");
const $6ec3e537150500ab$var$parseTenantContextEdition = (tenantContextValue)=>{
    switch(tenantContextValue){
        case 'f':
            return 0, $cblKs.FREE_EDITION;
        case 's':
            return 0, $cblKs.STANDARD_EDITION;
        case 'p':
            return 0, $cblKs.PREMIUM_EDITION;
        default:
            return 0, $cblKs.UNLICENSED;
    }
};
const $6ec3e537150500ab$var$parseTenantContextEditions = (tenantContextEditions)=>(0, $cblKs.populateApplicationEditions)({
        core: $6ec3e537150500ab$var$parseTenantContextEdition(tenantContextEditions['jira-core']),
        software: $6ec3e537150500ab$var$parseTenantContextEdition(tenantContextEditions['jira-software']),
        serviceDesk: $6ec3e537150500ab$var$parseTenantContextEdition(tenantContextEditions['jira-servicedesk']),
        customerService: $6ec3e537150500ab$var$parseTenantContextEdition(tenantContextEditions['jira-customer-service']),
        productDiscovery: $6ec3e537150500ab$var$parseTenantContextEdition(tenantContextEditions['jira-product-discovery'])
    });
const $6ec3e537150500ab$var$determineApplicationEditions = (getMetaImpl)=>{
    try {
        const tenantContextEditions = JSON.parse(getMetaImpl('ajs-product-editions') || '{}');
        return $6ec3e537150500ab$var$parseTenantContextEditions(tenantContextEditions);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Error parsing application editions from tenant context: ${error}`);
        return (0, $cblKs.populateApplicationEditions)();
    }
};
var $6ec3e537150500ab$export$2e2bcd8739ae039 = $6ec3e537150500ab$var$determineApplicationEditions;

});
parcelRegister("cblKs", function(module, exports) {
$parcel$export(module.exports, "FREE_EDITION", () => $fb003bac48af88b4$export$e69af2c4378638a2);
$parcel$export(module.exports, "STANDARD_EDITION", () => $fb003bac48af88b4$export$7bc7dd5faba7ad6b);
$parcel$export(module.exports, "PREMIUM_EDITION", () => $fb003bac48af88b4$export$3fd0bbb8c68dc4c7);
$parcel$export(module.exports, "UNLICENSED", () => $fb003bac48af88b4$export$5747d23113da6aa6);
$parcel$export(module.exports, "STANDARD_EDITION_KEY", () => $fb003bac48af88b4$export$6ad005c3d13398a0);
$parcel$export(module.exports, "PREMIUM_EDITION_KEY", () => $fb003bac48af88b4$export$ee574a74f490a9e8);
$parcel$export(module.exports, "editionKeyToEdition", () => $fb003bac48af88b4$export$21d25cf944084a5e);
$parcel$export(module.exports, "editionToEditionKey", () => $fb003bac48af88b4$export$564d24f5605eb83d);
$parcel$export(module.exports, "populateApplicationEditions", () => $fb003bac48af88b4$export$6bdd11dc05a96fbd);
$parcel$export(module.exports, "getEdition", () => $fb003bac48af88b4$export$acf25cbc735b9b90);
$parcel$export(module.exports, "getEditionForProject", () => $fb003bac48af88b4$export$7f5fd5f8e6705012);
$parcel$export(module.exports, "toEdition", () => $fb003bac48af88b4$export$59f6e933a5e0096b);

var $lBYgs = parcelRequire("lBYgs");
const $fb003bac48af88b4$export$e69af2c4378638a2 = 'FREE_EDITION';
const $fb003bac48af88b4$export$7bc7dd5faba7ad6b = 'STANDARD_EDITION';
const $fb003bac48af88b4$export$3fd0bbb8c68dc4c7 = 'PREMIUM_EDITION';
const $fb003bac48af88b4$export$5747d23113da6aa6 = 'UNLICENSED';
const $fb003bac48af88b4$export$c8c756d9ef774404 = 'free';
const $fb003bac48af88b4$export$6ad005c3d13398a0 = 'standard';
const $fb003bac48af88b4$export$ee574a74f490a9e8 = 'premium';
const $fb003bac48af88b4$export$21d25cf944084a5e = (editionShort)=>{
    if (editionShort === $fb003bac48af88b4$export$c8c756d9ef774404) return $fb003bac48af88b4$export$e69af2c4378638a2;
    if (editionShort === $fb003bac48af88b4$export$6ad005c3d13398a0) return $fb003bac48af88b4$export$7bc7dd5faba7ad6b;
    if (editionShort === $fb003bac48af88b4$export$ee574a74f490a9e8) return $fb003bac48af88b4$export$3fd0bbb8c68dc4c7;
    return $fb003bac48af88b4$export$5747d23113da6aa6;
};
const $fb003bac48af88b4$export$564d24f5605eb83d = (edition)=>{
    switch(edition){
        case $fb003bac48af88b4$export$e69af2c4378638a2:
            return $fb003bac48af88b4$export$c8c756d9ef774404;
        case $fb003bac48af88b4$export$7bc7dd5faba7ad6b:
            return $fb003bac48af88b4$export$6ad005c3d13398a0;
        case $fb003bac48af88b4$export$3fd0bbb8c68dc4c7:
            return $fb003bac48af88b4$export$ee574a74f490a9e8;
        default:
            return undefined;
    }
};
const $fb003bac48af88b4$export$6bdd11dc05a96fbd = (overrides = {}, defaultEdition = $fb003bac48af88b4$export$5747d23113da6aa6)=>({
        core: defaultEdition,
        software: defaultEdition,
        serviceDesk: defaultEdition,
        customerService: defaultEdition,
        productDiscovery: defaultEdition,
        ...overrides
    });
const $fb003bac48af88b4$export$acf25cbc735b9b90 = (application, applicationEditions)=>{
    switch(application){
        case 0, $lBYgs.JIRA_CORE:
            return applicationEditions.core;
        case 0, $lBYgs.JIRA_SOFTWARE:
            return applicationEditions.software;
        case 0, $lBYgs.JIRA_PRODUCT_DISCOVERY:
            return applicationEditions.productDiscovery;
        case 0, $lBYgs.JIRA_SERVICE_DESK:
            return applicationEditions.serviceDesk;
        case 0, $lBYgs.JIRA_CUSTOMER_SERVICE:
            return applicationEditions.customerService;
        default:
            throw new Error(`Unrecognised application: ${application}`);
    }
};
const $fb003bac48af88b4$export$7f5fd5f8e6705012 = (projectType, applicationEditions)=>{
    const application = (0, $lBYgs.getApplicationForProject)(projectType);
    return $fb003bac48af88b4$export$acf25cbc735b9b90(application, applicationEditions);
};
const $fb003bac48af88b4$export$59f6e933a5e0096b = (edition)=>{
    switch(edition){
        case $fb003bac48af88b4$export$e69af2c4378638a2:
            return $fb003bac48af88b4$export$e69af2c4378638a2;
        case $fb003bac48af88b4$export$7bc7dd5faba7ad6b:
            return $fb003bac48af88b4$export$7bc7dd5faba7ad6b;
        case $fb003bac48af88b4$export$3fd0bbb8c68dc4c7:
            return $fb003bac48af88b4$export$3fd0bbb8c68dc4c7;
        case $fb003bac48af88b4$export$5747d23113da6aa6:
        default:
            return $fb003bac48af88b4$export$5747d23113da6aa6;
    }
};

});
parcelRegister("lBYgs", function(module, exports) {
$parcel$export(module.exports, "JIRA_PORTFOLIO", () => $ed4bb02d92cf03d1$export$29c4c091cb388ff0);
$parcel$export(module.exports, "JIRA_SERVICE_DESK", () => $ed4bb02d92cf03d1$export$3afc372bb8c4538c);
$parcel$export(module.exports, "JIRA_CUSTOMER_SERVICE", () => $ed4bb02d92cf03d1$export$19eb54cb466391c5);
$parcel$export(module.exports, "JIRA_SOFTWARE", () => $ed4bb02d92cf03d1$export$ad9850d60736acbb);
$parcel$export(module.exports, "JIRA_CORE", () => $ed4bb02d92cf03d1$export$66e37ea59188c0b8);
$parcel$export(module.exports, "JIRA_PRODUCT_DISCOVERY", () => $ed4bb02d92cf03d1$export$b6c5b3e2284b683b);
$parcel$export(module.exports, "getApplicationForProject", () => $ed4bb02d92cf03d1$export$3804df50ba7ca359);
const $ed4bb02d92cf03d1$export$29c4c091cb388ff0 = 'JIRA_PORTFOLIO';
const $ed4bb02d92cf03d1$export$3afc372bb8c4538c = 'JIRA_SERVICE_DESK';
const $ed4bb02d92cf03d1$export$19eb54cb466391c5 = 'JIRA_CUSTOMER_SERVICE';
const $ed4bb02d92cf03d1$export$ad9850d60736acbb = 'JIRA_SOFTWARE';
const $ed4bb02d92cf03d1$export$66e37ea59188c0b8 = 'JIRA_CORE';
const $ed4bb02d92cf03d1$export$b6c5b3e2284b683b = 'JIRA_PRODUCT_DISCOVERY';
const $ed4bb02d92cf03d1$export$3804df50ba7ca359 = (projectType)=>{
    switch(projectType){
        case 'business':
            return $ed4bb02d92cf03d1$export$66e37ea59188c0b8;
        case 'product_discovery':
            return $ed4bb02d92cf03d1$export$b6c5b3e2284b683b;
        case 'software':
            return $ed4bb02d92cf03d1$export$ad9850d60736acbb;
        case 'service_desk':
            return $ed4bb02d92cf03d1$export$3afc372bb8c4538c;
        case 'customer_service':
            return $ed4bb02d92cf03d1$export$19eb54cb466391c5;
        default:
            throw new Error(`Unrecognised project type: ${projectType}`);
    }
};
const $ed4bb02d92cf03d1$export$70d16cc42a798666 = (projectType)=>{
    switch(projectType){
        case 'business':
            return $ed4bb02d92cf03d1$export$66e37ea59188c0b8;
        case 'product_discovery':
            return $ed4bb02d92cf03d1$export$b6c5b3e2284b683b;
        case 'software':
            return $ed4bb02d92cf03d1$export$ad9850d60736acbb;
        case 'service_desk':
            return $ed4bb02d92cf03d1$export$3afc372bb8c4538c;
        case 'customer_service':
            return $ed4bb02d92cf03d1$export$19eb54cb466391c5;
        default:
            throw new Error(`Unrecognised project type: ${projectType}`);
    }
};

});



parcelRegister("cDvK0", function(module, exports) {
$parcel$export(module.exports, "default", () => $2af962fe8c6c42ce$export$2e2bcd8739ae039);

var $5KtrL = parcelRequire("5KtrL");
const $2af962fe8c6c42ce$var$parseTenantContextLicenseState = (tenantContextValue)=>{
    switch(tenantContextValue){
        case 'ACTIVE':
            return 0, $5KtrL.LICENSE_STATE_ACTIVE;
        case 'SUSPENDED':
            return 0, $5KtrL.LICENSE_STATE_SUSPENDED;
        case 'EXPIRED':
            return 0, $5KtrL.LICENSE_STATE_EXPIRED;
        default:
            return 0, $5KtrL.LICENSE_STATE_UNLICENSED;
    }
};
const $2af962fe8c6c42ce$var$parseTenantContextLicenseStates = (tenantContextLicenseStates)=>(0, $5KtrL.populateApplicationLicenseStates)({
        core: $2af962fe8c6c42ce$var$parseTenantContextLicenseState(tenantContextLicenseStates['jira-core']),
        software: $2af962fe8c6c42ce$var$parseTenantContextLicenseState(tenantContextLicenseStates['jira-software']),
        serviceDesk: $2af962fe8c6c42ce$var$parseTenantContextLicenseState(tenantContextLicenseStates['jira-servicedesk']),
        customerService: $2af962fe8c6c42ce$var$parseTenantContextLicenseState(tenantContextLicenseStates['jira-customer-service']),
        productDiscovery: $2af962fe8c6c42ce$var$parseTenantContextLicenseState(tenantContextLicenseStates['jira-product-discovery'])
    });
const $2af962fe8c6c42ce$var$determineApplicationLicenseStates = (getMetaImpl)=>{
    try {
        const tenantContextLicenseStates = JSON.parse(getMetaImpl('ajs-product-license-states') || '{}');
        return $2af962fe8c6c42ce$var$parseTenantContextLicenseStates(tenantContextLicenseStates);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Error parsing application license states from tenant context: ${error}`);
        return (0, $5KtrL.populateApplicationLicenseStates)();
    }
};
var $2af962fe8c6c42ce$export$2e2bcd8739ae039 = $2af962fe8c6c42ce$var$determineApplicationLicenseStates;

});

parcelRegister("8FAyk", function(module, exports) {
$parcel$export(module.exports, "default", () => $b3ee847faaab2d15$export$2e2bcd8739ae039);

// Fallback to true(not allowed) if product does not exist. This makes sense, because the tenant has no product.
// If user tries to somehow access the feature they are not supposed to access, it should be blocked.
const $b3ee847faaab2d15$var$parseProductPermissionGates = (productPermissionGatesRaw)=>({
        core: typeof productPermissionGatesRaw[0, $315aedf92e50a945$export$db515c8cec1e6f79] === 'boolean' ? productPermissionGatesRaw[0, $315aedf92e50a945$export$db515c8cec1e6f79] : true,
        software: typeof productPermissionGatesRaw[0, $315aedf92e50a945$export$1346c9aa3cbb477d] === 'boolean' ? productPermissionGatesRaw[0, $315aedf92e50a945$export$1346c9aa3cbb477d] : true,
        serviceDesk: typeof productPermissionGatesRaw[0, $315aedf92e50a945$export$c8c1c8c3f8ddba61] === 'boolean' ? productPermissionGatesRaw[0, $315aedf92e50a945$export$c8c1c8c3f8ddba61] : true,
        productDiscovery: typeof productPermissionGatesRaw[0, $315aedf92e50a945$export$202f50ee62667e32] === 'boolean' ? productPermissionGatesRaw[0, $315aedf92e50a945$export$202f50ee62667e32] : true,
        customerService: typeof productPermissionGatesRaw[0, $315aedf92e50a945$export$e9c56aa3b027d98f] === 'boolean' ? productPermissionGatesRaw[0, $315aedf92e50a945$export$e9c56aa3b027d98f] : true
    });
const $b3ee847faaab2d15$var$defaultProductPermissionGates = {
    core: true,
    software: true,
    serviceDesk: true,
    productDiscovery: true,
    customerService: true
};
const $b3ee847faaab2d15$var$getProductPermissionGates = (getMetaImpl)=>{
    try {
        const productPermissionGatesRaw = JSON.parse(getMetaImpl('ajs-product-permission-gates') || '{}');
        return $b3ee847faaab2d15$var$parseProductPermissionGates(productPermissionGatesRaw);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn(`Error parsing product permission gates from tenant context: ${error}`);
        return $b3ee847faaab2d15$var$defaultProductPermissionGates;
    }
};
var $b3ee847faaab2d15$export$2e2bcd8739ae039 = $b3ee847faaab2d15$var$getProductPermissionGates;

});
const $315aedf92e50a945$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $315aedf92e50a945$export$e9c56aa3b027d98f = 'jira-customer-service';
const $315aedf92e50a945$export$1346c9aa3cbb477d = 'jira-software';
const $315aedf92e50a945$export$202f50ee62667e32 = 'jira-product-discovery';
const $315aedf92e50a945$export$db515c8cec1e6f79 = 'jira-core';
const $315aedf92e50a945$export$c811f21c9ad05dc2 = 'confluence';
const $315aedf92e50a945$export$961148c98d198270 = 'opsgenie';
const $315aedf92e50a945$export$a310f85340477585 = 'assets';



parcelRegister("hwYGJ", function(module, exports) {
$parcel$export(module.exports, "SERIALIZABLE_ATTRIBUTES", () => $3d7ff20c5032679e$export$b5bdb04ea16a02e3);
$parcel$export(module.exports, "normaliseSentryBreadcrumbs", () => $3d7ff20c5032679e$export$6f14342128c6eaa4);
const $3d7ff20c5032679e$export$b5bdb04ea16a02e3 = [
    'data-test-id',
    'data-testid'
];
const $3d7ff20c5032679e$var$WHITELISTED_ATTRIBNUTES = [
    'type',
    'name',
    ...$3d7ff20c5032679e$export$b5bdb04ea16a02e3
];
const $3d7ff20c5032679e$var$REG_MATCH_NOTALLOWED_ATTRIBUTES = new RegExp(`\\[(?!${$3d7ff20c5032679e$var$WHITELISTED_ATTRIBNUTES.join('|')}).*?\\]`, 'gm');
// attributes may contain UGC that we need to strip out
// only allow type and name attributes
const $3d7ff20c5032679e$var$sanitiseUiBreadcrumbMessage = (message)=>message.replace($3d7ff20c5032679e$var$REG_MATCH_NOTALLOWED_ATTRIBUTES, '');
const $3d7ff20c5032679e$export$6f14342128c6eaa4 = (breadcrumb)=>{
    const { category: category } = breadcrumb || {};
    // allow "ui*"" category breadcrumbs, that include clicks and inputs on DOM elements
    // they may contain UGC that needs to be stripped out
    if (category?.startsWith('ui')) {
        // sentry can include the element attributes in the data
        // which may contain UGC that we need to strip out
        const sanitisedBreadCrumb = breadcrumb;
        const { message: message } = sanitisedBreadCrumb;
        if (message !== null && message !== undefined) sanitisedBreadCrumb.message = $3d7ff20c5032679e$var$sanitiseUiBreadcrumbMessage(message);
        return breadcrumb;
    }
    return breadcrumb;
};

});

parcelRegister("fJfOq", function(module, exports) {
$parcel$export(module.exports, "normaliseSentryEvent", () => $b8cefe68ea217e07$export$c1a1d522906bf17c);

var $lpMrC = parcelRequire("lpMrC");

var $4cTDP = parcelRequire("4cTDP");

var $dMM78 = parcelRequire("dMM78");

var $kQnVX = parcelRequire("kQnVX");

var $kkHo2 = parcelRequire("kkHo2");

var $jEL6Q = parcelRequire("jEL6Q");

var $ivUuU = parcelRequire("ivUuU");

var $aEQyd = parcelRequire("aEQyd");
const $b8cefe68ea217e07$var$REPORTED_ERRORS = new WeakSet();
const $b8cefe68ea217e07$var$REPORTED_STRING_ERRORS = new WeakSet();
const $b8cefe68ea217e07$var$getFragmentNames = (stackTrace)=>{
    const re = /(?:src\/entry|src|assets)\/([^,./]+)/g;
    const fragmentNames = new Set();
    let fragmentName = re.exec(stackTrace);
    while(fragmentName){
        fragmentNames.add(fragmentName[1]);
        fragmentName = re.exec(stackTrace);
    }
    return Array.from(fragmentNames);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b8cefe68ea217e07$var$getBackendStatus = (exception)=>exception.statusCode || exception.cause?.statusCode || exception.cause?.extensions?.statusCode || (0, $dMM78.isBackendAPIError)(exception) && 'true' || 'false';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b8cefe68ea217e07$var$getTraceId = (exception)=>exception.traceId || exception.cause?.traceId || exception.cause?.extensions?.traceId || undefined;
// Add custom tags based on stack trace
const $b8cefe68ea217e07$var$getTaggedData = (data, hint, samplingResult)=>{
    if (!hint) return data;
    const exception = hint.originalException || hint.syntheticException;
    if (!exception) return data;
    if (typeof exception === 'string') return data;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const stackTrace = exception.stack;
    if (!stackTrace) return data;
    const taggedData = data;
    taggedData.tags = {
        backend: $b8cefe68ea217e07$var$getBackendStatus(exception),
        hash: (0, $jEL6Q.getErrorHash)(exception),
        userLocation: (0, $kQnVX.getUserLocation)(),
        traceId: $b8cefe68ea217e07$var$getTraceId(exception),
        ...taggedData.tags
    };
    const fragmentNames = $b8cefe68ea217e07$var$getFragmentNames(stackTrace);
    if (!fragmentNames.length) taggedData.tags = {
        ...taggedData.tags,
        fragment: 'unknown'
    };
    else {
        taggedData.tags = {
            ...taggedData.tags,
            fragment: fragmentNames[0]
        };
        if (fragmentNames.length > 1) taggedData.extra = {
            ...taggedData.extra,
            allRelevantFragments: fragmentNames
        };
    }
    if (samplingResult && samplingResult.samplingRate !== null) // this tag indicates the true volume of the exception being sampled
    taggedData.tags.sampled = `1/${samplingResult.samplingRate}`;
    return taggedData;
};
/**
 * It's possible to receive an event with a string exception instead of an Error object.
 * This is typically the case when we catch a console.error.
 *
 * This function performs the same normalisation as `normaliseSentryEvent`, but only includes the steps that are relevant for strings
 */ const $b8cefe68ea217e07$var$normaliseStringException = (event, hint)=>{
    const exception = hint?.originalException;
    if (typeof exception !== 'string') return null;
    // If we are reporting an error with a logger tag and we already reported it, ignore
    if ($b8cefe68ea217e07$var$REPORTED_STRING_ERRORS.has(exception)) return null;
    if (event.tags?.logger) $b8cefe68ea217e07$var$REPORTED_STRING_ERRORS.add(exception);
    // Yes, we're mutating the argument, but at this point in the error handling lifecycle
    // immutability is not important and it simplifies the logic
    // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
    let updatedData = event;
    if (updatedData.request?.url) updatedData.request.url = (0, $kkHo2.default)(updatedData.request.url);
    updatedData = (0, $aEQyd.stackFrameAssetRewrite)(updatedData);
    const samplingResult = (0, $ivUuU.default)(exception, updatedData.request?.url);
    // sample data sent to sentry if it matches the sampling config
    if (samplingResult.limitCaptureException) return null;
    updatedData.tags = {
        userLocation: (0, $kQnVX.getUserLocation)(),
        ...updatedData.tags
    };
    return updatedData;
};
const $b8cefe68ea217e07$export$c1a1d522906bf17c = (event, hint)=>{
    // We want to report only real exceptions, so we filter out everything that is non-error
    const exception = hint?.originalException;
    if (!event || event.environment === 'development') return null;
    if (typeof exception === 'string' && (0, $4cTDP.fg)('jira-capture-console-errors-in-sentry')) return $b8cefe68ea217e07$var$normaliseStringException(event, hint);
    if (!(exception instanceof Error)) return null;
    // Ignore errors coming from unsupported browsers (or faking it)
    const isSupportedUA = (0, $lpMrC.isChrome)(84) || (0, $lpMrC.isFirefox)(76) || (0, $lpMrC.isSafari)(15) || (0, $lpMrC.isEdge)(84);
    if (!('allSettled' in Promise) || !isSupportedUA) return null;
    // Ignore errors that explicitly want to skip Sentry
    if ('skipSentry' in exception && (exception.skipSentry === true || typeof exception.skipSentry === 'function' && exception.skipSentry())) return null;
    // Ignore network-like errors
    if ((0, $dMM78.isClientFetchError)(exception)) return null;
    // If we are reporting an error with a logger tag and we already reported it, ignore
    if ($b8cefe68ea217e07$var$REPORTED_ERRORS.has(exception)) return null;
    if (event.tags?.logger) $b8cefe68ea217e07$var$REPORTED_ERRORS.add(exception);
    // Yes, we're mutating the argument, but at this point in the error handling lifecycle
    // immutability is not important and it simplifies the logic
    // Event type is documented here: https://github.com/getsentry/sentry-javascript/blob/master/packages/types/src/event.ts
    let updatedData = event;
    if (updatedData.request?.url) updatedData.request.url = (0, $kkHo2.default)(updatedData.request.url);
    updatedData = (0, $aEQyd.stackFrameAssetRewrite)(updatedData);
    let samplingResult = (0, $ivUuU.default)(exception?.message, updatedData.request?.url);
    // sample data sent to sentry if it matches the sampling config
    if (samplingResult.limitCaptureException) return null;
    if ((0, $dMM78.isBackendAPIError)(exception)) {
        // capture only 1/X of backend API errors
        const samplingRate = 20;
        samplingResult = {
            limitCaptureException: Math.random() <= 1 / samplingRate,
            samplingRate: samplingRate
        };
        if (samplingResult.limitCaptureException) return null;
    }
    updatedData = $b8cefe68ea217e07$var$getTaggedData(updatedData, hint, samplingResult);
    return updatedData;
};

});
parcelRegister("kkHo2", function(module, exports) {
$parcel$export(module.exports, "default", () => $408a97f936a5acec$export$2e2bcd8739ae039);

var $3Q6BV = parcelRequire("3Q6BV");

var $dVuvn = parcelRequire("dVuvn");
const $408a97f936a5acec$var$applyMatchers = (url, mappings)=>{
    for(let i = 0; i < mappings.length; i += 1){
        const mapping = mappings[i];
        if (!mapping.matcher) return mapping.transformer;
        const match = url.match(mapping.matcher);
        if (match) {
            if (typeof mapping.transformer === 'string') {
                if (match.length > 1) throw new Error('Grouped matcher requires a match => string transformer');
                return mapping.transformer;
            }
            if (match.length === 1) throw new Error('Basic matcher only supports a string transformer');
            return mapping.transformer(match);
        }
    }
    throw new Error('No URL mappers matched! Expected a default matcher.');
};
const $408a97f936a5acec$var$normaliseUrl = (url, mappings = (0, $dVuvn.default))=>{
    let parsedUrl;
    try {
        // This is a little bit of a hack, it's really hard to actually get `url-parse` to throw an
        // error, so instead we set the default base URL to be the fallback - if parsing fails the
        // fallback URL will be the parsed URL
        parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(url, (0, $dVuvn.PARSE_ERROR_FALLBACK_URL));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ex) {
        // we can't log the original URL or message because we could end up with UGC, so we return a
        // safe fallback URL so we don't lose the error
        return 0, $dVuvn.PARSE_ERROR_FALLBACK_URL;
    }
    const partialUrl = `${parsedUrl.pathname}${parsedUrl.query}`;
    const result = $408a97f936a5acec$var$applyMatchers(partialUrl, mappings);
    // For the purposes of normalisation, we assume we're only returning a path im the normalised URL
    return `${parsedUrl.protocol}//${parsedUrl.host}${result}`;
};
var $408a97f936a5acec$export$2e2bcd8739ae039 = $408a97f936a5acec$var$normaliseUrl;

});
parcelRegister("dVuvn", function(module, exports) {
$parcel$export(module.exports, "PARSE_ERROR_FALLBACK_URL", () => $8dffdd74c5c905e8$export$92f2182a552c2178);
$parcel$export(module.exports, "default", () => $8dffdd74c5c905e8$export$2e2bcd8739ae039);
const $8dffdd74c5c905e8$var$PARSE_ERROR_FALLBACK_PATH = '/could-not-parse/';
const $8dffdd74c5c905e8$export$92f2182a552c2178 = `https://unknown.example.com${$8dffdd74c5c905e8$var$PARSE_ERROR_FALLBACK_PATH}`;
const $8dffdd74c5c905e8$var$defaultMappings = [
    {
        matcher: /^\/browse\/.*/i,
        transformer: '/browse/:issueKey'
    },
    {
        matcher: /^\/project\/[A-Z][A-Z0-9]+\/issues/i,
        transformer: '/project/:projectKey/issues'
    },
    {
        matcher: /^\/jira\/software\/projects\/[A-Z][A-Z0-9]+\/issues/i,
        transformer: '/jira/software/projects/:projectKey/issues'
    },
    {
        matcher: /^\/jira\/software\/c\/projects\/[A-Z][A-Z0-9]+\/issues/i,
        transformer: '/jira/software/c/projects/:projectKey/issues'
    },
    {
        matcher: /^\/jira\/servicedesk\/projects\/[A-Z][A-Z0-9]+\/issues/i,
        transformer: '/jira/servicedesk/projects/:projectKey/issues'
    },
    {
        matcher: /^\/jira\/core\/projects\/[A-Z][A-Z0-9]+\/issues/i,
        transformer: '/jira/core/projects/:projectKey/issues'
    },
    {
        matcher: /^\/issues/i,
        transformer: '/issues'
    },
    {
        matcher: /^\/jira\/issues/i,
        transformer: '/jira/issues'
    },
    {
        matcher: /^\/jira\/software\/projects\/[A-Z][A-Z0-9]+\/boards\/\d+(\/backlog|\/roadmap|\/timeline)?/i,
        transformer: (match)=>`/jira/software/projects/:projectKey/boards/:boardId${match[1] ? match[1] : ''}`
    },
    {
        matcher: /^\/jira\/software\/c\/projects\/[A-Z][A-Z0-9]+\/boards\/\d+(\/roadmap|\/timeline)?/i,
        transformer: (match)=>`/jira/software/c/projects/:projectKey/boards/:boardId${match[1] ? match[1] : ''}`
    },
    {
        matcher: /^\/rest\/agile\/(.*?)\/board\/\d+\/configuration/i,
        transformer: (match)=>`/rest/agile/${match[1]}/board/:boardId/configuration`
    },
    {
        matcher: /^\/gateway\/api\/insights\/agile\/board\/\d+\/backlog\/sprint-commitment/i,
        transformer: '/gateway/api/insights/agile/board/:boardId/backlog/sprint-commitment'
    },
    {
        matcher: /^\/rest\/internal\/board\/\d+\/sprint\/\d+\/workload/i,
        transformer: '/rest/internal/board/:boardId/sprint/:sprintId/workload'
    },
    {
        matcher: /^\/rest\/internal\/board\/\d+\/sprint\/\d+\/sprint-progress/i,
        transformer: '/rest/internal/board/:boardId/sprint/:sprintId/sprint-progress'
    },
    {
        matcher: /^\/rest\/internal\/board\/\d+\/sprint\/\d+\/blocked-issues/i,
        transformer: '/rest/internal/board/:boardId/sprint/:sprintId/blocked-issues'
    },
    {
        matcher: /^\/rest\/internal\/board\/\d+\/sprint\/\d+\/epic-progress/i,
        transformer: '/rest/internal/board/:boardId/sprint/:sprintId/epic-progress'
    },
    {
        matcher: /^\/gateway\/api\/aris\/jira\/[a-f0-9-]+\/board\/\d+\/config/i,
        transformer: '/gateway/api/aris/jira/:cloudId/board/:boardId/config'
    },
    {
        matcher: /^\/gateway\/api\/jira-insights\/settings\/board\/\d+\/permissions\/board-admin/i,
        transformer: '/gateway/api/jira-insights/settings/board/:boardId/permissions/board-admin'
    },
    {
        matcher: /\/gateway\/api\/jira-insights\/settings\/board\/\d+/i,
        transformer: '/gateway/api/jira-insights/settings/board/:boardId'
    },
    {
        matcher: /^\/gateway\/api\/insights\/agile\/board\/\d+\/sprint\/\d+\/burndown/i,
        transformer: '/gateway/api/insights/agile/board/:boardId/sprint/:sprintId/burndown'
    },
    {
        matcher: /^\/jira\/servicedesk\/projects\/[A-Z][A-Z0-9]+\/queues\/custom\/\d+/i,
        transformer: '/jira/servicedesk/projects/:projectKey/queues/custom/:queueId/:issueKey'
    },
    {
        matcher: /^\/jira\/servicedesk\/projects\/[A-Z][A-Z0-9]+\/section\/[A-Z]+\/custom\/\d+/i,
        transformer: '/jira/servicedesk/projects/:projectKey/section/:category/custom/:queueId/:issueKey'
    },
    {
        matcher: /^\/projects\/[A-Z][A-Z0-9]+\/settings(\/[a-z]+)?/i,
        transformer: (match)=>`/projects/settings${match[1] ? match[1] : ''}`
    },
    {
        matcher: /^\/projects\/[A-Z][A-Z0-9]+.*?selectedItem=com\.atlassian\.jira\.jira-projects-plugin:(\w+)/i,
        transformer: (match)=>`/projects/:projectKey?selectedItem=com.atlassian.jira.jira-projects-plugin:${match[1]}`
    },
    {
        matcher: /^\/secure\/ConfigureReport!default.jspa.*?reportKey=com.atlassian.jira.plugin.system.reports:(\w+)/i,
        transformer: (match)=>`/secure/ConfigureReport!default.jspa?reportKey=com.atlassian.jira.plugin.system.reports:${match[1]}`
    },
    {
        matcher: /^\/secure\/((.*?\/)?\w+.jspa)/i,
        transformer: (match)=>`/secure/${match[1]}`
    },
    {
        matcher: /^\/plugins\/servlet\/(\w+)/i,
        transformer: (match)=>`/plugins/servlet/${match[1]}`
    },
    {
        matcher: /^\/jira\/your-work/i,
        transformer: '/jira/your-work'
    },
    // Part of the hack around detecting invalid URLs, if we've parsed to the fallback URL, then
    // we return the fallback path instead of the generic "unknown" path
    {
        matcher: new RegExp($8dffdd74c5c905e8$var$PARSE_ERROR_FALLBACK_PATH),
        transformer: '/could-not-parse/'
    },
    {
        matcher: null,
        transformer: '/unknown'
    }
];
var $8dffdd74c5c905e8$export$2e2bcd8739ae039 = $8dffdd74c5c905e8$var$defaultMappings;

});


parcelRegister("jEL6Q", function(module, exports) {
$parcel$export(module.exports, "getErrorHash", () => $a78fd38ce1b4a409$export$211977f0fb53738b);
/* eslint-disable no-bitwise, no-fallthrough, default-case */ /**
 * JS Implementation of MurmurHash2
 * http://github.com/garycourt/murmurhash-js
 * http://sites.google.com/site/murmurhash/
 */ const $a78fd38ce1b4a409$var$murmurHash2 = (str, seed = 1)=>{
    let l = str.length;
    let h = seed ^ l;
    let i = 0;
    let k;
    while(l >= 4){
        k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        k ^= k >>> 24;
        k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
        h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
        l -= 4;
        ++i;
    }
    switch(l){
        // @ts-expect-error - TS7029 - Fallthrough case in switch.
        case 3:
            h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
        // @ts-expect-error - TS7029 - Fallthrough case in switch.
        case 2:
            h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
        case 1:
            h ^= str.charCodeAt(i) & 0xff;
            h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    }
    h ^= h >>> 13;
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h ^= h >>> 15;
    return h >>> 0;
};
const $a78fd38ce1b4a409$export$156fa11ef8a619c3 = (stack)=>{
    const assetPaths = stack.match(/\/([\w.~\-_]+)\.[jt]sx?/g);
    const lineCols = stack.match(/:\d+:\d+/g);
    // uncomment this to get more specific paths
    // const uniquePaths = (assetPaths || [])
    //     .slice(0, 10)
    //     .reduce((acc, v) => {
    //         const [asset] = v.split(':');
    //         if (!acc.includes(asset)) acc.push(asset);
    //         return acc;
    //     }, [])
    //     .slice(1, 5);
    return (assetPaths?.[0] ?? '') + (lineCols?.[0] ?? '');
};
const $a78fd38ce1b4a409$var$cache = new WeakMap();
const $a78fd38ce1b4a409$export$211977f0fb53738b = (error)=>{
    if ($a78fd38ce1b4a409$var$cache.has(error)) return $a78fd38ce1b4a409$var$cache.get(error);
    let stackStr = '';
    if (error.stack !== undefined) try {
        stackStr = $a78fd38ce1b4a409$export$156fa11ef8a619c3(error.stack);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /* ignore */ }
    let errorString = `${error.name} ${stackStr || error.message}`;
    const hash = $a78fd38ce1b4a409$var$murmurHash2(errorString).toString(36).toUpperCase();
    try {
        $a78fd38ce1b4a409$var$cache.set(error, hash);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    /* ignore */ }
    return hash;
};

});

parcelRegister("ivUuU", function(module, exports) {
$parcel$export(module.exports, "default", () => $4a3d428ee77af890$export$2e2bcd8739ae039);

var $jPROM = parcelRequire("jPROM");

var $4xHaP = parcelRequire("4xHaP");
const $4a3d428ee77af890$var$checkForRuleMatch = (config, message, url)=>{
    const { matcher: matcher, route: route } = config;
    // Rule #1: no regex match on message
    if (!matcher.test(message || '')) return false;
    // Rule #2: If the config has a route specific condition
    if (route !== undefined) {
        // the sampling config requires the error originates from a certain route to be limited
        const matchesRoute = Boolean(url !== undefined && url.endsWith(route));
        if (!matchesRoute) return false;
    }
    return true;
};
// The Math.random produces a 0-1 number then multiplied by samplingRate
const $4a3d428ee77af890$var$shouldLimit = (samplingRate)=>Math.floor(Math.random() * samplingRate) !== 0;
const $4a3d428ee77af890$export$bb9cc46c6e38bd57 = (ruleSet, shouldLimitFn)=>(message, url)=>{
        // Find the matching config and store the rate, otherwise null
        const rule = ruleSet.find((config)=>$4a3d428ee77af890$var$checkForRuleMatch(config, message, url));
        const samplingRate = !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(rule) ? rule.samplingRate : null;
        return {
            limitCaptureException: !(0, (/*@__PURE__*/$parcel$interopDefault($jPROM)))(samplingRate) ? shouldLimitFn(samplingRate) : false,
            samplingRate: samplingRate
        };
    };
var $4a3d428ee77af890$export$2e2bcd8739ae039 = $4a3d428ee77af890$export$bb9cc46c6e38bd57((0, $4xHaP.default), $4a3d428ee77af890$var$shouldLimit);

});
parcelRegister("4xHaP", function(module, exports) {
$parcel$export(module.exports, "default", () => $60123ad77d7a82a8$export$2e2bcd8739ae039);
/**
 * BEFORE adding a new sampling configuration:
 * - Ensure no recent change in volume for the error type
 * - Talk to the owners of the error. Confirm there is no other easy fix
 * - Create an issue to improve signal to noise for the error type
 */ const $60123ad77d7a82a8$var$SENTRY_SAMPLING_CONFIG = [
    {
        // Ignore postrobot errors triggered by forge as team won't fix
        // https://atlassian.slack.com/archives/C03MMQ1B39V/p1671517439783989
        matcher: /postrobot_method/,
        samplingRate: 0
    },
    {
        // Ignore e.source.postMessage from monolith Connect JS as caused by callback on a closed window
        // https://atlassian.slack.com/archives/CFGTZ99TL/p1677032642940009
        matcher: /postMessage'\)/,
        samplingRate: 0
    },
    {
        // JFP-1542
        matcher: /^\[Frontend PubSub\] Failed to retrieve subscription configuration \[object Object\]$/,
        samplingRate: 10
    }
];
var $60123ad77d7a82a8$export$2e2bcd8739ae039 = $60123ad77d7a82a8$var$SENTRY_SAMPLING_CONFIG;

});


parcelRegister("aEQyd", function(module, exports) {
$parcel$export(module.exports, "stackFrameAssetRewrite", () => $f1ef952bf58db319$export$94684a7ef5037b24);
const $f1ef952bf58db319$export$94684a7ef5037b24 = (data)=>{
    // There isn't a strong type definition for the `data` object with
    // raven-js (it's literally `any`), so we have to do some shape validation to find the deep
    // part we're interested in (if it exists). We're also extra defensive by wrapping the whole
    // thing in a try/catch - if an error occurs we'll just return the data as-is.
    try {
        const rewriteStacktrace = (value)=>{
            if (!(value && value.stacktrace && value.stacktrace.frames && value.stacktrace.frames.length)) return;
            value.stacktrace.frames.forEach((frame)=>{
                if (!frame.filename) return;
                // Yes, we're manipulating the input, this is an implicit choice for this part
                // of the codebase
                // eslint-disable-next-line no-param-reassign
                frame.filename = frame.filename.replace('/assets-brotli/', '/assets/');
            });
        };
        // for non-error errors there can be a top-level `data.stacktrace`
        rewriteStacktrace(data);
        // for normal errors there can be exception.values, these might contain stacktraces
        if (!(data.exception && data.exception.values && data.exception.values.length)) return data;
        data.exception.values.forEach(rewriteStacktrace);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ex) {
        // eslint-disable-next-line no-console
        console.warn('Unable to rewrite stacktrace filenames', ex);
    }
    return data;
};

});


parcelRegister("avUww", function(module, exports) {
$parcel$export(module.exports, "handleAtlaspackErrors", () => $39bd170cb2a974e5$export$5087a2ae4570e1ae);

var $4cTDP = parcelRequire("4cTDP");

var $es5G8 = parcelRequire("es5G8");
class $39bd170cb2a974e5$var$AtlaspackErrors extends Array {
    constructor(...args){
        super(...args);
        // Report errors immediately on initialisation, as atlaspack may have already pushed errors
        this.reportErrors();
    }
    push(...args) {
        const result = super.push(...args);
        // Report errors immediately after pushing
        this.reportErrors();
        return result;
    }
    /**
	 * Report errors in this array state to Sentry
	 */ reportErrors() {
        while(this.length > 0){
            const error = this.shift();
            if (error) (0, $es5G8.captureException)('atlaspack', error);
        }
    }
}
const $39bd170cb2a974e5$export$5087a2ae4570e1ae = ()=>{
    if (!(0, $4cTDP.fg)('jira_atlaspack_errors_array_tracker')) return;
    // This variable is defined by Atlaspack, cast so we can have type safety in this file
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const globalVar = globalThis;
    if (!(globalVar.__ATLASPACK_ERRORS instanceof $39bd170cb2a974e5$var$AtlaspackErrors)) globalVar.__ATLASPACK_ERRORS = new $39bd170cb2a974e5$var$AtlaspackErrors(...globalVar.__ATLASPACK_ERRORS ?? []);
};

});



parcelRegister("cWTNU", function(module, exports) {
$parcel$export(module.exports, "platformErrorHandler", () => $2f22b91c8c0fada5$export$51242f403a159805);

var $h47gY = parcelRequire("h47gY");
function $2f22b91c8c0fada5$export$51242f403a159805(payload) {
    (0, $h47gY.reportError)(payload.error, payload.errorInfo, {
        id: payload.interactionId
    });
}

});
parcelRegister("h47gY", function(module, exports) {
$parcel$export(module.exports, "reportError", () => $79fad3539deb3f94$export$b33b857ad1d9900e);
$parcel$export(module.exports, "default", () => $79fad3539deb3f94$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $hEhKB = parcelRequire("hEhKB");

var $jEL6Q = parcelRequire("jEL6Q");

var $7aoMz = parcelRequire("7aoMz");

var $kVpZx = parcelRequire("kVpZx");

var $2QO3b = parcelRequire("2QO3b");

var $hya93 = parcelRequire("hya93");

var $eSnSE = parcelRequire("eSnSE");

var $es5G8 = parcelRequire("es5G8");

var $14RSn = parcelRequire("14RSn");

var $4cTDP = parcelRequire("4cTDP");

var $aK3Xl = parcelRequire("aK3Xl");
const $79fad3539deb3f94$var$EGRESS_LIMIT = 5;
const $79fad3539deb3f94$var$getLocation = ({ id: id, packageName: packageName, prefixOverride: prefixOverride })=>{
    const prefix = prefixOverride != null ? prefixOverride : 'common';
    if (id != null) return packageName != null ? `${prefix}.error-boundary.${packageName}.${id}` : `${prefix}.error-boundary.${id}`;
    return `${prefix}.error-boundary`;
};
const $79fad3539deb3f94$var$ErrorBoundary = (props)=>{
    const interactionId = (0, $eJOHy.useContext)((0, $kVpZx.default));
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    const OwnershipMarker = (0, $hEhKB.useOwnershipMarkerComponent)({
        markerType: 'error-boundary',
        name: props.id ?? 'unknown',
        packageName: props.packageName,
        teamName: props.teamName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(OwnershipMarker, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($79fad3539deb3f94$export$4b4ea7be124cdbd8, {
        ...props,
        ufoInteractionId: interactionId.current,
        ufoLabelStack: interactionContext?.labelStack
    }));
};
function $79fad3539deb3f94$export$b33b857ad1d9900e(error, info, { id: id, packageName: packageName, teamName: teamName, prefixOverride: prefixOverride, onError: onError, extraEventData: extraEventData = {} }, interactionId, labelStack) {
    // Somehow, the ErrorBoundary component catch an undefined error.
    // So this check helps to reduce the noise in our Sentry.
    const errorToReport = error ?? new (0, $aK3Xl.UnknownError)();
    const isFetchOrValidationError = errorToReport instanceof (0, $14RSn.default) || errorToReport instanceof (0, $14RSn.ValidationError);
    const isRelayError = (0, $14RSn.isRelayNetworkError)(errorToReport);
    const getErrorStatusCode = ()=>{
        if (isFetchOrValidationError) return errorToReport.statusCode;
        if (isRelayError && (0, $4cTDP.fg)('send_relay_status_code_to_ufo')) return errorToReport.source?.errors?.[0]?.extensions?.statusCode;
    };
    const hash = (0, $jEL6Q.getErrorHash)(errorToReport);
    const event = {
        teamName: teamName ?? null,
        ...extraEventData,
        message: errorToReport.message ?? null,
        stack: errorToReport.stack ?? null,
        // FIXME type "ErrorInfo" used to be mistyped but the type fix propagates in a non-trivial way,
        // cf. PR https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/137436/
        // Progress over perfection: I'm casting to keep the above PR type-only.
        // Next dev actively changing this code, please remove the type cast and use selective inclusion instead.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        componentStack: info.componentStack,
        hash: hash ?? null
    };
    const location = $79fad3539deb3f94$var$getLocation({
        id: id,
        packageName: packageName,
        prefixOverride: prefixOverride
    });
    $79fad3539deb3f94$export$4b4ea7be124cdbd8.logErrorToSplunk(hash, location, event);
    (0, $es5G8.captureException)(location, errorToReport, // @ts-expect-error TS2345: Index signature for type string is missing in type ErrorInfo
    info);
    if (interactionId) {
        if ((0, $4cTDP.fg)('obsrve-2504-add-errorhash-to-ufo-message')) (0, $2QO3b.addError)(interactionId, `JSErrorBoundary:${id}`, labelStack || null, errorToReport.name, errorToReport.message, errorToReport.stack, undefined, hash, (0, $4cTDP.fg)('send_status_code_to_ufo') ? getErrorStatusCode() : undefined);
        else (0, $2QO3b.addError)(interactionId, `JSErrorBoundary:${id}`, labelStack || null, errorToReport.name, errorToReport.message, errorToReport.stack, undefined, undefined, (0, $4cTDP.fg)('send_status_code_to_ufo') ? getErrorStatusCode() : undefined);
    } else if ((0, $4cTDP.fg)('obsrve-2504-add-errorhash-to-ufo-message')) (0, $2QO3b.addErrorToAll)(`JSErrorBoundary:${id}`, labelStack || null, errorToReport.name, errorToReport.message, errorToReport.stack, hash, (0, $4cTDP.fg)('send_status_code_to_ufo') ? getErrorStatusCode() : undefined);
    else (0, $2QO3b.addErrorToAll)(`JSErrorBoundary:${id}`, labelStack || null, errorToReport.name, errorToReport.message, errorToReport.stack, undefined, (0, $4cTDP.fg)('send_status_code_to_ufo') ? getErrorStatusCode() : undefined);
    if (onError) onError(location, errorToReport, event);
}
class $79fad3539deb3f94$export$4b4ea7be124cdbd8 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            children: null,
            extraEventData: {},
            render: ()=>null,
            withExperienceTracker: false,
            onError: ()=>undefined,
            ufoInteractionId: null,
            ufoLabelStack: null
        };
    }
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.errorFrequencyMap = new Map();
    }
    // go/jfe-eslint
    // eslint-disable-next-line react/sort-comp
    static logErrorToSplunk(hash, location, event) {
        let occurrences;
        if (hash !== undefined) {
            // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
            occurrences = (this.errorFrequencyMap.get(hash) ?? 0) + 1;
            // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
            this.errorFrequencyMap.set(hash, occurrences);
        } else // If there's no hash, treat it as the first time
        occurrences = 1;
        // Only send the error log if we are below the egress limit
        if (occurrences <= $79fad3539deb3f94$var$EGRESS_LIMIT) (0, $eSnSE.default).safeErrorWithoutCustomerData(location, 'Unhandled error caught by error boundary', event);
    }
    static getDerivedStateFromProps(props, state) {
        if (!!props.resetCaughtError && state.caughtError?.error === props.resetCaughtError) return {
            ...state,
            caughtError: null
        };
        return state;
    }
    componentDidCatch(error, info) {
        const { id: id, packageName: packageName, teamName: teamName, prefixOverride: prefixOverride, onError: onError, extraEventData: extraEventData } = this.props;
        this.setState({
            caughtError: {
                error: error,
                info: info
            }
        });
        // passing this.props will cause "'onError' PropType is defined but prop is never used" eslint error
        $79fad3539deb3f94$export$b33b857ad1d9900e(error, info, {
            id: id,
            packageName: packageName,
            teamName: teamName,
            prefixOverride: prefixOverride,
            onError: onError,
            extraEventData: extraEventData
        }, this.props.ufoInteractionId, this.props.ufoLabelStack);
    }
    render() {
        const { caughtError: caughtError } = this.state;
        const { children: children, render: renderFallback, withExperienceTracker: withExperienceTracker, extraEventData: extraEventData } = this.props;
        if (!caughtError) return children;
        const location = $79fad3539deb3f94$var$getLocation(this.props);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, renderFallback({
            error: caughtError.error
        }), withExperienceTracker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $hya93.ExperienceFailureTracker), {
            location: location,
            failureEventAttributes: extraEventData
        }));
    }
    constructor(...args){
        super(...args), this.state = {
            caughtError: null
        };
    }
}
var $79fad3539deb3f94$export$2e2bcd8739ae039 = $79fad3539deb3f94$var$ErrorBoundary;

});
parcelRegister("hEhKB", function(module, exports) {
$parcel$export(module.exports, "useOwnershipMarkerComponent", () => $38e0ce9c400ae822$export$3e3d8535d27f3df3);

var $eJOHy = parcelRequire("eJOHy");

var $SvJbY = parcelRequire("SvJbY");

var $1EXUK = parcelRequire("1EXUK");
const $38e0ce9c400ae822$var$MARKER_COMPONENTS = new Map();
(0, $SvJbY.autoBeforeEachTest)(()=>{
    $38e0ce9c400ae822$var$MARKER_COMPONENTS.clear();
});
const $38e0ce9c400ae822$var$createKeyForComponent = ({ markerType: markerType, name: name, packageName: packageName, teamName: teamName })=>{
    return `${markerType}/${name}/${packageName ?? (0, $1EXUK.NULL_STR)}/${teamName ?? (0, $1EXUK.NULL_STR)}`;
};
const $38e0ce9c400ae822$export$3e3d8535d27f3df3 = (nextParams)=>{
    const params = (0, $eJOHy.useRef)(nextParams).current;
    const componentKey = $38e0ce9c400ae822$var$createKeyForComponent(params);
    const ExistingComponent = $38e0ce9c400ae822$var$MARKER_COMPONENTS.get(componentKey);
    if (ExistingComponent) return ExistingComponent;
    const NewComponent = ({ children: children })=>children;
    Object.defineProperty(NewComponent, 'name', {
        value: $38e0ce9c400ae822$var$encodeDisplayName(params)
    });
    $38e0ce9c400ae822$var$MARKER_COMPONENTS.set(componentKey, NewComponent);
    return NewComponent;
};
const $38e0ce9c400ae822$var$encodeDisplayName = ({ markerType: markerType, name: name, packageName: packageName = (0, $1EXUK.NULL_STR), teamName: teamName = (0, $1EXUK.NULL_STR) })=>{
    return `${0, $1EXUK.OWNER_PREFIX}${markerType}___${name}___${packageName}___${teamName}`;
};

});
parcelRegister("SvJbY", function(module, exports) {
$parcel$export(module.exports, "autoBeforeEachTest", () => $09fd08fb2d2fac31$export$720b76bfb5694d3e);
let $09fd08fb2d2fac31$var$isTestEnvironment = false;
const $09fd08fb2d2fac31$export$c6b22c43dfccffc1 = (value)=>{
    $09fd08fb2d2fac31$var$isTestEnvironment = value;
};
const $09fd08fb2d2fac31$var$autoBeforeEachActions = [];
const $09fd08fb2d2fac31$export$720b76bfb5694d3e = (fn)=>{
    if ($09fd08fb2d2fac31$var$isTestEnvironment) $09fd08fb2d2fac31$var$autoBeforeEachActions.push(fn);
};
const $09fd08fb2d2fac31$export$51eb38a36a7defc6 = ()=>{
    $09fd08fb2d2fac31$var$autoBeforeEachActions.forEach((action)=>action());
};

});

parcelRegister("1EXUK", function(module, exports) {
$parcel$export(module.exports, "NULL_STR", () => $366beff2a6bab0d0$export$f930edd3f4fc2523);
$parcel$export(module.exports, "OWNER_PREFIX", () => $366beff2a6bab0d0$export$e7fd45b374bf8fc0);
$parcel$export(module.exports, "extractOwnershipStack", () => $366beff2a6bab0d0$export$2835e4008154306c);
$parcel$export(module.exports, "getOwningTeam", () => $366beff2a6bab0d0$export$d6e429d0895093);
$parcel$export(module.exports, "getContainingPackageName", () => $366beff2a6bab0d0$export$26973c6d18aa1840);
const $366beff2a6bab0d0$export$f930edd3f4fc2523 = '-';
const $366beff2a6bab0d0$export$e7fd45b374bf8fc0 = 'OwnerMark___';
const $366beff2a6bab0d0$export$2835e4008154306c = (reactComponentStack)=>{
    return reactComponentStack.split('\n').flatMap((untrimmedLine)=>{
        const line = untrimmedLine.trim();
        if (line.startsWith(`at ${$366beff2a6bab0d0$export$e7fd45b374bf8fc0}`)) {
            const withoutPrefix = line.replace(`at ${$366beff2a6bab0d0$export$e7fd45b374bf8fc0}`, '');
            // Exclude trailing `(source path + line number)`
            const withoutSuffix = withoutPrefix.split(' ')[0];
            return [
                withoutSuffix
            ];
        }
        return [];
    }).flatMap((line)=>{
        const parts = line.split('___');
        if (parts.length !== 4) return [];
        const [markerType, name, packageName, teamName] = parts;
        return [
            {
                markerType: markerType,
                name: name,
                packageName: packageName !== $366beff2a6bab0d0$export$f930edd3f4fc2523 ? packageName : null,
                teamName: teamName !== $366beff2a6bab0d0$export$f930edd3f4fc2523 ? teamName : null
            }
        ];
    });
};
const $366beff2a6bab0d0$export$d6e429d0895093 = (ownershipStack)=>{
    return ownershipStack.map(({ teamName: teamName })=>teamName).find((teamName)=>teamName !== null) ?? null;
};
const $366beff2a6bab0d0$export$26973c6d18aa1840 = (ownershipStack)=>{
    return ownershipStack.map(({ packageName: packageName })=>packageName).find((packageName)=>packageName !== null) ?? null;
};

});


parcelRegister("hya93", function(module, exports) {
$parcel$export(module.exports, "ExperienceSuccessTracker", () => $3f86e7031e82fc54$export$b721eda798584098);
$parcel$export(module.exports, "ExperienceFailureTracker", () => $3f86e7031e82fc54$export$7877e129ff70728d);
$parcel$export(module.exports, "ExperienceAbortTracker", () => $3f86e7031e82fc54$export$69d4d8a5c14b1454);
$parcel$export(module.exports, "ExperienceResultFromPropsTracker", () => $3f86e7031e82fc54$export$be2c49f6982d0964);

var $eJOHy = parcelRequire("eJOHy");

var $1cD2y = parcelRequire("1cD2y");
class $3f86e7031e82fc54$export$3908b77264c263e4 extends (0, $eJOHy.Component) {
    static{
        this.defaultProps = {
            hasSucceeded: false,
            hasFailed: false,
            hasAborted: false,
            children: null
        };
    }
    componentDidMount() {
        this.postRenderChecks();
    }
    componentDidUpdate() {
        this.postRenderChecks();
    }
    postRenderChecks() {
        const { onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort, hasSucceeded: hasSucceeded, hasFailed: hasFailed, hasAborted: hasAborted } = this.props;
        if (hasFailed) onExperienceFailure();
        else if (hasAborted) onExperienceAbort();
        else if (hasSucceeded) onExperienceSuccess();
    }
    render() {
        return this.props.children;
    }
}
const $3f86e7031e82fc54$export$5ffc4962dc653e10 = ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort, hasSucceeded: hasSucceeded = false, hasFailed: hasFailed = false, hasAborted: hasAborted = false, children: children = null })=>{
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-manage-parent
    (0, $eJOHy.useEffect)(()=>{
        if (hasFailed) onExperienceFailure();
        else if (hasAborted) onExperienceAbort();
        else if (hasSucceeded) onExperienceSuccess();
    }, [
        hasSucceeded,
        hasFailed,
        hasAborted,
        onExperienceSuccess,
        onExperienceFailure,
        onExperienceAbort
    ]);
    return children;
};
const $3f86e7031e82fc54$export$2a8244c81400d030 = $3f86e7031e82fc54$export$5ffc4962dc653e10;
const $3f86e7031e82fc54$export$b721eda798584098 = ({ children: children, ...props })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1cD2y.ExperienceTracker), props, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3f86e7031e82fc54$export$2a8244c81400d030, {
            hasSucceeded: true,
            onExperienceSuccess: onExperienceSuccess,
            onExperienceFailure: onExperienceFailure,
            onExperienceAbort: onExperienceAbort
        }, children));
$3f86e7031e82fc54$export$b721eda798584098.defaultProps = (0, $1cD2y.defaultProps);
const $3f86e7031e82fc54$export$7877e129ff70728d = ({ children: children, ...props })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1cD2y.ExperienceTracker), props, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3f86e7031e82fc54$export$2a8244c81400d030, {
            hasFailed: true,
            onExperienceSuccess: onExperienceSuccess,
            onExperienceFailure: onExperienceFailure,
            onExperienceAbort: onExperienceAbort
        }, children));
$3f86e7031e82fc54$export$7877e129ff70728d.defaultProps = (0, $1cD2y.defaultProps);
const $3f86e7031e82fc54$export$69d4d8a5c14b1454 = ({ children: children, ...props })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1cD2y.ExperienceTracker), props, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3f86e7031e82fc54$export$2a8244c81400d030, {
            hasAborted: true,
            onExperienceSuccess: onExperienceSuccess,
            onExperienceFailure: onExperienceFailure,
            onExperienceAbort: onExperienceAbort
        }, children));
$3f86e7031e82fc54$export$69d4d8a5c14b1454.defaultProps = (0, $1cD2y.defaultProps);
const $3f86e7031e82fc54$export$be2c49f6982d0964 = ({ hasSucceeded: hasSucceeded, hasFailed: hasFailed, hasAborted: hasAborted, children: children, ...trackerProps })=>false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1cD2y.ExperienceTracker), trackerProps, ({ onExperienceSuccess: onExperienceSuccess, onExperienceFailure: onExperienceFailure, onExperienceAbort: onExperienceAbort })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($3f86e7031e82fc54$export$2a8244c81400d030, {
            hasSucceeded: hasSucceeded,
            hasFailed: hasFailed,
            hasAborted: hasAborted,
            onExperienceSuccess: onExperienceSuccess,
            onExperienceFailure: onExperienceFailure,
            onExperienceAbort: onExperienceAbort
        }, children));
$3f86e7031e82fc54$export$be2c49f6982d0964.defaultProps = {
    hasSucceeded: false,
    hasFailed: false,
    hasAborted: false,
    ...(0, $1cD2y.defaultProps)
};

});
parcelRegister("1cD2y", function(module, exports) {
$parcel$export(module.exports, "defaultProps", () => $389c50de354f6b6f$export$9c21a3269931e1e6);
$parcel$export(module.exports, "ExperienceTracker", () => $389c50de354f6b6f$export$12b6b072930fd68f);

var $eJOHy = parcelRequire("eJOHy");

var $12DRg = parcelRequire("12DRg");

var $eSnSE = parcelRequire("eSnSE");

var $6DllT = parcelRequire("6DllT");

var $e5QGj = parcelRequire("e5QGj");
const $389c50de354f6b6f$export$9c21a3269931e1e6 = {
    failureEventAttributes: null,
    parentProviders: null,
    children: null
};
const $389c50de354f6b6f$export$12b6b072930fd68f = ({ children: children, ...props })=>{
    const context = (0, $eJOHy.useContext)((0, $6DllT.default));
    (0, $eJOHy.useEffect)(()=>{
        if (context === null) (0, $eSnSE.default).safeErrorWithoutCustomerData('experience-tracker.missing-provider', 'Experience tracker rendered without a provider');
    }, [
        context
    ]);
    if (context == null || false) return typeof children === 'function' ? children({
        onExperienceSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onExperienceFailure: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
        onExperienceAbort: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg)))
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e5QGj.default), {
        location: props.location,
        experienceContext: context,
        failureEventAttributes: props.failureEventAttributes,
        parentProvidersWhitelist: props.parentProviders
    }, children);
};
$389c50de354f6b6f$export$12b6b072930fd68f.defaultProps = $389c50de354f6b6f$export$9c21a3269931e1e6;

});
parcelRegister("6DllT", function(module, exports) {
$parcel$export(module.exports, "default", () => $a75a38c680cd51ff$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");
var $a75a38c680cd51ff$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $eJOHy.createContext)(null);

});

parcelRegister("e5QGj", function(module, exports) {
$parcel$export(module.exports, "default", () => $63591557644dfb5c$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $dMM78 = parcelRequire("dMM78");
class $63591557644dfb5c$export$2e2bcd8739ae039 extends (0, $eJOHy.Component) {
    constructor(props){
        super(props), this.onSuccess = ()=>{
            // This guards against the possibility of the child calling `onExperienceSuccess` repeatedly.
            if (!this.hasSignalledSuccess && this.isReportingToCurrentProvider()) {
                this.hasSignalledSuccess = true;
                this.props.experienceContext.consumerCallbacks.onSuccess();
            }
        }, this.onFailure = (locationSuffix, extraFailureEventAttributes)=>{
            const { experienceContext: { consumerCallbacks: { onFailure: onFailure } }, location: location, failureEventAttributes: failureEventAttributes } = this.props;
            if (!this.hasSignalledFailure && this.isReportingToCurrentProvider()) {
                this.hasSignalledFailure = true;
                const concatenatedLocation = locationSuffix == null ? location : `${location}.${locationSuffix}`;
                const mergedFailureAttributes = {
                    ...extraFailureEventAttributes,
                    ...failureEventAttributes
                };
                onFailure(concatenatedLocation, mergedFailureAttributes);
            }
        }, this.onAbort = (locationSuffix, extraFailureEventAttributes)=>{
            const { experienceContext: { consumerCallbacks: { onAbort: onAbort } }, location: location, failureEventAttributes: failureEventAttributes } = this.props;
            if (!this.hasSignalledFailure && this.isReportingToCurrentProvider()) {
                this.hasSignalledFailure = true;
                const concatenatedLocation = locationSuffix == null ? location : `${location}.${locationSuffix}`;
                const mergedFailureAttributes = {
                    ...extraFailureEventAttributes,
                    ...failureEventAttributes
                };
                onAbort(concatenatedLocation, mergedFailureAttributes);
            }
        };
        this.resetTracker();
    }
    componentDidCatch(error) {
        if (!(0, $dMM78.isClientFetchError)(error)) this.onFailure(undefined, {
            errorMessage: error.message
        });
        // We're deliberately rethrowing the error here because we don't want to interfere with
        // any error handling the container app may have in place. This app exists only to track
        // error/success metrics; we don't want to interfere with the app that's actually rendering UI.
        throw error;
    }
    isReportingToCurrentProvider() {
        const { experience: experience } = this.props.experienceContext;
        return(// parentProviders is an OPTIONAL whitelist. If not specified, then we are definitely reporting to the current experience
        this.parentProvidersWhitelistSet == null || // otherwise make sure we are currently in one of the listed experiences
        this.parentProvidersWhitelistSet.has(experience));
    }
    // Resetting must not call setState since this can be executed in the render phase
    resetTracker() {
        this.hasSignalledFailure = false;
        this.hasSignalledSuccess = false;
        this.lastExperienceId = this.props.experienceContext.experienceId;
        // Must only respect updates to `parentProvidersWhitelist` when the experience resets, otherwise weird bugs can arise.
        // Eg: a component could call onSuccess when it never called onPending, this would result in premature experience successes.
        this.parentProvidersWhitelistSet = this.props.parentProvidersWhitelist ? new Set(this.props.parentProvidersWhitelist) : null;
        this.isReportingToCurrentProvider() && this.props.experienceContext.consumerCallbacks.onPending();
    }
    // Check every render to reset the experience state instance variables
    checkExperienceIdForExperienceReset() {
        if (this.lastExperienceId !== this.props.experienceContext.experienceId) this.resetTracker();
    }
    render() {
        this.checkExperienceIdForExperienceReset();
        const { children: children } = this.props;
        return typeof children === 'function' ? children({
            onExperienceSuccess: this.onSuccess,
            onExperienceFailure: this.onFailure,
            onExperienceAbort: this.onAbort
        }) : children;
    }
}

});



parcelRegister("aK3Xl", function(module, exports) {
$parcel$export(module.exports, "UnknownError", () => $63e5072b60ba1eed$export$ff4405149dbd0c5c);
class $63e5072b60ba1eed$export$ff4405149dbd0c5c extends Error {
    constructor(){
        super();
        this.name = 'UnknownError';
        this.message = 'There is something wrong and ErrorBoundary component catch an undefined error.';
    }
}

});




parcelRegister("2I68T", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "AnalyticsProviders", () => $d9f06bf69bc5bb00$export$fe99df39f319f93e);
$parcel$export(module.exports, "default", () => $d9f06bf69bc5bb00$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $l7Alo = parcelRequire("l7Alo");

var $eSnSE = parcelRequire("eSnSE");

var $kGj4V = parcelRequire("kGj4V");

var $g9Vr6 = parcelRequire("g9Vr6");

var $koAZ4 = parcelRequire("koAZ4");

var $hWeHP = parcelRequire("hWeHP");

var $exfGR = parcelRequire("exfGR");

var $HpPtH = parcelRequire("HpPtH");
const $d9f06bf69bc5bb00$export$fe99df39f319f93e = ({ children: children })=>{
    const tenantContext = (0, $koAZ4.useTenantContext)();
    const { data: orgId } = (0, $g9Vr6.useOrgId)();
    (0, $eJOHy.useEffect)(()=>{
        if (false) return;
        try {
            const success = (0, $exfGR.initAnalytics)({
                ...tenantContext,
                orgId: orgId
            });
            if (success === undefined) throw new Error('observability.analytics-providers-error: @atlassiansox/analytics-web-client AnalyticsClient in src/common/analytics-web-react/web-client/index.js failed to initialise successfully');
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            (0, $eSnSE.default).safeErrorWithoutCustomerData('observability.analytics-providers.analytics', e);
        }
    }, [
        orgId,
        tenantContext
    ]);
    if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, children);
    // Temporary analytics for our experiment
    const mobileAnalytics = {
        isMobileUserAgent: (0, $l7Alo.isSupportedUserAgent)(),
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        userAgent: navigator?.userAgent
    };
    /**
	 * As per Jira: Incident Detection and Reliability Uplift we need to add shard and region to the analytics context
	 * This will add shard and region to all analytics events fired throughout the application
	 * we check for false above to ensure SSR does not break with getMeta()
	 */ const shardAndRegionAnalytics = {
        shard: (0, $hWeHP.default)('ajs-shard') || '',
        region: (0, $hWeHP.default)('ajs-region') || ''
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $HpPtH.JiraStructuredAnalyticsListener), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $kGj4V.ContextualAnalyticsData), {
        attributes: {
            isSPA: __SPA__,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            variant: window.BUILD_VARIANT,
            ...mobileAnalytics,
            ...shardAndRegionAnalytics
        }
    }, children));
};
var $d9f06bf69bc5bb00$export$2e2bcd8739ae039 = $d9f06bf69bc5bb00$export$fe99df39f319f93e;

});
parcelRegister("l7Alo", function(module, exports) {
$parcel$export(module.exports, "isSupportedUserAgent", () => $e711cf9145d67cc9$export$2b0f0a801c573b06);
$parcel$export(module.exports, "isAndroidUserAgent", () => $e711cf9145d67cc9$export$6053d3a1e6477e0f);
$parcel$export(module.exports, "isTabletUserAgent", () => $e711cf9145d67cc9$export$a33e336659bb3eb6);
$parcel$export(module.exports, "shouldShowReturnToMobileBanner", () => $e711cf9145d67cc9$export$604401c0b63e5273);
$parcel$export(module.exports, "shouldShowReturnToMobileBannerMobileMvp", () => $e711cf9145d67cc9$export$511710677ef866);
$parcel$export(module.exports, "shouldShowDismissButton", () => $e711cf9145d67cc9$export$5ad7f0440f4fd036);
$parcel$export(module.exports, "determineOperatingSystemAttribute", () => $e711cf9145d67cc9$export$d9f2497f8d710783);
$parcel$export(module.exports, "default", () => $e711cf9145d67cc9$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/cookie -- This reduced TS complexity by 3,114,190 across Jira

var $5H4WP = parcelRequire("5H4WP");
/*
This logic was ported from MobileUtils class from jira monolith to
provide the same conditions for checking whether the user agent is mobile or not.
*/ const $e711cf9145d67cc9$var$DESKTOP_SWITCH_COOKIE_KEY = 'jira.mobile.desktop.switch';
const $e711cf9145d67cc9$var$MOBILE_USER_AGENT = new RegExp('(iPhone;|iPhone Simulator;|iPad;|iPod;|iPod touch|Android)');
const $e711cf9145d67cc9$var$MOBILE_STRING_IN_USER_AGENT = new RegExp('Mobile');
const $e711cf9145d67cc9$var$IPAD_USER_AGENT = new RegExp('iPad;');
const $e711cf9145d67cc9$var$IOS_USER_AGENT = new RegExp('(iPhone;|iPad;|iPod;)');
const $e711cf9145d67cc9$var$ANDROID_USER_AGENT = new RegExp('Android');
// This regex matches the following iOS rendering engines:
// 1. Chrome for iOS
// 2. Firefox for iOS
// 3. Edge for iOS
const $e711cf9145d67cc9$var$NON_SAFARI_IOS_RENDERING_ENGINE_USER_AGENT = new RegExp('CriOS|FxiOS|EdgiOS');
const $e711cf9145d67cc9$export$2b0f0a801c573b06 = ()=>{
    if (false) return false;
    if (!globalThis.navigator?.userAgent.length) return false;
    const isMobile = $e711cf9145d67cc9$var$MOBILE_USER_AGENT.test(globalThis.navigator?.userAgent);
    return isMobile;
};
const $e711cf9145d67cc9$export$6053d3a1e6477e0f = ()=>{
    return $e711cf9145d67cc9$var$ANDROID_USER_AGENT.test(globalThis.navigator?.userAgent);
};
const $e711cf9145d67cc9$export$b4161aa2f4036482 = ()=>$e711cf9145d67cc9$var$IOS_USER_AGENT.test(globalThis.navigator?.userAgent);
const $e711cf9145d67cc9$export$a33e336659bb3eb6 = ()=>{
    if (!globalThis.navigator?.userAgent.length) return false;
    return $e711cf9145d67cc9$var$IPAD_USER_AGENT.test(globalThis.navigator?.userAgent) || $e711cf9145d67cc9$export$6053d3a1e6477e0f() && !$e711cf9145d67cc9$var$MOBILE_STRING_IN_USER_AGENT.test(globalThis.navigator?.userAgent);
};
const $e711cf9145d67cc9$var$isDesktopSwitchEnabled = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($5H4WP))).get($e711cf9145d67cc9$var$DESKTOP_SWITCH_COOKIE_KEY) === 'true';
const $e711cf9145d67cc9$var$isMobileUserAgent = ()=>$e711cf9145d67cc9$export$2b0f0a801c573b06() && !$e711cf9145d67cc9$var$isDesktopSwitchEnabled();
const $e711cf9145d67cc9$export$1cb1de725ba5b3e3 = ()=>{
    if (typeof navigator === 'undefined') return false;
    return $e711cf9145d67cc9$export$b4161aa2f4036482() && !$e711cf9145d67cc9$var$NON_SAFARI_IOS_RENDERING_ENGINE_USER_AGENT.test(globalThis.navigator?.userAgent);
};
const $e711cf9145d67cc9$export$604401c0b63e5273 = ()=>$e711cf9145d67cc9$export$2b0f0a801c573b06();
const $e711cf9145d67cc9$export$511710677ef866 = ()=>{
    return $e711cf9145d67cc9$export$2b0f0a801c573b06() && !$e711cf9145d67cc9$export$1cb1de725ba5b3e3();
};
const $e711cf9145d67cc9$export$5ad7f0440f4fd036 = ()=>$e711cf9145d67cc9$export$604401c0b63e5273() && $e711cf9145d67cc9$export$a33e336659bb3eb6();
const $e711cf9145d67cc9$export$d9f2497f8d710783 = ()=>{
    if ($e711cf9145d67cc9$export$b4161aa2f4036482()) return 'ios';
    if ($e711cf9145d67cc9$export$6053d3a1e6477e0f()) return 'android';
    return 'other';
};
var $e711cf9145d67cc9$export$2e2bcd8739ae039 = $e711cf9145d67cc9$var$isMobileUserAgent;

});

parcelRegister("kGj4V", function(module, exports) {
$parcel$export(module.exports, "extractContextualData", () => $54ceb99d590796c6$export$dc30f43798194b03);
$parcel$export(module.exports, "ContextualAnalyticsData", () => $54ceb99d590796c6$export$198470770171c65);
/**
 * This library is the only place where you'd use raw AnalyticsContext
 * It provides a typed wrapper around it for better user experience
 */ 
var $eJOHy = parcelRequire("eJOHy");

var $6dPbw = parcelRequire("6dPbw");

var $4lYQk = parcelRequire("4lYQk");

var $e2B2h = parcelRequire("e2B2h");
const $54ceb99d590796c6$export$dc30f43798194b03 = (props)=>{
    const { children: children, sourceName: sourceName, sourceType: sourceType, ...rest } = props;
    const source = sourceName && sourceType ? `${sourceName}${sourceType}` : undefined;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))({
        source: source,
        ...rest
    }, (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw))));
};
const $54ceb99d590796c6$export$198470770171c65 = /*#__PURE__*/ (0, $eJOHy.memo)((props)=>{
    const data = $54ceb99d590796c6$export$dc30f43798194b03(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $e2B2h.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, props.children));
});

});

parcelRegister("g9Vr6", function(module, exports) {
$parcel$export(module.exports, "useOrgId", () => $015f4ca0131950ab$export$52a03a3207af3687);
// eslint-disable-next-line jira/import-whitelist

var $hWeHP = parcelRequire("hWeHP");
const $015f4ca0131950ab$export$52a03a3207af3687 = ()=>{
    const orgId = (0, $hWeHP.default)('ajs-org-id');
    return {
        data: orgId || undefined
    };
};

});

parcelRegister("koAZ4", function(module, exports) {
$parcel$export(module.exports, "TenantContextContainer", () => $5c51d5b30a597dac$export$8b5d54c1fa2f746f);
$parcel$export(module.exports, "TenantContextSubscriber", () => $5c51d5b30a597dac$export$9d1e1d1d0f8eeb35);
$parcel$export(module.exports, "useTenantContextHook", () => $5c51d5b30a597dac$export$b24a99788063c041);
$parcel$export(module.exports, "useTenantContext", () => $5c51d5b30a597dac$export$28e7c557f4d454d9);

var $6E16M = parcelRequire("6E16M");
var $iJq0l = parcelRequire("iJq0l");
var $ht3nQ = parcelRequire("ht3nQ");

var $45yyw = parcelRequire("45yyw");

var $g9iF5 = parcelRequire("g9iF5");
const $5c51d5b30a597dac$export$8b5d54c1fa2f746f = (0, $6E16M.createContainer)((0, $g9iF5.default), {
    onInit: ()=>({ dispatch: dispatch })=>dispatch($45yyw.bootstrap())
});
const $5c51d5b30a597dac$export$9d1e1d1d0f8eeb35 = (0, $ht3nQ.createSubscriber)((0, $g9iF5.default), {
    displayName: 'TenantContextSubscriber'
});
const $5c51d5b30a597dac$export$b24a99788063c041 = (0, $iJq0l.createHook)((0, $g9iF5.default));
const $5c51d5b30a597dac$export$28e7c557f4d454d9 = ()=>{
    const [{ tenantContext: tenantContext }] = $5c51d5b30a597dac$export$b24a99788063c041();
    return tenantContext;
};

});
parcelRegister("45yyw", function(module, exports) {
$parcel$export(module.exports, "bootstrap", () => $6b5a43b2240a6bdd$export$36aff1fbb4f5dfc6);

var $aYncF = parcelRequire("aYncF");
const $6b5a43b2240a6bdd$export$36aff1fbb4f5dfc6 = ()=>({ setState: setState, getState: getState }, { getMeta: getMeta })=>{
        if (getState().tenantContext) return;
        const tenantContext = (0, $aYncF.getTenantContext_DEPRECATED_DO_NOT_USE)(getMeta);
        setState({
            tenantContext: tenantContext
        });
    };

});

parcelRegister("g9iF5", function(module, exports) {
$parcel$export(module.exports, "default", () => $a79fc789a65a50dd$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $GtRbT = parcelRequire("GtRbT");

var $45yyw = parcelRequire("45yyw");
// @ts-expect-error - TS2322 - Type 'null' is not assignable to type 'TenantContext'.
const $a79fc789a65a50dd$var$initialState = {
    tenantContext: null
};
var $a79fc789a65a50dd$export$2e2bcd8739ae039 = (0, $GtRbT.createStore)({
    name: 'tenantContext',
    initialState: $a79fc789a65a50dd$var$initialState,
    actions: $45yyw
});

});


parcelRegister("exfGR", function(module, exports) {
$parcel$export(module.exports, "initAnalytics", () => $5d38cd8f7368fef3$export$f2a39aaa42ea357a);

var $5G60L = parcelRequire("5G60L");

var $jI4f2 = parcelRequire("jI4f2");

var $64sVH = parcelRequire("64sVH");

var $dsexO = parcelRequire("dsexO");

var $eXiXf = parcelRequire("eXiXf");
const $5d38cd8f7368fef3$export$f2a39aaa42ea357a = ({ cloudId: cloudId, cloudName: cloudName, atlassianAccountId: atlassianAccountId, environment: environment, locale: locale, orgId: orgId, activationId: workspaceId })=>(0, $5G60L.initAnalyticsWebClient)({
        tenantId: cloudId,
        ...atlassianAccountId ? {
            userId: atlassianAccountId
        } : undefined,
        ...orgId && {
            orgId: orgId
        },
        ...workspaceId && {
            workspaceId: workspaceId
        },
        product: 'jira',
        environment: environment === 'prod' ? 'prod' : (0, $dsexO.default)({
            cloudId: cloudId,
            cloudName: cloudName,
            environment: environment
        }),
        callback: (0, $eXiXf.logEmau),
        subProduct: (0, $64sVH.default),
        solutions: (0, $jI4f2.default)(),
        locale: locale
    });

});
parcelRegister("jI4f2", function(module, exports) {
$parcel$export(module.exports, "default", () => $8722081fb7c8f225$export$2e2bcd8739ae039);


var $64sVH = parcelRequire("64sVH");
const $8722081fb7c8f225$var$getApplicationSolutions = ()=>(0, $64sVH.default)() === 'serviceDesk' ? [
        (0, $c2258fadc4095860$export$c8b406ad8ee0dab9)
    ] : undefined;
var $8722081fb7c8f225$export$2e2bcd8739ae039 = $8722081fb7c8f225$var$getApplicationSolutions;

});
const $c2258fadc4095860$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';

parcelRegister("64sVH", function(module, exports) {
$parcel$export(module.exports, "default", () => $bbe8b34c7e980538$export$2e2bcd8739ae039);

var $hWeHP = parcelRequire("hWeHP");

var $jfEiR = parcelRequire("jfEiR");
const $bbe8b34c7e980538$var$getApplicationSubProduct = ()=>(0, $jfEiR.default)((0, $hWeHP.default)('ajs-application-key'));
var $bbe8b34c7e980538$export$2e2bcd8739ae039 = $bbe8b34c7e980538$var$getApplicationSubProduct;

});
parcelRegister("jfEiR", function(module, exports) {
$parcel$export(module.exports, "default", () => $8df0db037eae1be8$export$2e2bcd8739ae039);
/**
 * Transforms sub-product identifiers into a simplified or generic form, providing
 * a default when unspecified. This aids in standardizing the representation of
 * sub-product names across different contexts.
 */ const $8df0db037eae1be8$var$transformSubProducts = (subProduct)=>{
    if (!subProduct) return 'unknown';
    if (subProduct === 'family') return 'platform';
    if (subProduct === 'jira-servicedesk') return 'serviceDesk';
    if (subProduct.startsWith('jira-')) return subProduct.replace('jira-', '');
    return subProduct;
};
var $8df0db037eae1be8$export$2e2bcd8739ae039 = $8df0db037eae1be8$var$transformSubProducts;

});



parcelRegister("dsexO", function(module, exports) {
$parcel$export(module.exports, "default", () => $294900c9ed7c0df9$export$2e2bcd8739ae039);
// MR - stands for the atlassian monorepo prefix
const $294900c9ed7c0df9$var$isOverridingFragments = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    !!(window?.BUILD_KEY && !/^(?:MR)?JF-PROD-\d+$/.test(window.BUILD_KEY));
const $294900c9ed7c0df9$var$isOverridingSsr = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    !!(window?.SSR_BUILD_KEY && !/^(?:MR)?JF-PROD-\d+$/i.test(window.SSR_BUILD_KEY));
const $294900c9ed7c0df9$var$isVoltExplore = ({ cloudId: cloudId, cloudName: cloudName })=>/^(TEST--)/.test(cloudId) && /^(atl-vertigo--jira-jira-branch)/.test(cloudName);
/**
 * Selects the 'staging' environment under specific conditions, defaulting to 'dev' otherwise.
 * This decision is based on the current environment setting and the absence of specific overrides.
 */ const $294900c9ed7c0df9$var$getStagingEnvironment = ({ environment: environment, cloudId: cloudId, cloudName: cloudName })=>{
    if (environment === 'staging' && !$294900c9ed7c0df9$var$isOverridingFragments() && !$294900c9ed7c0df9$var$isOverridingSsr() && !$294900c9ed7c0df9$var$isVoltExplore({
        cloudId: cloudId,
        cloudName: cloudName
    })) return environment;
    return 'dev';
};
var $294900c9ed7c0df9$export$2e2bcd8739ae039 = $294900c9ed7c0df9$var$getStagingEnvironment;

});

parcelRegister("eXiXf", function(module, exports) {
$parcel$export(module.exports, "logEmau", () => $9a679ca747ff7a82$export$f6d9e07ca353aa2e);

var $eBhI6 = parcelRequire("eBhI6");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $9a679ca747ff7a82$var$logEmauForJira = (subproduct, url, urlParams)=>{
    const body = JSON.stringify({
        eventData: {
            url: url,
            subproduct: subproduct,
            urlParams: urlParams
        }
    });
    const endpointUrl = '/rest/internal/2/log/unsafe/emau';
    const fetchOptions = {
        ...(0, $eBhI6.getDefaultOptions)(endpointUrl),
        method: 'POST',
        body: body
    };
    return fetch(endpointUrl, fetchOptions);
};
const $9a679ca747ff7a82$export$f6d9e07ca353aa2e = ({ product: product, subproduct: subproduct })=>{
    if (product === 'jira') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $9a679ca747ff7a82$var$logEmauForJira(subproduct, window.location.pathname, window.location.search);
};

});


parcelRegister("HpPtH", function(module, exports) {
$parcel$export(module.exports, "JiraStructuredAnalyticsListener", () => $6dfca3c6269e3850$export$ba6a124597fff04a);

var $eJOHy = parcelRequire("eJOHy");

var $3VCQy = parcelRequire("3VCQy");

var $8QoO2 = parcelRequire("8QoO2");

var $5P9yM = parcelRequire("5P9yM");

var $eSnSE = parcelRequire("eSnSE");

var $2xVsC = parcelRequire("2xVsC");

var $2Mqjh = parcelRequire("2Mqjh");

var $8kKDR = parcelRequire("8kKDR");
const $6dfca3c6269e3850$var$EXCLUDED_CHANNELS = [
    (0, $3VCQy.FabricChannel).atlaskit
];
const $6dfca3c6269e3850$var$addSearchPayload = (event, isProductAnalyticsV3 = false)=>{
    try {
        const searchPayload = (0, $8kKDR.addSearchSessionAttributes)();
        if (Object.keys(searchPayload).length > 0) {
            if (isProductAnalyticsV3) // eslint-disable-next-line no-param-reassign
            event.payload.attributes = {
                ...event.payload.attributes,
                ...searchPayload
            };
            else // eslint-disable-next-line no-param-reassign
            event.payload = {
                ...event.payload,
                ...searchPayload
            };
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $eSnSE.default).safeErrorWithoutCustomerData('observability.analytics-providers.addSearchPayload', 'Failed to dynamically add search payload', e);
    }
    return event;
};
const $6dfca3c6269e3850$var$getAnalyticsWebClientInstance = ()=>(0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>client.getInstance());
const $6dfca3c6269e3850$var$sendAnalyticsEvent = (event)=>{
    // Preemptively create an error so we can find who sends invalid events in Sentry
    const callError = new Error(`This ${event.type} event is not valid`);
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        try {
            client.sendEvent(event);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            err.cause = callError;
            throw err;
        }
    });
};
const $6dfca3c6269e3850$var$onStructuredAnalyticsEvent = (event)=>{
    const enrichedEvent = $6dfca3c6269e3850$var$addSearchPayload(event);
    $6dfca3c6269e3850$var$sendAnalyticsEvent((0, $5P9yM.default)(enrichedEvent));
};
const $6dfca3c6269e3850$var$onProductAnalyticsV3 = (event)=>{
    const enrichedEvent = $6dfca3c6269e3850$var$addSearchPayload(event, true);
    $6dfca3c6269e3850$var$sendAnalyticsEvent((0, $2xVsC.getEvent)(enrichedEvent));
};
const $6dfca3c6269e3850$var$JiraAnalyticsListener = ({ onEvent: onEvent, onEventV3: onEventV3, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8QoO2.default), {
        onEvent: onEvent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $8QoO2.default), {
        onEvent: onEventV3,
        channel: "productAnalytics"
    }, children));
const $6dfca3c6269e3850$export$ba6a124597fff04a = ({ children: children })=>{
    if (false) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $3VCQy.default), {
        // @ts-expect-error - Type 'GasPurePayload' is not assignable to type 'UITrackAndOperationalEventPayload'.
        client: $6dfca3c6269e3850$var$getAnalyticsWebClientInstance(),
        excludedChannels: $6dfca3c6269e3850$var$EXCLUDED_CHANNELS
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($6dfca3c6269e3850$var$JiraAnalyticsListener, {
        onEvent: $6dfca3c6269e3850$var$onStructuredAnalyticsEvent,
        onEventV3: $6dfca3c6269e3850$var$onProductAnalyticsV3
    }, children));
};

});
parcelRegister("5P9yM", function(module, exports) {
$parcel$export(module.exports, "default", () => $084e61a490312bee$export$2e2bcd8739ae039);

var $6dPbw = parcelRequire("6dPbw");

var $1ilzu = parcelRequire("1ilzu");

var $4lYQk = parcelRequire("4lYQk");

var $9X75V = parcelRequire("9X75V");

var $g4Rv9 = parcelRequire("g4Rv9");
const $084e61a490312bee$var$formatActionSubjectId = (name, actionSubject)=>actionSubject ? `${name}${actionSubject[0].toUpperCase()}${actionSubject.substring(1)}` : name;
const $084e61a490312bee$var$getActionSubjectForEventType = (event, analyticsType)=>{
    if (analyticsType === (0, $9X75V.TRACK_EVENT_TYPE)) return (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $g4Rv9.getActionSubjects)(event));
    return (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $g4Rv9.getComponents)(event));
};
const $084e61a490312bee$var$getActionSubjectIdForEventType = (event, analyticsType, actionSubject)=>{
    const name = (0, $g4Rv9.getName)(event);
    // for UI and operational events, the actionSubjectId is generated
    // but for operational events name is optional, since it doesnt always make sense.
    // Consider a high level component BespokeComponent. If this fires an internal event
    // The unique instance of the component is likely to be BespokeComponent (ie there is 1)
    // so if name wasn't optional we would end up with actionSubjectId=bespokeComponentBespokeComponent
    if (analyticsType === (0, $9X75V.OPERATIONAL_EVENT_TYPE)) return name ? $084e61a490312bee$var$formatActionSubjectId(name, actionSubject) : actionSubject;
    if (analyticsType === (0, $9X75V.UI_EVENT_TYPE)) return $084e61a490312bee$var$formatActionSubjectId(name, actionSubject);
    return (0, $g4Rv9.getActionSubjectId)(event);
};
/**
 * This util exists to bridge the two different formats between atlaskit and the data services events. Two formats are required because
 * atlaskit needs to be able to collect aribtrary events from the tree while the data service event doesn't (and shouldn't) care about the react tree.
 *
 * Atlaskit event format:
 *
 * event {
 *      payload: {
 *          ...attributesFromLowestPointInTheTree
 *      },
 *      context: [{
 *          ...attributesFromHighestPointInTheTree
 *      }, {
 *          ...attributesFromSecondHighestPointInTheTree
 *      }]
 * }
 *
 * Data Services event format:
 *  event {
 *      type: <"TRACK"|"SCREEN"|"UI"|"OPERATIONAL">
 *      payload {
 *          ...mandatoryFieldsBasedOnEventType
 *          ...optionalFieldsBasedOnEventType
 *          attributes: {
 *              ...arbirtaryAttributes
 *          }
 *      }
 *  }
 */ const $084e61a490312bee$var$getEvent = (event)=>{
    const sources = (0, $g4Rv9.getSources)(event);
    const analyticsType = (0, $g4Rv9.getAnalyticsType)(event);
    const actionSubject = $084e61a490312bee$var$getActionSubjectForEventType(event, analyticsType);
    const source = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))(sources);
    const action = (0, $g4Rv9.getAction)(event);
    const attributes = {
        ...(0, $g4Rv9.getAttributes)(event),
        namespaces: sources.join('.')
    };
    const containers = (0, $g4Rv9.getContainers)(event);
    if (action === (0, $9X75V.PAGE_EVENT_ACTION)) return {
        type: (0, $9X75V.SCREEN_EVENT_TYPE),
        payload: {
            name: source,
            attributes: attributes,
            containers: containers
        }
    };
    switch(analyticsType){
        case 0, $9X75V.UI_EVENT_TYPE:
        case 0, $9X75V.TRACK_EVENT_TYPE:
        case 0, $9X75V.OPERATIONAL_EVENT_TYPE:
            {
                const actionSubjectId = $084e61a490312bee$var$getActionSubjectIdForEventType(event, analyticsType, actionSubject);
                const containerId = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $g4Rv9.getContainerIds)(event));
                const containerType = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $g4Rv9.getContainerTypes)(event));
                const objectId = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $g4Rv9.getObjectIds)(event));
                const objectType = (0, (/*@__PURE__*/$parcel$interopDefault($1ilzu)))((0, $g4Rv9.getObjectTypes)(event));
                const tags = (0, $g4Rv9.getTags)(event);
                return {
                    type: analyticsType,
                    payload: (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))({
                        action: action,
                        actionSubject: actionSubject,
                        actionSubjectId: actionSubjectId,
                        source: source,
                        tags: tags,
                        containerId: containerId,
                        containers: containers,
                        containerType: containerType,
                        objectType: objectType,
                        objectId: objectId,
                        attributes: attributes
                    }, (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw))))
                };
            }
        default:
            return {
                payload: {
                    source: source,
                    actionSubject: actionSubject,
                    attributes: attributes,
                    containers: containers
                },
                type: undefined
            };
    }
};
var $084e61a490312bee$export$2e2bcd8739ae039 = $084e61a490312bee$var$getEvent;

});
parcelRegister("9X75V", function(module, exports) {
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $902823add2a25378$export$a1562d08625f5d7e);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $902823add2a25378$export$947dac6c72b26f81);
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", () => $902823add2a25378$export$f1d537d508d2945a);
$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $902823add2a25378$export$12346a674644c156);
$parcel$export(module.exports, "PAGE_EVENT_ACTION", () => $902823add2a25378$export$a953886d20994732);
$parcel$export(module.exports, "ScreenTypes", () => $902823add2a25378$export$9dd85b191ff3384f);
/**
 * ANALYTICS WEB CLIENT EVENTS
 */ // those events are going to the analytics web client
const $902823add2a25378$export$a1562d08625f5d7e = 'UI';
const $902823add2a25378$export$947dac6c72b26f81 = 'TRACK';
const $902823add2a25378$export$f1d537d508d2945a = 'SCREEN';
const $902823add2a25378$export$12346a674644c156 = 'OPERATIONAL';
const $902823add2a25378$export$a953886d20994732 = 'page-view';
const $902823add2a25378$var$SCREEN = 'Screen';
const $902823add2a25378$var$DRAWER = 'Drawer';
const $902823add2a25378$var$MODAL = 'Modal';
const $902823add2a25378$var$INLINE_DIALOG = 'InlineDialog';
const $902823add2a25378$var$DROPDOWN = 'Dropdown';
const $902823add2a25378$export$9dd85b191ff3384f = {
    SCREEN: $902823add2a25378$var$SCREEN,
    MODAL: $902823add2a25378$var$MODAL,
    DRAWER: $902823add2a25378$var$DRAWER,
    INLINE_DIALOG: $902823add2a25378$var$INLINE_DIALOG,
    DROPDOWN: $902823add2a25378$var$DROPDOWN
};

});

parcelRegister("g4Rv9", function(module, exports) {
$parcel$export(module.exports, "getComponents", () => $aeb7747f4631a3ee$export$4e811121b221213b);
$parcel$export(module.exports, "getActionSubjects", () => $aeb7747f4631a3ee$export$d9a2a7d6b7a9497b);
$parcel$export(module.exports, "getSources", () => $aeb7747f4631a3ee$export$5f9bc633b116660f);
$parcel$export(module.exports, "getAttributes", () => $aeb7747f4631a3ee$export$fe94072fee8a6976);
$parcel$export(module.exports, "getTags", () => $aeb7747f4631a3ee$export$af63d7414243dad3);
$parcel$export(module.exports, "getContainerTypes", () => $aeb7747f4631a3ee$export$94b487dda8940141);
$parcel$export(module.exports, "getContainerIds", () => $aeb7747f4631a3ee$export$9a462447889d734e);
$parcel$export(module.exports, "getObjectTypes", () => $aeb7747f4631a3ee$export$9ed2cbb83cd51da0);
$parcel$export(module.exports, "getObjectIds", () => $aeb7747f4631a3ee$export$2e78a279ad2bf08);
$parcel$export(module.exports, "getActionSubjectId", () => $aeb7747f4631a3ee$export$b6f8db3ad0711b02);
$parcel$export(module.exports, "getAnalyticsType", () => $aeb7747f4631a3ee$export$a3569ac53b82a914);
$parcel$export(module.exports, "getName", () => $aeb7747f4631a3ee$export$7d9f7e9c1c02b41e);
$parcel$export(module.exports, "getAction", () => $aeb7747f4631a3ee$export$6ca3170acb89054);
$parcel$export(module.exports, "getContainers", () => $aeb7747f4631a3ee$export$ae861c5c02c4c14c);

var $6dPbw = parcelRequire("6dPbw");

var $1O6Yz = parcelRequire("1O6Yz");

var $4lYQk = parcelRequire("4lYQk");

var $jvwCK = parcelRequire("jvwCK");
const $aeb7747f4631a3ee$var$extractFromEventContext = (propertyNames, event)=>event.context // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, contextItem)=>{
        propertyNames.forEach((propertyName)=>{
            acc.push(contextItem[propertyName]);
        });
        return acc;
    }, []).filter(Boolean);
const $aeb7747f4631a3ee$var$extractFromEventPayload = (propertyName, event)=>event.payload[propertyName];
const $aeb7747f4631a3ee$var$extractFromPayloadOrContext = (propertyName, event)=>{
    const payloadProp = $aeb7747f4631a3ee$var$extractFromEventPayload(propertyName, event);
    const contextProps = $aeb7747f4631a3ee$var$extractFromEventContext([
        propertyName
    ], event);
    return payloadProp ? contextProps.concat(payloadProp) : contextProps;
};
const $aeb7747f4631a3ee$var$extractPayloadAttributes = (event)=>{
    const { tags: tags, actionSubjectId: actionSubjectId, containerType: containerType, containerId: containerId, objectType: objectType, objectId: objectId, analyticsType: analyticsType, name: name, action: action, ...attributes } = event.payload;
    return attributes;
};
const $aeb7747f4631a3ee$export$4e811121b221213b = (event)=>$aeb7747f4631a3ee$var$extractFromEventContext([
        'component',
        'componentName'
    ], event);
const $aeb7747f4631a3ee$export$d9a2a7d6b7a9497b = (event)=>$aeb7747f4631a3ee$var$extractFromEventContext([
        'actionSubject'
    ], event);
const $aeb7747f4631a3ee$export$5f9bc633b116660f = (event)=>$aeb7747f4631a3ee$var$extractFromEventContext([
        'source'
    ], event);
const $aeb7747f4631a3ee$export$fe94072fee8a6976 = (event)=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    $aeb7747f4631a3ee$var$extractFromEventContext([
        'attributes'
    ], event).reduce((result, extraAttributes)=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(result, extraAttributes), {}), $aeb7747f4631a3ee$var$extractPayloadAttributes(event));
const $aeb7747f4631a3ee$export$af63d7414243dad3 = (event)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const tags = (0, (/*@__PURE__*/$parcel$interopDefault($jvwCK)))($aeb7747f4631a3ee$var$extractFromEventContext([
        'tags'
    ], event) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((result, extraTags)=>result.concat(extraTags), []).concat($aeb7747f4631a3ee$var$extractFromEventPayload('tags', event)).filter(Boolean));
    return tags.length > 0 ? tags : undefined;
};
const $aeb7747f4631a3ee$export$94b487dda8940141 = (event)=>$aeb7747f4631a3ee$var$extractFromPayloadOrContext('containerType', event);
const $aeb7747f4631a3ee$export$9a462447889d734e = (event)=>$aeb7747f4631a3ee$var$extractFromPayloadOrContext('containerId', event);
const $aeb7747f4631a3ee$export$9ed2cbb83cd51da0 = (event)=>$aeb7747f4631a3ee$var$extractFromPayloadOrContext('objectType', event);
const $aeb7747f4631a3ee$export$2e78a279ad2bf08 = (event)=>$aeb7747f4631a3ee$var$extractFromPayloadOrContext('objectId', event);
const $aeb7747f4631a3ee$export$b6f8db3ad0711b02 = (event)=>$aeb7747f4631a3ee$var$extractFromEventPayload('actionSubjectId', event);
const $aeb7747f4631a3ee$export$a3569ac53b82a914 = (event)=>$aeb7747f4631a3ee$var$extractFromEventPayload('analyticsType', event);
const $aeb7747f4631a3ee$export$7d9f7e9c1c02b41e = (event)=>$aeb7747f4631a3ee$var$extractFromEventPayload('name', event);
const $aeb7747f4631a3ee$export$6ca3170acb89054 = (event)=>$aeb7747f4631a3ee$var$extractFromEventPayload('action', event);
const $aeb7747f4631a3ee$export$ae861c5c02c4c14c = (event)=>{
    const contextContainers = $aeb7747f4631a3ee$var$extractFromEventContext([
        'containers'
    ], event);
    const payloadContainers = event.payload.containers;
    const allContainers = (0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    contextContainers.reduce((result, extraContainers)=>(0, (/*@__PURE__*/$parcel$interopDefault($1O6Yz)))(result, extraContainers), {}), payloadContainers);
    const finalContainers = (0, (/*@__PURE__*/$parcel$interopDefault($4lYQk)))(allContainers, (0, (/*@__PURE__*/$parcel$interopDefault($6dPbw))));
    return Object.keys(finalContainers).length > 0 ? finalContainers : undefined;
};

});


parcelRegister("8kKDR", function(module, exports) {
$parcel$export(module.exports, "addSearchSessionAttributes", () => $12c7d3348615f122$export$ee9fabaf3a23e7bf);

var $d7YnM = parcelRequire("d7YnM");

var $9pL9Y = parcelRequire("9pL9Y");

var $hWeHP = parcelRequire("hWeHP");
const $12c7d3348615f122$export$ee9fabaf3a23e7bf = (payload)=>{
    const safePayload = payload || {};
    const sessionAttributes = {
        searchSessionId: 'searchSessionId' in safePayload && safePayload.searchSessionId ? safePayload.searchSessionId : (0, $hWeHP.default)('ajs-search-session-id'),
        searchObjectId: 'searchObjectId' in safePayload && safePayload.searchObjectId ? safePayload.searchObjectId : (0, $hWeHP.default)('ajs-search-object-id'),
        searchContainerId: 'searchContainerId' in safePayload && safePayload.searchContainerId ? safePayload.searchContainerId : (0, $hWeHP.default)('ajs-search-container-id'),
        searchContentType: 'searchContentType' in safePayload && safePayload.searchContentType ? safePayload.searchContentType : (0, $hWeHP.default)('ajs-search-content-type')
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        ...payload,
        ...(0, (/*@__PURE__*/$parcel$interopDefault($9pL9Y)))(sessionAttributes, (0, (/*@__PURE__*/$parcel$interopDefault($d7YnM))))
    };
};

});



parcelRegister("7lk3V", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "default", () => $8cfb5337f1b9e58b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $78ewy = parcelRequire("78ewy");

var $fvNZm = parcelRequire("fvNZm");

var $dCptc = parcelRequire("dCptc");

var $7Q9YQ = parcelRequire("7Q9YQ");

var $hWeHP = parcelRequire("hWeHP");

var $2Mqjh = parcelRequire("2Mqjh");
/**
 * Conditionally renders its children or enriches them with specific configurations for engagement and analytics. This component acts differently based on the execution environment (server vs client) and the availability of user metadata, aiming to seamlessly integrate analytics functionality where applicable.
 */ const $8cfb5337f1b9e58b$var$EngagementProvider = (props)=>{
    if (false) return props.children;
    const environment = (0, $dCptc.toEnvironment)((0, $hWeHP.default)('ajs-environment'));
    const getEnvironmentType = (env)=>{
        if (env === 'prod') return (0, $78ewy.envType).PROD;
        if (env === 'staging') return (0, $78ewy.envType).STAGING;
        return (0, $78ewy.envType).DEV;
    };
    const aaid = (0, $hWeHP.default)('ajs-atlassian-account-id');
    if (aaid === null) return props.children;
    const config = {
        aaid: aaid,
        cloudId: (0, $hWeHP.default)('ajs-cloud-id') || '',
        locale: (0, $hWeHP.default)('ajs-user-locale') || '',
        product: 'jira',
        stargateUrl: '/gateway/api',
        orgId: props.orgId
    };
    const coordinationOptions = {
        envType: getEnvironmentType(environment),
        enableChoreographer: true,
        additionalData: {
            sourceProductId: (0, $7Q9YQ.ProductIds).JIRA
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fvNZm.default), {
        ...props,
        config: config,
        analyticsClientInstance: Promise.resolve((0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>client.getInstance())),
        coordinationOptions: coordinationOptions
    });
};
var $8cfb5337f1b9e58b$export$2e2bcd8739ae039 = $8cfb5337f1b9e58b$var$EngagementProvider;

});

parcelRegister("lDIQ7", function(module, exports) {
$parcel$export(module.exports, "localePropType", () => $0276c7ad8efa4e6a$export$ade363a7f01ce39d);
$parcel$export(module.exports, "defaultLocale", () => (parcelRequire("6uJpm")).defaultLocale);
$parcel$export(module.exports, "supportedLanguagesMap", () => (parcelRequire("6uJpm")).supportedLanguagesMap);
$parcel$export(module.exports, "getLocale", () => (parcelRequire("dO9h7")).getLocale);
$parcel$export(module.exports, "formatTimezonedWithLocale", () => (parcelRequire("dO9h7")).formatTimezonedWithLocale);
$parcel$export(module.exports, "floatDifferenceOfDates", () => (parcelRequire("dO9h7")).floatDifferenceOfDates);
$parcel$export(module.exports, "formatWithLocale", () => (parcelRequire("dO9h7")).formatWithLocale);
$parcel$export(module.exports, "formatDistanceWithLocale", () => (parcelRequire("dO9h7")).formatDistanceWithLocale);
$parcel$export(module.exports, "formatRelativeWithLocale", () => (parcelRequire("dO9h7")).formatRelativeWithLocale);
$parcel$export(module.exports, "formatDistanceStrictWithLocale", () => (parcelRequire("dO9h7")).formatDistanceStrictWithLocale);
$parcel$export(module.exports, "weekStartDayWithLocale", () => (parcelRequire("dO9h7")).weekStartDayWithLocale);
$parcel$export(module.exports, "formatZonedDateTimeWithZone", () => (parcelRequire("dO9h7")).formatZonedDateTimeWithZone);
$parcel$export(module.exports, "parseZoneDateTime", () => (parcelRequire("dO9h7")).parseZoneDateTime);
$parcel$export(module.exports, "setTimezoneOffset", () => (parcelRequire("dO9h7")).setTimezoneOffset);
$parcel$export(module.exports, "setNumberOffsetToISODate", () => (parcelRequire("dO9h7")).setNumberOffsetToISODate);
$parcel$export(module.exports, "formatDateStringToISO", () => (parcelRequire("dO9h7")).formatDateStringToISO);
$parcel$export(module.exports, "isValidTimeZone", () => (parcelRequire("dO9h7")).isValidTimeZone);
// eslint-disable-next-line jira/restricted/prop-types

var $cT3Ey = parcelRequire("cT3Ey");

var $4uPfU = parcelRequire("4uPfU");

var $6uJpm = parcelRequire("6uJpm");

var $dO9h7 = parcelRequire("dO9h7");
const $0276c7ad8efa4e6a$export$ade363a7f01ce39d = (0, (/*@__PURE__*/$parcel$interopDefault($cT3Ey))).oneOf(Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($4uPfU)))));

});
parcelRegister("4uPfU", function(module, exports) {
module.exports = JSON.parse("{\"cs_CZ\":\"cs-CZ\",\"cs\":\"cs-CZ\",\"da_DK\":\"da-DK\",\"da\":\"da-DK\",\"de_DE\":\"de-DE\",\"de\":\"de-DE\",\"en_GB\":\"en-GB\",\"en-GB\":\"en-GB\",\"en_UK\":\"en-US\",\"en-UK\":\"en-US\",\"enUS\":\"enUS\",\"en_US\":\"en-US\",\"en-US\":\"en-US\",\"es-ES\":\"es-ES\",\"es\":\"es-ES\",\"et_EE\":\"et-EE\",\"et\":\"et-EE\",\"fi_FI\":\"fi-FI\",\"fi\":\"fi-FI\",\"fr_FR\":\"fr-FR\",\"fr\":\"fr-FR\",\"hu_HU\":\"hu-HU\",\"hu\":\"hu-HU\",\"is_IS\":\"is-IS\",\"is\":\"is-IS\",\"it_IT\":\"it-IT\",\"it\":\"it-IT\",\"ja_JP\":\"ja-JP\",\"ja\":\"ja-JP\",\"ko_KR\":\"ko-KR\",\"ko\":\"ko-KR\",\"nb_NO\":\"nb-NO\",\"nb\":\"nb-NO\",\"nl_NL\":\"nl-NL\",\"nl\":\"nl-NL\",\"pl_PL\":\"pl-PL\",\"pl\":\"pl-PL\",\"pt_BR\":\"pt-BR\",\"pt-BR\":\"pt-BR\",\"pt_PT\":\"pt-PT\",\"pt\":\"pt-PT\",\"ro_RO\":\"ro-RO\",\"ro\":\"ro-RO\",\"ru_RU\":\"ru-RU\",\"ru\":\"ru-RU\",\"sk_SK\":\"sk-SK\",\"sk\":\"sk-SK\",\"sv_SE\":\"sv-SE\",\"sv\":\"sv-SE\",\"tr\":\"tr-TR\",\"tr_TR\":\"tr-TR\",\"tr-TR\":\"tr-TR\",\"zh_CN\":\"zh-CN\",\"zh-CN\":\"zh-CN\",\"zh_TW\":\"zh-TW\",\"zh-TW\":\"zh-TW\"}");

});

parcelRegister("6uJpm", function(module, exports) {
$parcel$export(module.exports, "defaultLocale", () => $d09059f56c5a579b$export$d7f512c98c859244);
$parcel$export(module.exports, "supportedLanguagesMap", () => $d09059f56c5a579b$export$ff4f0d1b20f0caad);
const $d09059f56c5a579b$export$d7f512c98c859244 = 'enUS';
const $d09059f56c5a579b$var$arabicLocale = 'arDZ';
const $d09059f56c5a579b$export$ff4f0d1b20f0caad = {
    ar: $d09059f56c5a579b$var$arabicLocale,
    ar_DZ: $d09059f56c5a579b$var$arabicLocale,
    ar_MA: $d09059f56c5a579b$var$arabicLocale,
    ar_SA: $d09059f56c5a579b$var$arabicLocale,
    cs_CZ: 'cs',
    cs: 'cs',
    da_DK: 'da',
    da: 'da',
    de_DE: 'de',
    de: 'de',
    en_GB: 'enGB',
    'en-GB': 'enGB',
    en_UK: $d09059f56c5a579b$export$d7f512c98c859244,
    'en-UK': $d09059f56c5a579b$export$d7f512c98c859244,
    en_US: $d09059f56c5a579b$export$d7f512c98c859244,
    'en-US': $d09059f56c5a579b$export$d7f512c98c859244,
    en_AU: 'enAU',
    es_ES: 'es',
    es: 'es',
    et_EE: 'et',
    et: 'et',
    fi_FI: 'fi',
    fi: 'fi',
    fr_FR: 'fr',
    fr: 'fr',
    hu_HU: 'hu',
    hu: 'hu',
    is_IS: 'is',
    is: 'is',
    it_IT: 'it',
    it: 'it',
    ja_JP: 'ja',
    ja: 'ja',
    ko_KR: 'ko',
    ko: 'ko',
    nb_NO: 'nb',
    nb: 'nb',
    nl_NL: 'nl',
    nl: 'nl',
    pl_PL: 'pl',
    pl: 'pl',
    pt_BR: 'ptBR',
    'pt-BR': 'ptBR',
    pt_PT: 'pt',
    pt: 'pt',
    ro_RO: 'ro',
    ro: 'ro',
    ru_RU: 'ru',
    ru: 'ru',
    sk_SK: 'sk',
    sk: 'sk',
    sv_SE: 'sv',
    sv: 'sv',
    tr: 'tr',
    tr_TR: 'tr',
    zh_CN: 'zhCN',
    'zh-CN': 'zhCN',
    zh_TW: 'zhTW',
    'zh-TW': 'zhTW'
};

});

parcelRegister("dO9h7", function(module, exports) {
$parcel$export(module.exports, "getLocale", () => $b2e9153dd128b1bb$export$180605366c04f0cd);
$parcel$export(module.exports, "parseISODate", () => $b2e9153dd128b1bb$export$ee8e61141c87635a);
$parcel$export(module.exports, "isValidTimeZone", () => $b2e9153dd128b1bb$export$c793e14020d7c7b);
$parcel$export(module.exports, "formatWithLocale", () => $b2e9153dd128b1bb$export$fb3485f471c77284);
$parcel$export(module.exports, "formatTimezonedWithLocale", () => $b2e9153dd128b1bb$export$4383dd42a084ef32);
$parcel$export(module.exports, "formatDistanceWithLocale", () => $b2e9153dd128b1bb$export$c2180807b950d3da);
$parcel$export(module.exports, "formatRelativeWithLocale", () => $b2e9153dd128b1bb$export$12b50b1737ea07fc);
$parcel$export(module.exports, "formatDistanceStrictWithLocale", () => $b2e9153dd128b1bb$export$7a7656c130da0e93);
$parcel$export(module.exports, "weekStartDayWithLocale", () => $b2e9153dd128b1bb$export$d2c1381944cd40d9);
$parcel$export(module.exports, "parseZoneDateTime", () => $b2e9153dd128b1bb$export$736ce978ed45f974);
$parcel$export(module.exports, "setTimezoneOffset", () => $b2e9153dd128b1bb$export$11ef0295ba6f3d21);
$parcel$export(module.exports, "setNumberOffsetToISODate", () => $b2e9153dd128b1bb$export$fe2193e77e11d739);
$parcel$export(module.exports, "formatZonedDateTimeWithZone", () => $b2e9153dd128b1bb$export$dd52464bfc436f72);
$parcel$export(module.exports, "formatDateStringToISO", () => $b2e9153dd128b1bb$export$108dbdcbc1363368);
$parcel$export(module.exports, "floatDifferenceOfDates", () => $b2e9153dd128b1bb$export$8b999908ff0a4991);

var $2ruWJ = parcelRequire("2ruWJ");
var $hmO6M = parcelRequire("hmO6M");
var $e8XBu = parcelRequire("e8XBu");
var $57raR = parcelRequire("57raR");
var $2QHI9 = parcelRequire("2QHI9");
var $5fuQp = parcelRequire("5fuQp");
var $9rAv2 = parcelRequire("9rAv2");
var $aCFqL = parcelRequire("aCFqL");
var $kNfXW = parcelRequire("kNfXW");
var $hu795 = parcelRequire("hu795");
var $dBLX0 = parcelRequire("dBLX0");
var $cT05m = parcelRequire("cT05m");
var $kQ82p = parcelRequire("kQ82p");
var $5IPrF = parcelRequire("5IPrF");

var $hT96M = parcelRequire("hT96M");
var $6pRIG = parcelRequire("6pRIG");

var $109Mp = parcelRequire("109Mp");
var $7acw5 = parcelRequire("7acw5");
var $8jd9J = parcelRequire("8jd9J");
var $lFy5x = parcelRequire("lFy5x");
var $8cBti = parcelRequire("8cBti");
var $8JLm6 = parcelRequire("8JLm6");
var $agyKL = parcelRequire("agyKL");
var $gqB2k = parcelRequire("gqB2k");
var $01taM = parcelRequire("01taM");
var $7eJKK = parcelRequire("7eJKK");
var $2Fw99 = parcelRequire("2Fw99");
var $eeShq = parcelRequire("eeShq");
var $6e6Ha = parcelRequire("6e6Ha");
var $6609g = parcelRequire("6609g");
var $akAFq = parcelRequire("akAFq");
var $gFFcU = parcelRequire("gFFcU");
var $9VIdj = parcelRequire("9VIdj");
var $bmEYw = parcelRequire("bmEYw");
var $9yEMq = parcelRequire("9yEMq");
var $2juPt = parcelRequire("2juPt");
var $gYYzt = parcelRequire("gYYzt");
var $fA5Lp = parcelRequire("fA5Lp");
var $bZFHe = parcelRequire("bZFHe");
var $cmLAh = parcelRequire("cmLAh");
var $gjhJ4 = parcelRequire("gjhJ4");
var $1Sotl = parcelRequire("1Sotl");
var $iL2gc = parcelRequire("iL2gc");
var $8ZUjr = parcelRequire("8ZUjr");

var $6uJpm = parcelRequire("6uJpm");
const $b2e9153dd128b1bb$var$locales = {
    arDZ: $109Mp.default,
    cs: $7acw5.default,
    cs_CZ: (0, $7acw5.default),
    da: $8jd9J.default,
    da_DK: (0, $8jd9J.default),
    de: $lFy5x.default,
    de_DE: (0, $lFy5x.default),
    enUS: $agyKL.default,
    en_US: (0, $agyKL.default),
    'en-US': (0, $agyKL.default),
    enGB: $8JLm6.default,
    en_UK: (0, $8JLm6.default),
    'en-UK': (0, $8JLm6.default),
    'en-GB': (0, $8JLm6.default),
    en_GB: (0, $8JLm6.default),
    enAU: $8cBti.default,
    es: $gqB2k.default,
    es_ES: (0, $gqB2k.default),
    et: $01taM.default,
    et_EE: (0, $01taM.default),
    fi: $7eJKK.default,
    fi_FI: (0, $7eJKK.default),
    fr: $2Fw99.default,
    fr_FR: (0, $2Fw99.default),
    hu: $eeShq.default,
    hu_HU: (0, $eeShq.default),
    is: $6e6Ha.default,
    is_IS: (0, $6e6Ha.default),
    it: $6609g.default,
    it_IT: (0, $6609g.default),
    ja: $akAFq.default,
    ja_JP: (0, $akAFq.default),
    ko: $gFFcU.default,
    ko_KR: (0, $gFFcU.default),
    nb: $9VIdj.default,
    nb_NO: (0, $9VIdj.default),
    nl: $bmEYw.default,
    nl_NL: (0, $bmEYw.default),
    pl: $9yEMq.default,
    pl_PL: (0, $9yEMq.default),
    pt: $2juPt.default,
    'pt-PT': (0, $2juPt.default),
    pt_PT: (0, $2juPt.default),
    ptBR: $gYYzt.default,
    'pt-BR': (0, $gYYzt.default),
    pt_BR: (0, $gYYzt.default),
    ro: $fA5Lp.default,
    ro_RO: (0, $fA5Lp.default),
    ru: $bZFHe.default,
    ru_RU: (0, $bZFHe.default),
    sk: $cmLAh.default,
    sk_SK: (0, $cmLAh.default),
    sv: $gjhJ4.default,
    sv_SE: (0, $gjhJ4.default),
    tr: $1Sotl.default,
    'tr-TR': (0, $1Sotl.default),
    tr_TR: (0, $1Sotl.default),
    zhCN: $iL2gc.default,
    'zh-CN': (0, $iL2gc.default),
    zh_CN: (0, $iL2gc.default),
    zhTW: $8ZUjr.default,
    'zh-TW': (0, $8ZUjr.default),
    zh_TW: (0, $8ZUjr.default)
};
const $b2e9153dd128b1bb$var$nonUTCFullZoneRegExp = new RegExp(/:\d\d(\.\d+)?[-,+]\d\d:\d\d$/);
const $b2e9153dd128b1bb$var$negativeZoneRegExp = new RegExp(/:\d\d(\.\d+)?-/);
const $b2e9153dd128b1bb$var$milliseconds\u0421oefficients = {
    seconds: 1000,
    minutes: 60000,
    // 1000 * 60
    hours: 3600000,
    // 1000 * 60 * 60
    days: 86400000,
    // 1000 * 60 * 60 * 24
    weeks: 604800000
};
const $b2e9153dd128b1bb$export$180605366c04f0cd = (locale)=>{
    const dateFnsLocale = (0, $6uJpm.supportedLanguagesMap)[locale] || (0, $6uJpm.defaultLocale);
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly arDZ: Locale; readonly cs: Locale; readonly cs_CZ: Locale; readonly da: Locale; readonly da_DK: Locale; readonly de: Locale; ... 56 more ...; readonly zh_TW: Locale; }'.
    return $b2e9153dd128b1bb$var$locales[dateFnsLocale];
};
const $b2e9153dd128b1bb$export$ee8e61141c87635a = (dateString)=>{
    const parsedDate = (0, $kQ82p.default)(dateString);
    return (0, $dBLX0.default)(parsedDate) ? new Date(dateString) : undefined;
};
const $b2e9153dd128b1bb$export$c793e14020d7c7b = (tz)=>{
    try {
        Intl.DateTimeFormat(undefined, {
            timeZone: tz
        });
        return true;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ex) {
        return false;
    }
};
const $b2e9153dd128b1bb$export$fb3485f471c77284 = (date, formatStyle, locale)=>(0, $57raR.default)(date, formatStyle, {
        locale: $b2e9153dd128b1bb$export$180605366c04f0cd(locale)
    });
const $b2e9153dd128b1bb$export$4383dd42a084ef32 = (date, formatStyle, locale, timeZone)=>$b2e9153dd128b1bb$export$c793e14020d7c7b(timeZone) ? (0, $hT96M.default)((0, $6pRIG.default)(date, timeZone), formatStyle, {
        locale: $b2e9153dd128b1bb$export$180605366c04f0cd(locale),
        timeZone: timeZone
    }) : (0, $hT96M.default)((0, $6pRIG.default)(date, 'utc'), formatStyle, {
        locale: $b2e9153dd128b1bb$export$180605366c04f0cd(locale),
        timeZone: 'utc'
    });
const $b2e9153dd128b1bb$export$c2180807b950d3da = (date, baseDate, locale, addSuffix = false)=>(0, $2QHI9.default)(date, baseDate, {
        locale: $b2e9153dd128b1bb$export$180605366c04f0cd(locale),
        addSuffix: addSuffix
    });
const $b2e9153dd128b1bb$export$12b50b1737ea07fc = (date, baseDate, locale)=>(0, $9rAv2.default)(date, baseDate, {
        locale: $b2e9153dd128b1bb$export$180605366c04f0cd(locale)
    });
const $b2e9153dd128b1bb$export$7a7656c130da0e93 = (date, baseDate, locale, addSuffix = false)=>(0, $5fuQp.default)(date, baseDate, {
        locale: $b2e9153dd128b1bb$export$180605366c04f0cd(locale),
        addSuffix: addSuffix
    });
const $b2e9153dd128b1bb$export$d2c1381944cd40d9 = (date, locale)=>(0, $5IPrF.default)(date, {
        locale: $b2e9153dd128b1bb$export$180605366c04f0cd(locale)
    });
const $b2e9153dd128b1bb$export$736ce978ed45f974 = (parsingDate)=>{
    const date = typeof parsingDate === 'string' ? parsingDate : new Date().toISOString();
    const indxs = {
        positiveZoneStartIndex: date.indexOf('+'),
        negativeZoneStartIndex: $b2e9153dd128b1bb$var$negativeZoneRegExp.test(date) ? date.lastIndexOf('-') : -1,
        utcZoneStartIndex: date.indexOf('Z')
    };
    const zoneStartIndex = Object.values(indxs).find((el)=>typeof el === 'number' && el > -1);
    const parsedDate = typeof zoneStartIndex === 'number' ? date.substring(0, zoneStartIndex) : date;
    let zone = '';
    if (typeof zoneStartIndex === 'number') zone = $b2e9153dd128b1bb$var$nonUTCFullZoneRegExp.test(date) ? date.substring(zoneStartIndex, zoneStartIndex + 6) : `${date.substring(zoneStartIndex, zoneStartIndex + 3)}:00`;
    return {
        date: (0, $kQ82p.default)(parsedDate),
        zone: indxs.utcZoneStartIndex > -1 ? '+00:00' : zone
    };
};
const $b2e9153dd128b1bb$var$calcOffset = (zone)=>Number.parseInt(zone, 10) * 60 + Number.parseInt(`${zone.substring(0, 1)}${zone.substring(4)}`, 10);
const $b2e9153dd128b1bb$export$11ef0295ba6f3d21 = (date, offsetSource)=>{
    const dateOffset = date.getTimezoneOffset();
    const offset = $b2e9153dd128b1bb$var$calcOffset($b2e9153dd128b1bb$export$736ce978ed45f974(offsetSource).zone);
    return (0, $2ruWJ.default)(date, offset + dateOffset); // plus because getTimezoneOffset returns difference in minutes (e.g. +3:00 => -180)
};
const $b2e9153dd128b1bb$export$fe2193e77e11d739 = (date, offsetHoursNumber)=>{
    const parsedDate = $b2e9153dd128b1bb$export$736ce978ed45f974(date);
    const originalOffset = $b2e9153dd128b1bb$var$calcOffset(parsedDate.zone);
    const calculatedDateTime = (0, $2ruWJ.default)(parsedDate.date, offsetHoursNumber * 60 - originalOffset);
    return calculatedDateTime;
};
const $b2e9153dd128b1bb$export$dd52464bfc436f72 = (date, formatString, zone)=>{
    let res = '';
    const formatedString = (0, $57raR.default)(date, formatString);
    const indxs = {
        positiveZoneStartIndex: formatedString.indexOf('+'),
        negativeZoneStartIndex: $b2e9153dd128b1bb$var$negativeZoneRegExp.test(formatedString) ? formatedString.lastIndexOf('-') : -1,
        utcZoneStartIndex: formatedString.indexOf('Z')
    };
    const zoneStartIndex = Object.values(indxs).find((el)=>typeof el === 'number' && el > -1);
    if (typeof zoneStartIndex === 'number') res = `${formatedString.substring(0, zoneStartIndex)}${zone}`; // e.g. 2021-12-12T12:00:00+13:00
    return res;
};
const $b2e9153dd128b1bb$export$108dbdcbc1363368 = (date, formatString = 'yyyy-MM-dd')=>{
    const defaultReturnValue = '';
    if (date == null || date === '') return defaultReturnValue;
    const parsedDate = (0, $cT05m.default)(date, formatString, new Date(0, 0, 0, 0, 0, 0));
    if (!(0, $dBLX0.default)(parsedDate)) return defaultReturnValue;
    return parsedDate.toISOString(); // formatISO can have issues with timezones: https://github.com/date-fns/date-fns/issues/2151 (
};
// this is copy of diff functions from moment.js
// @ts-expect-error - TS7023 - 'monthDiff' implicitly has return type 'any' because it does not have a return type annotation and is referenced directly or indirectly in one of its return expressions.
const $b2e9153dd128b1bb$var$monthDiff = (a, b)=>{
    if ((0, $aCFqL.default)(a) < (0, $aCFqL.default)(b)) // end-of-month calculations work correct when the start month has more
    // days than the end month.
    return -$b2e9153dd128b1bb$var$monthDiff(b, a);
    // difference in months
    const wholeMonthDiff = ((0, $hu795.default)(b) - (0, $hu795.default)(a)) * 12 + ((0, $kNfXW.default)(b) - (0, $kNfXW.default)(a));
    // b is in (anchor - 1 month, anchor + 1 month)
    const anchor = (0, $hmO6M.default)(a, wholeMonthDiff);
    let anchor2;
    let adjust;
    // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
    if (b - anchor < 0) {
        anchor2 = (0, $hmO6M.default)(a, wholeMonthDiff - 1);
        // linear across the month
        // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
        adjust = (b - anchor) / (anchor - anchor2);
    } else {
        anchor2 = (0, $hmO6M.default)(a, wholeMonthDiff + 1);
        // linear across the month
        // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
        adjust = (b - anchor) / (anchor2 - anchor);
    }
    // check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
};
const $b2e9153dd128b1bb$export$8b999908ff0a4991 = (endDate, startDate, measurement)=>{
    const zoneDelta = startDate.getTimezoneOffset() * -60000 - endDate.getTimezoneOffset() * -60000; // copied from moment
    switch(measurement){
        case 'years':
            return $b2e9153dd128b1bb$var$monthDiff(endDate, startDate) / 12;
        case 'quarters':
            return $b2e9153dd128b1bb$var$monthDiff(endDate, startDate) / 3;
        case 'months':
            return $b2e9153dd128b1bb$var$monthDiff(endDate, startDate);
        case 'weeks':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate - zoneDelta) / $b2e9153dd128b1bb$var$milliseconds\u0421oefficients.weeks;
        // negate dst
        case 'days':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate - zoneDelta) / $b2e9153dd128b1bb$var$milliseconds\u0421oefficients.days;
        // negate dst
        case 'hours':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate) / $b2e9153dd128b1bb$var$milliseconds\u0421oefficients.hours;
        case 'minutes':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate) / $b2e9153dd128b1bb$var$milliseconds\u0421oefficients.minutes;
        case 'seconds':
            // @ts-expect-error - TS2362 - The left-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type. | TS2363 - The right-hand side of an arithmetic operation must be of type 'any', 'number', 'bigint' or an enum type.
            return (endDate - startDate) / $b2e9153dd128b1bb$var$milliseconds\u0421oefficients.seconds;
        default:
            return (0, $e8XBu.default)(endDate, startDate);
    }
};

});



parcelRegister("7iHUq", function(module, exports) {
$parcel$export(module.exports, "default", () => $74ae8959ca8e874b$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $5vQ2T = parcelRequire("5vQ2T");

var $gnQAk = parcelRequire("gnQAk");
/**
 * A boundary around an "app," where an app is a distinct piece of functionality, and could potentially be nested within another app.
 *
 * Wraps children in an error boundary (by default) and a redux store provider (if store is passed).
 */ function $74ae8959ca8e874b$var$AppBaseFC({ id: // FIXME: id should be required
id = '@atlassian/jira-app-base::unknown-app', packageName: // FIXME: packageName should be required
packageName = '@atlassian/jira-app-base', teamName: teamName, hasErrorBoundary: hasErrorBoundary = true, fallback: // JSErrorBoundary fallback default is 'page' but AppBase is used around any "app"
fallback = 'flag', store: store, children: children }) {
    let contents = children;
    if (store) contents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $gnQAk.Provider), {
        store: store
    }, contents);
    if (hasErrorBoundary) contents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $5vQ2T.JSErrorBoundary), {
        id: id,
        teamName: teamName,
        fallback: fallback,
        packageName: packageName
    }, contents);
    return contents;
}
var $74ae8959ca8e874b$export$2e2bcd8739ae039 = $74ae8959ca8e874b$var$AppBaseFC;

});
parcelRegister("5vQ2T", function(module, exports) {
$parcel$export(module.exports, "JSErrorBoundary", () => $b859bc84149c97d3$export$1e964c961b2b98bf);

var $6pJMC = parcelRequire("6pJMC");
const $b859bc84149c97d3$export$1e964c961b2b98bf = (0, $6pJMC.JSErrorBoundary);

});
parcelRegister("6pJMC", function(module, exports) {
$parcel$export(module.exports, "JSErrorBoundary", () => $512cc9a26f232cc2$export$1e964c961b2b98bf);

var $eJOHy = parcelRequire("eJOHy");

var $fGnU6 = parcelRequire("fGnU6");

var $eiDhP = parcelRequire("eiDhP");

var $1qbKn = parcelRequire("1qbKn");

var $h47gY = parcelRequire("h47gY");
const $512cc9a26f232cc2$var$ErrorPage = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eiDhP.JSErrorPageAsync), {
        error: error
    });
const $512cc9a26f232cc2$var$Empty = ()=>null;
const $512cc9a26f232cc2$var$getFallback = (fallback, ErrorFlag)=>{
    switch(fallback){
        case 'page':
            return $512cc9a26f232cc2$var$ErrorPage;
        case 'flag':
            return ErrorFlag;
        case 'unmount':
            return $512cc9a26f232cc2$var$Empty;
        default:
            return fallback;
    }
};
const $512cc9a26f232cc2$var$DEFAULT_EXTRA_EVENT_DATA = {};
const $512cc9a26f232cc2$export$1e964c961b2b98bf = ({ id: id, packageName: packageName, teamName: teamName, fallback: fallback = 'page', children: children, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk, onError: onError, extraEventData: extraEventData = $512cc9a26f232cc2$var$DEFAULT_EXTRA_EVENT_DATA, ...rest })=>{
    const ErrorFlag = (0, $eJOHy.useCallback)(({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $1qbKn.ErrorFlagRenderer), {
            id: id,
            error: error
        }), [
        id
    ]);
    const onErrorRef = (0, $eJOHy.useRef)(onError);
    onErrorRef.current = onError;
    const onErrorHandler = (0, $eJOHy.useCallback)((location, error, errorAttributes)=>{
        onErrorRef.current?.(location, error, errorAttributes);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        render: $512cc9a26f232cc2$var$getFallback(fallback, ErrorFlag),
        onError: onErrorHandler,
        extraEventData: extraEventData,
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fGnU6.ReportErrors), {
        id: id,
        packageName: packageName,
        teamName: teamName,
        attributes: attributes,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    }, children));
};

});
parcelRegister("fGnU6", function(module, exports) {
$parcel$export(module.exports, "ReportErrors", () => $9ea8142eba85a5c3$export$ffd17f83e27b9460);

var $eJOHy = parcelRequire("eJOHy");

var $9pTd3 = parcelRequire("9pTd3");

var $7aoMz = parcelRequire("7aoMz");

var $ftN6c = parcelRequire("ftN6c");

var $bJscI = parcelRequire("bJscI");

var $4cTDP = parcelRequire("4cTDP");
const $9ea8142eba85a5c3$export$7549babf6b1dfb78 = (labelStack)=>{
    const view = labelStack?.find((label)=>(0, $9pTd3.VIEW_WHITELIST).has(label.name));
    return view?.name;
};
class $9ea8142eba85a5c3$var$CatchAndReportErrors extends (0, $eJOHy.Component) {
    componentDidCatch(error, errorInfo) {
        const { packageName: packageName, teamName: teamName, id: id, attributes: attributes, createAnalyticsEvent: createAnalyticsEvent, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk, ufoLabelStack: ufoLabelStack } = this.props;
        const analyticsEvent = createAnalyticsEvent({
            action: 'failed'
        });
        (0, $9pTd3.fireErrorAnalytics)({
            event: analyticsEvent,
            errorInfo: errorInfo,
            error: error,
            meta: {
                id: id,
                packageName: packageName,
                teamName: teamName
            },
            attributes: typeof attributes === 'function' ? attributes(error) : attributes,
            sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk,
            view: (0, $4cTDP.fg)('jira-report-unhandled-errors-by-view') ? $9ea8142eba85a5c3$export$7549babf6b1dfb78(ufoLabelStack) : undefined
        });
        throw error;
    }
    render() {
        return this.props.children;
    }
}
const $9ea8142eba85a5c3$var$ReportErrorsWithAnalytics = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $ftN6c.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9ea8142eba85a5c3$var$CatchAndReportErrors, {
        ...props,
        createAnalyticsEvent: createAnalyticsEvent
    });
};
// When cleaning up jira-report-unhandled-errors-by-view combine into 1 wrapper for CatchAndReportErrors rather than 2
const $9ea8142eba85a5c3$var$ReportErrorsWithUFOContext = (props)=>{
    const interactionContext = (0, $7aoMz.useInteractionContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9ea8142eba85a5c3$var$ReportErrorsWithAnalytics, {
        ...props,
        ufoLabelStack: interactionContext?.labelStack
    });
};
const $9ea8142eba85a5c3$export$ffd17f83e27b9460 = (0, $bJscI.componentWithFG)('jira-report-unhandled-errors-by-view', $9ea8142eba85a5c3$var$ReportErrorsWithUFOContext, $9ea8142eba85a5c3$var$ReportErrorsWithAnalytics);

});
parcelRegister("bJscI", function(module, exports) {
$parcel$export(module.exports, "componentWithFG", () => $a04dd2857591b12a$export$cf56d0f54cfcce4);

var $f2JN3 = parcelRequire("f2JN3");

var $4cTDP = parcelRequire("4cTDP");
const $a04dd2857591b12a$export$cf56d0f54cfcce4 = (gateName, ComponentTrue, ComponentFalse)=>(0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)(gateName), ComponentTrue, ComponentFalse);

});
parcelRegister("f2JN3", function(module, exports) {
$parcel$export(module.exports, "componentWithCondition", () => $95df13e2d486a532$export$6e8ea24b15199873);

var $eJOHy = parcelRequire("eJOHy");
function $95df13e2d486a532$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $eJOHy.forwardRef)((props, ref)=>condition() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ComponentTrue, {
            ...props,
            ref: ref
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return ComponentWithCondition;
}

});



parcelRegister("eiDhP", function(module, exports) {
$parcel$export(module.exports, "JSErrorPageAsync", () => $59144feb0ed33ee3$export$f5794426a1f1dedd);

var $eJOHy = parcelRequire("eJOHy");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $59144feb0ed33ee3$var$LazyJSErrorPage = (0, $bQWwW.lazy)(()=>(parcelRequire("fM7ce")).then((module)=>module.JSErrorPage), {
    moduleId: "./src/packages/platform/js-error-page/src/JSErrorPage.tsx"
});
const $59144feb0ed33ee3$export$f5794426a1f1dedd = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-js-error-page",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($59144feb0ed33ee3$var$LazyJSErrorPage, props));

});
parcelRegister("2imLM", function(module, exports) {
$parcel$export(module.exports, "default", () => $a10e7c825d702ff8$export$2e2bcd8739ae039);
$parcel$export(module.exports, "PlaceholderWithNativeSuspense", () => $a10e7c825d702ff8$export$64cdcd2c25694f20);
$parcel$export(module.exports, "PlaceholderNew", () => $a10e7c825d702ff8$export$c6bea9996b2be30e);
$parcel$export(module.exports, "SuspenseMigrationPlaceholder", () => $a10e7c825d702ff8$export$9884347fb8890448);

var $eJOHy = parcelRequire("eJOHy");

var $hEhKB = parcelRequire("hEhKB");

var $7aoMz = parcelRequire("7aoMz");

var $4cTDP = parcelRequire("4cTDP");

var $hhgtU = parcelRequire("hhgtU");

var $eSXqs = parcelRequire("eSXqs");
var $iETA0 = parcelRequire("iETA0");

var $f2JN3 = parcelRequire("f2JN3");

var $9RE4U = parcelRequire("9RE4U");

var $7zyWi = parcelRequire("7zyWi");
function $a10e7c825d702ff8$var$Hold({ name: name }) {
    const interactionContext = (0, $eJOHy.useContext)((0, $7aoMz.default));
    const waitContext = (0, $eJOHy.useContext)((0, $iETA0.WaitContext));
    const nameWithUnderscores = (0, $4cTDP.fg)('jfp_fix_placeholder_name') ? name?.replaceAll('/', '_') : name;
    // Runs synchronously, to allow us to identify async items
    (0, $hhgtU.default)(()=>{
        // if until context exists means there is a LazyWait parent component
        // we use that value
        const shouldHold = waitContext ? !!waitContext.currentValue() : true;
        if (interactionContext != null && shouldHold) return interactionContext.hold(nameWithUnderscores);
    }, [
        interactionContext,
        nameWithUnderscores,
        waitContext
    ]);
    return null;
}
/**
 * This is a "safe-to-use" Placeholder but it's actually expected to be used only around React-Loosely-Lazy components.
 * WARNING: Make sure we use same placeholders in a rendering tree.
 * Mixed use may cause unexpected behavior, such as rendering child component twice.
 * Ref: https://hello.atlassian.net/wiki/x/iJpOHwE
 */ function $a10e7c825d702ff8$var$RLLPlaceholder({ name: name, children: children, fallback: fallback }) {
    // react-18: can use fallback directly
    const fb = fallback != null ? fallback : null;
    // react-18: can use children directly
    const kids = children != null ? children : null;
    const OwnershipMarker = (0, $hEhKB.useOwnershipMarkerComponent)({
        markerType: 'placeholder',
        name: name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(OwnershipMarker, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eSXqs.LazySuspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, fb, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a10e7c825d702ff8$var$Hold, {
            name: name
        })),
        name: name
    }, kids));
}
const $a10e7c825d702ff8$var$Placeholder = (0, $f2JN3.componentWithCondition)(// this condition is coupled with hydration rollout, not the fact of hydration
// SuspensePlaceholder can be used for non-hydrating pages as well, if no "SSR content preservation" is required
// See PlaceholderWithNativeSuspense
()=>(0, $9RE4U.useIsHydrateRenderMode)(), (0, $7zyWi.SuspensePlaceholder), $a10e7c825d702ff8$var$RLLPlaceholder);
var $a10e7c825d702ff8$export$2e2bcd8739ae039 = $a10e7c825d702ff8$var$Placeholder;
const $a10e7c825d702ff8$export$64cdcd2c25694f20 = (0, $7zyWi.SuspensePlaceholder);
const $a10e7c825d702ff8$export$c6bea9996b2be30e = (0, $f2JN3.componentWithCondition)(()=>(0, $4cTDP.fg)('concurrent-native-suspense'), $a10e7c825d702ff8$export$64cdcd2c25694f20, $a10e7c825d702ff8$var$Placeholder);
function $a10e7c825d702ff8$export$9884347fb8890448({ condition: condition, fallback: fallback, name: name, children: children }) {
    if (condition) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($a10e7c825d702ff8$export$64cdcd2c25694f20, {
        fallback: fallback,
        name: name
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
        fallback: fallback
    }, children);
}

});
parcelRegister("hhgtU", function(module, exports) {
$parcel$export(module.exports, "default", () => $da8ae9e081e62827$export$2e2bcd8739ae039);
// code-reaper-ignore-file -- Uses `useLayoutEffect` in the browser and `useEffect` in the server.

var $eJOHy = parcelRequire("eJOHy");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$da8ae9e081e62827$export$2e2bcd8739ae039 = (0, $eJOHy.useLayoutEffect);

});

parcelRegister("9RE4U", function(module, exports) {
$parcel$export(module.exports, "useIsHydrateRenderMode", () => $6995051841b0d037$export$50c1edaaed881ec4);
$parcel$export(module.exports, "useSsrPlaceholders", () => $6995051841b0d037$export$5b86f8a52685e7a6);
$parcel$export(module.exports, "setIsHydrationRenderMode", () => $6995051841b0d037$export$1005a4e5bbaa775b);
$parcel$export(module.exports, "reportHydrationEnd", () => $6995051841b0d037$export$365316c4efc7213);
$parcel$export(module.exports, "getIsHydrationInProgress", () => $6995051841b0d037$export$aaae7fa8de9c1841);
$parcel$export(module.exports, "useIsGlobalHydrationComplete", () => $6995051841b0d037$export$2f0a8b29a48aa524);
$parcel$export(module.exports, "useGlobalHydrationActions", () => $6995051841b0d037$export$a92d0836dfe80799);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iJq0l = parcelRequire("iJq0l");
var $GtRbT = parcelRequire("GtRbT");

var $SvJbY = parcelRequire("SvJbY");

var $6XSXq = parcelRequire("6XSXq");

var $4cTDP = parcelRequire("4cTDP");
const $6995051841b0d037$var$DEFAULT_STATE = {
    renderMode: 'createRoot'
};
let $6995051841b0d037$var$state = Object.freeze($6995051841b0d037$var$DEFAULT_STATE);
const $6995051841b0d037$export$50c1edaaed881ec4 = ()=>$6995051841b0d037$var$state.renderMode === 'hydrateRoot';
const $6995051841b0d037$export$5b86f8a52685e7a6 = ()=>$6995051841b0d037$var$state.renderMode !== 'hydrateRoot' || !(0, $4cTDP.fg)('jfp-magma-data-ssr-placeholder-retain');
const $6995051841b0d037$export$1005a4e5bbaa775b = ()=>{
    $6995051841b0d037$var$state = {
        renderMode: 'hydrateRoot',
        isComplete: false
    };
};
const $6995051841b0d037$export$365316c4efc7213 = ()=>{
    if ($6995051841b0d037$var$state.renderMode === 'hydrateRoot') $6995051841b0d037$var$state.isComplete = true;
};
const $6995051841b0d037$export$aaae7fa8de9c1841 = ()=>$6995051841b0d037$var$state.renderMode === 'hydrateRoot' && !$6995051841b0d037$var$state.isComplete;
(0, $SvJbY.autoBeforeEachTest)(()=>{
    $6995051841b0d037$var$state = $6995051841b0d037$var$DEFAULT_STATE;
});
let $6995051841b0d037$var$clearCompletionSubscription = null;
const $6995051841b0d037$var$actions = {
    reportHydrationEnd: ()=>({ setState: setState })=>{
            $6995051841b0d037$export$365316c4efc7213();
            setState({
                isComplete: true
            });
        },
    addPendingSubtree: (componentId)=>({ getState: getState, setState: setState })=>{
            if (!$6995051841b0d037$export$aaae7fa8de9c1841()) return;
            const { pendingIds: pendingIds } = getState();
            if (!pendingIds.includes(componentId)) setState({
                pendingIds: [
                    ...pendingIds,
                    componentId
                ]
            });
        },
    completePendingSubtree: (componentId)=>({ getState: getState, setState: setState })=>{
            if (!$6995051841b0d037$export$aaae7fa8de9c1841()) return;
            const previousPendingIds = getState().pendingIds;
            const updatedPendingIds = previousPendingIds.filter((pendingId)=>pendingId !== componentId);
            setState({
                pendingIds: updatedPendingIds
            });
            if (previousPendingIds.includes(componentId) && updatedPendingIds.length === 0) {
                if ($6995051841b0d037$var$clearCompletionSubscription != null) $6995051841b0d037$var$clearCompletionSubscription();
                // Add a delay before checking for completion because the pending set becomes empty several times as React
                // hydrates each "layer".
                $6995051841b0d037$var$clearCompletionSubscription = (0, $6XSXq.callWhenIdle)(()=>{
                    $6995051841b0d037$var$clearCompletionSubscription = null;
                    if (getState().pendingIds.length === 0) {
                        $6995051841b0d037$export$365316c4efc7213();
                        setState({
                            isComplete: true
                        });
                    }
                }, /* timeout for browsers without requestIdleCallback */ 2000);
            }
        }
};
/**
 * We need access to global hydration state inside React (reactive) and outside React, so have both a store and module state.
 */ const $6995051841b0d037$var$store = (0, $GtRbT.createStore)({
    name: 'hydration-global-completion',
    initialState: ()=>({
            isComplete: false,
            pendingIds: []
        }),
    actions: $6995051841b0d037$var$actions
});
const $6995051841b0d037$export$2f0a8b29a48aa524 = (0, $iJq0l.createStateHook)($6995051841b0d037$var$store, {
    selector: ({ isComplete: isComplete })=>isComplete
});
const $6995051841b0d037$export$e86488111e485305 = (0, $iJq0l.createStateHook)($6995051841b0d037$var$store, {
    selector: ({ pendingIds: pendingIds })=>pendingIds
});
const $6995051841b0d037$export$a92d0836dfe80799 = (0, $iJq0l.createActionsHook)($6995051841b0d037$var$store);

});
parcelRegister("6XSXq", function(module, exports) {
$parcel$export(module.exports, "callWhenIdle", () => $8638770e300a4099$export$d2542992df1e054);
const $8638770e300a4099$export$d2542992df1e054 = (callback, timeout = 200)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (typeof window.requestIdleCallback === 'function') {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const callbackId = window.requestIdleCallback(callback);
        return ()=>cancelIdleCallback(callbackId);
    }
    const timer = setTimeout(callback, timeout);
    return ()=>{
        clearTimeout(timer);
    };
};

});


parcelRegister("7zyWi", function(module, exports) {
$parcel$export(module.exports, "SuspensePlaceholder", () => $9a412305208245bc$export$25177ae6586aed49);

var $eJOHy = parcelRequire("eJOHy");

var $hEhKB = parcelRequire("hEhKB");

var $9RE4U = parcelRequire("9RE4U");

var $4cTDP = parcelRequire("4cTDP");

var $boxLx = parcelRequire("boxLx");

var $6rSJX = parcelRequire("6rSJX");

var $gUIqk = parcelRequire("gUIqk");
const $9a412305208245bc$var$SuspenseWrapper = ({ fallback: fallback, fallbackRender: fallbackRender, children: children, childrenRender: childrenRender })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $eJOHy.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).Fragment, null, fallback, fallbackRender)
    }, children, childrenRender);
/**
 * intermediate memo to avoid LazySuspense re-rendering when locked
 * also replaces useMemo for children and fallback "componsition"
 */ const $9a412305208245bc$var$MemoizedSuspense = /*#__PURE__*/ (0, $eJOHy.memo)($9a412305208245bc$var$SuspenseWrapper, (prev, next)=>{
    if (!next.unlocked) return true;
    return next.fallback === prev.fallback && next.children === prev.children;
});
const $9a412305208245bc$export$25177ae6586aed49 = ({ name: name, children: children, fallback: fallback })=>{
    const [renderedPath, renderedPathRef, render] = (0, $6rSJX.useSwitchControl)();
    const isHoldEnabled = (0, $eJOHy.useCallback)(()=>renderedPathRef.current !== 'children', [
        renderedPathRef
    ]);
    (0, $gUIqk.useHold)(name, // hold is "controlled" by the fact of children render
    renderedPath !== 'children', // if children become visible we don't need to hold anymore
    isHoldEnabled);
    const isContentRendered = Boolean(renderedPath);
    (0, $boxLx.useHydrationSubtreeCompleter)({
        isSubtreeRendered: isContentRendered
    });
    const OwnershipMarker = (0, $hEhKB.useOwnershipMarkerComponent)({
        markerType: 'placeholder',
        name: name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement(OwnershipMarker, null, (0, $4cTDP.fg)('jfp-magma-placeholder-hydration-markers') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9a412305208245bc$var$HydrationMarker, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9a412305208245bc$var$MemoizedSuspense, {
        fallback: fallback,
        fallbackRender: render.fallback,
        childrenRender: render.children,
        unlocked: isContentRendered || !(0, $9RE4U.getIsHydrationInProgress)()
    }, children), (0, $4cTDP.fg)('jfp-magma-placeholder-hydration-markers') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($9a412305208245bc$var$HydrationMarker, null));
};
/**
 * This component can be use to see if there has been divergence in the react fibers between the server and client.
 * If there is, we can expect to see different values for `data-hydration-marker` between CSR and SSR.
 */ function $9a412305208245bc$var$HydrationMarker() {
    const uid = (0, $eJOHy.useId)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement("input", {
        type: "hidden",
        "data-hydration-marker": uid
    });
}

});
parcelRegister("boxLx", function(module, exports) {
$parcel$export(module.exports, "useHydrationSubtreeCompleter", () => $453f9b67db2cc371$export$507a191610ed3a18);

var $eJOHy = parcelRequire("eJOHy");

var $4cTDP = parcelRequire("4cTDP");

var $9RE4U = parcelRequire("9RE4U");
/**
 * This component is rendered at all suspense boundaries (placeholders), to be able to know when
 * hydration has completed globally - when every subtree has rendered.
 */ const $453f9b67db2cc371$var$useHydrationSubtreeCompleterImpl = ({ isSubtreeRendered: isSubtreeRendered })=>{
    const id = (0, $eJOHy.useId)();
    const { addPendingSubtree: addPendingSubtree, completePendingSubtree: completePendingSubtree } = (0, $9RE4U.useGlobalHydrationActions)();
    (0, $eJOHy.useEffect)(()=>{
        if (isSubtreeRendered) completePendingSubtree(id);
        else addPendingSubtree(id);
    }, [
        isSubtreeRendered,
        id,
        completePendingSubtree,
        addPendingSubtree
    ]);
    // Exists to ensure that we complete a subtree if it unmounts before `isSubtreeRendered` flips to true
    (0, $eJOHy.useEffect)(()=>{
        return ()=>{
            completePendingSubtree(id);
        };
    }, [
        id,
        completePendingSubtree
    ]);
};
const $453f9b67db2cc371$export$507a191610ed3a18 = (params)=>{
    // Feature gates flip between on/off in storybooks, resulting in React (rightly) complaining that the number of hook
    // calls has changed between renders. This specific hook is a no-op in storybooks anyway, so freeze the condition.
    const enabled = (0, $eJOHy.useRef)((0, $4cTDP.fg)('jfp-magma-fix-hydration-completion')).current;
    if (enabled) // eslint-disable-next-line react-hooks/rules-of-hooks
    $453f9b67db2cc371$var$useHydrationSubtreeCompleterImpl(params);
};

});

parcelRegister("6rSJX", function(module, exports) {
$parcel$export(module.exports, "useSwitchControl", () => $e746e367a76d75ad$export$ecfdf004dc213783);

var $eJOHy = parcelRequire("eJOHy");

var $hhgtU = parcelRequire("hhgtU");
const $e746e367a76d75ad$var$ReportLocation = ({ cb: cb, location: location })=>{
    (0, $hhgtU.default)(()=>{
        cb(location);
    }, [
        cb,
        location
    ]);
    return null;
};
const $e746e367a76d75ad$export$ecfdf004dc213783 = ()=>{
    const locationRef = (0, $eJOHy.useRef)(undefined);
    const [location, setLocationState] = (0, $eJOHy.useState)(undefined);
    const setLocation = (0, $eJOHy.useCallback)((loc)=>{
        locationRef.current = loc;
        setLocationState(loc);
    }, []);
    return [
        location,
        locationRef,
        (0, $eJOHy.useMemo)(()=>({
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e746e367a76d75ad$var$ReportLocation, {
                    key: "unfreeze",
                    cb: setLocation,
                    location: "fallback"
                }),
                children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e746e367a76d75ad$var$ReportLocation, {
                    key: "unfreeze",
                    cb: setLocation,
                    location: "children"
                })
            }), [
            setLocation
        ])
    ];
};

});

parcelRegister("gUIqk", function(module, exports) {
$parcel$export(module.exports, "useHold", () => $5d225bb0a1322e79$export$9b6ebe8ffd9dc981);

var $eJOHy = parcelRequire("eJOHy");

var $7aoMz = parcelRequire("7aoMz");

var $iETA0 = parcelRequire("iETA0");

var $hhgtU = parcelRequire("hhgtU");
const $5d225bb0a1322e79$export$518d3dc8bbe6d22b = ()=>(0, $eJOHy.useContext)((0, $7aoMz.default));
const $5d225bb0a1322e79$var$returnTrue = ()=>true;
const $5d225bb0a1322e79$export$9b6ebe8ffd9dc981 = (name, lock, isEnabled = $5d225bb0a1322e79$var$returnTrue)=>{
    const interactionContext = $5d225bb0a1322e79$export$518d3dc8bbe6d22b();
    const waitContext = (0, $eJOHy.useContext)((0, $iETA0.WaitContext));
    // Runs synchronously, to allow us to identify async items
    (0, $hhgtU.default)(()=>{
        if (!lock || !isEnabled()) return;
        // if until context exists means there is a LazyWait parent component
        // we use that value
        const shouldHold = waitContext ? !!waitContext.currentValue() : true;
        if (interactionContext != null && shouldHold) return interactionContext.hold(name);
    }, [
        interactionContext,
        name,
        waitContext,
        lock,
        isEnabled
    ]);
};

});



parcelRegister("fM7ce", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("7mIf9"),
    $ewTvA("jXweD"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("kNFvF"),
    $ewTvA("kVX56"),
    $ewTvA("jbxE1"),
    $ewTvA("7imUH"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("8zh4V")
]).then(()=>parcelRequire('gOtK1'));

});
parcelRegister("ewTvA", function(module, exports) {
"use strict";

function $a93f1ca862af756d$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("iTG8W")).resolve(id));
}
module.exports = $a93f1ca862af756d$var$load;

});
parcelRegister("iTG8W", function(module, exports) {
$parcel$export(module.exports, "register", () => $dc1e0dd440d9db39$export$6503ec6e8aabbaf, (v) => $dc1e0dd440d9db39$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $dc1e0dd440d9db39$export$f7ad0328861e2f03, (v) => $dc1e0dd440d9db39$export$f7ad0328861e2f03 = v);
var $dc1e0dd440d9db39$export$6503ec6e8aabbaf;
var $dc1e0dd440d9db39$export$f7ad0328861e2f03;
"use strict";
var $dc1e0dd440d9db39$var$mapping = new Map();
function $dc1e0dd440d9db39$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$dc1e0dd440d9db39$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $dc1e0dd440d9db39$var$resolve(id) {
    var resolved = $dc1e0dd440d9db39$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$dc1e0dd440d9db39$export$6503ec6e8aabbaf = $dc1e0dd440d9db39$var$register;
$dc1e0dd440d9db39$export$f7ad0328861e2f03 = $dc1e0dd440d9db39$var$resolve;

});




parcelRegister("1qbKn", function(module, exports) {
$parcel$export(module.exports, "ErrorFlagRenderer", () => $e08c3a5c6aa7daeb$export$71d5b03f33fc194b);
$parcel$export(module.exports, "ErrorBoundaryFlag", () => $e08c3a5c6aa7daeb$export$7b744ef274d5ae99);

var $eJOHy = parcelRequire("eJOHy");

var $fGnU6 = parcelRequire("fGnU6");

var $h47gY = parcelRequire("h47gY");

var $2imLM = parcelRequire("2imLM");

var $bQWwW = parcelRequire("bQWwW");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $e08c3a5c6aa7daeb$var$ErrorFlagRendererLazy = (0, $bQWwW.lazy)(()=>(parcelRequire("dLegd")), {
    moduleId: "./src/packages/platform/ui/error-flag-renderer/src/ui/index.tsx"
});
const $e08c3a5c6aa7daeb$export$71d5b03f33fc194b = (props)=>{
    const packageDetails = {
        id: 'asyncErrorFlagComponent',
        packageName: 'jiraErrorBoundary'
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), packageDetails, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $fGnU6.ReportErrors), {
        teamName: "magma",
        ...packageDetails
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $2imLM.default), {
        name: "async-error-flag-renderer",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e08c3a5c6aa7daeb$var$ErrorFlagRendererLazy, props))));
};
const $e08c3a5c6aa7daeb$var$renderErrorFlag = ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement($e08c3a5c6aa7daeb$export$71d5b03f33fc194b, {
        id: "error-boundary",
        error: error
    });
const $e08c3a5c6aa7daeb$export$7b744ef274d5ae99 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $h47gY.default), {
        ...props,
        render: $e08c3a5c6aa7daeb$var$renderErrorFlag
    }, children);
$e08c3a5c6aa7daeb$export$7b744ef274d5ae99.defaultProps = {
    extraEventData: {},
    id: undefined
};

});
parcelRegister("dLegd", function(module, exports) {

var $ewTvA = parcelRequire("ewTvA");
module.exports = Promise.all([
    $ewTvA("kNFvF"),
    $ewTvA("76n7a"),
    $ewTvA("l253H"),
    $ewTvA("ffQaD"),
    $ewTvA("kvRbA"),
    $ewTvA("1GIUR")
]).then(()=>parcelRequire('8UANz'));

});





parcelRegister("6uWhG", function(module, exports) {
$parcel$export(module.exports, "getMark", () => $e5dd03c0c639e194$export$f45af69d005a6ed);
$parcel$export(module.exports, "setMark", () => $e5dd03c0c639e194$export$f7a1fb90d8604165);
$parcel$export(module.exports, "setMeasure", () => $e5dd03c0c639e194$export$3d472a4be9f2b366);
$parcel$export(module.exports, "measureFunc", () => $e5dd03c0c639e194$export$25a311d3df56652d);
/* eslint-disable no-console */ 
var $gPCSe = parcelRequire("gPCSe");
const $e5dd03c0c639e194$export$f45af69d005a6ed = (markName)=>{
    if (!(0, $gPCSe.default).getEntriesByName) return null;
    const marks = (0, $gPCSe.default).getEntriesByName(markName) || [];
    return marks.length > 0 ? marks[0] : null;
};
const $e5dd03c0c639e194$export$f7a1fb90d8604165 = (markName, markOptions)=>{
    if (!(0, $gPCSe.default).mark) return undefined;
    const entry = (0, $gPCSe.default).mark(markName, markOptions);
    if (console.timeStamp) console.timeStamp(markName);
    return entry;
};
const $e5dd03c0c639e194$export$3d472a4be9f2b366 = (measureName, start, end)=>{
    // performance.measure will throw an exception if either start/end marks are not set
    try {
        return (0, $gPCSe.default).measure(measureName, start, end);
    // eslint-disable-next-line no-empty
    } catch (_err) {}
    return undefined;
};
function $e5dd03c0c639e194$export$25a311d3df56652d(measureName, func) {
    $e5dd03c0c639e194$export$f7a1fb90d8604165(`${measureName}:start`);
    const result = func();
    $e5dd03c0c639e194$export$f7a1fb90d8604165(`${measureName}:end`);
    $e5dd03c0c639e194$export$3d472a4be9f2b366(measureName, `${measureName}:start`, `${measureName}:end`);
    return result;
}

});
parcelRegister("gPCSe", function(module, exports) {
$parcel$export(module.exports, "default", () => $7d4147290e665ee0$export$2e2bcd8739ae039);
/* eslint-disable no-restricted-properties */ 
var $12DRg = parcelRequire("12DRg");
const $7d4147290e665ee0$var$getPerf = ()=>{
    try {
        // TODO - Write up an explanation to why we are doing this, if this method is approved.
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.performance.clearResourceTimings && (window.performance.clearResourceTimings = (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))));
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return window.performance;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        // no op implementation
        return {
            now: ()=>0,
            mark: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            clearMarks: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            clearResourceTimings: (0, (/*@__PURE__*/$parcel$interopDefault($12DRg))),
            getEntriesByType: (_type)=>[],
            getEntriesByName: (_name)=>[],
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            measure: (_measureName, _start, _end)=>{}
        };
    }
};
var $7d4147290e665ee0$export$2e2bcd8739ae039 = $7d4147290e665ee0$var$getPerf();

});


parcelRegister("iZsVo", function(module, exports) {
$parcel$export(module.exports, "ssr", () => $bd622791964552f9$export$ea2375f6c0c9ffdc);
$parcel$export(module.exports, "ssrExtended", () => $bd622791964552f9$export$b821aa3bb9044abf);

var $LFmXM = parcelRequire("LFmXM");

var $hWeHP = parcelRequire("hWeHP");

var $bd1QF = parcelRequire("bd1QF");

var $d4UrD = parcelRequire("d4UrD");
const $bd622791964552f9$var$getSSRFeatureFlags = (0, $LFmXM.default)(()=>{
    try {
        const metaTagValue = (0, $hWeHP.default)('spa-service-flags');
        if (metaTagValue === null) return null;
        return JSON.parse(metaTagValue) || null;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
});
const $bd622791964552f9$export$ea2375f6c0c9ffdc = {
    getDoneMark: (0, $bd1QF.getSSRMark),
    getTimings: (0, $d4UrD.getSSRTimings),
    getFeatureFlags: $bd622791964552f9$var$getSSRFeatureFlags
};
const $bd622791964552f9$export$b821aa3bb9044abf = {
    ...$bd622791964552f9$export$ea2375f6c0c9ffdc,
    includeFeatureFlags: 'when-available'
};

});
parcelRegister("bd1QF", function(module, exports) {
$parcel$export(module.exports, "getSSRMark", () => $f2226353914e0cfa$export$1faf7d001841a41c);

var $6uWhG = parcelRequire("6uWhG");

const $f2226353914e0cfa$export$1faf7d001841a41c = ()=>(0, $6uWhG.getMark)((0, $fcc2379b1f384e36$export$135c96ab5afee429))?.startTime || null;

});
const $fcc2379b1f384e36$export$56940a9488e85199 = 'jira.fe.spa-';
const $fcc2379b1f384e36$export$45c4b6bf7935c69a = `${$fcc2379b1f384e36$export$56940a9488e85199}start`;
const $fcc2379b1f384e36$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $fcc2379b1f384e36$export$ff834eccc35b9089 = 'appBundleReady';
const $fcc2379b1f384e36$export$86b05e34d462ead8 = 'prefetchApiReady';
const $fcc2379b1f384e36$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $fcc2379b1f384e36$export$3ae43cc1782d058f = 'jswRenderStart';
const $fcc2379b1f384e36$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $fcc2379b1f384e36$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $fcc2379b1f384e36$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $fcc2379b1f384e36$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $fcc2379b1f384e36$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $fcc2379b1f384e36$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $fcc2379b1f384e36$export$99c08ec92759c71c = 'tti-raf-mark';
const $fcc2379b1f384e36$export$48552baa9db8ce1d = 'tti-raf';


parcelRegister("d4UrD", function(module, exports) {
$parcel$export(module.exports, "getSSRTimings", () => $4d224cd03d50270c$export$bf7408e83532dcd0);

var $fqICx = parcelRequire("fqICx");
const $4d224cd03d50270c$export$bf7408e83532dcd0 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!window.SPA_STATE) return null;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const detailRenderTrace = window.SPA_STATE['ssr/detail_render_trace'];
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const detailRequestTrace = window.SPA_STATE['ssr/detail_request_trace'];
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const highLevelMetrics = window.SPA_STATE['ssr/metrics'];
    const timings = (0, (/*@__PURE__*/$parcel$interopDefault($fqICx)))(detailRenderTrace?.data?.traces) || {};
    if (highLevelMetrics?.data) {
        if ('ssrTotal' in highLevelMetrics.data) timings.total = {
            startTime: 0,
            duration: highLevelMetrics.data.ssrTotal
        };
        if ('ssrGetStyle' in highLevelMetrics.data) timings.styles = {
            startTime: highLevelMetrics.data.ssrGetStyle - highLevelMetrics.data.ssrGetStyle,
            duration: highLevelMetrics.data.ssrGetStyle
        };
        if ('ssrPrefetch' in highLevelMetrics.data) {
            const prefetchStartTime = Object.values(detailRenderTrace?.data?.traces || {}).reduce((min, { startTime: startTime })=>min === -1 || min > startTime ? startTime : min, -1);
            timings.prefetch = {
                startTime: prefetchStartTime,
                duration: highLevelMetrics.data.ssrPrefetch
            };
        }
    }
    if (detailRequestTrace?.data) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.entries(detailRequestTrace.data).forEach(([key, value])=>{
        timings[`prefetch/${key}`] = value;
    });
    return timings;
};

});


parcelRegister("1Q1XT", function(module, exports) {
$parcel$export(module.exports, "initBrowserMetrics3", () => $1bdabe384288ea4c$export$156d1d35be797a9d);

var $eJOHy = parcelRequire("eJOHy");

var $k04JP = parcelRequire("k04JP");

var $4cTDP = parcelRequire("4cTDP");

var $hWeHP = parcelRequire("hWeHP");

var $hVEQH = parcelRequire("hVEQH");

var $2Mqjh = parcelRequire("2Mqjh");

var $2lxLk = parcelRequire("2lxLk");
var $8tVkR = parcelRequire("8tVkR");
var $hSmZA = parcelRequire("hSmZA");

var $5d2lU = parcelRequire("5d2lU");

var $um4ng = parcelRequire("um4ng");

var $c17mK = parcelRequire("c17mK");

var $diftH = parcelRequire("diftH");

var $inFDJ = parcelRequire("inFDJ");

var $gTg7X = parcelRequire("gTg7X");

var $3bfFp = parcelRequire("3bfFp");

var $aRRWa = parcelRequire("aRRWa");
var $hXeVV = parcelRequire("hXeVV");

var $iZsVo = parcelRequire("iZsVo");
const $1bdabe384288ea4c$var$isWRMResource = (url)=>url.includes('/batch.js') || url.includes('/batch.css');
const $1bdabe384288ea4c$var$getWRMAssetName = (url)=>{
    const [, resources] = /\/([\w.\-,:]*?)(?:,-|\/batch\.)/.exec(url) || [];
    const assetName = (0, $hVEQH.sanitiseAssetName)(false)(url);
    if (!resources) return assetName;
    return `wrm/${resources}/${assetName}`;
};
const $1bdabe384288ea4c$var$getFileName = (url)=>$1bdabe384288ea4c$var$isWRMResource(url) ? $1bdabe384288ea4c$var$getWRMAssetName(url) : (0, $hVEQH.sanitiseAssetName)(false)(url);
const $1bdabe384288ea4c$export$156d1d35be797a9d = ()=>{
    (0, $hXeVV.startLSObserver)();
    (0, $hXeVV.startLTObserver)();
    const info = {
        product: 'jira',
        app: {
            version: {
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                web: window.BUILD_KEY,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                ssr: window.SSR_BUILD_KEY
            },
            framework: {
                name: 'react',
                version: $eJOHy.version
            }
        },
        region: (0, $hWeHP.default)('ajs-region') || 'unknown'
    };
    const endpoints = {
        eventPipelineClient: (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
            const instance = client.getInstance();
            if (!(0, $4cTDP.fg)('uip_bm3_stop-page-load')) return instance;
            return {
                sendOperationalEvent: (payload)=>{
                    const type = payload?.attributes?.properties?.['event:type'];
                    if (type === 'page-load') return;
                    return instance.sendOperationalEvent(payload);
                }
            };
        })
    };
    const resourceTimings = {
        sanitiseEndpoints: $gTg7X.sanitiseEndpoints,
        mapResources: $1bdabe384288ea4c$var$getFileName,
        hasTimingHeaders: (url)=>url.includes('jira-frontend-branch') || $1bdabe384288ea4c$var$isWRMResource(url),
        // @ts-expect-error - TS7006 - Parameter 'url' implicitly has an 'any' type.
        xhrFilter: (url)=>url.includes('/rest/greenhopper/')
    };
    const featureFlagClient = {
        getValue: (_featureFlagName)=>{
            return undefined;
        }
    };
    const featureFlags = {
        client: Promise.resolve(featureFlagClient)
    };
    const plugins = {
        featureFlags: featureFlags,
        resourceTimings: resourceTimings,
        bundleEvalTimings: $5d2lU.bundleEvalTimings
    };
    (0, $2Mqjh.getAnalyticsWebClientPromise)().then((client)=>{
        (0, $8tVkR.payloadPublisher).setup({
            product: 'jira',
            app: {
                version: {
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    web: window.BUILD_KEY,
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    ssr: window.SSR_BUILD_KEY
                },
                framework: {
                    name: 'react',
                    version: $eJOHy.version
                }
            },
            region: (0, $hWeHP.default)('ajs-region') || 'unknown',
            tenantType: (0, $hWeHP.default)('ajs-is-synthetic') === 'true' ? (0, $hSmZA.TenantType).Synthetic : (0, $hSmZA.TenantType).RealUser,
            gasv3: client.getInstance(),
            bundleEvalTimings: // @ts-expect-error - TS2322 - Type '{ readonly mapPerformanceMark: (mark: string) => { name: string; type: string; } | null; }' is not assignable to type 'BundleEvalTimingsConfig'.
            $5d2lU.bundleEvalTimings,
            resourceTimings: resourceTimings,
            featureFlagClient: featureFlagClient,
            featureFlags: [
                ...(0, $diftH.featureFlagsAddedToEVERYJiraEvent),
                ...(0, $3bfFp.jfpPerfFeatureFlags),
                ...(0, $inFDJ.featureFlagsAddedToEVERYPageLoadEvent)
            ],
            plugins: [
                // all
                (0, $um4ng.getCustomData),
                // @ts-expect-error - TS2322 - Type '(data: {    start: number;}) => Record<string, any> | null' is not assignable to type '(data: ExperienceData | PageLoadExperienceData) => CustomData | null'.
                (0, $gTg7X.getMarks),
                (0, $gTg7X.getMemoryMetrics),
                // page-load
                (0, $c17mK.getPageSizeMetrics),
                (0, $c17mK.getExtraNavigationTimings),
                // @ts-expect-error - TS2322 - Type '() => (() => unknown)[]' is not assignable to type '(data: ExperienceData | PageLoadExperienceData) => CustomData | null'.
                (0, $gTg7X.getPageLoadPlugins)
            ],
            ssr: $iZsVo.ssr,
            performanceConfig: {
                histogram: {
                    [(0, $2lxLk.ExperiencePerformanceTypes).PageLoad]: {
                        initial: {
                            fmp: '2500_3000_3500_4000_5000_6000',
                            tti: '4000_4500_5000_6000_7000_8000_9000'
                        },
                        transition: {
                            fmp: '2500_3000_3500_4000_5000_6000',
                            tti: '2500_3000_3500_4000_5000_6000'
                        }
                    },
                    [(0, $2lxLk.ExperiencePerformanceTypes).InlineResult]: {
                        result: '100_200_500_1000_1500',
                        response: '50_100_150_200_300_500'
                    },
                    [(0, $2lxLk.ExperiencePerformanceTypes).Custom]: {
                        duration: '250_500_1000_1500_2000_3000_4000'
                    }
                }
            }
        });
    });
    (0, $k04JP.browserMetrics).init({
        info: info,
        endpoints: // @ts-expect-error - TS2322 - Type '{ eventPipelineClient: Promise<AnalyticsWebClient> | Promise<IEventPipelineClient>; metalClient: Promise<MetalClient>; }' is not assignable to type '{ eventPipelineClient: Promise<{ sendOperationalEvent: (payload: GasPurePayload) => void; }>; metalClient?: Promise<{ metric: { submit: (payload: unknown) => void; }; }> | undefined; }'.
        endpoints,
        plugins: // @ts-expect-error - TS2322 - Type '{ featureFlags: { client: Promise<{ getValue: (featureFlagName: string) => FeatureFlagValue | undefined; }>; }; resourceTimings: { sanitiseEndpoints: (url: string) => string; mapResources: (url: string) => any; hasTimingHeaders: (url: string) => boolean; xhrFilter: (url: any) => any; }; bundleEvalTimings: { ...; }; }' is not assignable to type '{ resourceTimings: ResourceTimingsConfig; bundleEvalTimings?: BundleEvalTimingsConfig | undefined; featureFlags: { client: FeatureFlagsClientPromise; }; }'.
        plugins,
        events: {
            all: {
                featureFlags: [
                    ...(0, $diftH.featureFlagsAddedToEVERYJiraEvent),
                    ...(0, $3bfFp.jfpPerfFeatureFlags)
                ],
                plugins: [
                    (0, $gTg7X.getMarks),
                    (0, $gTg7X.getMemoryMetrics),
                    (0, $aRRWa.getLighthouseMetrics),
                    (0, $um4ng.newGetCustomData)
                ]
            },
            PAGE_LOAD: {
                featureFlags: [
                    ...(0, $inFDJ.featureFlagsAddedToEVERYPageLoadEvent)
                ],
                custom: {
                    ...(0, $c17mK.getPageSizeMetrics)(),
                    ...(0, $c17mK.getExtraNavigationTimings)()
                },
                // @ts-expect-error - TS2322 - Type '(() => unknown)[]' is not assignable to type 'CustomPlugin[]'.
                plugins: (0, $gTg7X.getPageLoadPlugins)(),
                histogram: {
                    initial: {
                        fmp: '2500_3000_3500_4000_5000_6000',
                        tti: '4000_4500_5000_6000_7000_8000_9000'
                    },
                    transition: {
                        fmp: '2500_3000_3500_4000_5000_6000',
                        tti: '2500_3000_3500_4000_5000_6000'
                    }
                }
            },
            INLINE_RESULT: {
                histogram: {
                    result: '100_200_500_1000_1500',
                    response: '50_100_150_200_300_500'
                }
            },
            CUSTOM: {
                histogram: {
                    duration: '250_500_1000_1500_2000_3000_4000'
                }
            },
            WEB_VITALS: {
                enabled: !false && (0, $hWeHP.default)('ajs-is-synthetic') === 'true'
            }
        },
        // @ts-expect-error - TS2322 - Type '{ readonly includeFeatureFlags: "when-available"; readonly getDoneMark: () => number | null; readonly getTimings: () => any; readonly getFeatureFlags: MemoizedFn<() => any>; }' is not assignable to type 'SSRConfig'.
        ssr: (0, $iZsVo.ssrExtended)
    });
    (0, $k04JP.browserMetrics).startPageLoad({
        isInitial: true
    });
};

});
parcelRegister("5d2lU", function(module, exports) {
$parcel$export(module.exports, "bundleEvalTimings", () => $1b9aad173b4d116a$export$1a2bb347935fc536);

var $75yrv = parcelRequire("75yrv");
const $1b9aad173b4d116a$export$1a2bb347935fc536 = {
    mapPerformanceMark: (mark)=>{
        if (mark.endsWith((0, $75yrv.JS_EVAL_START))) return {
            name: mark.substring(0, mark.indexOf((0, $75yrv.JS_EVAL_START))),
            type: 'start'
        };
        if (mark.endsWith((0, $75yrv.JS_EVAL_STOP))) return {
            name: mark.substring(0, mark.indexOf((0, $75yrv.JS_EVAL_STOP))),
            type: 'end'
        };
        return null;
    }
};

});

parcelRegister("um4ng", function(module, exports) {
$parcel$export(module.exports, "newGetCustomData", () => $dea163372c06e6a7$export$bc962f7892f5542c);
$parcel$export(module.exports, "getCustomData", () => $dea163372c06e6a7$export$c740a965f4a07e8e);

var $5PQOA = parcelRequire("5PQOA");

var $LFmXM = parcelRequire("LFmXM");

var $hWeHP = parcelRequire("hWeHP");

var $6D8kE = parcelRequire("6D8kE");

var $4cTDP = parcelRequire("4cTDP");

var $6SNzM = parcelRequire("6SNzM");

var $5Dg0E = parcelRequire("5Dg0E");

var $6hCn2 = parcelRequire("6hCn2");
const $dea163372c06e6a7$var$customData = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const commonCustomData = {};
    const shard = (0, $hWeHP.default)('ajs-shard');
    if (shard !== null && shard !== '') commonCustomData.shard = shard;
    if ((0, $4cTDP.fg)('add_editions_to_bm3_splunk_events')) commonCustomData['jira:productEditions'] = (0, $6D8kE.getProductEditions)();
    commonCustomData['network:assetEncoding'] = (0, $6SNzM.getAssetEncoding)();
    const buildVariant = (0, $5Dg0E.getBuildVariant)();
    if (buildVariant) commonCustomData['app:buildVariant'] = buildVariant;
    const bundlerVersion = (0, $6hCn2.getBundlerVersion)();
    if (bundlerVersion) commonCustomData['app:bundlerVersion'] = bundlerVersion;
    commonCustomData.httpProtocol = // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    performance.getEntriesByType('resource')// @ts-expect-error - TS2339  - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'. | TS2339 - Property 'nextHopProtocol' does not exist on type 'PerformanceEntry'.
    .find(({ nextHopProtocol: nextHopProtocol })=>!!nextHopProtocol)?.nextHopProtocol ?? 'unknown';
    return commonCustomData;
};
const $dea163372c06e6a7$export$bc962f7892f5542c = (0, (/*@__PURE__*/$parcel$interopDefault($5PQOA)))($dea163372c06e6a7$var$customData, ()=>true);
const $dea163372c06e6a7$export$c740a965f4a07e8e = (0, $LFmXM.default)($dea163372c06e6a7$var$customData);

});
parcelRegister("6SNzM", function(module, exports) {
$parcel$export(module.exports, "getAssetEncoding", () => $6ca8f6fb1586f3a3$export$fd12d8f45e126585);
const $6ca8f6fb1586f3a3$export$fd12d8f45e126585 = ()=>{
    const assetEncodings = Array.prototype.map// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    .call(document.querySelectorAll('script[data-encoding], link[data-encoding]'), (i)=>i.getAttribute('data-encoding')) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((acc, i)=>{
        // @ts-expect-error - TS2538 - Type 'unknown' cannot be used as an index type.
        acc[i] = true;
        return acc;
    }, {});
    const uniqueEncodings = Object.keys(assetEncodings).sort();
    let result = 'unknown';
    if (uniqueEncodings.length === 1) [result] = uniqueEncodings;
    if (uniqueEncodings.length > 1) result = `mixed: ${uniqueEncodings.toString()}`;
    return result;
};

});

parcelRegister("5Dg0E", function(module, exports) {
$parcel$export(module.exports, "getBuildVariant", () => $8b4dcceb62a18a98$export$ca0c40b5b7c3b911);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $8b4dcceb62a18a98$export$ca0c40b5b7c3b911 = ()=>window.BUILD_VARIANT;

});

parcelRegister("6hCn2", function(module, exports) {
$parcel$export(module.exports, "getBundlerVersion", () => $60aa2c8ee5374db2$export$5dca7b2a9cf4f500);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $60aa2c8ee5374db2$export$5dca7b2a9cf4f500 = ()=>window.BUNDLER_VERSION;

});


parcelRegister("c17mK", function(module, exports) {
$parcel$export(module.exports, "getPageSizeMetrics", () => $7274feec32126a38$export$84e3d676f1564c75);
$parcel$export(module.exports, "getExtraNavigationTimings", () => $7274feec32126a38$export$b37a70af06e58097);
$parcel$export(module.exports, "getPageSizeInfo", () => $7274feec32126a38$export$b72e035af6568be7);

var $gPCSe = parcelRequire("gPCSe");
const $7274feec32126a38$export$84e3d676f1564c75 = ()=>{
    let maxDepth = -1;
    let maxWidth = -1;
    let numElements = 0;
    // As described in the lighthouse DOM audit - https://web.dev/dom-size/
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const calculateDOMsizeAndDepth = (el = document.body, depth = 1)=>{
        if (!el) return;
        if (depth > maxDepth) maxDepth = depth;
        if (el.children.length > maxWidth) maxWidth = el.children.length;
        let child = el.firstElementChild;
        while(child){
            // @ts-expect-error - TS2345 - Argument of type 'Element' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child, depth + 1);
            // If element has shadow dom, traverse into that tree.
            if (child.shadowRoot) // @ts-expect-error - TS2345 - Argument of type 'ShadowRoot' is not assignable to parameter of type 'HTMLElement'.
            calculateDOMsizeAndDepth(child.shadowRoot, depth + 1);
            child = child.nextElementSibling;
            numElements += 1;
        }
    };
    calculateDOMsizeAndDepth();
    return {
        totalBodyElements: numElements,
        maxNestedLevels: maxDepth,
        maxChildElements: maxWidth
    };
};
const $7274feec32126a38$export$b37a70af06e58097 = ()=>{
    if (!(0, $gPCSe.default)) return {};
    const navigation = (0, $gPCSe.default).getEntriesByType('navigation')[0];
    if (!navigation) return {};
    return {
        // From https://www.w3.org/TR/navigation-timing-2/
        // @ts-expect-error - TS2339 - Property 'decodedBodySize' does not exist on type 'PerformanceEntry'.
        decodedBodySize: navigation.decodedBodySize,
        // @ts-expect-error - TS2339 - Property 'encodedBodySize' does not exist on type 'PerformanceEntry'.
        encodedBodySize: navigation.encodedBodySize,
        // @ts-expect-error - TS2339 - Property 'transferSize' does not exist on type 'PerformanceEntry'.
        transferSize: navigation.transferSize
    };
};
const $7274feec32126a38$var$assetsTypes = [
    'script',
    'link'
];
const $7274feec32126a38$export$b72e035af6568be7 = ({ start: start, stop: stop })=>{
    const pageSize = $7274feec32126a38$export$b37a70af06e58097();
    if (!pageSize || Object.keys(pageSize).length === 0 || pageSize.decodedBodySize === 0 || start > 0) return {};
    const decoded = {
        total: pageSize.decodedBodySize,
        pageSize: pageSize.decodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const encoded = {
        total: pageSize.encodedBodySize,
        pageSize: pageSize.encodedBodySize,
        assets: 0,
        endpoints: 0
    };
    const net = {
        total: pageSize.transferSize,
        assets: 0,
        endpoints: 0
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    for (const entry of (0, $gPCSe.default).getEntriesByType('resource')){
        if (entry.startTime > stop) continue;
        if ($7274feec32126a38$var$assetsTypes.includes(entry.initiatorType)) {
            decoded.total += entry.decodedBodySize;
            decoded.assets += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.assets += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.assets += entry.transferSize;
        } else {
            decoded.total += entry.decodedBodySize;
            decoded.endpoints += entry.decodedBodySize;
            encoded.total += entry.encodedBodySize;
            encoded.endpoints += entry.encodedBodySize;
            net.total += entry.transferSize;
            net.endpoints += entry.transferSize;
        }
    }
    const returnValue = {};
    Object.keys(decoded).forEach((key)=>{
        returnValue[`size:decoded:${key}`] = decoded[key];
    });
    Object.keys(encoded).forEach((key)=>{
        returnValue[`size:encoded:${key}`] = encoded[key];
    });
    Object.keys(net).forEach((key)=>{
        returnValue[`size:net:${key}`] = net[key];
    });
    return returnValue;
};

});

parcelRegister("diftH", function(module, exports) {
$parcel$export(module.exports, "featureFlagsAddedToEVERYJiraEvent", () => $2c7f074ae52a96b2$export$8f6204c7f33d9925);
// by adding feature flag to this array you agree that this feature flag:
// * is expected to impact all performance metrics in Jira (page load, interactions, etc)
// * is expected to be short term
const $2c7f074ae52a96b2$export$8f6204c7f33d9925 = [];

});

parcelRegister("inFDJ", function(module, exports) {
$parcel$export(module.exports, "featureFlagsAddedToEVERYPageLoadEvent", () => $9be9333e6169e995$export$85fd4da798ef108b);
// by adding feature flag to this array you agree that this feature flag:
// * is expected to impact *all page load* performance metrics in Jira
// * is expected to be short term
const $9be9333e6169e995$export$85fd4da798ef108b = [];

});

parcelRegister("gTg7X", function(module, exports) {
$parcel$export(module.exports, "getPageLoadPlugins", () => $71b5449896aa0d2f$export$4d5c3be18e81b958);
$parcel$export(module.exports, "getMemoryMetrics", () => $71b5449896aa0d2f$export$500422125b861bab);
$parcel$export(module.exports, "getMarks", () => $71b5449896aa0d2f$export$9d952633c9c2237b);
$parcel$export(module.exports, "sanitiseEndpoints", () => $71b5449896aa0d2f$export$6dfc8bfc2349f367);

var $3Q6BV = parcelRequire("3Q6BV");

var $a5R5f = parcelRequire("a5R5f");

var $75yrv = parcelRequire("75yrv");

var $jmNHL = parcelRequire("jmNHL");

var $aKjW6 = parcelRequire("aKjW6");

var $c17mK = parcelRequire("c17mK");

var $84rXz = parcelRequire("84rXz");

var $cxegf = parcelRequire("cxegf");

var $9LzIn = parcelRequire("9LzIn");

var $pSnTj = parcelRequire("pSnTj");
const $71b5449896aa0d2f$var$endpointsWithOperationNameRegex = new RegExp('/rest/graphql/1/|/rest/gira/1/|/gateway/api/graphql|/jsw2/graphql');
const $71b5449896aa0d2f$export$4d5c3be18e81b958 = ()=>{
    const pageLoadCustomData = [];
    pageLoadCustomData.push((data)=>{
        // initial load only
        const startTime = data?.start || data?.result?.startTime || 0;
        if (startTime !== 0) return {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return Object.entries((0, $aKjW6.getServerDurationMetrics)()).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc, [key, value])=>{
            acc[key] = value;
            return acc;
        }, {});
    });
    pageLoadCustomData.push((0, $9LzIn.getRouterResourceMetrics));
    pageLoadCustomData.push((0, $pSnTj.getWRMStats));
    pageLoadCustomData.push((0, $84rXz.getCacheHitRatio));
    pageLoadCustomData.push((0, $cxegf.getCHRInfo));
    pageLoadCustomData.push((0, $c17mK.getPageSizeInfo));
    return pageLoadCustomData;
};
const $71b5449896aa0d2f$export$500422125b861bab = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const customData = {};
    const memoryUsageReport = (0, $jmNHL.getMemoryUsageReport)();
    if (memoryUsageReport) customData.memory = memoryUsageReport;
    return customData;
};
const $71b5449896aa0d2f$export$9d952633c9c2237b = (data)=>{
    const userTiming = (0, $a5R5f.getUserTiming)();
    if (userTiming === null) return null;
    const sanitizeName = (name)=>name.replace(/[\W_]+/g, '_');
    // @ts-expect-error - TS7031 - Binding element 'baseName' implicitly has an 'any' type. | TS7031 - Binding element 'collection' implicitly has an 'any' type.
    const getNextAvailableName = ({ baseName: baseName, collection: collection })=>{
        let candidateName = baseName;
        // If <name> is taken, we'll try <name>_2 and increment from there
        let counter = 2;
        let validName;
        while(!validName)if (candidateName in collection) {
            candidateName = `${baseName}_${counter}`;
            counter += 1;
        } else validName = candidateName;
        return validName;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const marks = {};
    // Excludes mark starting with '_'. This allows marks to opt-out from the report.
    userTiming.filter(// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    (item)=>item.type === 'mark' && !item.name.startsWith('_') && !item.name.endsWith((0, $75yrv.JS_EVAL_START)) && !item.name.endsWith((0, $75yrv.JS_EVAL_STOP)) && item.startTime >= data.start)// @ts-expect-error - TS7006 - Parameter 'item' implicitly has an 'any' type.
    .forEach((item)=>{
        const name = getNextAvailableName({
            baseName: `mark__${sanitizeName(item.name)}`,
            collection: marks
        });
        marks[name] = Math.round(item.startTime - data.start);
    });
    return marks;
};
const $71b5449896aa0d2f$export$6dfc8bfc2349f367 = (url)=>{
    const parsedUrl = (0, (/*@__PURE__*/$parcel$interopDefault($3Q6BV)))(url, true);
    let fileName = parsedUrl.pathname.replace(/\/(\w+)-(\d+)\//i, '/<issue-key>/').replace(/[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}/i, '<uuid>').replace(/\/pq\/[a-fA-F0-9]+/i, '/pq/<id>') // persisted queries
    .replace(/\/\d+$/i, '/<id>');
    /**
	 * For these endpoints we make a special exception to add the query parameters so that we can distinguish calls using different queries
	 */ if ($71b5449896aa0d2f$var$endpointsWithOperationNameRegex.test(fileName)) {
        const { operation: operation } = parsedUrl.query;
        if (operation) fileName += `?operation=${operation}`;
    }
    return fileName;
};

});
parcelRegister("jmNHL", function(module, exports) {
$parcel$export(module.exports, "getMemoryUsageReport", () => $fff10ea369943f60$export$e5bd2d61c7c80651);
// This is an approximation of the start of the session
const $fff10ea369943f60$var$sessionStart = Date.now();
const $fff10ea369943f60$export$e5bd2d61c7c80651 = ()=>{
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (typeof performance === 'undefined' || performance?.memory == null) return null;
    const now = Date.now();
    const sessionTime = now - $fff10ea369943f60$var$sessionStart;
    // @ts-expect-error - TS2339 - Property 'memory' does not exist on type 'Performance'.
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } = performance.memory;
    return {
        sessionTime: sessionTime,
        performanceMemoryEntry: {
            jsHeapSizeLimit: jsHeapSizeLimit,
            totalJSHeapSize: totalJSHeapSize,
            usedJSHeapSize: usedJSHeapSize
        }
    };
};

});

parcelRegister("aKjW6", function(module, exports) {
$parcel$export(module.exports, "getServerDurationMetrics", () => $b26b8c3fdd816f36$export$efd8b60b870e5282);
/**
 * Extracts and compiles key performance metrics from the DOM to assess server response times and request handling efficiency.
 * This includes metrics like server duration, trace IDs, concurrency levels, and timing details, which are crucial for analyzing server behavior and identifying potential bottlenecks.
 */ const $b26b8c3fdd816f36$export$efd8b60b870e5282 = ()=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const metrics = {};
    try {
        // server duration metric is buried in a hidden form near end of </body>
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverDurationElem = document.querySelector('#jira_request_timing_info [title="jira.request.server.time"]');
        if (serverDurationElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverDuration = Number(serverDurationElem.value);
            if (serverDuration > 0) metrics.serverDuration = Math.round(serverDuration);
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceIdElem = document.querySelector('#jira_request_timing_info [title="jira.request.trace.id"]');
        if (serverTraceIdElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceId = serverTraceIdElem.value;
            metrics.serverRequestTraceId = serverRequestTraceId;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverTraceSampledElem = document.querySelector('#jira_request_timing_info [title="jira.request.sampled"]');
        if (serverTraceSampledElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestTraceSampled = serverTraceSampledElem.value;
            switch(serverRequestTraceSampled){
                case 'true':
                    metrics.serverRequestTraceSampled = true;
                    break;
                case 'false':
                    metrics.serverRequestTraceSampled = false;
                    break;
                default:
                    metrics.serverRequestTraceSampled = null;
                    break;
            }
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const concurrentRequestsElem = document.querySelector('#jira_request_timing_info [name="jira.request.concurrent.requests"]');
        if (concurrentRequestsElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const concurrentRequests = concurrentRequestsElem.value;
            metrics.concurrentRequests = concurrentRequests;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const serverRequestStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.start.millis"]');
        if (serverRequestStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const serverRequestStartTime = serverRequestStartTimeElem.value;
            metrics.serverRequestStartTime = serverRequestStartTime;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const frontendFlushStartTimeElem = document.querySelector('#jira_request_timing_info [name="jira.request.frontend.flush.start"]');
        if (frontendFlushStartTimeElem) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const frontendFlushStartTime = frontendFlushStartTimeElem.value;
            metrics.frontendFlushStartTime = frontendFlushStartTime;
        }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (ignored) {
    /* noop */ }
    return metrics;
};

});

parcelRegister("84rXz", function(module, exports) {
$parcel$export(module.exports, "getCacheHitRatio", () => $1d0927e6b92a3e53$export$e8a9322c3d9da8a6);

var $gPCSe = parcelRequire("gPCSe");
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $1d0927e6b92a3e53$var$cacheableTypes = [
    'script',
    'link'
];
const $1d0927e6b92a3e53$var$CACHE_NETWORK = 'network';
const $1d0927e6b92a3e53$var$CACHE_MEMORY = 'memory';
const $1d0927e6b92a3e53$var$CACHE_DISK = 'disk';
const $1d0927e6b92a3e53$var$calculateTransferType = (type, duration, size)=>{
    if (!$1d0927e6b92a3e53$var$cacheableTypes.includes(type)) return $1d0927e6b92a3e53$var$CACHE_NETWORK;
    if ((size === undefined || size === 0) && duration === 0) return $1d0927e6b92a3e53$var$CACHE_MEMORY;
    if (size === 0 && duration > 0) return $1d0927e6b92a3e53$var$CACHE_DISK;
    if (size === undefined) return null;
    return $1d0927e6b92a3e53$var$CACHE_NETWORK;
};
const $1d0927e6b92a3e53$export$e8a9322c3d9da8a6 = ({ start: start })=>{
    let fromCache = 0;
    let preloadFromCache = 0;
    let total = 0;
    let totalPreload = 0;
    // initial load only
    if (start !== 0) return {};
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $gPCSe.default).getEntriesByType('resource')){
            // The BM3 resource timing collector checks for whether the timing information is available,
            // but we can make the assumption that it is for this Jira specific collector.
            const transferType = $1d0927e6b92a3e53$var$calculateTransferType(entry.initiatorType, entry.duration, entry.transferSize);
            const isPreload = entry.initiatorType === 'link';
            if (transferType === 'disk' || transferType === 'memory') {
                fromCache += 1;
                if (isPreload) preloadFromCache += 1;
            }
            if (transferType !== null) {
                total += 1;
                if (isPreload) totalPreload += 1;
            }
        }
        const result = {};
        if (total > 0) result.cacheHitRatio = fromCache / total;
        if (totalPreload > 0) result.preloadCacheHitRatio = preloadFromCache / totalPreload;
        return result;
    } catch (e) {
        return {};
    }
};

});

parcelRegister("cxegf", function(module, exports) {
$parcel$export(module.exports, "getCHRInfo", () => $c4ec0f3e660c0c60$export$9e005e111be93521);

var $gPCSe = parcelRequire("gPCSe");

var $bd1QF = parcelRequire("bd1QF");

var $cKGbY = parcelRequire("cKGbY");
const $c4ec0f3e660c0c60$export$9e005e111be93521 = ({ start: start })=>{
    // initial load only
    if (start !== 0) return {};
    const ssrMark = (0, $bd1QF.getSSRMark)();
    const reporter = new (0, $cKGbY.CHRReporter)(ssrMark);
    try {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        for (const entry of (0, $gPCSe.default).getEntriesByType('resource'))reporter.add(entry);
        const chr = reporter.get();
        return chr === null ? {} : {
            chr: chr
        };
    } catch (e) {
        return {};
    }
};

});
parcelRegister("cKGbY", function(module, exports) {
$parcel$export(module.exports, "CHRReporter", () => $dfe09da0446f84da$export$7d0d4cfb6455ffa5);

var $gi6BY = parcelRequire("gi6BY");

var $hNKFE = parcelRequire("hNKFE");
class $dfe09da0446f84da$export$7d0d4cfb6455ffa5 {
    constructor(ssrMark){
        this.preloaded = new (0, $hNKFE.CHRSummary)();
        this.all = new (0, $hNKFE.CHRSummary)();
        this.ssrMark = null;
        this.ssrMark = ssrMark;
    }
    add(item) {
        if (item.encodedBodySize === 0) return;
        if (item.initiatorType === 'link' && (0, $gi6BY.cacheableTypes).includes(item.initiatorType) && (this.ssrMark === null || item.startTime < this.ssrMark)) this.preloaded.add(item);
        this.all.add(item);
    }
    static round(n) {
        return Math.round(n * 10000) / 10000;
    }
    makePayload(summary) {
        const bundlesLoadType = {
            mem: $dfe09da0446f84da$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $hNKFE.CHRSummary).MEMORY_KEY] / summary.bundlesCount),
            disk: $dfe09da0446f84da$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $hNKFE.CHRSummary).DISK_KEY] / summary.bundlesCount),
            net: $dfe09da0446f84da$export$7d0d4cfb6455ffa5.round(summary.bundles[(0, $hNKFE.CHRSummary).NETWORK_KEY] / summary.bundlesCount)
        };
        const bundlesRatio = $dfe09da0446f84da$export$7d0d4cfb6455ffa5.round((summary.bundles[(0, $hNKFE.CHRSummary).MEMORY_KEY] + summary.bundles[(0, $hNKFE.CHRSummary).DISK_KEY]) / summary.bundlesCount);
        const sizeLoadType = {
            mem: $dfe09da0446f84da$export$7d0d4cfb6455ffa5.round(summary.size[(0, $hNKFE.CHRSummary).MEMORY_KEY] / summary.sizeTotal),
            disk: $dfe09da0446f84da$export$7d0d4cfb6455ffa5.round(summary.size[(0, $hNKFE.CHRSummary).DISK_KEY] / summary.sizeTotal),
            net: $dfe09da0446f84da$export$7d0d4cfb6455ffa5.round(summary.size[(0, $hNKFE.CHRSummary).NETWORK_KEY] / summary.sizeTotal)
        };
        const sizeRatio = $dfe09da0446f84da$export$7d0d4cfb6455ffa5.round((summary.size[(0, $hNKFE.CHRSummary).MEMORY_KEY] + summary.size[(0, $hNKFE.CHRSummary).DISK_KEY]) / summary.sizeTotal);
        return {
            bundles: {
                ratio: bundlesRatio,
                count: summary.bundlesCount,
                loadType: bundlesLoadType
            },
            size: {
                ratio: sizeRatio,
                total: summary.sizeTotal,
                loadType: sizeLoadType
            }
        };
    }
    get() {
        if (this.all.bundlesCount === 0) return null;
        return {
            preloaded: this.makePayload(this.preloaded),
            all: this.makePayload(this.all)
        };
    }
}

});
parcelRegister("gi6BY", function(module, exports) {
$parcel$export(module.exports, "cacheableTypes", () => $f8b97f5eec2b020d$export$5e1aa91d6932ddaa);
/* Borrowed from https://bitbucket.org/atlassian/atlassian-frontend/src/master/packages/performance/browser-metrics/src/plugins/timings/resource.ts */ const $f8b97f5eec2b020d$export$5e1aa91d6932ddaa = [
    'script',
    'link'
];

});

parcelRegister("hNKFE", function(module, exports) {
$parcel$export(module.exports, "CHRSummary", () => $cd892e62cb703278$export$783d6618ee601ba);

var $gi6BY = parcelRequire("gi6BY");
const $cd892e62cb703278$var$calculateTransferType = (type, duration, size)=>{
    if (!(0, $gi6BY.cacheableTypes).includes(type)) return null;
    if ((size === undefined || size === 0) && duration === 0) return $cd892e62cb703278$export$783d6618ee601ba.MEMORY_KEY;
    if (size === 0 && duration > 0) return $cd892e62cb703278$export$783d6618ee601ba.DISK_KEY;
    if (size === undefined) return null;
    return $cd892e62cb703278$export$783d6618ee601ba.NETWORK_KEY;
};
class $cd892e62cb703278$export$783d6618ee601ba {
    static{
        this.MEMORY_KEY = 'mem';
    }
    static{
        this.DISK_KEY = 'disk';
    }
    static{
        this.NETWORK_KEY = 'net';
    }
    add(item) {
        const type = $cd892e62cb703278$var$calculateTransferType(item.initiatorType, item.duration, item.transferSize);
        if (type === null) return;
        this.bundles[type] += 1;
        this.bundlesCount += 1;
        this.size[type] += item.encodedBodySize;
        this.sizeTotal += item.encodedBodySize;
    }
    constructor(){
        this.bundles = {
            [$cd892e62cb703278$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$cd892e62cb703278$export$783d6618ee601ba.DISK_KEY]: 0,
            [$cd892e62cb703278$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.bundlesCount = 0;
        this.size = {
            [$cd892e62cb703278$export$783d6618ee601ba.MEMORY_KEY]: 0,
            [$cd892e62cb703278$export$783d6618ee601ba.DISK_KEY]: 0,
            [$cd892e62cb703278$export$783d6618ee601ba.NETWORK_KEY]: 0
        };
        this.sizeTotal = 0;
    }
}

});



parcelRegister("9LzIn", function(module, exports) {
$parcel$export(module.exports, "getRouterResourceMetrics", () => $2a301144fe2cce75$export$e703af446a67c7f4);
const $2a301144fe2cce75$export$e703af446a67c7f4 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const ssrRouterResourceTimeouts = window.SPA_STATE ? Object.keys(window.SPA_STATE).filter((key)=>{
        if (key !== key.toUpperCase()) return false;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const resource = window.SPA_STATE[key];
        if (typeof resource !== 'object') return false;
        const resourceResponse = resource[Object.keys(resource)[0]];
        return resourceResponse?.error?.name === 'TimeoutError';
    }) : [];
    return {
        ssrRouterResourceTimeouts: ssrRouterResourceTimeouts
    };
};

});

parcelRegister("pSnTj", function(module, exports) {
$parcel$export(module.exports, "getWRMStats", () => $d5b5b9a6920f5e15$export$d2d916ddd03b82bc);
const $d5b5b9a6920f5e15$export$d2d916ddd03b82bc = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const wrmStats = window.__WRM_INTERNAL_STATS__ ?? {};
    return {
        wrmStats: wrmStats
    };
};

});


parcelRegister("3bfFp", function(module, exports) {
$parcel$export(module.exports, "jfpPerfFeatureFlags", () => $e0d26cf1dda88a51$export$b1f8075e4696e880);
const $e0d26cf1dda88a51$export$b1f8075e4696e880 = [];

});

parcelRegister("aRRWa", function(module, exports) {
$parcel$export(module.exports, "getLighthouseMetrics", () => $fe842ac51cd33b8d$export$b46cecdf698e4bb5);

var $8BXTP = parcelRequire("8BXTP");

var $3b3tm = parcelRequire("3b3tm");

var $6XArn = parcelRequire("6XArn");

var $IXHjh = parcelRequire("IXHjh");

var $hXeVV = parcelRequire("hXeVV");
const $fe842ac51cd33b8d$export$b46cecdf698e4bb5 = ({ start: start, stop: stop })=>{
    const tbt = (0, $6XArn.getTBT)(start, stop, (0, $IXHjh.EntriesBuffer)[(0, $3b3tm.PerformanceObserverEntryTypes).LongTask]);
    // no round as CLS is usually 0-1
    const cls = (0, $8BXTP.getCLS)(start, stop, (0, $IXHjh.EntriesBuffer)[(0, $3b3tm.PerformanceObserverEntryTypes).LayoutShift]);
    return {
        'metric:tbt': Math.round(tbt.total),
        'metric:tbt:observed': Math.round(tbt.observed),
        'metric:cls': cls
    };
};

});
parcelRegister("8BXTP", function(module, exports) {
$parcel$export(module.exports, "getCLS", () => $4eac4f88a1f4afec$export$fc6227831ee7c7);
const $4eac4f88a1f4afec$export$fc6227831ee7c7 = (start, stop, buffer)=>{
    const layoutShifts = buffer.getAll().filter((entry)=>entry.startTime >= start && entry.startTime <= stop);
    const sessionWindows = [];
    let currentWindow = null;
    // Group layout shifts into session windows
    for (const shift of layoutShifts){
        const { startTime: startTime } = shift;
        const endTime = shift.startTime + shift.duration;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const score = shift.value;
        if (currentWindow === null || startTime - currentWindow.endTime > 1000 || endTime - currentWindow.startTime > 5000) {
            // Start a new session window
            currentWindow = {
                startTime: startTime,
                endTime: endTime,
                score: score
            };
            sessionWindows.push(currentWindow);
        } else {
            // Add layout shift to current session window
            currentWindow.endTime = endTime;
            currentWindow.score += score;
        }
    }
    // Find session window with highest cumulative score
    const maxScore = sessionWindows.reduce((max, sessionWindow)=>sessionWindow.score > max ? sessionWindow.score : max, 0);
    // Return score of largest burst as CLS metric
    return Math.round(maxScore * 10000) / 10000;
};

});

parcelRegister("3b3tm", function(module, exports) {
$parcel$export(module.exports, "PerformanceObserverEntryTypes", () => $1ce2790a9cacf064$export$a4def92db6fc8e17);
const $1ce2790a9cacf064$export$a4def92db6fc8e17 = {
    LayoutShift: 'layout-shift',
    LongTask: 'longtask'
};

});

parcelRegister("6XArn", function(module, exports) {
$parcel$export(module.exports, "getTBT", () => $30e934b2bd258090$export$2d6e933b35bd3407);
const $30e934b2bd258090$var$MAX_ACCEPTABLE_TASK_DURATION = 50;
const $30e934b2bd258090$export$2d6e933b35bd3407 = (start, stop, buffer)=>buffer.getAll().filter((entry)=>entry.startTime <= stop && entry.duration > $30e934b2bd258090$var$MAX_ACCEPTABLE_TASK_DURATION && (entry.startTime >= start || entry.startTime + entry.duration >= start || entry.startTime <= start && entry.startTime + entry.duration >= stop)).reduce((tbt, entry)=>{
        const longTaskStop = entry.startTime + entry.duration;
        const intersectStart = Math.max(entry.startTime + $30e934b2bd258090$var$MAX_ACCEPTABLE_TASK_DURATION, start);
        const intersectStop = Math.min(longTaskStop, stop);
        const longTaskIncluded = Math.max(intersectStop - intersectStart, 0);
        // eslint-disable-next-line no-param-reassign
        tbt.observed += entry.duration - $30e934b2bd258090$var$MAX_ACCEPTABLE_TASK_DURATION;
        // eslint-disable-next-line no-param-reassign
        tbt.total += longTaskIncluded;
        return tbt;
    }, {
        total: 0,
        observed: 0
    });

});

parcelRegister("IXHjh", function(module, exports) {
$parcel$export(module.exports, "EntriesBuffer", () => $8dad8f5b76730210$export$f7dc16cbd16f7bbe);

var $3b3tm = parcelRequire("3b3tm");
class $8dad8f5b76730210$export$2c6e86519c9e8188 {
    constructor(maxLength = 1000){
        this.buffer = [];
        this.full = false;
        this.maxLength = maxLength;
    }
    push(item) {
        if (this.full || this.maxLength === this.buffer.length) {
            this.full = true;
            this.buffer.shift();
        }
        this.buffer.push(item);
    }
    getAll() {
        return this.buffer;
    }
}
const $8dad8f5b76730210$export$f7dc16cbd16f7bbe = {
    [(0, $3b3tm.PerformanceObserverEntryTypes).LongTask]: new $8dad8f5b76730210$export$2c6e86519c9e8188(),
    [(0, $3b3tm.PerformanceObserverEntryTypes).LayoutShift]: new $8dad8f5b76730210$export$2c6e86519c9e8188()
};

});

parcelRegister("hXeVV", function(module, exports) {
$parcel$export(module.exports, "startLSObserver", () => $42f94d4c8054b925$export$768ccc3ab7bac3ea);
$parcel$export(module.exports, "startLTObserver", () => $42f94d4c8054b925$export$54fb8b6aaf70ec9c);

var $3b3tm = parcelRequire("3b3tm");

var $IXHjh = parcelRequire("IXHjh");
let $42f94d4c8054b925$var$pe = null;
const $42f94d4c8054b925$var$getObserver = ()=>{
    if ($42f94d4c8054b925$var$pe !== null) return $42f94d4c8054b925$var$pe;
    $42f94d4c8054b925$var$pe = new PerformanceObserver((list)=>{
        list.getEntries().forEach((entry)=>{
            if (entry.entryType === (0, $3b3tm.PerformanceObserverEntryTypes).LayoutShift) (0, $IXHjh.EntriesBuffer)[(0, $3b3tm.PerformanceObserverEntryTypes).LayoutShift].push(entry);
            if (entry.entryType === (0, $3b3tm.PerformanceObserverEntryTypes).LongTask) (0, $IXHjh.EntriesBuffer)[(0, $3b3tm.PerformanceObserverEntryTypes).LongTask].push(entry);
        });
    });
    return $42f94d4c8054b925$var$pe;
};
const $42f94d4c8054b925$export$768ccc3ab7bac3ea = ()=>{
    $42f94d4c8054b925$var$getObserver().observe({
        type: (0, $3b3tm.PerformanceObserverEntryTypes).LayoutShift,
        buffered: true
    });
};
const $42f94d4c8054b925$export$54fb8b6aaf70ec9c = ()=>{
    $42f94d4c8054b925$var$getObserver().observe({
        type: (0, $3b3tm.PerformanceObserverEntryTypes).LongTask,
        buffered: true
    });
};

});



const $c9cb1b3997607889$export$ce553301d55c2fd8 = 'fedramp-moderate';
const $c9cb1b3997607889$export$f005e2e9f707cb5f = 'commercial';
const $c9cb1b3997607889$export$bd6b5a7802d76127 = 'fedramp-fedex';
const $c9cb1b3997607889$export$a739cd5aac835909 = 'stg';
const $c9cb1b3997607889$export$42dd0cdd351a4a9 = 'prod';
const $c9cb1b3997607889$export$404582bc18fe4d9e = 'dev';

const $54dbbe6dc88f8bd2$export$42f4885608027d0c = 'non_boolean';

// This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
const $9790b8dfe6f31c81$export$19d68f5aa485d903 = false;

const $652f5f63189f3e2a$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $652f5f63189f3e2a$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $652f5f63189f3e2a$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $652f5f63189f3e2a$export$b2c0462ff17aa26e = 'BUSINESS_BOARD';
const $652f5f63189f3e2a$export$f154708d773ba5a0 = 'JIRA_BOARD';
const $652f5f63189f3e2a$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $652f5f63189f3e2a$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $652f5f63189f3e2a$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $652f5f63189f3e2a$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $652f5f63189f3e2a$export$4695c1a423ffe431 = 'DASHBOARD';
const $652f5f63189f3e2a$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $652f5f63189f3e2a$export$9a80695e72849f84 = 'X-Atlassian-Capability';

// SCREENS
const $aa42ce8e355d58fa$export$f636b5b56f1d624a = 'Screen';
const $aa42ce8e355d58fa$export$9d2de6eebf7462b5 = 'Drawer';
const $aa42ce8e355d58fa$export$1171103ea9083ffa = 'Modal';
const $aa42ce8e355d58fa$export$cae2783c9279926 = 'InlineDialog';
const $aa42ce8e355d58fa$export$d1123261ca8831d2 = 'Dropdown';
const $aa42ce8e355d58fa$export$238d30785c4bca84 = 'Banner';
const $aa42ce8e355d58fa$export$a1562d08625f5d7e = 'UI';
const $aa42ce8e355d58fa$export$947dac6c72b26f81 = 'TRACK';
const $aa42ce8e355d58fa$export$f1d537d508d2945a = 'SCREEN';
const $aa42ce8e355d58fa$export$12346a674644c156 = 'OPERATIONAL';

const $e9db81972dce4ebc$export$f636b5b56f1d624a = 'Screen';
const $e9db81972dce4ebc$export$9d2de6eebf7462b5 = 'Drawer';
const $e9db81972dce4ebc$export$1171103ea9083ffa = 'Modal';
const $e9db81972dce4ebc$export$cae2783c9279926 = 'InlineDialog';
const $e9db81972dce4ebc$export$d1123261ca8831d2 = 'Dropdown';
const $e9db81972dce4ebc$export$a1562d08625f5d7e = 'UI';
const $e9db81972dce4ebc$export$947dac6c72b26f81 = 'TRACK';
const $e9db81972dce4ebc$export$f1d537d508d2945a = 'SCREEN';
const $e9db81972dce4ebc$export$12346a674644c156 = 'OPERATIONAL';
const $e9db81972dce4ebc$export$2ceccf177fae277c = 'analyticsBridge';

// Media uses a namespaced analytics context under the following key MEDIA_CONTEXT.
const $5bf02ef989474068$export$70df29c238ba7306 = 'mediaCtx'; // However we don't export any JSX component to create that namespaced analytics context.
 // In media components, analytics context is being created by this component:
 // @see packages/media/media-common/src/analytics/withMediaAnalyticsContext.tsx

// same types defined in analytics-web-client but avoid creating dependency with that
const $d6f34b7bd34f6138$export$a1562d08625f5d7e = 'ui';
const $d6f34b7bd34f6138$export$947dac6c72b26f81 = 'track';
const $d6f34b7bd34f6138$export$f1d537d508d2945a = 'screen';
const $d6f34b7bd34f6138$export$12346a674644c156 = 'operational';
const $d6f34b7bd34f6138$export$b055de0e665cb20c = 'unknown';

const $71feb0ebe2f021d7$export$cf090d5281b5ae06 = 10000;
const $71feb0ebe2f021d7$export$8575e30be0feb909 = 30000;

const $10b5883439ef237e$export$3288b14b6745c572 = 204;
const $10b5883439ef237e$export$c09e7ea0fc79f34f = 409;
const $10b5883439ef237e$export$974c37534b0191b1 = 503;

const $3e9c0e1856c1af11$export$b98e411ae80c806f = '/';

// temp solution until a proper versioning
const $c2146f5087eba60f$export$93809551debf385f = '0.1.7';

const $779a7211687b8cb3$export$b98e411ae80c806f = '/';


$parcel$global.rlb("b3QiB")
//# sourceMappingURL=shared~commons~ar.588d4974.js.map
